/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const FundFamilyCaseDetailsFragmentDoc = gql`
    fragment FundFamilyCaseDetails on FundFamilyChangeRequestType {
  id
  familyId
  billingCaseId
  familyDisplayName
  clientId
  arenaId
  requestedAt
  requestedById
  decision
  approvedById
  approvedAt
  rejectedById
  rejectedAt
  decisionReason
  status
  resolution
  assigneeName
  secondaryAssigneeName
  clientName
  requestType
  assigneeId
  resolvedByName
  __typename
}
    `;
export const GpxClienteDetailsFragmentDoc = gql`
    fragment GpxClienteDetails on GpxType {
  client
  clientId
  arenaId
  csm
  nextRenewalDate
  productLine
  edition
  currentBlendSoftwareEum
  faEumUsd
  __typename
}
    `;
export const DocumentForDocumentFragmentDoc = gql`
    fragment DocumentForDocument on DocumentType {
  id
  agentExtractedData
  agentJobStatus
  agentJobId
}
    `;
export const SubscriptionMailingAddressFragmentDoc = gql`
    fragment SubscriptionMailingAddress on SubscriptionAddressObjectType {
  street
  street2
  street3
  city
  region
  state {
    id
    code
  }
  country {
    id
    name
  }
  postalCode
}
    `;
export const ProfileForBeneficiarySearchFragmentDoc = gql`
    fragment ProfileForBeneficiarySearch on ProfileType {
  id
  firstName
  middleName
  lastName
  legalName
  complianceObjectType
  accountType
  positionCount
  lastUsedAt
  positions {
    id
    onboardingCase {
      id
      createdAt
      externalArena {
        id
        name
      }
      externalEntity {
        id
        name
      }
      investingProfile {
        id
        firstName
        lastName
        legalName
        middleName
        complianceObjectType
      }
      program {
        id
        name
      }
    }
  }
  parentRelationships {
    id
    relationshipType
    parentProfileId
  }
}
    `;
export const ProfileRelationshipDetailsFragmentDoc = gql`
    fragment ProfileRelationshipDetails on ProfileRelationshipType {
  id
  parentProfileId
  childProfileId
  relationshipType
  percentOwnership
  childProfile {
    id
    complianceObjectType
    firstName
    lastName
    legalName
    addresses {
      id
      country {
        id
        name
        alpha2code
        riskRating
      }
      isPrimaryDomicile
    }
  }
}
    `;
export const BasicComplianceCaseDetailsFragmentDoc = gql`
    fragment BasicComplianceCaseDetails on ComplianceCaseType {
  id
  createdAt
  readonly
  name
  origin
  resolution
  status
  subStatus
  programId
  program {
    id
    name
  }
  casePrograms {
    id
    name
  }
  caseType
  sourceCase {
    caseType
  }
  externalArena {
    id
    objectId
    objectTypeEnum
    name
  }
  externalEntity {
    id
    objectId
    objectTypeEnum
    name
  }
  externalObject {
    id
    objectId
    objectTypeEnum
    name
  }
  position {
    id
    account {
      id
      name
    }
    investmentEntity {
      id
      name
    }
  }
  assignee {
    id
    externalUser {
      id
      name
      objectId
    }
  }
  maker {
    id
    externalUser {
      id
      objectId
    }
  }
  checker {
    id
    externalUser {
      id
      objectId
    }
  }
  investingProfile {
    id
    firstName
    complianceObjectType
    middleName
    lastName
    legalName
    dateOfBirth
    dateOfOrganization
  }
}
    `;
export const FullComplianceCaseDetailsFragmentDoc = gql`
    fragment FullComplianceCaseDetails on ComplianceCaseType {
  id
  createdAt
  readonly
  rules
  name
  caseType
  program {
    id
    name
  }
  casePrograms {
    id
    name
  }
  origin
  resolution
  status
  subStatus
  metaData
  programId
  externalArena {
    id
    objectId
    objectTypeEnum
    name
  }
  externalEntity {
    id
    objectId
    objectTypeEnum
    name
  }
  entity {
    id
    complianceSettings {
      fatcaCrsEnabled
    }
  }
  externalObject {
    id
    objectId
    objectTypeEnum
    name
  }
  externalObjects {
    id
    objectId
    name
    objectTypeEnum
  }
  assignee {
    id
    externalUser {
      id
      name
      objectId
    }
  }
  maker {
    id
    externalUser {
      id
      objectId
    }
  }
  checker {
    id
    externalUser {
      id
      objectId
    }
  }
  documents {
    id
    name
    profileId
    s3Link
    status
    expiryDate
    documentPurpose {
      baseType
      expires
      complianceObjectType
    }
    metadata {
      key
      value
      type
    }
    contentType
    agentJobId
    agentJobStatus
    agentExtractedData
    conflictsResolved
  }
  investingProfile {
    id
    profileGuid
    firstName
    complianceObjectType
    accountType
    middleName
    lastName
    legalName
    dateOfBirth
    dateOfOrganization
    positions {
      id
    }
    clients
    complianceCases(caseTypes: [investor_onboarding, remediation]) {
      complianceCase {
        id
        name
        status
        resolution
        externalArena {
          id
          objectId
          name
        }
        position {
          id
        }
      }
    }
    taxIdUnencrypted
    taxIdType
    addresses {
      id
      street
      city
      postalCode
      street2
      province
      state {
        code
        id
        name
      }
      country {
        id
        name
        alpha2code
      }
      isPrimaryDomicile
    }
    beneficialOwners {
      id
      relationshipType
      childProfile {
        id
        complianceObjectType
        firstName
        middleName
        lastName
        legalName
      }
    }
    controllingPersons {
      id
      relationshipType
      childProfile {
        id
        complianceObjectType
        firstName
        middleName
        lastName
        legalName
      }
    }
    documents {
      id
      name
      profileId
      s3Link
      status
      expiryDate
      documentPurpose {
        baseType
        expires
        complianceObjectType
      }
      metadata {
        key
        value
        type
      }
      contentType
    }
    screeningMatches {
      pepCategory
      result
    }
  }
  recurringHitRootProfile {
    id
    firstName
    middleName
    lastName
    legalName
    complianceObjectType
  }
  profiles {
    id
    accountType
    complianceObjectType
    firstName
    middleName
    lastName
    legalName
    dateOfBirth
    dateOfOrganization
    positions {
      id
    }
    clients
    complianceCases(caseTypes: [investor_onboarding]) {
      complianceCase {
        id
        name
        status
        resolution
        externalArena {
          id
          objectId
          name
        }
      }
    }
    taxIdUnencrypted
    taxIdType
    addresses {
      id
      street
      city
      postalCode
      street2
      province
      state {
        code
        id
        name
      }
      country {
        id
        name
        alpha2code
      }
      isPrimaryDomicile
    }
    parentRelationships {
      id
      relationshipType
    }
    screeningMatches {
      pepCategory
      result
    }
  }
  escalations {
    caseId
    description
    id
    modifiedAt
    profileId
    waiverDocumentId
    document {
      id
      name
      profileId
      s3Link
      status
      expiryDate
      documentPurposeId
      documentPurpose {
        baseType
        expires
        complianceObjectType
      }
      metadata {
        key
        value
        type
      }
      contentType
    }
  }
  sourceCase {
    id
    name
    caseType
    investingProfile {
      id
      middleName
      firstName
      lastName
      legalName
      complianceObjectType
    }
  }
  childCases {
    caseType
    status
    resolution
  }
  position {
    id
  }
  paymentAccount {
    id
    bankCountryId
    bankCountry {
      id
      name
      alpha2code
    }
    mismatchReason
    payeeName
    providerName
    paymentPrefId
    profileId
    riskRating {
      id
      calculatedRating
      overriddenRating
    }
    profile {
      id
      accountType
      complianceObjectType
      firstName
      middleName
      lastName
      legalName
      dateOfBirth
      dateOfOrganization
      taxIdUnencrypted
      taxIdType
      addresses {
        id
        street
        city
        postalCode
        street2
        province
        state {
          code
          id
          name
        }
        country {
          id
          name
          alpha2code
        }
        isPrimaryDomicile
      }
      parentRelationships {
        id
        relationshipType
      }
    }
  }
}
    `;
export const AccountComparisonAddressFragmentDoc = gql`
    fragment AccountComparisonAddress on AddressObjectType {
  street
  street2
  street3
  city
  region
  postalCode
  state {
    objectName
  }
  country {
    objectName
  }
}
    `;
export const OwnershipTreeProfileFragmentDoc = gql`
    fragment OwnershipTreeProfile on ProfileType {
  id
  complianceObjectType
  firstName
  middleName
  lastName
  legalName
}
    `;
export const OwnershipTreeEdgeFragmentDoc = gql`
    fragment OwnershipTreeEdge on ProfileRelationshipType {
  id
  relationshipType
  percentOwnership
}
    `;
export const OwnershipTreeProfileL4FragmentDoc = gql`
    fragment OwnershipTreeProfileL4 on ProfileType {
  ...OwnershipTreeProfile
  beneficialOwners {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfile
    }
  }
  controllingPersons {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfile
    }
  }
}
    ${OwnershipTreeProfileFragmentDoc}
${OwnershipTreeEdgeFragmentDoc}`;
export const OwnershipTreeProfileL3FragmentDoc = gql`
    fragment OwnershipTreeProfileL3 on ProfileType {
  ...OwnershipTreeProfile
  beneficialOwners {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfileL4
    }
  }
  controllingPersons {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfileL4
    }
  }
}
    ${OwnershipTreeProfileFragmentDoc}
${OwnershipTreeEdgeFragmentDoc}
${OwnershipTreeProfileL4FragmentDoc}`;
export const OwnershipTreeProfileL2FragmentDoc = gql`
    fragment OwnershipTreeProfileL2 on ProfileType {
  ...OwnershipTreeProfile
  beneficialOwners {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfileL3
    }
  }
  controllingPersons {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfileL3
    }
  }
}
    ${OwnershipTreeProfileFragmentDoc}
${OwnershipTreeEdgeFragmentDoc}
${OwnershipTreeProfileL3FragmentDoc}`;
export const OwnershipTreeProfileL1FragmentDoc = gql`
    fragment OwnershipTreeProfileL1 on ProfileType {
  ...OwnershipTreeProfile
  beneficialOwners {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfileL2
    }
  }
  controllingPersons {
    ...OwnershipTreeEdge
    childProfile {
      ...OwnershipTreeProfileL2
    }
  }
}
    ${OwnershipTreeProfileFragmentDoc}
${OwnershipTreeEdgeFragmentDoc}
${OwnershipTreeProfileL2FragmentDoc}`;
export const ExtensionFieldValueDataMinimalFragmentDoc = gql`
    fragment ExtensionFieldValueDataMinimal on ExtensionFieldValueObjectType {
  id
  intValue
  floatValue
  stringValue
  dateValue
  enumValue {
    enumValueCode
    enumValueLabel
  }
}
    `;
export const ExtensionFieldDataFragmentDoc = gql`
    fragment ExtensionFieldData on ExtensionFieldObjectType {
  id
  name
  description
  extensionFieldTypeId
  enumName
  isMultivalued
  enumValues {
    id
    enumName
    enumValueCode
    enumValueLabel
  }
  activeEnumValues {
    id
    enumName
    enumValueCode
    enumValueLabel
  }
}
    `;
export const ExtensionFieldValueDataFragmentDoc = gql`
    fragment ExtensionFieldValueData on ExtensionFieldValueObjectType {
  id
  intValue
  floatValue
  stringValue
  dateValue
  enumValue {
    id
    enumName
    enumValueCode
    enumValueLabel
  }
  extensionField {
    id
    name
  }
}
    `;
export const ExtensionFieldTupleDataFragmentDoc = gql`
    fragment ExtensionFieldTupleData on ExtensionFieldTuple {
  extensionField {
    ...ExtensionFieldData
  }
  values {
    ...ExtensionFieldValueData
  }
}
    ${ExtensionFieldDataFragmentDoc}
${ExtensionFieldValueDataFragmentDoc}`;
export const AnnouncementFieldsFragmentDoc = gql`
    fragment AnnouncementFields on Announcement {
  id
  name
  header
  body
  url
  roles
  arenaGroups
  createdAt
  updatedAt
  expiredAt
  deletedAt
  createdByUser {
    id
    firstName
    middleName
    lastName
  }
}
    `;
export const TransactionCategoryPreviewFragmentDoc = gql`
    fragment TransactionCategoryPreview on TransactionCategoryPreviewData {
  hasMappedTransactionTypes
  existingTransactions {
    startDate
    endDate
    totalAmount
    transactionTypeName
    transactions {
      transactionTypeName
      glDate
      batchExternalId
      amount
      effectiveDate
      isDeleted
      includesDeleted
      glBatchCategory
      glBatchDescription
      positionAccountName
    }
  }
  newTransactions {
    startDate
    endDate
    totalAmount
    transactionTypeName
    transactions {
      transactionTypeName
      glDate
      batchExternalId
      amount
      effectiveDate
      isDeleted
      includesDeleted
      glBatchCategory
      glBatchDescription
      positionAccountName
    }
  }
  missingPositions {
    id
    name
  }
  flaggedZeroOwnershipPositions {
    id
    name
  }
  unmappedTransactionTypes
}
    `;
export const RuleSetFieldsFragmentDoc = gql`
    fragment RuleSetFields on RuleSetType {
  groupsOperator
  groups {
    id
    sortOrder
    conditionOperator
    conditions {
      id
      attribute
      operator
      value
      valueKind
      sortOrder
    }
  }
}
    `;
export const FieldSettingsFieldsFragmentDoc = gql`
    fragment FieldSettingsFields on FieldSettingsType {
  fieldType
  overrideDecimalPlaces
  decimalPlaces
  overrideDisplayFormat
  negativeNumberStyle
  numberScale
  thousandsSeparator
  showCurrencySymbol
  currencySymbolPosition
  zeroDisplayStyle
  nullDisplayStyle
  dateFormatPattern
  filterRules {
    ...RuleSetFields
  }
  suppressionRules {
    ...RuleSetFields
  }
}
    ${RuleSetFieldsFragmentDoc}`;
export const DatePeriodFieldsFragmentDoc = gql`
    fragment DatePeriodFields on DatePeriodType {
  periodKind
  dateType
  offsetMonths
  trailingMonths
  customRangeKind
  customStartParameter
  customStartDate
  customEndParameter
  customEndDate
}
    `;
export const QueryFieldComponentFieldsFragmentDoc = gql`
    fragment QueryFieldComponentFields on QueryFieldComponentType {
  id
  formulaComponentId
  settings {
    ...FieldSettingsFields
  }
  datePeriod {
    ...DatePeriodFields
  }
  levels {
    levels
  }
}
    ${FieldSettingsFieldsFragmentDoc}
${DatePeriodFieldsFragmentDoc}`;
export const QueryFieldFieldsFragmentDoc = gql`
    fragment QueryFieldFields on QueryFieldType {
  id
  queryVersionId
  referenceKind
  alias
  mergeField
  typeHierarchyNodeId
  formulaId
  primaryField
  primaryFieldId
  dynamicDate
  sortOrder
  settings {
    ...FieldSettingsFields
  }
  datePeriod {
    ...DatePeriodFields
  }
  levels {
    levels
  }
  components {
    ...QueryFieldComponentFields
    children {
      ...QueryFieldComponentFields
      children {
        ...QueryFieldComponentFields
        children {
          ...QueryFieldComponentFields
          children {
            ...QueryFieldComponentFields
            children {
              ...QueryFieldComponentFields
              children {
                ...QueryFieldComponentFields
                children {
                  ...QueryFieldComponentFields
                  children {
                    ...QueryFieldComponentFields
                    children {
                      ...QueryFieldComponentFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${FieldSettingsFieldsFragmentDoc}
${DatePeriodFieldsFragmentDoc}
${QueryFieldComponentFieldsFragmentDoc}`;
export const QueryFootnoteFieldsFragmentDoc = gql`
    fragment QueryFootnoteFields on QueryFootnoteType {
  id
  queryVersionId
  footnoteKind
  name
  mergeFieldSlug
  symbolMergeField
  text
  customFieldId: customFieldIdStr
  linkedKind
  linkedTypeHierarchyNodeId
  linkedFormulaId
  linkedPrimaryField
  linkedFormulaDependencyId
  overrideFootnoteSymbol
  footnoteSymbolStyle
  sortOrder
  suppressionRules {
    ...RuleSetFields
  }
}
    ${RuleSetFieldsFragmentDoc}`;
export const QuerySettingsFieldsFragmentDoc = gql`
    fragment QuerySettingsFields on QuerySettingsType {
  decimalPlaces
  formatWithinQuery
  negativeNumberStyle
  numberScale
  thousandsSeparator
  showCurrencySymbol
  currencySymbolPosition
  zeroDisplayStyle
  nullDisplayStyle
  dateFormatPattern
  footnoteSymbolStyle
  supportedTemplateType
  customMessageEnabled
  filterRules {
    ...RuleSetFields
  }
  suppressionRules {
    ...RuleSetFields
  }
}
    ${RuleSetFieldsFragmentDoc}`;
export const QueryDetailFieldsFragmentDoc = gql`
    fragment QueryDetailFields on QueryDetail {
  id
  name
  description
  arenaId
  dataPackageVersionId
  version
  isActive
  fields {
    ...QueryFieldFields
  }
  footnotes {
    ...QueryFootnoteFields
  }
  settings {
    ...QuerySettingsFields
  }
  transactionTypeNodes {
    id
    queryVersionId
    typeHierarchyNodeId
  }
}
    ${QueryFieldFieldsFragmentDoc}
${QueryFootnoteFieldsFragmentDoc}
${QuerySettingsFieldsFragmentDoc}`;
export const GetEnablementAnnouncementsDevFfDocument = gql`
    query GetEnablementAnnouncementsDevFF {
  devFeatures {
    enablementAnnouncements
  }
}
    `;

/**
 * __useGetEnablementAnnouncementsDevFfQuery__
 *
 * To run a query within a React component, call `useGetEnablementAnnouncementsDevFfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnablementAnnouncementsDevFfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnablementAnnouncementsDevFfQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnablementAnnouncementsDevFfQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>(GetEnablementAnnouncementsDevFfDocument, options);
      }
export function useGetEnablementAnnouncementsDevFfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>(GetEnablementAnnouncementsDevFfDocument, options);
        }
// @ts-ignore
export function useGetEnablementAnnouncementsDevFfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>;
export function useGetEnablementAnnouncementsDevFfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery | undefined, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>;
export function useGetEnablementAnnouncementsDevFfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>(GetEnablementAnnouncementsDevFfDocument, options);
        }
export type GetEnablementAnnouncementsDevFfQueryHookResult = ReturnType<typeof useGetEnablementAnnouncementsDevFfQuery>;
export type GetEnablementAnnouncementsDevFfLazyQueryHookResult = ReturnType<typeof useGetEnablementAnnouncementsDevFfLazyQuery>;
export type GetEnablementAnnouncementsDevFfSuspenseQueryHookResult = ReturnType<typeof useGetEnablementAnnouncementsDevFfSuspenseQuery>;
export type GetEnablementAnnouncementsDevFfQueryResult = Apollo.QueryResult<GraphqlTypes.GetEnablementAnnouncementsDevFfQuery, GraphqlTypes.GetEnablementAnnouncementsDevFfQueryVariables>;
export const ComplianceGeneratePresignedUrlsDocument = gql`
    mutation complianceGeneratePresignedUrls($urlGeneratorInput: [CompliancePresignedUrlInput!]!) {
  complianceGeneratePresignedUrls(urlGeneratorInput: $urlGeneratorInput) {
    s3Url
    objectKey
    fileName
  }
}
    `;
export type ComplianceGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>;

/**
 * __useComplianceGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useComplianceGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComplianceGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [complianceGeneratePresignedUrlsMutation, { data, loading, error }] = useComplianceGeneratePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *   },
 * });
 */
export function useComplianceGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>(ComplianceGeneratePresignedUrlsDocument, options);
      }
export type ComplianceGeneratePresignedUrlsMutationHookResult = ReturnType<typeof useComplianceGeneratePresignedUrlsMutation>;
export type ComplianceGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation>;
export type ComplianceGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ComplianceGeneratePresignedUrlsMutation, GraphqlTypes.ComplianceGeneratePresignedUrlsMutationVariables>;
export const DataStudioListOnboardingJobsDocument = gql`
    query DataStudioListOnboardingJobs($limit: Int, $filters: DataStudioListOnboardingJobsFilterInput) {
  dataStudioListOnboardingJobs(limit: $limit, filters: $filters) {
    success
    message
    totalCount
    limit
    hasMore
    nextCursor
    jobs {
      jobId
      jobName
      jobType
      jobStatus
      arenaDomain
      arenaUserEmail
      environment
      createdAt
      createdBy
      jobConfig
      substate
    }
    errors
  }
}
    `;

/**
 * __useDataStudioListOnboardingJobsQuery__
 *
 * To run a query within a React component, call `useDataStudioListOnboardingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataStudioListOnboardingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataStudioListOnboardingJobsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDataStudioListOnboardingJobsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>(DataStudioListOnboardingJobsDocument, options);
      }
export function useDataStudioListOnboardingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>(DataStudioListOnboardingJobsDocument, options);
        }
// @ts-ignore
export function useDataStudioListOnboardingJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>;
export function useDataStudioListOnboardingJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataStudioListOnboardingJobsQuery | undefined, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>;
export function useDataStudioListOnboardingJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>(DataStudioListOnboardingJobsDocument, options);
        }
export type DataStudioListOnboardingJobsQueryHookResult = ReturnType<typeof useDataStudioListOnboardingJobsQuery>;
export type DataStudioListOnboardingJobsLazyQueryHookResult = ReturnType<typeof useDataStudioListOnboardingJobsLazyQuery>;
export type DataStudioListOnboardingJobsSuspenseQueryHookResult = ReturnType<typeof useDataStudioListOnboardingJobsSuspenseQuery>;
export type DataStudioListOnboardingJobsQueryResult = Apollo.QueryResult<GraphqlTypes.DataStudioListOnboardingJobsQuery, GraphqlTypes.DataStudioListOnboardingJobsQueryVariables>;
export const GetJobMetadataDocument = gql`
    query GetJobMetadata {
  dataStudioGetJobMetadata {
    success
    message
    totalJobs
    byStatus {
      status
      count
      percentage
    }
    byType {
      jobType
      count
      percentage
    }
    byStatusAndType {
      status
      jobType
      count
    }
    errors
  }
}
    `;

/**
 * __useGetJobMetadataQuery__
 *
 * To run a query within a React component, call `useGetJobMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>(GetJobMetadataDocument, options);
      }
export function useGetJobMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>(GetJobMetadataDocument, options);
        }
// @ts-ignore
export function useGetJobMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>;
export function useGetJobMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJobMetadataQuery | undefined, GraphqlTypes.GetJobMetadataQueryVariables>;
export function useGetJobMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>(GetJobMetadataDocument, options);
        }
export type GetJobMetadataQueryHookResult = ReturnType<typeof useGetJobMetadataQuery>;
export type GetJobMetadataLazyQueryHookResult = ReturnType<typeof useGetJobMetadataLazyQuery>;
export type GetJobMetadataSuspenseQueryHookResult = ReturnType<typeof useGetJobMetadataSuspenseQuery>;
export type GetJobMetadataQueryResult = Apollo.QueryResult<GraphqlTypes.GetJobMetadataQuery, GraphqlTypes.GetJobMetadataQueryVariables>;
export const GetOnboardingJobLogsDocument = gql`
    query GetOnboardingJobLogs($jobId: String!, $createdAt: String!, $taskId: String, $limit: Int) {
  dataStudioGetOnboardingJobLogs(
    jobId: $jobId
    createdAt: $createdAt
    taskId: $taskId
    limit: $limit
  ) {
    success
    jobId
    dagId
    taskLogs {
      taskId
      executionDate
      tryNumber
      state
      logEntries {
        timestamp
        message
      }
    }
    errors
  }
}
    `;

/**
 * __useGetOnboardingJobLogsQuery__
 *
 * To run a query within a React component, call `useGetOnboardingJobLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingJobLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingJobLogsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      createdAt: // value for 'createdAt'
 *      taskId: // value for 'taskId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOnboardingJobLogsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables> & ({ variables: GraphqlTypes.GetOnboardingJobLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>(GetOnboardingJobLogsDocument, options);
      }
export function useGetOnboardingJobLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>(GetOnboardingJobLogsDocument, options);
        }
// @ts-ignore
export function useGetOnboardingJobLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>;
export function useGetOnboardingJobLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOnboardingJobLogsQuery | undefined, GraphqlTypes.GetOnboardingJobLogsQueryVariables>;
export function useGetOnboardingJobLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>(GetOnboardingJobLogsDocument, options);
        }
export type GetOnboardingJobLogsQueryHookResult = ReturnType<typeof useGetOnboardingJobLogsQuery>;
export type GetOnboardingJobLogsLazyQueryHookResult = ReturnType<typeof useGetOnboardingJobLogsLazyQuery>;
export type GetOnboardingJobLogsSuspenseQueryHookResult = ReturnType<typeof useGetOnboardingJobLogsSuspenseQuery>;
export type GetOnboardingJobLogsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOnboardingJobLogsQuery, GraphqlTypes.GetOnboardingJobLogsQueryVariables>;
export const GeneratePresignedUrlsDocument = gql`
    mutation GeneratePresignedUrls($input: DataStudioGeneratePresignedUrlsInput!) {
  dataStudioGeneratePresignedUrls(input: $input) {
    success
    presignedUrlObjs {
      s3Url
      objectKey
      filename
    }
    errors
  }
}
    `;
export type GeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;

/**
 * __useGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedUrlsMutation, { data, loading, error }] = useGeneratePresignedUrlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>(GeneratePresignedUrlsDocument, options);
      }
export type GeneratePresignedUrlsMutationHookResult = ReturnType<typeof useGeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($input: DataStudioCreateJobInput!) {
  dataStudioCreateJob(input: $input) {
    id
    s3Uri
    jobType
    arenaDomain
    message
  }
}
    `;
export type CreateJobMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateJobMutation, GraphqlTypes.CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateJobMutation, GraphqlTypes.CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateJobMutation, GraphqlTypes.CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<GraphqlTypes.CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateJobMutation, GraphqlTypes.CreateJobMutationVariables>;
export const AssignReviewerDocument = gql`
    mutation AssignReviewer($changeRequestId: UUID!, $reviewerId: Int) {
  assignReviewer(changeRequestId: $changeRequestId, reviewerId: $reviewerId) {
    changeRequest {
      id
      billingCaseId
      assigneeName
      assigneeId
      status
    }
  }
}
    `;
export type AssignReviewerMutationFn = Apollo.MutationFunction<GraphqlTypes.AssignReviewerMutation, GraphqlTypes.AssignReviewerMutationVariables>;

/**
 * __useAssignReviewerMutation__
 *
 * To run a mutation, you first call `useAssignReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignReviewerMutation, { data, loading, error }] = useAssignReviewerMutation({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *      reviewerId: // value for 'reviewerId'
 *   },
 * });
 */
export function useAssignReviewerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AssignReviewerMutation, GraphqlTypes.AssignReviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AssignReviewerMutation, GraphqlTypes.AssignReviewerMutationVariables>(AssignReviewerDocument, options);
      }
export type AssignReviewerMutationHookResult = ReturnType<typeof useAssignReviewerMutation>;
export type AssignReviewerMutationResult = Apollo.MutationResult<GraphqlTypes.AssignReviewerMutation>;
export type AssignReviewerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AssignReviewerMutation, GraphqlTypes.AssignReviewerMutationVariables>;
export const ClaimGpReviewerAssignmentDocument = gql`
    mutation ClaimGpReviewerAssignment($changeRequestId: UUID!) {
  claimGpReviewerAssignment(changeRequestId: $changeRequestId) {
    changeRequest {
      id
      decision
      billingApproverId
      billingApproverName
      csmManagerAssigneeId
      csmManagerAssigneeName
      approverDecisions {
        slot
        decision
        decidedAt
        reason
        resolution
      }
    }
  }
}
    `;
export type ClaimGpReviewerAssignmentMutationFn = Apollo.MutationFunction<GraphqlTypes.ClaimGpReviewerAssignmentMutation, GraphqlTypes.ClaimGpReviewerAssignmentMutationVariables>;

/**
 * __useClaimGpReviewerAssignmentMutation__
 *
 * To run a mutation, you first call `useClaimGpReviewerAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimGpReviewerAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimGpReviewerAssignmentMutation, { data, loading, error }] = useClaimGpReviewerAssignmentMutation({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *   },
 * });
 */
export function useClaimGpReviewerAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ClaimGpReviewerAssignmentMutation, GraphqlTypes.ClaimGpReviewerAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ClaimGpReviewerAssignmentMutation, GraphqlTypes.ClaimGpReviewerAssignmentMutationVariables>(ClaimGpReviewerAssignmentDocument, options);
      }
export type ClaimGpReviewerAssignmentMutationHookResult = ReturnType<typeof useClaimGpReviewerAssignmentMutation>;
export type ClaimGpReviewerAssignmentMutationResult = Apollo.MutationResult<GraphqlTypes.ClaimGpReviewerAssignmentMutation>;
export type ClaimGpReviewerAssignmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ClaimGpReviewerAssignmentMutation, GraphqlTypes.ClaimGpReviewerAssignmentMutationVariables>;
export const CreateChangeRequestDocument = gql`
    mutation CreateChangeRequest($input: CreateChangeRequestInput!) {
  createChangeRequest(input: $input) {
    changeRequest {
      id
      billingCaseId
      status
    }
    family {
      id
      displayName
    }
  }
}
    `;
export type CreateChangeRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateChangeRequestMutation, GraphqlTypes.CreateChangeRequestMutationVariables>;

/**
 * __useCreateChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChangeRequestMutation, { data, loading, error }] = useCreateChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateChangeRequestMutation, GraphqlTypes.CreateChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateChangeRequestMutation, GraphqlTypes.CreateChangeRequestMutationVariables>(CreateChangeRequestDocument, options);
      }
export type CreateChangeRequestMutationHookResult = ReturnType<typeof useCreateChangeRequestMutation>;
export type CreateChangeRequestMutationResult = Apollo.MutationResult<GraphqlTypes.CreateChangeRequestMutation>;
export type CreateChangeRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateChangeRequestMutation, GraphqlTypes.CreateChangeRequestMutationVariables>;
export const GeneratePresignedDocumentPutUrlDocument = gql`
    mutation GeneratePresignedDocumentPutUrl($input: GeneratePresignedDocumentPutUrlInput!) {
  generatePresignedDocumentPutUrl(input: $input) {
    s3DocumentKey
    putUrl
  }
}
    `;
export type GeneratePresignedDocumentPutUrlMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePresignedDocumentPutUrlMutation, GraphqlTypes.GeneratePresignedDocumentPutUrlMutationVariables>;

/**
 * __useGeneratePresignedDocumentPutUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedDocumentPutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedDocumentPutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedDocumentPutUrlMutation, { data, loading, error }] = useGeneratePresignedDocumentPutUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePresignedDocumentPutUrlMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePresignedDocumentPutUrlMutation, GraphqlTypes.GeneratePresignedDocumentPutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePresignedDocumentPutUrlMutation, GraphqlTypes.GeneratePresignedDocumentPutUrlMutationVariables>(GeneratePresignedDocumentPutUrlDocument, options);
      }
export type GeneratePresignedDocumentPutUrlMutationHookResult = ReturnType<typeof useGeneratePresignedDocumentPutUrlMutation>;
export type GeneratePresignedDocumentPutUrlMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePresignedDocumentPutUrlMutation>;
export type GeneratePresignedDocumentPutUrlMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePresignedDocumentPutUrlMutation, GraphqlTypes.GeneratePresignedDocumentPutUrlMutationVariables>;
export const RecordGpApproverDecisionDocument = gql`
    mutation RecordGpApproverDecision($input: RecordApproverDecisionInput!) {
  recordGpApproverDecision(input: $input) {
    bothApproversDecided
    caseAutoClosed
    changeRequest {
      id
      decision
      decisionReason
      primaryResolution
      secondaryResolution
      approverDecisions {
        slot
        decision
        decidedAt
        reason
        resolution
      }
    }
    appliedAdjustments {
      id
      entityId
      valueType
      eumOverrideValue
      totalCommitmentValue
      netCapitalValue
      distributions
      resolution
      resolutionDecidedAt
      changeRequestId
    }
  }
}
    `;
export type RecordGpApproverDecisionMutationFn = Apollo.MutationFunction<GraphqlTypes.RecordGpApproverDecisionMutation, GraphqlTypes.RecordGpApproverDecisionMutationVariables>;

/**
 * __useRecordGpApproverDecisionMutation__
 *
 * To run a mutation, you first call `useRecordGpApproverDecisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordGpApproverDecisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordGpApproverDecisionMutation, { data, loading, error }] = useRecordGpApproverDecisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordGpApproverDecisionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RecordGpApproverDecisionMutation, GraphqlTypes.RecordGpApproverDecisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RecordGpApproverDecisionMutation, GraphqlTypes.RecordGpApproverDecisionMutationVariables>(RecordGpApproverDecisionDocument, options);
      }
export type RecordGpApproverDecisionMutationHookResult = ReturnType<typeof useRecordGpApproverDecisionMutation>;
export type RecordGpApproverDecisionMutationResult = Apollo.MutationResult<GraphqlTypes.RecordGpApproverDecisionMutation>;
export type RecordGpApproverDecisionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RecordGpApproverDecisionMutation, GraphqlTypes.RecordGpApproverDecisionMutationVariables>;
export const ReleaseGpReviewerAssignmentDocument = gql`
    mutation ReleaseGpReviewerAssignment($changeRequestId: UUID!, $slot: ApproverSlot) {
  releaseGpReviewerAssignment(changeRequestId: $changeRequestId, slot: $slot) {
    changeRequest {
      id
      decision
      billingApproverId
      billingApproverName
      csmManagerAssigneeId
      csmManagerAssigneeName
      approverDecisions {
        slot
        decision
        decidedAt
        reason
        resolution
      }
    }
  }
}
    `;
export type ReleaseGpReviewerAssignmentMutationFn = Apollo.MutationFunction<GraphqlTypes.ReleaseGpReviewerAssignmentMutation, GraphqlTypes.ReleaseGpReviewerAssignmentMutationVariables>;

/**
 * __useReleaseGpReviewerAssignmentMutation__
 *
 * To run a mutation, you first call `useReleaseGpReviewerAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseGpReviewerAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseGpReviewerAssignmentMutation, { data, loading, error }] = useReleaseGpReviewerAssignmentMutation({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *      slot: // value for 'slot'
 *   },
 * });
 */
export function useReleaseGpReviewerAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReleaseGpReviewerAssignmentMutation, GraphqlTypes.ReleaseGpReviewerAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReleaseGpReviewerAssignmentMutation, GraphqlTypes.ReleaseGpReviewerAssignmentMutationVariables>(ReleaseGpReviewerAssignmentDocument, options);
      }
export type ReleaseGpReviewerAssignmentMutationHookResult = ReturnType<typeof useReleaseGpReviewerAssignmentMutation>;
export type ReleaseGpReviewerAssignmentMutationResult = Apollo.MutationResult<GraphqlTypes.ReleaseGpReviewerAssignmentMutation>;
export type ReleaseGpReviewerAssignmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReleaseGpReviewerAssignmentMutation, GraphqlTypes.ReleaseGpReviewerAssignmentMutationVariables>;
export const ResolveChangeRequestDocument = gql`
    mutation ResolveChangeRequest($input: ResolveChangeRequestInput!) {
  resolveChangeRequest(input: $input) {
    changeRequest {
      id
      billingCaseId
      decision
      status
      resolution
      assigneeName
      decisionReason
    }
  }
}
    `;
export type ResolveChangeRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.ResolveChangeRequestMutation, GraphqlTypes.ResolveChangeRequestMutationVariables>;

/**
 * __useResolveChangeRequestMutation__
 *
 * To run a mutation, you first call `useResolveChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveChangeRequestMutation, { data, loading, error }] = useResolveChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResolveChangeRequestMutation, GraphqlTypes.ResolveChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResolveChangeRequestMutation, GraphqlTypes.ResolveChangeRequestMutationVariables>(ResolveChangeRequestDocument, options);
      }
export type ResolveChangeRequestMutationHookResult = ReturnType<typeof useResolveChangeRequestMutation>;
export type ResolveChangeRequestMutationResult = Apollo.MutationResult<GraphqlTypes.ResolveChangeRequestMutation>;
export type ResolveChangeRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResolveChangeRequestMutation, GraphqlTypes.ResolveChangeRequestMutationVariables>;
export const SetGpCaseResolutionDocument = gql`
    mutation SetGpCaseResolution($input: SetCaseResolutionInput!) {
  setGpCaseResolution(input: $input) {
    changeRequest {
      id
      decision
      primaryResolution
      secondaryResolution
    }
    appliedAdjustments {
      id
      entityId
      valueType
      eumOverrideValue
      totalCommitmentValue
      netCapitalValue
      distributions
      resolution
      resolutionDecidedAt
      changeRequestId
    }
  }
}
    `;
export type SetGpCaseResolutionMutationFn = Apollo.MutationFunction<GraphqlTypes.SetGpCaseResolutionMutation, GraphqlTypes.SetGpCaseResolutionMutationVariables>;

/**
 * __useSetGpCaseResolutionMutation__
 *
 * To run a mutation, you first call `useSetGpCaseResolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGpCaseResolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGpCaseResolutionMutation, { data, loading, error }] = useSetGpCaseResolutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGpCaseResolutionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetGpCaseResolutionMutation, GraphqlTypes.SetGpCaseResolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetGpCaseResolutionMutation, GraphqlTypes.SetGpCaseResolutionMutationVariables>(SetGpCaseResolutionDocument, options);
      }
export type SetGpCaseResolutionMutationHookResult = ReturnType<typeof useSetGpCaseResolutionMutation>;
export type SetGpCaseResolutionMutationResult = Apollo.MutationResult<GraphqlTypes.SetGpCaseResolutionMutation>;
export type SetGpCaseResolutionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetGpCaseResolutionMutation, GraphqlTypes.SetGpCaseResolutionMutationVariables>;
export const SubmitGpChangeRequestDocument = gql`
    mutation SubmitGpChangeRequest($input: SubmitChangeRequestInput!) {
  submitGpChangeRequest(input: $input) {
    changeRequest {
      id
      clientId
      arenaId
      billingCaseId
      requestType
      decision
      decisionReason
      billingApproverId
      billingApproverName
      csmManagerAssigneeId
      csmManagerAssigneeName
      primaryResolution
      secondaryResolution
      items {
        entityId
        entityName
        changeType
        reasonCode
        justification
        overridePayload {
          eumOverrideValue
          s3DocumentKey
        }
        calcEditPayload {
          totalCommitmentValue
          netCapitalValue
          distributions
          s3DocumentKey
        }
        currentValuesSnapshot {
          effectiveEumValue
          netCapitalValue
          totalCommitmentValue
          distributions
          snapshotTakenAt
        }
      }
      approverDecisions {
        slot
        decision
        decidedAt
        reason
        resolution
      }
    }
  }
}
    `;
export type SubmitGpChangeRequestMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitGpChangeRequestMutation, GraphqlTypes.SubmitGpChangeRequestMutationVariables>;

/**
 * __useSubmitGpChangeRequestMutation__
 *
 * To run a mutation, you first call `useSubmitGpChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGpChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGpChangeRequestMutation, { data, loading, error }] = useSubmitGpChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGpChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitGpChangeRequestMutation, GraphqlTypes.SubmitGpChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitGpChangeRequestMutation, GraphqlTypes.SubmitGpChangeRequestMutationVariables>(SubmitGpChangeRequestDocument, options);
      }
export type SubmitGpChangeRequestMutationHookResult = ReturnType<typeof useSubmitGpChangeRequestMutation>;
export type SubmitGpChangeRequestMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitGpChangeRequestMutation>;
export type SubmitGpChangeRequestMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitGpChangeRequestMutation, GraphqlTypes.SubmitGpChangeRequestMutationVariables>;
export const GetBillingCaseDetailDocument = gql`
    query GetBillingCaseDetail($changeRequestId: UUID!) {
  getCaseDetail(changeRequestId: $changeRequestId) {
    id
    billingCaseId
    familyId
    familyDisplayName
    clientId
    status
    resolution
    assigneeName
    decision
    requestType
    proposedDisplayName
    originalDisplayName
    currentVsProposed {
      currentFeederFunds {
        feederFundId
        name
        action
      }
      proposedAdded {
        feederFundId
        name
        action
        sourceFamilyDisplayName
      }
      proposedRemoved {
        feederFundId
        name
        action
      }
    }
    fccProposedChanges {
      entityId
      entityName
      currentDate
      proposedDate
    }
  }
}
    `;

/**
 * __useGetBillingCaseDetailQuery__
 *
 * To run a query within a React component, call `useGetBillingCaseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingCaseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingCaseDetailQuery({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *   },
 * });
 */
export function useGetBillingCaseDetailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables> & ({ variables: GraphqlTypes.GetBillingCaseDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>(GetBillingCaseDetailDocument, options);
      }
export function useGetBillingCaseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>(GetBillingCaseDetailDocument, options);
        }
// @ts-ignore
export function useGetBillingCaseDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>;
export function useGetBillingCaseDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingCaseDetailQuery | undefined, GraphqlTypes.GetBillingCaseDetailQueryVariables>;
export function useGetBillingCaseDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>(GetBillingCaseDetailDocument, options);
        }
export type GetBillingCaseDetailQueryHookResult = ReturnType<typeof useGetBillingCaseDetailQuery>;
export type GetBillingCaseDetailLazyQueryHookResult = ReturnType<typeof useGetBillingCaseDetailLazyQuery>;
export type GetBillingCaseDetailSuspenseQueryHookResult = ReturnType<typeof useGetBillingCaseDetailSuspenseQuery>;
export type GetBillingCaseDetailQueryResult = Apollo.QueryResult<GraphqlTypes.GetBillingCaseDetailQuery, GraphqlTypes.GetBillingCaseDetailQueryVariables>;
export const GetCaseHistoryDocument = gql`
    query GetCaseHistory($changeRequestId: UUID!, $offset: Int, $limit: Int) {
  getCaseHistory(
    changeRequestId: $changeRequestId
    offset: $offset
    limit: $limit
  ) {
    entries {
      id
      eventType
      changedByName
      changedAt
    }
  }
}
    `;

/**
 * __useGetCaseHistoryQuery__
 *
 * To run a query within a React component, call `useGetCaseHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseHistoryQuery({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCaseHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables> & ({ variables: GraphqlTypes.GetCaseHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>(GetCaseHistoryDocument, options);
      }
export function useGetCaseHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>(GetCaseHistoryDocument, options);
        }
// @ts-ignore
export function useGetCaseHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>;
export function useGetCaseHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseHistoryQuery | undefined, GraphqlTypes.GetCaseHistoryQueryVariables>;
export function useGetCaseHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>(GetCaseHistoryDocument, options);
        }
export type GetCaseHistoryQueryHookResult = ReturnType<typeof useGetCaseHistoryQuery>;
export type GetCaseHistoryLazyQueryHookResult = ReturnType<typeof useGetCaseHistoryLazyQuery>;
export type GetCaseHistorySuspenseQueryHookResult = ReturnType<typeof useGetCaseHistorySuspenseQuery>;
export type GetCaseHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseHistoryQuery, GraphqlTypes.GetCaseHistoryQueryVariables>;
export const GetFamilyHistoryDocument = gql`
    query GetFamilyHistory($familyId: UUID!, $billingCaseId: Int, $offset: Int, $limit: Int) {
  getFamilyHistory(
    familyId: $familyId
    billingCaseId: $billingCaseId
    offset: $offset
    limit: $limit
  ) {
    entries {
      id
      eventType
      changedByName
      changedAt
    }
  }
}
    `;

/**
 * __useGetFamilyHistoryQuery__
 *
 * To run a query within a React component, call `useGetFamilyHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyHistoryQuery({
 *   variables: {
 *      familyId: // value for 'familyId'
 *      billingCaseId: // value for 'billingCaseId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFamilyHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables> & ({ variables: GraphqlTypes.GetFamilyHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>(GetFamilyHistoryDocument, options);
      }
export function useGetFamilyHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>(GetFamilyHistoryDocument, options);
        }
// @ts-ignore
export function useGetFamilyHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>;
export function useGetFamilyHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFamilyHistoryQuery | undefined, GraphqlTypes.GetFamilyHistoryQueryVariables>;
export function useGetFamilyHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>(GetFamilyHistoryDocument, options);
        }
export type GetFamilyHistoryQueryHookResult = ReturnType<typeof useGetFamilyHistoryQuery>;
export type GetFamilyHistoryLazyQueryHookResult = ReturnType<typeof useGetFamilyHistoryLazyQuery>;
export type GetFamilyHistorySuspenseQueryHookResult = ReturnType<typeof useGetFamilyHistorySuspenseQuery>;
export type GetFamilyHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetFamilyHistoryQuery, GraphqlTypes.GetFamilyHistoryQueryVariables>;
export const GetGpBillingReviewersDocument = gql`
    query GetGpBillingReviewers {
  getGpBillingReviewers {
    id
    displayName
  }
}
    `;

/**
 * __useGetGpBillingReviewersQuery__
 *
 * To run a query within a React component, call `useGetGpBillingReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpBillingReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpBillingReviewersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGpBillingReviewersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>(GetGpBillingReviewersDocument, options);
      }
export function useGetGpBillingReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>(GetGpBillingReviewersDocument, options);
        }
// @ts-ignore
export function useGetGpBillingReviewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>;
export function useGetGpBillingReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpBillingReviewersQuery | undefined, GraphqlTypes.GetGpBillingReviewersQueryVariables>;
export function useGetGpBillingReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>(GetGpBillingReviewersDocument, options);
        }
export type GetGpBillingReviewersQueryHookResult = ReturnType<typeof useGetGpBillingReviewersQuery>;
export type GetGpBillingReviewersLazyQueryHookResult = ReturnType<typeof useGetGpBillingReviewersLazyQuery>;
export type GetGpBillingReviewersSuspenseQueryHookResult = ReturnType<typeof useGetGpBillingReviewersSuspenseQuery>;
export type GetGpBillingReviewersQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpBillingReviewersQuery, GraphqlTypes.GetGpBillingReviewersQueryVariables>;
export const GetGpChangeRequestDocument = gql`
    query GetGpChangeRequest($changeRequestId: UUID!) {
  getGpChangeRequest(changeRequestId: $changeRequestId) {
    id
    clientId
    arenaId
    billingCaseId
    requestType
    requestedAt
    requestedById
    decision
    decisionReason
    billingApproverId
    billingApproverName
    csmManagerAssigneeId
    csmManagerAssigneeName
    primaryResolution
    secondaryResolution
    items {
      entityId
      entityName
      changeType
      reasonCode
      justification
      overridePayload {
        eumOverrideValue
        s3DocumentKey
      }
      calcEditPayload {
        totalCommitmentValue
        netCapitalValue
        distributions
        s3DocumentKey
      }
      currentValuesSnapshot {
        effectiveEumValue
        netCapitalValue
        totalCommitmentValue
        distributions
        snapshotTakenAt
      }
    }
    approverDecisions {
      slot
      decision
      decidedAt
      reason
      resolution
    }
  }
}
    `;

/**
 * __useGetGpChangeRequestQuery__
 *
 * To run a query within a React component, call `useGetGpChangeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpChangeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpChangeRequestQuery({
 *   variables: {
 *      changeRequestId: // value for 'changeRequestId'
 *   },
 * });
 */
export function useGetGpChangeRequestQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables> & ({ variables: GraphqlTypes.GetGpChangeRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>(GetGpChangeRequestDocument, options);
      }
export function useGetGpChangeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>(GetGpChangeRequestDocument, options);
        }
// @ts-ignore
export function useGetGpChangeRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>;
export function useGetGpChangeRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpChangeRequestQuery | undefined, GraphqlTypes.GetGpChangeRequestQueryVariables>;
export function useGetGpChangeRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>(GetGpChangeRequestDocument, options);
        }
export type GetGpChangeRequestQueryHookResult = ReturnType<typeof useGetGpChangeRequestQuery>;
export type GetGpChangeRequestLazyQueryHookResult = ReturnType<typeof useGetGpChangeRequestLazyQuery>;
export type GetGpChangeRequestSuspenseQueryHookResult = ReturnType<typeof useGetGpChangeRequestSuspenseQuery>;
export type GetGpChangeRequestQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpChangeRequestQuery, GraphqlTypes.GetGpChangeRequestQueryVariables>;
export const GetGpCsmManagerReviewersDocument = gql`
    query GetGpCsmManagerReviewers {
  getGpCsmManagerReviewers {
    id
    displayName
  }
}
    `;

/**
 * __useGetGpCsmManagerReviewersQuery__
 *
 * To run a query within a React component, call `useGetGpCsmManagerReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpCsmManagerReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpCsmManagerReviewersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGpCsmManagerReviewersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>(GetGpCsmManagerReviewersDocument, options);
      }
export function useGetGpCsmManagerReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>(GetGpCsmManagerReviewersDocument, options);
        }
// @ts-ignore
export function useGetGpCsmManagerReviewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>;
export function useGetGpCsmManagerReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpCsmManagerReviewersQuery | undefined, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>;
export function useGetGpCsmManagerReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>(GetGpCsmManagerReviewersDocument, options);
        }
export type GetGpCsmManagerReviewersQueryHookResult = ReturnType<typeof useGetGpCsmManagerReviewersQuery>;
export type GetGpCsmManagerReviewersLazyQueryHookResult = ReturnType<typeof useGetGpCsmManagerReviewersLazyQuery>;
export type GetGpCsmManagerReviewersSuspenseQueryHookResult = ReturnType<typeof useGetGpCsmManagerReviewersSuspenseQuery>;
export type GetGpCsmManagerReviewersQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpCsmManagerReviewersQuery, GraphqlTypes.GetGpCsmManagerReviewersQueryVariables>;
export const GetGpDocumentDownloadUrlDocument = gql`
    query GetGpDocumentDownloadUrl($input: GetGpDocumentDownloadUrlInput!) {
  getGpDocumentDownloadUrl(input: $input) {
    getUrl
  }
}
    `;

/**
 * __useGetGpDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetGpDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpDocumentDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGpDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>(GetGpDocumentDownloadUrlDocument, options);
      }
export function useGetGpDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>(GetGpDocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetGpDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>;
export function useGetGpDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpDocumentDownloadUrlQuery | undefined, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>;
export function useGetGpDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>(GetGpDocumentDownloadUrlDocument, options);
        }
export type GetGpDocumentDownloadUrlQueryHookResult = ReturnType<typeof useGetGpDocumentDownloadUrlQuery>;
export type GetGpDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetGpDocumentDownloadUrlLazyQuery>;
export type GetGpDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetGpDocumentDownloadUrlSuspenseQuery>;
export type GetGpDocumentDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpDocumentDownloadUrlQuery, GraphqlTypes.GetGpDocumentDownloadUrlQueryVariables>;
export const GetReviewersDocument = gql`
    query GetReviewers {
  getReviewers {
    id
    displayName
  }
}
    `;

/**
 * __useGetReviewersQuery__
 *
 * To run a query within a React component, call `useGetReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReviewersQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>(GetReviewersDocument, options);
      }
export function useGetReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>(GetReviewersDocument, options);
        }
// @ts-ignore
export function useGetReviewersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>;
export function useGetReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReviewersQuery | undefined, GraphqlTypes.GetReviewersQueryVariables>;
export function useGetReviewersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>(GetReviewersDocument, options);
        }
export type GetReviewersQueryHookResult = ReturnType<typeof useGetReviewersQuery>;
export type GetReviewersLazyQueryHookResult = ReturnType<typeof useGetReviewersLazyQuery>;
export type GetReviewersSuspenseQueryHookResult = ReturnType<typeof useGetReviewersSuspenseQuery>;
export type GetReviewersQueryResult = Apollo.QueryResult<GraphqlTypes.GetReviewersQuery, GraphqlTypes.GetReviewersQueryVariables>;
export const GetSafeCaseIdsForClientDocument = gql`
    query GetSafeCaseIdsForClient($clientId: String!, $asOfDate: String!) {
  getSafeCaseIdsForClient(clientId: $clientId, asOfDate: $asOfDate) {
    safeCaseIdOptions {
      label
      value
    }
  }
}
    `;

/**
 * __useGetSafeCaseIdsForClientQuery__
 *
 * To run a query within a React component, call `useGetSafeCaseIdsForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSafeCaseIdsForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSafeCaseIdsForClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetSafeCaseIdsForClientQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables> & ({ variables: GraphqlTypes.GetSafeCaseIdsForClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>(GetSafeCaseIdsForClientDocument, options);
      }
export function useGetSafeCaseIdsForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>(GetSafeCaseIdsForClientDocument, options);
        }
// @ts-ignore
export function useGetSafeCaseIdsForClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>;
export function useGetSafeCaseIdsForClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSafeCaseIdsForClientQuery | undefined, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>;
export function useGetSafeCaseIdsForClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>(GetSafeCaseIdsForClientDocument, options);
        }
export type GetSafeCaseIdsForClientQueryHookResult = ReturnType<typeof useGetSafeCaseIdsForClientQuery>;
export type GetSafeCaseIdsForClientLazyQueryHookResult = ReturnType<typeof useGetSafeCaseIdsForClientLazyQuery>;
export type GetSafeCaseIdsForClientSuspenseQueryHookResult = ReturnType<typeof useGetSafeCaseIdsForClientSuspenseQuery>;
export type GetSafeCaseIdsForClientQueryResult = Apollo.QueryResult<GraphqlTypes.GetSafeCaseIdsForClientQuery, GraphqlTypes.GetSafeCaseIdsForClientQueryVariables>;
export const SearchFundFamiliesDocument = gql`
    query SearchFundFamilies($clientId: Int!) {
  searchFundFamilies(clientId: $clientId) {
    families {
      id
      displayName
      canonicalName
      sfSafeCaseId
    }
  }
}
    `;

/**
 * __useSearchFundFamiliesQuery__
 *
 * To run a query within a React component, call `useSearchFundFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFundFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFundFamiliesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSearchFundFamiliesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables> & ({ variables: GraphqlTypes.SearchFundFamiliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>(SearchFundFamiliesDocument, options);
      }
export function useSearchFundFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>(SearchFundFamiliesDocument, options);
        }
// @ts-ignore
export function useSearchFundFamiliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>;
export function useSearchFundFamiliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SearchFundFamiliesQuery | undefined, GraphqlTypes.SearchFundFamiliesQueryVariables>;
export function useSearchFundFamiliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>(SearchFundFamiliesDocument, options);
        }
export type SearchFundFamiliesQueryHookResult = ReturnType<typeof useSearchFundFamiliesQuery>;
export type SearchFundFamiliesLazyQueryHookResult = ReturnType<typeof useSearchFundFamiliesLazyQuery>;
export type SearchFundFamiliesSuspenseQueryHookResult = ReturnType<typeof useSearchFundFamiliesSuspenseQuery>;
export type SearchFundFamiliesQueryResult = Apollo.QueryResult<GraphqlTypes.SearchFundFamiliesQuery, GraphqlTypes.SearchFundFamiliesQueryVariables>;
export const GetFundFamilyCasesDocument = gql`
    query GetFundFamilyCases($arenaId: Int, $clientId: Int, $decision: FamilyChangeRequestDecision, $filters: [CaseFilter!], $sorts: [CaseSort!], $offset: Int!, $limit: Int!) {
  getFundFamilyCases(
    arenaId: $arenaId
    clientId: $clientId
    decision: $decision
    filters: $filters
    sorts: $sorts
    offset: $offset
    limit: $limit
  ) {
    cases {
      ...FundFamilyCaseDetails
      __typename
    }
    filteredCount
    __typename
  }
}
    ${FundFamilyCaseDetailsFragmentDoc}`;

/**
 * __useGetFundFamilyCasesQuery__
 *
 * To run a query within a React component, call `useGetFundFamilyCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundFamilyCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundFamilyCasesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      clientId: // value for 'clientId'
 *      decision: // value for 'decision'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFundFamilyCasesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables> & ({ variables: GraphqlTypes.GetFundFamilyCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>(GetFundFamilyCasesDocument, options);
      }
export function useGetFundFamilyCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>(GetFundFamilyCasesDocument, options);
        }
// @ts-ignore
export function useGetFundFamilyCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>;
export function useGetFundFamilyCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundFamilyCasesQuery | undefined, GraphqlTypes.GetFundFamilyCasesQueryVariables>;
export function useGetFundFamilyCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>(GetFundFamilyCasesDocument, options);
        }
export type GetFundFamilyCasesQueryHookResult = ReturnType<typeof useGetFundFamilyCasesQuery>;
export type GetFundFamilyCasesLazyQueryHookResult = ReturnType<typeof useGetFundFamilyCasesLazyQuery>;
export type GetFundFamilyCasesSuspenseQueryHookResult = ReturnType<typeof useGetFundFamilyCasesSuspenseQuery>;
export type GetFundFamilyCasesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundFamilyCasesQuery, GraphqlTypes.GetFundFamilyCasesQueryVariables>;
export const CreateAllEntitiesExportDocument = gql`
    mutation CreateAllEntitiesExport($exportType: BillingExportType!, $asOfDate: String!, $filters: [OverviewFilters!]) {
  createEntitiesExport(
    exportType: $exportType
    asOfDate: $asOfDate
    filters: $filters
  ) {
    exportRequestId
    status
    message
  }
}
    `;
export type CreateAllEntitiesExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAllEntitiesExportMutation, GraphqlTypes.CreateAllEntitiesExportMutationVariables>;

/**
 * __useCreateAllEntitiesExportMutation__
 *
 * To run a mutation, you first call `useCreateAllEntitiesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllEntitiesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllEntitiesExportMutation, { data, loading, error }] = useCreateAllEntitiesExportMutation({
 *   variables: {
 *      exportType: // value for 'exportType'
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCreateAllEntitiesExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAllEntitiesExportMutation, GraphqlTypes.CreateAllEntitiesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAllEntitiesExportMutation, GraphqlTypes.CreateAllEntitiesExportMutationVariables>(CreateAllEntitiesExportDocument, options);
      }
export type CreateAllEntitiesExportMutationHookResult = ReturnType<typeof useCreateAllEntitiesExportMutation>;
export type CreateAllEntitiesExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAllEntitiesExportMutation>;
export type CreateAllEntitiesExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAllEntitiesExportMutation, GraphqlTypes.CreateAllEntitiesExportMutationVariables>;
export const CreateFaEntitiesExportDocument = gql`
    mutation CreateFAEntitiesExport($exportType: BillingExportType!, $asOfDate: String!, $filters: [OverviewFilters!], $productLine: [String!]) {
  createEntitiesExport(
    exportType: $exportType
    asOfDate: $asOfDate
    filters: $filters
    productLine: $productLine
  ) {
    exportRequestId
    status
    message
  }
}
    `;
export type CreateFaEntitiesExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateFaEntitiesExportMutation, GraphqlTypes.CreateFaEntitiesExportMutationVariables>;

/**
 * __useCreateFaEntitiesExportMutation__
 *
 * To run a mutation, you first call `useCreateFaEntitiesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaEntitiesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaEntitiesExportMutation, { data, loading, error }] = useCreateFaEntitiesExportMutation({
 *   variables: {
 *      exportType: // value for 'exportType'
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *      productLine: // value for 'productLine'
 *   },
 * });
 */
export function useCreateFaEntitiesExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateFaEntitiesExportMutation, GraphqlTypes.CreateFaEntitiesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateFaEntitiesExportMutation, GraphqlTypes.CreateFaEntitiesExportMutationVariables>(CreateFaEntitiesExportDocument, options);
      }
export type CreateFaEntitiesExportMutationHookResult = ReturnType<typeof useCreateFaEntitiesExportMutation>;
export type CreateFaEntitiesExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateFaEntitiesExportMutation>;
export type CreateFaEntitiesExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateFaEntitiesExportMutation, GraphqlTypes.CreateFaEntitiesExportMutationVariables>;
export const CreateSoftwareEntitiesExportDocument = gql`
    mutation CreateSoftwareEntitiesExport($exportType: BillingExportType!, $asOfDate: String!, $filters: [OverviewFilters!], $productLine: [String!]) {
  createEntitiesExport(
    exportType: $exportType
    asOfDate: $asOfDate
    filters: $filters
    productLine: $productLine
  ) {
    exportRequestId
    status
    message
  }
}
    `;
export type CreateSoftwareEntitiesExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateSoftwareEntitiesExportMutation, GraphqlTypes.CreateSoftwareEntitiesExportMutationVariables>;

/**
 * __useCreateSoftwareEntitiesExportMutation__
 *
 * To run a mutation, you first call `useCreateSoftwareEntitiesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoftwareEntitiesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoftwareEntitiesExportMutation, { data, loading, error }] = useCreateSoftwareEntitiesExportMutation({
 *   variables: {
 *      exportType: // value for 'exportType'
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *      productLine: // value for 'productLine'
 *   },
 * });
 */
export function useCreateSoftwareEntitiesExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateSoftwareEntitiesExportMutation, GraphqlTypes.CreateSoftwareEntitiesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateSoftwareEntitiesExportMutation, GraphqlTypes.CreateSoftwareEntitiesExportMutationVariables>(CreateSoftwareEntitiesExportDocument, options);
      }
export type CreateSoftwareEntitiesExportMutationHookResult = ReturnType<typeof useCreateSoftwareEntitiesExportMutation>;
export type CreateSoftwareEntitiesExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateSoftwareEntitiesExportMutation>;
export type CreateSoftwareEntitiesExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateSoftwareEntitiesExportMutation, GraphqlTypes.CreateSoftwareEntitiesExportMutationVariables>;
export const GetOverviewDataDocument = gql`
    query GetOverviewData($asOfDate: String!, $offset: Int, $limit: Int, $filters: [OverviewFilters!], $sorts: [OverviewSort!]) {
  getGpxData(
    asOfDate: $asOfDate
    offset: $offset
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    filteredCount
    rows {
      ...GpxClienteDetails
      __typename
    }
    __typename
  }
}
    ${GpxClienteDetailsFragmentDoc}`;

/**
 * __useGetOverviewDataQuery__
 *
 * To run a query within a React component, call `useGetOverviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOverviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOverviewDataQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useGetOverviewDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables> & ({ variables: GraphqlTypes.GetOverviewDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>(GetOverviewDataDocument, options);
      }
export function useGetOverviewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>(GetOverviewDataDocument, options);
        }
// @ts-ignore
export function useGetOverviewDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>;
export function useGetOverviewDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOverviewDataQuery | undefined, GraphqlTypes.GetOverviewDataQueryVariables>;
export function useGetOverviewDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>(GetOverviewDataDocument, options);
        }
export type GetOverviewDataQueryHookResult = ReturnType<typeof useGetOverviewDataQuery>;
export type GetOverviewDataLazyQueryHookResult = ReturnType<typeof useGetOverviewDataLazyQuery>;
export type GetOverviewDataSuspenseQueryHookResult = ReturnType<typeof useGetOverviewDataSuspenseQuery>;
export type GetOverviewDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetOverviewDataQuery, GraphqlTypes.GetOverviewDataQueryVariables>;
export const GetBillingExportDocument = gql`
    query GetBillingExport($exportId: UUID!) {
  getBillingExport(exportId: $exportId) {
    id
    exportType
    s3Path
    status
    errorMessage
    info
  }
}
    `;

/**
 * __useGetBillingExportQuery__
 *
 * To run a query within a React component, call `useGetBillingExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingExportQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetBillingExportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables> & ({ variables: GraphqlTypes.GetBillingExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>(GetBillingExportDocument, options);
      }
export function useGetBillingExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>(GetBillingExportDocument, options);
        }
// @ts-ignore
export function useGetBillingExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>;
export function useGetBillingExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingExportQuery | undefined, GraphqlTypes.GetBillingExportQueryVariables>;
export function useGetBillingExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>(GetBillingExportDocument, options);
        }
export type GetBillingExportQueryHookResult = ReturnType<typeof useGetBillingExportQuery>;
export type GetBillingExportLazyQueryHookResult = ReturnType<typeof useGetBillingExportLazyQuery>;
export type GetBillingExportSuspenseQueryHookResult = ReturnType<typeof useGetBillingExportSuspenseQuery>;
export type GetBillingExportQueryResult = Apollo.QueryResult<GraphqlTypes.GetBillingExportQuery, GraphqlTypes.GetBillingExportQueryVariables>;
export const CreateBillingClientOverviewExportDocument = gql`
    mutation CreateBillingClientOverviewExport($asOfDate: String!, $filters: [OverviewFilters!] = null, $sorts: [OverviewSort!] = null) {
  createBillingClientOverviewExport(
    asOfDate: $asOfDate
    filters: $filters
    sorts: $sorts
  )
}
    `;
export type CreateBillingClientOverviewExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateBillingClientOverviewExportMutation, GraphqlTypes.CreateBillingClientOverviewExportMutationVariables>;

/**
 * __useCreateBillingClientOverviewExportMutation__
 *
 * To run a mutation, you first call `useCreateBillingClientOverviewExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingClientOverviewExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingClientOverviewExportMutation, { data, loading, error }] = useCreateBillingClientOverviewExportMutation({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useCreateBillingClientOverviewExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateBillingClientOverviewExportMutation, GraphqlTypes.CreateBillingClientOverviewExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateBillingClientOverviewExportMutation, GraphqlTypes.CreateBillingClientOverviewExportMutationVariables>(CreateBillingClientOverviewExportDocument, options);
      }
export type CreateBillingClientOverviewExportMutationHookResult = ReturnType<typeof useCreateBillingClientOverviewExportMutation>;
export type CreateBillingClientOverviewExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateBillingClientOverviewExportMutation>;
export type CreateBillingClientOverviewExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateBillingClientOverviewExportMutation, GraphqlTypes.CreateBillingClientOverviewExportMutationVariables>;
export const GetClientEntityHierarchyDocument = gql`
    query GetClientEntityHierarchy($clientId: String!, $asOfDate: String!) {
  getClientEntityHierarchy(clientId: $clientId, asOfDate: $asOfDate) {
    clientId
    softwareEumUsd
    billableFaEumUsd
    billingGroups {
      billingGroupId
      billingGroupName
      entities {
        entityId
        entityName
        productLine
        eumValue
        fundFamilyTrace
      }
    }
  }
}
    `;

/**
 * __useGetClientEntityHierarchyQuery__
 *
 * To run a query within a React component, call `useGetClientEntityHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientEntityHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientEntityHierarchyQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetClientEntityHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables> & ({ variables: GraphqlTypes.GetClientEntityHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>(GetClientEntityHierarchyDocument, options);
      }
export function useGetClientEntityHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>(GetClientEntityHierarchyDocument, options);
        }
// @ts-ignore
export function useGetClientEntityHierarchySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>;
export function useGetClientEntityHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientEntityHierarchyQuery | undefined, GraphqlTypes.GetClientEntityHierarchyQueryVariables>;
export function useGetClientEntityHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>(GetClientEntityHierarchyDocument, options);
        }
export type GetClientEntityHierarchyQueryHookResult = ReturnType<typeof useGetClientEntityHierarchyQuery>;
export type GetClientEntityHierarchyLazyQueryHookResult = ReturnType<typeof useGetClientEntityHierarchyLazyQuery>;
export type GetClientEntityHierarchySuspenseQueryHookResult = ReturnType<typeof useGetClientEntityHierarchySuspenseQuery>;
export type GetClientEntityHierarchyQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientEntityHierarchyQuery, GraphqlTypes.GetClientEntityHierarchyQueryVariables>;
export const GetClientEntitiesByBillingGroupDocument = gql`
    query GetClientEntitiesByBillingGroup($clientId: String!, $asOfDate: String!, $groupKeys: [String!]!, $filters: [ClientArenaFilter!], $sorts: [ClientArenaSort!], $offset: Int, $limit: Int) {
  getClientEntitiesByBillingGroup(
    clientId: $clientId
    asOfDate: $asOfDate
    groupKeys: $groupKeys
    filters: $filters
    sorts: $sorts
    offset: $offset
    limit: $limit
  ) {
    billingGroups {
      billingGroupId
      billingGroupName
      softwareEumUsd
      billableFaEumUsd
      childCount
      activeInvestments
    }
    entities {
      entity
      entityId
      customerLegalName
      jsqProductLine
      sfdcEntityId
      faEntityType
      faEumType
      faFundFamily
      serviceStartDate
      serviceEndDate
      billingStatus
      entityStatus
      currency
      positionCount
      fxRate
      positionCountOfActiveInvestors
      commitmentsLocal
      commitmentsUsd
      contributionsLocal
      contributionsUsd
      redemptionsLocal
      redemptionsUsd
      distributionsLocal
      distributionsUsd
      returnOfCapitalLocal
      returnOfCapitalUsd
      billableFaEumLocal
      billableFaEumUsd
      flatFeeRate
      countAchPayments
      countWirePayments
      countCheckPayments
      currentBlendSoftwareEumLocal
      currentBlendSoftwareEumUsd
      showSpinner
      firstCapitalCallDate
      safeCaseId
      faEntityNumber
      feeBasis
      activeInvestments
      discountedEumUsd
      __typename
    }
    totalCount
  }
}
    `;

/**
 * __useGetClientEntitiesByBillingGroupQuery__
 *
 * To run a query within a React component, call `useGetClientEntitiesByBillingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientEntitiesByBillingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientEntitiesByBillingGroupQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      asOfDate: // value for 'asOfDate'
 *      groupKeys: // value for 'groupKeys'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClientEntitiesByBillingGroupQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables> & ({ variables: GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>(GetClientEntitiesByBillingGroupDocument, options);
      }
export function useGetClientEntitiesByBillingGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>(GetClientEntitiesByBillingGroupDocument, options);
        }
// @ts-ignore
export function useGetClientEntitiesByBillingGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>;
export function useGetClientEntitiesByBillingGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientEntitiesByBillingGroupQuery | undefined, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>;
export function useGetClientEntitiesByBillingGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>(GetClientEntitiesByBillingGroupDocument, options);
        }
export type GetClientEntitiesByBillingGroupQueryHookResult = ReturnType<typeof useGetClientEntitiesByBillingGroupQuery>;
export type GetClientEntitiesByBillingGroupLazyQueryHookResult = ReturnType<typeof useGetClientEntitiesByBillingGroupLazyQuery>;
export type GetClientEntitiesByBillingGroupSuspenseQueryHookResult = ReturnType<typeof useGetClientEntitiesByBillingGroupSuspenseQuery>;
export type GetClientEntitiesByBillingGroupQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientEntitiesByBillingGroupQuery, GraphqlTypes.GetClientEntitiesByBillingGroupQueryVariables>;
export const GetClientDataDocument = gql`
    query GetClientData($clientId: String!, $asOfDate: String!) {
  getClientData(clientId: $clientId, asOfDate: $asOfDate) {
    clientArena {
      clientName
      clientId
      arenaId
      edition
      baseEumUsd
      billableFaEumLocal
      billableFaEumUsd
      totalPayments
      accountManager
      customerSuccessManager
      renewalDate
      deploymentDate
      contractStartDate
      currentBlendSoftwareEumLocal
      currentBlendSoftwareEumUsd
      showSpinner
      __typename
    }
    quickLinks {
      name
      url
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetClientDataQuery__
 *
 * To run a query within a React component, call `useGetClientDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDataQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetClientDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables> & ({ variables: GraphqlTypes.GetClientDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>(GetClientDataDocument, options);
      }
export function useGetClientDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>(GetClientDataDocument, options);
        }
// @ts-ignore
export function useGetClientDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>;
export function useGetClientDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientDataQuery | undefined, GraphqlTypes.GetClientDataQueryVariables>;
export function useGetClientDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>(GetClientDataDocument, options);
        }
export type GetClientDataQueryHookResult = ReturnType<typeof useGetClientDataQuery>;
export type GetClientDataLazyQueryHookResult = ReturnType<typeof useGetClientDataLazyQuery>;
export type GetClientDataSuspenseQueryHookResult = ReturnType<typeof useGetClientDataSuspenseQuery>;
export type GetClientDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientDataQuery, GraphqlTypes.GetClientDataQueryVariables>;
export const GetClientEntitiesDocument = gql`
    query GetClientEntities($clientId: String!, $asOfDate: String!, $filters: [ClientArenaFilter!] = null, $sorts: [ClientArenaSort!] = null, $offset: Int, $limit: Int) {
  getClientEntities(
    clientId: $clientId
    asOfDate: $asOfDate
    filters: $filters
    sorts: $sorts
    offset: $offset
    limit: $limit
  ) {
    entities {
      entity
      entityId
      customerLegalName
      jsqProductLine
      sfdcEntityId
      faEntityType
      faEumType
      faFundFamily
      serviceStartDate
      serviceEndDate
      billingStatus
      entityStatus
      currency
      positionCount
      fxRate
      positionCountOfActiveInvestors
      commitmentsLocal
      commitmentsUsd
      contributionsLocal
      contributionsUsd
      redemptionsLocal
      redemptionsUsd
      distributionsLocal
      distributionsUsd
      returnOfCapitalLocal
      returnOfCapitalUsd
      billableFaEumLocal
      billableFaEumUsd
      flatFeeRate
      countAchPayments
      countWirePayments
      countCheckPayments
      currentBlendSoftwareEumLocal
      currentBlendSoftwareEumUsd
      showSpinner
      firstCapitalCallDate
      safeCaseId
      faEntityNumber
      feeBasis
      activeInvestments
      __typename
    }
    filteredCount
    __typename
  }
}
    `;

/**
 * __useGetClientEntitiesQuery__
 *
 * To run a query within a React component, call `useGetClientEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientEntitiesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClientEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetClientEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>(GetClientEntitiesDocument, options);
      }
export function useGetClientEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>(GetClientEntitiesDocument, options);
        }
// @ts-ignore
export function useGetClientEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>;
export function useGetClientEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientEntitiesQuery | undefined, GraphqlTypes.GetClientEntitiesQueryVariables>;
export function useGetClientEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>(GetClientEntitiesDocument, options);
        }
export type GetClientEntitiesQueryHookResult = ReturnType<typeof useGetClientEntitiesQuery>;
export type GetClientEntitiesLazyQueryHookResult = ReturnType<typeof useGetClientEntitiesLazyQuery>;
export type GetClientEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetClientEntitiesSuspenseQuery>;
export type GetClientEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientEntitiesQuery, GraphqlTypes.GetClientEntitiesQueryVariables>;
export const CreateBillingClientArenaExportDocument = gql`
    mutation CreateBillingClientArenaExport($clientId: String!, $asOfDate: String!, $filters: [ClientArenaFilter!] = null, $sorts: [ClientArenaSort!] = null) {
  createBillingClientArenaExport(
    clientId: $clientId
    asOfDate: $asOfDate
    filters: $filters
    sorts: $sorts
  )
}
    `;
export type CreateBillingClientArenaExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateBillingClientArenaExportMutation, GraphqlTypes.CreateBillingClientArenaExportMutationVariables>;

/**
 * __useCreateBillingClientArenaExportMutation__
 *
 * To run a mutation, you first call `useCreateBillingClientArenaExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingClientArenaExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingClientArenaExportMutation, { data, loading, error }] = useCreateBillingClientArenaExportMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useCreateBillingClientArenaExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateBillingClientArenaExportMutation, GraphqlTypes.CreateBillingClientArenaExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateBillingClientArenaExportMutation, GraphqlTypes.CreateBillingClientArenaExportMutationVariables>(CreateBillingClientArenaExportDocument, options);
      }
export type CreateBillingClientArenaExportMutationHookResult = ReturnType<typeof useCreateBillingClientArenaExportMutation>;
export type CreateBillingClientArenaExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateBillingClientArenaExportMutation>;
export type CreateBillingClientArenaExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateBillingClientArenaExportMutation, GraphqlTypes.CreateBillingClientArenaExportMutationVariables>;
export const UpdateEntityStatusDocument = gql`
    mutation UpdateEntityStatus($input: EntityStatusUpdateInput!) {
  updateEntityStatus(input: $input) {
    id
    name
    arenaId
    status
    billingRecordCreated
  }
}
    `;
export type UpdateEntityStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEntityStatusMutation, GraphqlTypes.UpdateEntityStatusMutationVariables>;

/**
 * __useUpdateEntityStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEntityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityStatusMutation, { data, loading, error }] = useUpdateEntityStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEntityStatusMutation, GraphqlTypes.UpdateEntityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEntityStatusMutation, GraphqlTypes.UpdateEntityStatusMutationVariables>(UpdateEntityStatusDocument, options);
      }
export type UpdateEntityStatusMutationHookResult = ReturnType<typeof useUpdateEntityStatusMutation>;
export type UpdateEntityStatusMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEntityStatusMutation>;
export type UpdateEntityStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEntityStatusMutation, GraphqlTypes.UpdateEntityStatusMutationVariables>;
export const GetBillingUserGridViewDocument = gql`
    query GetBillingUserGridView($gridName: BillingUserGridName!) {
  getBillingUserGridView(gridName: $gridName) {
    id
    configuration
  }
}
    `;

/**
 * __useGetBillingUserGridViewQuery__
 *
 * To run a query within a React component, call `useGetBillingUserGridViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingUserGridViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingUserGridViewQuery({
 *   variables: {
 *      gridName: // value for 'gridName'
 *   },
 * });
 */
export function useGetBillingUserGridViewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables> & ({ variables: GraphqlTypes.GetBillingUserGridViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>(GetBillingUserGridViewDocument, options);
      }
export function useGetBillingUserGridViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>(GetBillingUserGridViewDocument, options);
        }
// @ts-ignore
export function useGetBillingUserGridViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>;
export function useGetBillingUserGridViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBillingUserGridViewQuery | undefined, GraphqlTypes.GetBillingUserGridViewQueryVariables>;
export function useGetBillingUserGridViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>(GetBillingUserGridViewDocument, options);
        }
export type GetBillingUserGridViewQueryHookResult = ReturnType<typeof useGetBillingUserGridViewQuery>;
export type GetBillingUserGridViewLazyQueryHookResult = ReturnType<typeof useGetBillingUserGridViewLazyQuery>;
export type GetBillingUserGridViewSuspenseQueryHookResult = ReturnType<typeof useGetBillingUserGridViewSuspenseQuery>;
export type GetBillingUserGridViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetBillingUserGridViewQuery, GraphqlTypes.GetBillingUserGridViewQueryVariables>;
export const CreateBillingUserGridViewDocument = gql`
    mutation CreateBillingUserGridView($input: CreateUserGridViewInput!) {
  createBillingUserGridView(input: $input) {
    id
    configuration
  }
}
    `;
export type CreateBillingUserGridViewMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateBillingUserGridViewMutation, GraphqlTypes.CreateBillingUserGridViewMutationVariables>;

/**
 * __useCreateBillingUserGridViewMutation__
 *
 * To run a mutation, you first call `useCreateBillingUserGridViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingUserGridViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingUserGridViewMutation, { data, loading, error }] = useCreateBillingUserGridViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillingUserGridViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateBillingUserGridViewMutation, GraphqlTypes.CreateBillingUserGridViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateBillingUserGridViewMutation, GraphqlTypes.CreateBillingUserGridViewMutationVariables>(CreateBillingUserGridViewDocument, options);
      }
export type CreateBillingUserGridViewMutationHookResult = ReturnType<typeof useCreateBillingUserGridViewMutation>;
export type CreateBillingUserGridViewMutationResult = Apollo.MutationResult<GraphqlTypes.CreateBillingUserGridViewMutation>;
export type CreateBillingUserGridViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateBillingUserGridViewMutation, GraphqlTypes.CreateBillingUserGridViewMutationVariables>;
export const GetGroupedEntitiesDocument = gql`
    query GetGroupedEntities($asOfDate: String!, $groupKeys: [String!]!, $filters: [ClientArenaFilter!], $sorts: [ClientArenaSort!], $offset: Int, $limit: Int) {
  getGroupedEntities(
    asOfDate: $asOfDate
    groupKeys: $groupKeys
    filters: $filters
    sorts: $sorts
    offset: $offset
    limit: $limit
  ) {
    rows {
      clientId
      clientName
      billingGroupId
      billingGroupName
      entityId
      entityName
      type
      softwareEumUsd
      billableFaEumUsd
      jsqProductLine
      billingStatus
      hasWarning
      childCount
    }
    totalCount
  }
}
    `;

/**
 * __useGetGroupedEntitiesQuery__
 *
 * To run a query within a React component, call `useGetGroupedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupedEntitiesQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *      groupKeys: // value for 'groupKeys'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGroupedEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetGroupedEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>(GetGroupedEntitiesDocument, options);
      }
export function useGetGroupedEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>(GetGroupedEntitiesDocument, options);
        }
// @ts-ignore
export function useGetGroupedEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>;
export function useGetGroupedEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGroupedEntitiesQuery | undefined, GraphqlTypes.GetGroupedEntitiesQueryVariables>;
export function useGetGroupedEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>(GetGroupedEntitiesDocument, options);
        }
export type GetGroupedEntitiesQueryHookResult = ReturnType<typeof useGetGroupedEntitiesQuery>;
export type GetGroupedEntitiesLazyQueryHookResult = ReturnType<typeof useGetGroupedEntitiesLazyQuery>;
export type GetGroupedEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetGroupedEntitiesSuspenseQuery>;
export type GetGroupedEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetGroupedEntitiesQuery, GraphqlTypes.GetGroupedEntitiesQueryVariables>;
export const GetUnassignedEntitiesDocument = gql`
    query GetUnassignedEntities($asOfDate: String!, $filters: [ClientArenaFilter!], $sorts: [ClientArenaSort!], $offset: Int, $limit: Int) {
  getUnassignedEntities(
    asOfDate: $asOfDate
    filters: $filters
    sorts: $sorts
    offset: $offset
    limit: $limit
  ) {
    entities {
      entityId
      entityName
      softwareEumUsd
      billableFaEumUsd
      jsqProductLine
      billingStatus
    }
    filteredCount
  }
}
    `;

/**
 * __useGetUnassignedEntitiesQuery__
 *
 * To run a query within a React component, call `useGetUnassignedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnassignedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnassignedEntitiesQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUnassignedEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetUnassignedEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>(GetUnassignedEntitiesDocument, options);
      }
export function useGetUnassignedEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>(GetUnassignedEntitiesDocument, options);
        }
// @ts-ignore
export function useGetUnassignedEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>;
export function useGetUnassignedEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUnassignedEntitiesQuery | undefined, GraphqlTypes.GetUnassignedEntitiesQueryVariables>;
export function useGetUnassignedEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>(GetUnassignedEntitiesDocument, options);
        }
export type GetUnassignedEntitiesQueryHookResult = ReturnType<typeof useGetUnassignedEntitiesQuery>;
export type GetUnassignedEntitiesLazyQueryHookResult = ReturnType<typeof useGetUnassignedEntitiesLazyQuery>;
export type GetUnassignedEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetUnassignedEntitiesSuspenseQuery>;
export type GetUnassignedEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetUnassignedEntitiesQuery, GraphqlTypes.GetUnassignedEntitiesQueryVariables>;
export const FinalizePositionImportTaskDocument = gql`
    query FinalizePositionImportTask($arenaId: ID!, $jobId: ID!) {
  positionImportTask(arenaId: $arenaId, jobId: $jobId) {
    spreadsheet {
      headers
      rows {
        cells {
          value
          isValid
          errorMessage
        }
        rowIndex
      }
      status
    }
    summary {
      positionsCreated
      accountsCreated
      errorMessage
      warnings
    }
  }
}
    `;

/**
 * __useFinalizePositionImportTaskQuery__
 *
 * To run a query within a React component, call `useFinalizePositionImportTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinalizePositionImportTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinalizePositionImportTaskQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useFinalizePositionImportTaskQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables> & ({ variables: GraphqlTypes.FinalizePositionImportTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>(FinalizePositionImportTaskDocument, options);
      }
export function useFinalizePositionImportTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>(FinalizePositionImportTaskDocument, options);
        }
// @ts-ignore
export function useFinalizePositionImportTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>;
export function useFinalizePositionImportTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FinalizePositionImportTaskQuery | undefined, GraphqlTypes.FinalizePositionImportTaskQueryVariables>;
export function useFinalizePositionImportTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>(FinalizePositionImportTaskDocument, options);
        }
export type FinalizePositionImportTaskQueryHookResult = ReturnType<typeof useFinalizePositionImportTaskQuery>;
export type FinalizePositionImportTaskLazyQueryHookResult = ReturnType<typeof useFinalizePositionImportTaskLazyQuery>;
export type FinalizePositionImportTaskSuspenseQueryHookResult = ReturnType<typeof useFinalizePositionImportTaskSuspenseQuery>;
export type FinalizePositionImportTaskQueryResult = Apollo.QueryResult<GraphqlTypes.FinalizePositionImportTaskQuery, GraphqlTypes.FinalizePositionImportTaskQueryVariables>;
export const UploadBulkPositionCreationDocument = gql`
    mutation UploadBulkPositionCreation($arenaId: ID!, $entityId: ID!, $fileUuid: String!, $dryRun: Boolean!) {
  importBulkPositions(
    arenaId: $arenaId
    entityId: $entityId
    fileUuid: $fileUuid
    dryRun: $dryRun
  ) {
    job {
      id
    }
  }
}
    `;
export type UploadBulkPositionCreationMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadBulkPositionCreationMutation, GraphqlTypes.UploadBulkPositionCreationMutationVariables>;

/**
 * __useUploadBulkPositionCreationMutation__
 *
 * To run a mutation, you first call `useUploadBulkPositionCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBulkPositionCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBulkPositionCreationMutation, { data, loading, error }] = useUploadBulkPositionCreationMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      fileUuid: // value for 'fileUuid'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useUploadBulkPositionCreationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadBulkPositionCreationMutation, GraphqlTypes.UploadBulkPositionCreationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadBulkPositionCreationMutation, GraphqlTypes.UploadBulkPositionCreationMutationVariables>(UploadBulkPositionCreationDocument, options);
      }
export type UploadBulkPositionCreationMutationHookResult = ReturnType<typeof useUploadBulkPositionCreationMutation>;
export type UploadBulkPositionCreationMutationResult = Apollo.MutationResult<GraphqlTypes.UploadBulkPositionCreationMutation>;
export type UploadBulkPositionCreationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadBulkPositionCreationMutation, GraphqlTypes.UploadBulkPositionCreationMutationVariables>;
export const RevokeExternalSsoDocument = gql`
    mutation RevokeExternalSso($revokeSsoTicketInput: RevokeExternalSSOTicketInput!) {
  revokeExternalSso(revokeSsoTicketInput: $revokeSsoTicketInput) {
    __typename
    ... on MutationSuccessResponse {
      didSucceed
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type RevokeExternalSsoMutationFn = Apollo.MutationFunction<GraphqlTypes.RevokeExternalSsoMutation, GraphqlTypes.RevokeExternalSsoMutationVariables>;

/**
 * __useRevokeExternalSsoMutation__
 *
 * To run a mutation, you first call `useRevokeExternalSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeExternalSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeExternalSsoMutation, { data, loading, error }] = useRevokeExternalSsoMutation({
 *   variables: {
 *      revokeSsoTicketInput: // value for 'revokeSsoTicketInput'
 *   },
 * });
 */
export function useRevokeExternalSsoMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RevokeExternalSsoMutation, GraphqlTypes.RevokeExternalSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RevokeExternalSsoMutation, GraphqlTypes.RevokeExternalSsoMutationVariables>(RevokeExternalSsoDocument, options);
      }
export type RevokeExternalSsoMutationHookResult = ReturnType<typeof useRevokeExternalSsoMutation>;
export type RevokeExternalSsoMutationResult = Apollo.MutationResult<GraphqlTypes.RevokeExternalSsoMutation>;
export type RevokeExternalSsoMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RevokeExternalSsoMutation, GraphqlTypes.RevokeExternalSsoMutationVariables>;
export const UnblockFromBruteForceProtectionDocument = gql`
    mutation UnblockFromBruteForceProtection($objectInput: UnblockFromBruteForceProtectionInput!) {
  unblockFromBruteForceProtection(objectInput: $objectInput) {
    __typename
    ... on MutationErrorResponse {
      message
      errorCode
    }
    ... on MutationSuccessResponse {
      didSucceed
    }
  }
}
    `;
export type UnblockFromBruteForceProtectionMutationFn = Apollo.MutationFunction<GraphqlTypes.UnblockFromBruteForceProtectionMutation, GraphqlTypes.UnblockFromBruteForceProtectionMutationVariables>;

/**
 * __useUnblockFromBruteForceProtectionMutation__
 *
 * To run a mutation, you first call `useUnblockFromBruteForceProtectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockFromBruteForceProtectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockFromBruteForceProtectionMutation, { data, loading, error }] = useUnblockFromBruteForceProtectionMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUnblockFromBruteForceProtectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnblockFromBruteForceProtectionMutation, GraphqlTypes.UnblockFromBruteForceProtectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnblockFromBruteForceProtectionMutation, GraphqlTypes.UnblockFromBruteForceProtectionMutationVariables>(UnblockFromBruteForceProtectionDocument, options);
      }
export type UnblockFromBruteForceProtectionMutationHookResult = ReturnType<typeof useUnblockFromBruteForceProtectionMutation>;
export type UnblockFromBruteForceProtectionMutationResult = Apollo.MutationResult<GraphqlTypes.UnblockFromBruteForceProtectionMutation>;
export type UnblockFromBruteForceProtectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnblockFromBruteForceProtectionMutation, GraphqlTypes.UnblockFromBruteForceProtectionMutationVariables>;
export const ResetUserTwoFaDocument = gql`
    mutation ResetUserTwoFa($input: ResetUserTwoFaInput!) {
  resetUserTwoFa(objectInput: $input) {
    user {
      id
      twoFaEnabled
      twoFaPhoneNumber
      twoFaEmailAddress
      currentTwoFaMethods
    }
  }
}
    `;
export type ResetUserTwoFaMutationFn = Apollo.MutationFunction<GraphqlTypes.ResetUserTwoFaMutation, GraphqlTypes.ResetUserTwoFaMutationVariables>;

/**
 * __useResetUserTwoFaMutation__
 *
 * To run a mutation, you first call `useResetUserTwoFaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserTwoFaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserTwoFaMutation, { data, loading, error }] = useResetUserTwoFaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserTwoFaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResetUserTwoFaMutation, GraphqlTypes.ResetUserTwoFaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResetUserTwoFaMutation, GraphqlTypes.ResetUserTwoFaMutationVariables>(ResetUserTwoFaDocument, options);
      }
export type ResetUserTwoFaMutationHookResult = ReturnType<typeof useResetUserTwoFaMutation>;
export type ResetUserTwoFaMutationResult = Apollo.MutationResult<GraphqlTypes.ResetUserTwoFaMutation>;
export type ResetUserTwoFaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResetUserTwoFaMutation, GraphqlTypes.ResetUserTwoFaMutationVariables>;
export const StartCoBrowseSessionDocument = gql`
    mutation StartCoBrowseSession($input: InitiateCoBrowseInput!) {
  startCobrowseSession(objectInput: $input) {
    success
    errorMsg
    watchUrl
  }
}
    `;
export type StartCoBrowseSessionMutationFn = Apollo.MutationFunction<GraphqlTypes.StartCoBrowseSessionMutation, GraphqlTypes.StartCoBrowseSessionMutationVariables>;

/**
 * __useStartCoBrowseSessionMutation__
 *
 * To run a mutation, you first call `useStartCoBrowseSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCoBrowseSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCoBrowseSessionMutation, { data, loading, error }] = useStartCoBrowseSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCoBrowseSessionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartCoBrowseSessionMutation, GraphqlTypes.StartCoBrowseSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartCoBrowseSessionMutation, GraphqlTypes.StartCoBrowseSessionMutationVariables>(StartCoBrowseSessionDocument, options);
      }
export type StartCoBrowseSessionMutationHookResult = ReturnType<typeof useStartCoBrowseSessionMutation>;
export type StartCoBrowseSessionMutationResult = Apollo.MutationResult<GraphqlTypes.StartCoBrowseSessionMutation>;
export type StartCoBrowseSessionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartCoBrowseSessionMutation, GraphqlTypes.StartCoBrowseSessionMutationVariables>;
export const SetComplianceProgramDocument = gql`
    mutation setComplianceProgram($arenaId: ID!, $entityId: ID!, $programString: String!) {
  setComplianceProgram(
    arenaId: $arenaId
    entityId: $entityId
    programString: $programString
  ) {
    ... on AccountObjectType {
      id
    }
  }
}
    `;
export type SetComplianceProgramMutationFn = Apollo.MutationFunction<GraphqlTypes.SetComplianceProgramMutation, GraphqlTypes.SetComplianceProgramMutationVariables>;

/**
 * __useSetComplianceProgramMutation__
 *
 * To run a mutation, you first call `useSetComplianceProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetComplianceProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setComplianceProgramMutation, { data, loading, error }] = useSetComplianceProgramMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      programString: // value for 'programString'
 *   },
 * });
 */
export function useSetComplianceProgramMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetComplianceProgramMutation, GraphqlTypes.SetComplianceProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetComplianceProgramMutation, GraphqlTypes.SetComplianceProgramMutationVariables>(SetComplianceProgramDocument, options);
      }
export type SetComplianceProgramMutationHookResult = ReturnType<typeof useSetComplianceProgramMutation>;
export type SetComplianceProgramMutationResult = Apollo.MutationResult<GraphqlTypes.SetComplianceProgramMutation>;
export type SetComplianceProgramMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetComplianceProgramMutation, GraphqlTypes.SetComplianceProgramMutationVariables>;
export const EnableComplianceDocument = gql`
    mutation enableCompliance($arenaId: ID!, $entityId: ID!, $enable: Boolean!) {
  enableCompliance(arenaId: $arenaId, entityId: $entityId, enable: $enable) {
    ... on AccountObjectType {
      id
    }
  }
}
    `;
export type EnableComplianceMutationFn = Apollo.MutationFunction<GraphqlTypes.EnableComplianceMutation, GraphqlTypes.EnableComplianceMutationVariables>;

/**
 * __useEnableComplianceMutation__
 *
 * To run a mutation, you first call `useEnableComplianceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableComplianceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableComplianceMutation, { data, loading, error }] = useEnableComplianceMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useEnableComplianceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EnableComplianceMutation, GraphqlTypes.EnableComplianceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EnableComplianceMutation, GraphqlTypes.EnableComplianceMutationVariables>(EnableComplianceDocument, options);
      }
export type EnableComplianceMutationHookResult = ReturnType<typeof useEnableComplianceMutation>;
export type EnableComplianceMutationResult = Apollo.MutationResult<GraphqlTypes.EnableComplianceMutation>;
export type EnableComplianceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EnableComplianceMutation, GraphqlTypes.EnableComplianceMutationVariables>;
export const GetFilteredEntitiesDocument = gql`
    query GetFilteredEntities($filters: EntitiesFilters, $sorts: [EntitiesSort], $offset: Int, $limit: Int) {
  investmentEntitiesForProgramAssignment(
    filters: $filters
    sorts: $sorts
    offset: $offset
    limit: $limit
  ) {
    rows {
      name
      id
      arenaId
      arena {
        id
        name
      }
      complianceSettings {
        complianceProgram
        enabled
      }
      isInvestorDiligenceEnabled
    }
    totalCount
    filteredCount
  }
}
    `;

/**
 * __useGetFilteredEntitiesQuery__
 *
 * To run a query within a React component, call `useGetFilteredEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredEntitiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFilteredEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>(GetFilteredEntitiesDocument, options);
      }
export function useGetFilteredEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>(GetFilteredEntitiesDocument, options);
        }
// @ts-ignore
export function useGetFilteredEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>;
export function useGetFilteredEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilteredEntitiesQuery | undefined, GraphqlTypes.GetFilteredEntitiesQueryVariables>;
export function useGetFilteredEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>(GetFilteredEntitiesDocument, options);
        }
export type GetFilteredEntitiesQueryHookResult = ReturnType<typeof useGetFilteredEntitiesQuery>;
export type GetFilteredEntitiesLazyQueryHookResult = ReturnType<typeof useGetFilteredEntitiesLazyQuery>;
export type GetFilteredEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetFilteredEntitiesSuspenseQuery>;
export type GetFilteredEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFilteredEntitiesQuery, GraphqlTypes.GetFilteredEntitiesQueryVariables>;
export const GetProgramsDocument = gql`
    query GetPrograms {
  programsAssignableToEntities {
    name
    id
    programType
  }
}
    `;

/**
 * __useGetProgramsQuery__
 *
 * To run a query within a React component, call `useGetProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>(GetProgramsDocument, options);
      }
export function useGetProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
// @ts-ignore
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>;
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProgramsQuery | undefined, GraphqlTypes.GetProgramsQueryVariables>;
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export type GetProgramsQueryHookResult = ReturnType<typeof useGetProgramsQuery>;
export type GetProgramsLazyQueryHookResult = ReturnType<typeof useGetProgramsLazyQuery>;
export type GetProgramsSuspenseQueryHookResult = ReturnType<typeof useGetProgramsSuspenseQuery>;
export type GetProgramsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProgramsQuery, GraphqlTypes.GetProgramsQueryVariables>;
export const GetAllCasesForProfileDocument = gql`
    query GetAllCasesForProfile($profileId: Int!) {
  complianceProfile(id: $profileId) {
    id
    activeCases {
      complianceCase {
        id
        caseType
        status
        createdAt
        investingProfile {
          id
          firstName
          middleName
          lastName
          legalName
          complianceObjectType
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllCasesForProfileQuery__
 *
 * To run a query within a React component, call `useGetAllCasesForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCasesForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCasesForProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetAllCasesForProfileQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables> & ({ variables: GraphqlTypes.GetAllCasesForProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>(GetAllCasesForProfileDocument, options);
      }
export function useGetAllCasesForProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>(GetAllCasesForProfileDocument, options);
        }
// @ts-ignore
export function useGetAllCasesForProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>;
export function useGetAllCasesForProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCasesForProfileQuery | undefined, GraphqlTypes.GetAllCasesForProfileQueryVariables>;
export function useGetAllCasesForProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>(GetAllCasesForProfileDocument, options);
        }
export type GetAllCasesForProfileQueryHookResult = ReturnType<typeof useGetAllCasesForProfileQuery>;
export type GetAllCasesForProfileLazyQueryHookResult = ReturnType<typeof useGetAllCasesForProfileLazyQuery>;
export type GetAllCasesForProfileSuspenseQueryHookResult = ReturnType<typeof useGetAllCasesForProfileSuspenseQuery>;
export type GetAllCasesForProfileQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllCasesForProfileQuery, GraphqlTypes.GetAllCasesForProfileQueryVariables>;
export const AssignCaseDocument = gql`
    mutation assignCase($caseId: Int!) {
  assignCase(caseId: $caseId) {
    __typename
  }
}
    `;
export type AssignCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.AssignCaseMutation, GraphqlTypes.AssignCaseMutationVariables>;

/**
 * __useAssignCaseMutation__
 *
 * To run a mutation, you first call `useAssignCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCaseMutation, { data, loading, error }] = useAssignCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useAssignCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AssignCaseMutation, GraphqlTypes.AssignCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AssignCaseMutation, GraphqlTypes.AssignCaseMutationVariables>(AssignCaseDocument, options);
      }
export type AssignCaseMutationHookResult = ReturnType<typeof useAssignCaseMutation>;
export type AssignCaseMutationResult = Apollo.MutationResult<GraphqlTypes.AssignCaseMutation>;
export type AssignCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AssignCaseMutation, GraphqlTypes.AssignCaseMutationVariables>;
export const PerformActionDocument = gql`
    mutation performAction($caseId: Int!, $action: ComplianceCaseAction!, $comment: CreateComplianceCommentInput) {
  performAction(caseId: $caseId, action: $action, comment: $comment) {
    __typename
  }
}
    `;
export type PerformActionMutationFn = Apollo.MutationFunction<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>;

/**
 * __usePerformActionMutation__
 *
 * To run a mutation, you first call `usePerformActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performActionMutation, { data, loading, error }] = usePerformActionMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      action: // value for 'action'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function usePerformActionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>(PerformActionDocument, options);
      }
export type PerformActionMutationHookResult = ReturnType<typeof usePerformActionMutation>;
export type PerformActionMutationResult = Apollo.MutationResult<GraphqlTypes.PerformActionMutation>;
export type PerformActionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PerformActionMutation, GraphqlTypes.PerformActionMutationVariables>;
export const CancelAssignmentDocument = gql`
    mutation cancelAssignment($caseId: Int!) {
  cancelAssignment(caseId: $caseId) {
    __typename
  }
}
    `;
export type CancelAssignmentMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelAssignmentMutation, GraphqlTypes.CancelAssignmentMutationVariables>;

/**
 * __useCancelAssignmentMutation__
 *
 * To run a mutation, you first call `useCancelAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAssignmentMutation, { data, loading, error }] = useCancelAssignmentMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useCancelAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelAssignmentMutation, GraphqlTypes.CancelAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelAssignmentMutation, GraphqlTypes.CancelAssignmentMutationVariables>(CancelAssignmentDocument, options);
      }
export type CancelAssignmentMutationHookResult = ReturnType<typeof useCancelAssignmentMutation>;
export type CancelAssignmentMutationResult = Apollo.MutationResult<GraphqlTypes.CancelAssignmentMutation>;
export type CancelAssignmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelAssignmentMutation, GraphqlTypes.CancelAssignmentMutationVariables>;
export const ReopenCaseDocument = gql`
    mutation reopenCase($caseId: Int!) {
  reopenCase(caseId: $caseId) {
    __typename
  }
}
    `;
export type ReopenCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.ReopenCaseMutation, GraphqlTypes.ReopenCaseMutationVariables>;

/**
 * __useReopenCaseMutation__
 *
 * To run a mutation, you first call `useReopenCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenCaseMutation, { data, loading, error }] = useReopenCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useReopenCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReopenCaseMutation, GraphqlTypes.ReopenCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReopenCaseMutation, GraphqlTypes.ReopenCaseMutationVariables>(ReopenCaseDocument, options);
      }
export type ReopenCaseMutationHookResult = ReturnType<typeof useReopenCaseMutation>;
export type ReopenCaseMutationResult = Apollo.MutationResult<GraphqlTypes.ReopenCaseMutation>;
export type ReopenCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReopenCaseMutation, GraphqlTypes.ReopenCaseMutationVariables>;
export const GetRiskRatingDetailsDocument = gql`
    query GetRiskRatingDetails($caseId: Int!) {
  complianceCase(id: $caseId) {
    id
    name
    programId
    riskRating
    rules
    investingProfile {
      id
      complianceObjectType
      legalName
      firstName
      lastName
      middleName
      riskRating {
        calculatedRating
        overriddenRating
      }
    }
    profiles {
      id
      riskRating {
        calculatedRating
        overriddenRating
      }
    }
    paymentAccount {
      id
      riskRating {
        calculatedRating
        overriddenRating
      }
      profileId
    }
    externalEntity {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRiskRatingDetailsQuery__
 *
 * To run a query within a React component, call `useGetRiskRatingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskRatingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskRatingDetailsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetRiskRatingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables> & ({ variables: GraphqlTypes.GetRiskRatingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>(GetRiskRatingDetailsDocument, options);
      }
export function useGetRiskRatingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>(GetRiskRatingDetailsDocument, options);
        }
// @ts-ignore
export function useGetRiskRatingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>;
export function useGetRiskRatingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRiskRatingDetailsQuery | undefined, GraphqlTypes.GetRiskRatingDetailsQueryVariables>;
export function useGetRiskRatingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>(GetRiskRatingDetailsDocument, options);
        }
export type GetRiskRatingDetailsQueryHookResult = ReturnType<typeof useGetRiskRatingDetailsQuery>;
export type GetRiskRatingDetailsLazyQueryHookResult = ReturnType<typeof useGetRiskRatingDetailsLazyQuery>;
export type GetRiskRatingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetRiskRatingDetailsSuspenseQuery>;
export type GetRiskRatingDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetRiskRatingDetailsQuery, GraphqlTypes.GetRiskRatingDetailsQueryVariables>;
export const DeleteComplianceDocumentDocument = gql`
    mutation DeleteComplianceDocument($caseId: Int!, $documentId: Int!) {
  deleteComplianceDocument(caseId: $caseId, documentId: $documentId)
}
    `;
export type DeleteComplianceDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteComplianceDocumentMutation, GraphqlTypes.DeleteComplianceDocumentMutationVariables>;

/**
 * __useDeleteComplianceDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteComplianceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComplianceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComplianceDocumentMutation, { data, loading, error }] = useDeleteComplianceDocumentMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteComplianceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteComplianceDocumentMutation, GraphqlTypes.DeleteComplianceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteComplianceDocumentMutation, GraphqlTypes.DeleteComplianceDocumentMutationVariables>(DeleteComplianceDocumentDocument, options);
      }
export type DeleteComplianceDocumentMutationHookResult = ReturnType<typeof useDeleteComplianceDocumentMutation>;
export type DeleteComplianceDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteComplianceDocumentMutation>;
export type DeleteComplianceDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteComplianceDocumentMutation, GraphqlTypes.DeleteComplianceDocumentMutationVariables>;
export const UpdateTaxDataSourceDocument = gql`
    mutation UpdateTaxDataSource($input: TaxDataSourceInput!) {
  updateTaxDataSource(input: $input) {
    assignments {
      id
      profileId
      documentId
      caseId
      referencedCaseId
      assignmentType
      status
    }
    count
  }
}
    `;
export type UpdateTaxDataSourceMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTaxDataSourceMutation, GraphqlTypes.UpdateTaxDataSourceMutationVariables>;

/**
 * __useUpdateTaxDataSourceMutation__
 *
 * To run a mutation, you first call `useUpdateTaxDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxDataSourceMutation, { data, loading, error }] = useUpdateTaxDataSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaxDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTaxDataSourceMutation, GraphqlTypes.UpdateTaxDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTaxDataSourceMutation, GraphqlTypes.UpdateTaxDataSourceMutationVariables>(UpdateTaxDataSourceDocument, options);
      }
export type UpdateTaxDataSourceMutationHookResult = ReturnType<typeof useUpdateTaxDataSourceMutation>;
export type UpdateTaxDataSourceMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTaxDataSourceMutation>;
export type UpdateTaxDataSourceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTaxDataSourceMutation, GraphqlTypes.UpdateTaxDataSourceMutationVariables>;
export const GetTaxDataSourceAssignmentsDocument = gql`
    query GetTaxDataSourceAssignments($input: TaxDataSourceAssignmentsInput!) {
  taxDataSourceAssignments(input: $input) {
    id
    profileId
    documentId
    caseId
    referencedCaseId
    assignmentType
    status
  }
}
    `;

/**
 * __useGetTaxDataSourceAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetTaxDataSourceAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxDataSourceAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxDataSourceAssignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTaxDataSourceAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables> & ({ variables: GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>(GetTaxDataSourceAssignmentsDocument, options);
      }
export function useGetTaxDataSourceAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>(GetTaxDataSourceAssignmentsDocument, options);
        }
// @ts-ignore
export function useGetTaxDataSourceAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>;
export function useGetTaxDataSourceAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTaxDataSourceAssignmentsQuery | undefined, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>;
export function useGetTaxDataSourceAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>(GetTaxDataSourceAssignmentsDocument, options);
        }
export type GetTaxDataSourceAssignmentsQueryHookResult = ReturnType<typeof useGetTaxDataSourceAssignmentsQuery>;
export type GetTaxDataSourceAssignmentsLazyQueryHookResult = ReturnType<typeof useGetTaxDataSourceAssignmentsLazyQuery>;
export type GetTaxDataSourceAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetTaxDataSourceAssignmentsSuspenseQuery>;
export type GetTaxDataSourceAssignmentsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTaxDataSourceAssignmentsQuery, GraphqlTypes.GetTaxDataSourceAssignmentsQueryVariables>;
export const GetProfileInfoDocument = gql`
    query GetProfileInfo($id: Int!) {
  complianceProfile(id: $id) {
    id
    firstName
    middleName
    lastName
    legalName
    complianceObjectType
    dateOfBirth
    dateOfOrganization
    addresses {
      street
      street2
      street3
      city
      state {
        id
        name
        code
      }
      postalCode
      country {
        id
        name
        alpha2code
      }
      province
      subprovince
      isPrimaryDomicile
    }
  }
}
    `;

/**
 * __useGetProfileInfoQuery__
 *
 * To run a query within a React component, call `useGetProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileInfoQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables> & ({ variables: GraphqlTypes.GetProfileInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>(GetProfileInfoDocument, options);
      }
export function useGetProfileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>(GetProfileInfoDocument, options);
        }
// @ts-ignore
export function useGetProfileInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>;
export function useGetProfileInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileInfoQuery | undefined, GraphqlTypes.GetProfileInfoQueryVariables>;
export function useGetProfileInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>(GetProfileInfoDocument, options);
        }
export type GetProfileInfoQueryHookResult = ReturnType<typeof useGetProfileInfoQuery>;
export type GetProfileInfoLazyQueryHookResult = ReturnType<typeof useGetProfileInfoLazyQuery>;
export type GetProfileInfoSuspenseQueryHookResult = ReturnType<typeof useGetProfileInfoSuspenseQuery>;
export type GetProfileInfoQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfileInfoQuery, GraphqlTypes.GetProfileInfoQueryVariables>;
export const UpdateComplianceDocumentDetailsDocument = gql`
    mutation UpdateComplianceDocumentDetails($caseId: Int!, $documentId: Int!, $updateInfo: DocumentUpdateInfoInput!) {
  updateComplianceDocumentDetails(
    caseId: $caseId
    documentId: $documentId
    updateInfo: $updateInfo
  ) {
    id
    profileId
    metadata {
      key
      value
      type
    }
    documentPurpose {
      baseType
    }
  }
}
    `;
export type UpdateComplianceDocumentDetailsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateComplianceDocumentDetailsMutation, GraphqlTypes.UpdateComplianceDocumentDetailsMutationVariables>;

/**
 * __useUpdateComplianceDocumentDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateComplianceDocumentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComplianceDocumentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComplianceDocumentDetailsMutation, { data, loading, error }] = useUpdateComplianceDocumentDetailsMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *      updateInfo: // value for 'updateInfo'
 *   },
 * });
 */
export function useUpdateComplianceDocumentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateComplianceDocumentDetailsMutation, GraphqlTypes.UpdateComplianceDocumentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateComplianceDocumentDetailsMutation, GraphqlTypes.UpdateComplianceDocumentDetailsMutationVariables>(UpdateComplianceDocumentDetailsDocument, options);
      }
export type UpdateComplianceDocumentDetailsMutationHookResult = ReturnType<typeof useUpdateComplianceDocumentDetailsMutation>;
export type UpdateComplianceDocumentDetailsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateComplianceDocumentDetailsMutation>;
export type UpdateComplianceDocumentDetailsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateComplianceDocumentDetailsMutation, GraphqlTypes.UpdateComplianceDocumentDetailsMutationVariables>;
export const ChangeAndResetDocumentDataDocument = gql`
    mutation ChangeAndResetDocumentData($caseId: Int!, $documentId: Int!, $resetInfo: DocumentResetInfoInput!) {
  changeAndResetDocumentData(
    caseId: $caseId
    documentId: $documentId
    resetInfo: $resetInfo
  ) {
    id
    status
    profileId
    metadata {
      key
      value
      type
    }
    documentPurpose {
      baseType
    }
  }
}
    `;
export type ChangeAndResetDocumentDataMutationFn = Apollo.MutationFunction<GraphqlTypes.ChangeAndResetDocumentDataMutation, GraphqlTypes.ChangeAndResetDocumentDataMutationVariables>;

/**
 * __useChangeAndResetDocumentDataMutation__
 *
 * To run a mutation, you first call `useChangeAndResetDocumentDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAndResetDocumentDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAndResetDocumentDataMutation, { data, loading, error }] = useChangeAndResetDocumentDataMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *      resetInfo: // value for 'resetInfo'
 *   },
 * });
 */
export function useChangeAndResetDocumentDataMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ChangeAndResetDocumentDataMutation, GraphqlTypes.ChangeAndResetDocumentDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ChangeAndResetDocumentDataMutation, GraphqlTypes.ChangeAndResetDocumentDataMutationVariables>(ChangeAndResetDocumentDataDocument, options);
      }
export type ChangeAndResetDocumentDataMutationHookResult = ReturnType<typeof useChangeAndResetDocumentDataMutation>;
export type ChangeAndResetDocumentDataMutationResult = Apollo.MutationResult<GraphqlTypes.ChangeAndResetDocumentDataMutation>;
export type ChangeAndResetDocumentDataMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ChangeAndResetDocumentDataMutation, GraphqlTypes.ChangeAndResetDocumentDataMutationVariables>;
export const GetDocumentDocument = gql`
    query GetDocument($documentId: Int!) {
  document(documentId: $documentId) {
    ...DocumentForDocument
  }
}
    ${DocumentForDocumentFragmentDoc}`;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables> & ({ variables: GraphqlTypes.GetDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
// @ts-ignore
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentQuery | undefined, GraphqlTypes.GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSuspenseQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentQuery, GraphqlTypes.GetDocumentQueryVariables>;
export const GetDocumentDetailsDocument = gql`
    query GetDocumentDetails($documentId: Int!) {
  document(documentId: $documentId) {
    id
    name
    s3Link
    contentType
    profileId
    documentPurpose {
      baseType
    }
  }
}
    `;

/**
 * __useGetDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables> & ({ variables: GraphqlTypes.GetDocumentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
      }
export function useGetDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
// @ts-ignore
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>;
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentDetailsQuery | undefined, GraphqlTypes.GetDocumentDetailsQueryVariables>;
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
export type GetDocumentDetailsQueryHookResult = ReturnType<typeof useGetDocumentDetailsQuery>;
export type GetDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsLazyQuery>;
export type GetDocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDetailsSuspenseQuery>;
export type GetDocumentDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentDetailsQuery, GraphqlTypes.GetDocumentDetailsQueryVariables>;
export const CreateTaxReportingProfileDocument = gql`
    mutation CreateTaxReportingProfile($caseId: Int!, $documentId: Int!, $parentProfileId: Int!, $taxReportingType: TaxReportingTypeEnum!, $metadata: TaxReportingProfileMetadataInput!, $sourceProfileId: Int) {
  createTaxReportingProfile(
    caseId: $caseId
    documentId: $documentId
    parentProfileId: $parentProfileId
    taxReportingType: $taxReportingType
    metadata: $metadata
    sourceProfileId: $sourceProfileId
  ) {
    id
    documentId
    profileId
    taxReportingType
    metaData
  }
}
    `;
export type CreateTaxReportingProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateTaxReportingProfileMutation, GraphqlTypes.CreateTaxReportingProfileMutationVariables>;

/**
 * __useCreateTaxReportingProfileMutation__
 *
 * To run a mutation, you first call `useCreateTaxReportingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxReportingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxReportingProfileMutation, { data, loading, error }] = useCreateTaxReportingProfileMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *      parentProfileId: // value for 'parentProfileId'
 *      taxReportingType: // value for 'taxReportingType'
 *      metadata: // value for 'metadata'
 *      sourceProfileId: // value for 'sourceProfileId'
 *   },
 * });
 */
export function useCreateTaxReportingProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateTaxReportingProfileMutation, GraphqlTypes.CreateTaxReportingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateTaxReportingProfileMutation, GraphqlTypes.CreateTaxReportingProfileMutationVariables>(CreateTaxReportingProfileDocument, options);
      }
export type CreateTaxReportingProfileMutationHookResult = ReturnType<typeof useCreateTaxReportingProfileMutation>;
export type CreateTaxReportingProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateTaxReportingProfileMutation>;
export type CreateTaxReportingProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateTaxReportingProfileMutation, GraphqlTypes.CreateTaxReportingProfileMutationVariables>;
export const UpdateTaxReportingProfileDocument = gql`
    mutation UpdateTaxReportingProfile($metadataId: Int!, $metadata: TaxReportingProfileMetadataInput!) {
  updateTaxReportingProfile(metadataId: $metadataId, metadata: $metadata) {
    id
    documentId
    profileId
    taxReportingType
    metaData
  }
}
    `;
export type UpdateTaxReportingProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateTaxReportingProfileMutation, GraphqlTypes.UpdateTaxReportingProfileMutationVariables>;

/**
 * __useUpdateTaxReportingProfileMutation__
 *
 * To run a mutation, you first call `useUpdateTaxReportingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxReportingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxReportingProfileMutation, { data, loading, error }] = useUpdateTaxReportingProfileMutation({
 *   variables: {
 *      metadataId: // value for 'metadataId'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdateTaxReportingProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateTaxReportingProfileMutation, GraphqlTypes.UpdateTaxReportingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateTaxReportingProfileMutation, GraphqlTypes.UpdateTaxReportingProfileMutationVariables>(UpdateTaxReportingProfileDocument, options);
      }
export type UpdateTaxReportingProfileMutationHookResult = ReturnType<typeof useUpdateTaxReportingProfileMutation>;
export type UpdateTaxReportingProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateTaxReportingProfileMutation>;
export type UpdateTaxReportingProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateTaxReportingProfileMutation, GraphqlTypes.UpdateTaxReportingProfileMutationVariables>;
export const DeleteTaxReportingProfileDocument = gql`
    mutation DeleteTaxReportingProfile($metadataId: Int!) {
  deleteTaxReportingProfile(metadataId: $metadataId) {
    id
  }
}
    `;
export type DeleteTaxReportingProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteTaxReportingProfileMutation, GraphqlTypes.DeleteTaxReportingProfileMutationVariables>;

/**
 * __useDeleteTaxReportingProfileMutation__
 *
 * To run a mutation, you first call `useDeleteTaxReportingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxReportingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxReportingProfileMutation, { data, loading, error }] = useDeleteTaxReportingProfileMutation({
 *   variables: {
 *      metadataId: // value for 'metadataId'
 *   },
 * });
 */
export function useDeleteTaxReportingProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteTaxReportingProfileMutation, GraphqlTypes.DeleteTaxReportingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteTaxReportingProfileMutation, GraphqlTypes.DeleteTaxReportingProfileMutationVariables>(DeleteTaxReportingProfileDocument, options);
      }
export type DeleteTaxReportingProfileMutationHookResult = ReturnType<typeof useDeleteTaxReportingProfileMutation>;
export type DeleteTaxReportingProfileMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteTaxReportingProfileMutation>;
export type DeleteTaxReportingProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteTaxReportingProfileMutation, GraphqlTypes.DeleteTaxReportingProfileMutationVariables>;
export const GetProfilesForControllingPersonsDocument = gql`
    query GetProfilesForControllingPersons($caseId: Int!) {
  complianceCase(id: $caseId) {
    id
    profiles {
      id
      complianceObjectType
      firstName
      middleName
      lastName
      legalName
      dateOfBirth
      taxIdUnencrypted
      lastUsedAt
      addresses {
        street
        street2
        city
        province
        postalCode
        country {
          alpha2code
        }
        isPrimaryDomicile
      }
    }
  }
}
    `;

/**
 * __useGetProfilesForControllingPersonsQuery__
 *
 * To run a query within a React component, call `useGetProfilesForControllingPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesForControllingPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesForControllingPersonsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetProfilesForControllingPersonsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables> & ({ variables: GraphqlTypes.GetProfilesForControllingPersonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>(GetProfilesForControllingPersonsDocument, options);
      }
export function useGetProfilesForControllingPersonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>(GetProfilesForControllingPersonsDocument, options);
        }
// @ts-ignore
export function useGetProfilesForControllingPersonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>;
export function useGetProfilesForControllingPersonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesForControllingPersonsQuery | undefined, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>;
export function useGetProfilesForControllingPersonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>(GetProfilesForControllingPersonsDocument, options);
        }
export type GetProfilesForControllingPersonsQueryHookResult = ReturnType<typeof useGetProfilesForControllingPersonsQuery>;
export type GetProfilesForControllingPersonsLazyQueryHookResult = ReturnType<typeof useGetProfilesForControllingPersonsLazyQuery>;
export type GetProfilesForControllingPersonsSuspenseQueryHookResult = ReturnType<typeof useGetProfilesForControllingPersonsSuspenseQuery>;
export type GetProfilesForControllingPersonsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfilesForControllingPersonsQuery, GraphqlTypes.GetProfilesForControllingPersonsQueryVariables>;
export const CreateDocumentsDocument = gql`
    mutation createDocuments($caseId: Int!, $documents: [DocumentInfoInput!]!, $processExtraction: Boolean) {
  createComplianceDocuments(
    caseId: $caseId
    documents: $documents
    processExtraction: $processExtraction
  ) {
    id
    documentPurpose {
      baseType
    }
  }
}
    `;
export type CreateDocumentsMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>;

/**
 * __useCreateDocumentsMutation__
 *
 * To run a mutation, you first call `useCreateDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentsMutation, { data, loading, error }] = useCreateDocumentsMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documents: // value for 'documents'
 *      processExtraction: // value for 'processExtraction'
 *   },
 * });
 */
export function useCreateDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>(CreateDocumentsDocument, options);
      }
export type CreateDocumentsMutationHookResult = ReturnType<typeof useCreateDocumentsMutation>;
export type CreateDocumentsMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDocumentsMutation>;
export type CreateDocumentsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDocumentsMutation, GraphqlTypes.CreateDocumentsMutationVariables>;
export const CreateDocumentsByArenaDocument = gql`
    mutation createDocumentsByArena($arenaId: Int!, $documents: [DocumentInfoInput!]!) {
  createOnboardingDocumentsWithoutCase(arenaId: $arenaId, documents: $documents) {
    id
    documentPurpose {
      baseType
    }
  }
}
    `;
export type CreateDocumentsByArenaMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDocumentsByArenaMutation, GraphqlTypes.CreateDocumentsByArenaMutationVariables>;

/**
 * __useCreateDocumentsByArenaMutation__
 *
 * To run a mutation, you first call `useCreateDocumentsByArenaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentsByArenaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentsByArenaMutation, { data, loading, error }] = useCreateDocumentsByArenaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useCreateDocumentsByArenaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDocumentsByArenaMutation, GraphqlTypes.CreateDocumentsByArenaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDocumentsByArenaMutation, GraphqlTypes.CreateDocumentsByArenaMutationVariables>(CreateDocumentsByArenaDocument, options);
      }
export type CreateDocumentsByArenaMutationHookResult = ReturnType<typeof useCreateDocumentsByArenaMutation>;
export type CreateDocumentsByArenaMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDocumentsByArenaMutation>;
export type CreateDocumentsByArenaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDocumentsByArenaMutation, GraphqlTypes.CreateDocumentsByArenaMutationVariables>;
export const GetEscalatedProfileRelationshipsDocument = gql`
    query GetEscalatedProfileRelationships($profileId: Int!) {
  complianceProfile(id: $profileId) {
    id
    parentRelationships {
      parentProfileId
      relationshipType
    }
  }
}
    `;

/**
 * __useGetEscalatedProfileRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetEscalatedProfileRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEscalatedProfileRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEscalatedProfileRelationshipsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetEscalatedProfileRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables> & ({ variables: GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>(GetEscalatedProfileRelationshipsDocument, options);
      }
export function useGetEscalatedProfileRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>(GetEscalatedProfileRelationshipsDocument, options);
        }
// @ts-ignore
export function useGetEscalatedProfileRelationshipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>;
export function useGetEscalatedProfileRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEscalatedProfileRelationshipsQuery | undefined, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>;
export function useGetEscalatedProfileRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>(GetEscalatedProfileRelationshipsDocument, options);
        }
export type GetEscalatedProfileRelationshipsQueryHookResult = ReturnType<typeof useGetEscalatedProfileRelationshipsQuery>;
export type GetEscalatedProfileRelationshipsLazyQueryHookResult = ReturnType<typeof useGetEscalatedProfileRelationshipsLazyQuery>;
export type GetEscalatedProfileRelationshipsSuspenseQueryHookResult = ReturnType<typeof useGetEscalatedProfileRelationshipsSuspenseQuery>;
export type GetEscalatedProfileRelationshipsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEscalatedProfileRelationshipsQuery, GraphqlTypes.GetEscalatedProfileRelationshipsQueryVariables>;
export const GetCaseWithRelationshipsDocument = gql`
    query GetCaseWithRelationships($caseId: Int!) {
  complianceCase(id: $caseId) {
    id
    name
    caseType
    investingProfile {
      id
      firstName
      middleName
      lastName
      legalName
      complianceObjectType
    }
    externalEntity {
      id
      name
    }
    externalArena {
      id
      name
      objectId
    }
    program {
      name
      id
    }
    createdAt
    sourceCase {
      id
    }
    peerCases {
      id
      name
      caseType
      investingProfile {
        id
        firstName
        middleName
        lastName
        legalName
        complianceObjectType
      }
      externalEntity {
        id
        name
      }
      externalArena {
        id
        name
        objectId
      }
      program {
        name
        id
      }
      createdAt
    }
    childCases {
      id
      name
      caseType
      investingProfile {
        id
        firstName
        middleName
        lastName
        legalName
        complianceObjectType
      }
      externalEntity {
        id
        name
      }
      externalArena {
        id
        name
        objectId
      }
      program {
        name
        id
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetCaseWithRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetCaseWithRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseWithRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseWithRelationshipsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetCaseWithRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables> & ({ variables: GraphqlTypes.GetCaseWithRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>(GetCaseWithRelationshipsDocument, options);
      }
export function useGetCaseWithRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>(GetCaseWithRelationshipsDocument, options);
        }
// @ts-ignore
export function useGetCaseWithRelationshipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>;
export function useGetCaseWithRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseWithRelationshipsQuery | undefined, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>;
export function useGetCaseWithRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>(GetCaseWithRelationshipsDocument, options);
        }
export type GetCaseWithRelationshipsQueryHookResult = ReturnType<typeof useGetCaseWithRelationshipsQuery>;
export type GetCaseWithRelationshipsLazyQueryHookResult = ReturnType<typeof useGetCaseWithRelationshipsLazyQuery>;
export type GetCaseWithRelationshipsSuspenseQueryHookResult = ReturnType<typeof useGetCaseWithRelationshipsSuspenseQuery>;
export type GetCaseWithRelationshipsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseWithRelationshipsQuery, GraphqlTypes.GetCaseWithRelationshipsQueryVariables>;
export const GetPositionsForCaseDocument = gql`
    query GetPositionsForCase($profileId: Int!, $caseTypes: [ComplianceCaseTypeEnum!]) {
  complianceProfile(id: $profileId) {
    clients
    positions {
      id
      arena {
        id
      }
      onboardingCase {
        id
        externalEntity {
          id
          name
        }
        investingProfile {
          id
          firstName
          middleName
          lastName
          legalName
          complianceObjectType
        }
        program {
          name
        }
      }
    }
    complianceCases(caseTypes: $caseTypes) {
      caseId
      complianceCase {
        id
        caseType
        position {
          id
        }
        program {
          name
          programType
        }
        externalEntity {
          id
          name
        }
        externalArena {
          id
          name
        }
        investingProfile {
          id
          firstName
          middleName
          lastName
          legalName
          complianceObjectType
        }
        position {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionsForCaseQuery__
 *
 * To run a query within a React component, call `useGetPositionsForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsForCaseQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      caseTypes: // value for 'caseTypes'
 *   },
 * });
 */
export function useGetPositionsForCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables> & ({ variables: GraphqlTypes.GetPositionsForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>(GetPositionsForCaseDocument, options);
      }
export function useGetPositionsForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>(GetPositionsForCaseDocument, options);
        }
// @ts-ignore
export function useGetPositionsForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>;
export function useGetPositionsForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsForCaseQuery | undefined, GraphqlTypes.GetPositionsForCaseQueryVariables>;
export function useGetPositionsForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>(GetPositionsForCaseDocument, options);
        }
export type GetPositionsForCaseQueryHookResult = ReturnType<typeof useGetPositionsForCaseQuery>;
export type GetPositionsForCaseLazyQueryHookResult = ReturnType<typeof useGetPositionsForCaseLazyQuery>;
export type GetPositionsForCaseSuspenseQueryHookResult = ReturnType<typeof useGetPositionsForCaseSuspenseQuery>;
export type GetPositionsForCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsForCaseQuery, GraphqlTypes.GetPositionsForCaseQueryVariables>;
export const GetOnboardingCasesForPositionsDocument = gql`
    query GetOnboardingCasesForPositions($positionFilters: PositionFilterInput!) {
  positions(positionFilters: $positionFilters) {
    edges {
      node {
        id
        prospect {
          id
        }
        subscription {
          id
        }
        onboardingCase {
          id
          externalEntity {
            id
            name
          }
          externalArena {
            id
            name
          }
          investingProfile {
            id
            firstName
            lastName
            middleName
            complianceObjectType
            legalName
          }
          program {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOnboardingCasesForPositionsQuery__
 *
 * To run a query within a React component, call `useGetOnboardingCasesForPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingCasesForPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingCasesForPositionsQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *   },
 * });
 */
export function useGetOnboardingCasesForPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables> & ({ variables: GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>(GetOnboardingCasesForPositionsDocument, options);
      }
export function useGetOnboardingCasesForPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>(GetOnboardingCasesForPositionsDocument, options);
        }
// @ts-ignore
export function useGetOnboardingCasesForPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>;
export function useGetOnboardingCasesForPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetOnboardingCasesForPositionsQuery | undefined, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>;
export function useGetOnboardingCasesForPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>(GetOnboardingCasesForPositionsDocument, options);
        }
export type GetOnboardingCasesForPositionsQueryHookResult = ReturnType<typeof useGetOnboardingCasesForPositionsQuery>;
export type GetOnboardingCasesForPositionsLazyQueryHookResult = ReturnType<typeof useGetOnboardingCasesForPositionsLazyQuery>;
export type GetOnboardingCasesForPositionsSuspenseQueryHookResult = ReturnType<typeof useGetOnboardingCasesForPositionsSuspenseQuery>;
export type GetOnboardingCasesForPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetOnboardingCasesForPositionsQuery, GraphqlTypes.GetOnboardingCasesForPositionsQueryVariables>;
export const GetArenaCountDocument = gql`
    query GetArenaCount($profileId: Int!, $caseTypes: [ComplianceCaseTypeEnum!]) {
  complianceProfile(id: $profileId) {
    clients
    complianceCases(caseTypes: $caseTypes) {
      caseId
      complianceCase {
        id
        externalEntity {
          id
        }
        externalArena {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetArenaCountQuery__
 *
 * To run a query within a React component, call `useGetArenaCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaCountQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      caseTypes: // value for 'caseTypes'
 *   },
 * });
 */
export function useGetArenaCountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables> & ({ variables: GraphqlTypes.GetArenaCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>(GetArenaCountDocument, options);
      }
export function useGetArenaCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>(GetArenaCountDocument, options);
        }
// @ts-ignore
export function useGetArenaCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>;
export function useGetArenaCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaCountQuery | undefined, GraphqlTypes.GetArenaCountQueryVariables>;
export function useGetArenaCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>(GetArenaCountDocument, options);
        }
export type GetArenaCountQueryHookResult = ReturnType<typeof useGetArenaCountQuery>;
export type GetArenaCountLazyQueryHookResult = ReturnType<typeof useGetArenaCountLazyQuery>;
export type GetArenaCountSuspenseQueryHookResult = ReturnType<typeof useGetArenaCountSuspenseQuery>;
export type GetArenaCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaCountQuery, GraphqlTypes.GetArenaCountQueryVariables>;
export const CreateEscalationDocument = gql`
    mutation CreateEscalation($caseId: Int!, $description: String!, $profileId: Int) {
  createEscalation(
    escalationInput: {caseId: $caseId, description: $description, profileId: $profileId}
  ) {
    id
    waiverDocumentId
    description
    document {
      id
      name
      s3Link
    }
    caseId
  }
}
    `;
export type CreateEscalationMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEscalationMutation, GraphqlTypes.CreateEscalationMutationVariables>;

/**
 * __useCreateEscalationMutation__
 *
 * To run a mutation, you first call `useCreateEscalationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEscalationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEscalationMutation, { data, loading, error }] = useCreateEscalationMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      description: // value for 'description'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useCreateEscalationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEscalationMutation, GraphqlTypes.CreateEscalationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEscalationMutation, GraphqlTypes.CreateEscalationMutationVariables>(CreateEscalationDocument, options);
      }
export type CreateEscalationMutationHookResult = ReturnType<typeof useCreateEscalationMutation>;
export type CreateEscalationMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEscalationMutation>;
export type CreateEscalationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEscalationMutation, GraphqlTypes.CreateEscalationMutationVariables>;
export const UpdateEscalationDocument = gql`
    mutation UpdateEscalation($id: Int!, $profileId: Int, $description: String) {
  updateEscalation(id: $id, profileId: $profileId, description: $description) {
    id
    waiverDocumentId
    description
    document {
      id
      name
      s3Link
    }
    caseId
  }
}
    `;
export type UpdateEscalationMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEscalationMutation, GraphqlTypes.UpdateEscalationMutationVariables>;

/**
 * __useUpdateEscalationMutation__
 *
 * To run a mutation, you first call `useUpdateEscalationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEscalationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEscalationMutation, { data, loading, error }] = useUpdateEscalationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profileId: // value for 'profileId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateEscalationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEscalationMutation, GraphqlTypes.UpdateEscalationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEscalationMutation, GraphqlTypes.UpdateEscalationMutationVariables>(UpdateEscalationDocument, options);
      }
export type UpdateEscalationMutationHookResult = ReturnType<typeof useUpdateEscalationMutation>;
export type UpdateEscalationMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEscalationMutation>;
export type UpdateEscalationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEscalationMutation, GraphqlTypes.UpdateEscalationMutationVariables>;
export const DeleteEscalationDocument = gql`
    mutation DeleteEscalation($id: Int!) {
  deleteEscalation(id: $id)
}
    `;
export type DeleteEscalationMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteEscalationMutation, GraphqlTypes.DeleteEscalationMutationVariables>;

/**
 * __useDeleteEscalationMutation__
 *
 * To run a mutation, you first call `useDeleteEscalationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEscalationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEscalationMutation, { data, loading, error }] = useDeleteEscalationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEscalationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteEscalationMutation, GraphqlTypes.DeleteEscalationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteEscalationMutation, GraphqlTypes.DeleteEscalationMutationVariables>(DeleteEscalationDocument, options);
      }
export type DeleteEscalationMutationHookResult = ReturnType<typeof useDeleteEscalationMutation>;
export type DeleteEscalationMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteEscalationMutation>;
export type DeleteEscalationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteEscalationMutation, GraphqlTypes.DeleteEscalationMutationVariables>;
export const GetTaxReportingDataDocument = gql`
    query GetTaxReportingData($caseId: Int!, $documentId: Int) {
  taxReportingData(caseId: $caseId, documentId: $documentId) {
    id
    documentId
    profileId
    taxReportingType
    metaData
    assigned
  }
}
    `;

/**
 * __useGetTaxReportingDataQuery__
 *
 * To run a query within a React component, call `useGetTaxReportingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxReportingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxReportingDataQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetTaxReportingDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables> & ({ variables: GraphqlTypes.GetTaxReportingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>(GetTaxReportingDataDocument, options);
      }
export function useGetTaxReportingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>(GetTaxReportingDataDocument, options);
        }
// @ts-ignore
export function useGetTaxReportingDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>;
export function useGetTaxReportingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTaxReportingDataQuery | undefined, GraphqlTypes.GetTaxReportingDataQueryVariables>;
export function useGetTaxReportingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>(GetTaxReportingDataDocument, options);
        }
export type GetTaxReportingDataQueryHookResult = ReturnType<typeof useGetTaxReportingDataQuery>;
export type GetTaxReportingDataLazyQueryHookResult = ReturnType<typeof useGetTaxReportingDataLazyQuery>;
export type GetTaxReportingDataSuspenseQueryHookResult = ReturnType<typeof useGetTaxReportingDataSuspenseQuery>;
export type GetTaxReportingDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetTaxReportingDataQuery, GraphqlTypes.GetTaxReportingDataQueryVariables>;
export const CreateComplianceCaseCommentDocument = gql`
    mutation createComplianceCaseComment($comment: String!, $format: ComplianceCommentFormat!, $objectType: ComplianceCommentObjectType!, $objectId: Int!, $internal: Boolean!) {
  createComplianceComment(
    createCommentInput: {comment: $comment, format: $format, objectType: $objectType, objectId: $objectId, internal: $internal}
  ) {
    comment
    format
    objectType
    objectId
    internal
    id
    createdBy
  }
}
    `;
export type CreateComplianceCaseCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateComplianceCaseCommentMutation, GraphqlTypes.CreateComplianceCaseCommentMutationVariables>;

/**
 * __useCreateComplianceCaseCommentMutation__
 *
 * To run a mutation, you first call `useCreateComplianceCaseCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceCaseCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceCaseCommentMutation, { data, loading, error }] = useCreateComplianceCaseCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      format: // value for 'format'
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      internal: // value for 'internal'
 *   },
 * });
 */
export function useCreateComplianceCaseCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateComplianceCaseCommentMutation, GraphqlTypes.CreateComplianceCaseCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateComplianceCaseCommentMutation, GraphqlTypes.CreateComplianceCaseCommentMutationVariables>(CreateComplianceCaseCommentDocument, options);
      }
export type CreateComplianceCaseCommentMutationHookResult = ReturnType<typeof useCreateComplianceCaseCommentMutation>;
export type CreateComplianceCaseCommentMutationResult = Apollo.MutationResult<GraphqlTypes.CreateComplianceCaseCommentMutation>;
export type CreateComplianceCaseCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateComplianceCaseCommentMutation, GraphqlTypes.CreateComplianceCaseCommentMutationVariables>;
export const GetComplianceCaseAuditLogsDocument = gql`
    query GetComplianceCaseAuditLogs($caseId: Int!) {
  getComplianceCaseAuditLogs(caseId: $caseId) {
    caseId
    createdAt
    createdBy {
      id
      objectId
      objectTypeEnum
      service
      name
    }
    eventData
    eventType
    id
  }
}
    `;

/**
 * __useGetComplianceCaseAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetComplianceCaseAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCaseAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCaseAuditLogsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetComplianceCaseAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>(GetComplianceCaseAuditLogsDocument, options);
      }
export function useGetComplianceCaseAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>(GetComplianceCaseAuditLogsDocument, options);
        }
// @ts-ignore
export function useGetComplianceCaseAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>;
export function useGetComplianceCaseAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseAuditLogsQuery | undefined, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>;
export function useGetComplianceCaseAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>(GetComplianceCaseAuditLogsDocument, options);
        }
export type GetComplianceCaseAuditLogsQueryHookResult = ReturnType<typeof useGetComplianceCaseAuditLogsQuery>;
export type GetComplianceCaseAuditLogsLazyQueryHookResult = ReturnType<typeof useGetComplianceCaseAuditLogsLazyQuery>;
export type GetComplianceCaseAuditLogsSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCaseAuditLogsSuspenseQuery>;
export type GetComplianceCaseAuditLogsQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCaseAuditLogsQuery, GraphqlTypes.GetComplianceCaseAuditLogsQueryVariables>;
export const GetPicrPositionDetailsDocument = gql`
    query GetPicrPositionDetails($caseId: Int!, $includeScreeningMatches: Boolean! = false) {
  picrPositionDetailsByCaseId(caseId: $caseId) {
    caseId
    positionId
    entityId
    paymentAccountOverrides {
      payeeName
      mismatchReason
      overriddenRiskRating
    }
    investmentEntity {
      name
    }
    simulatedRiskRating {
      investorProfileRiskRating
      paymentBeneficiaryRiskRating
    }
    createdProfileId
    createdProfile {
      id
      complianceObjectType
      legalName
      firstName
      lastName
    }
    linkedProfileId
    linkedProfile {
      complianceObjectType
      legalName
      firstName
      lastName
      taxIdUnencrypted
      taxIdType
      dateOfBirth
      dateOfOrganization
      complianceObjectType
      addresses {
        street
        street2
        city
        postalCode
        country {
          name
        }
        state {
          name
        }
        province
        isPrimaryDomicile
      }
      screeningRecord {
        matches {
          id
          pepCategory
          result
          screeningRecordId
          details
          immutable
          modifiedAt
        }
        searchInput
        status
        result
      }
      riskRating {
        id
        calculatedRating
        overriddenRating
      }
      paymentAccounts {
        id
        profileId
        bankCountry {
          name
          alpha2code
        }
        __typename
      }
      screeningMatches @include(if: $includeScreeningMatches) {
        id
        caseId
        clients {
          id
          name
        }
        pepCategory
        programs
        result
        screeningRecordId
        searchInput
        details
        modifiedAt
        immutable
        deletedAt
      }
    }
    linkedOnboardingCase {
      id
      status
      program {
        id
        name
      }
      investingProfile {
        id
        complianceObjectType
        legalName
        firstName
        lastName
        taxIdUnencrypted
        taxIdType
        dateOfBirth
        dateOfOrganization
        addresses {
          street
          street2
          city
          postalCode
          country {
            name
          }
          state {
            name
          }
          province
          isPrimaryDomicile
        }
        screeningRecord {
          matches {
            id
            pepCategory
            result
            screeningRecordId
            details
            immutable
            modifiedAt
          }
          searchInput
          status
          result
        }
        paymentAccounts {
          id
          profileId
          bankCountry {
            name
            alpha2code
          }
          __typename
        }
        riskRating {
          id
          calculatedRating
          overriddenRating
        }
        screeningMatches {
          id
          caseId
          clients {
            id
            name
          }
          pepCategory
          programs
          result
          screeningRecordId
          searchInput
          details
          modifiedAt
          immutable
          deletedAt
        }
      }
      profiles {
        id
        complianceObjectType
        legalName
        firstName
        lastName
        taxIdUnencrypted
        taxIdType
        dateOfBirth
        dateOfOrganization
        addresses {
          street
          street2
          city
          postalCode
          country {
            name
          }
          state {
            name
          }
          province
          isPrimaryDomicile
        }
        screeningRecord {
          matches {
            id
            pepCategory
            result
            screeningRecordId
            details
            immutable
            modifiedAt
          }
          searchInput
          status
          result
        }
        paymentAccounts {
          id
          profileId
          bankCountry {
            name
            alpha2code
          }
          __typename
        }
        riskRating {
          id
          calculatedRating
          overriddenRating
        }
        parentRelationships {
          id
          relationshipType
        }
        screeningMatches {
          id
          caseId
          clients {
            id
            name
          }
          pepCategory
          programs
          result
          screeningRecordId
          searchInput
          details
          modifiedAt
          immutable
          deletedAt
        }
      }
      paymentAccount {
        id
        bankCountryId
        bankCountry {
          id
          name
        }
        mismatchReason
        payeeName
        providerName
        paymentPrefId
        profileId
        riskRating {
          id
          calculatedRating
          overriddenRating
        }
      }
    }
    currentBankName
    redactedBankAccountNumber
    successorCases {
      id
    }
  }
}
    `;

/**
 * __useGetPicrPositionDetailsQuery__
 *
 * To run a query within a React component, call `useGetPicrPositionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPicrPositionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPicrPositionDetailsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      includeScreeningMatches: // value for 'includeScreeningMatches'
 *   },
 * });
 */
export function useGetPicrPositionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables> & ({ variables: GraphqlTypes.GetPicrPositionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>(GetPicrPositionDetailsDocument, options);
      }
export function useGetPicrPositionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>(GetPicrPositionDetailsDocument, options);
        }
// @ts-ignore
export function useGetPicrPositionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>;
export function useGetPicrPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPicrPositionDetailsQuery | undefined, GraphqlTypes.GetPicrPositionDetailsQueryVariables>;
export function useGetPicrPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>(GetPicrPositionDetailsDocument, options);
        }
export type GetPicrPositionDetailsQueryHookResult = ReturnType<typeof useGetPicrPositionDetailsQuery>;
export type GetPicrPositionDetailsLazyQueryHookResult = ReturnType<typeof useGetPicrPositionDetailsLazyQuery>;
export type GetPicrPositionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPicrPositionDetailsSuspenseQuery>;
export type GetPicrPositionDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPicrPositionDetailsQuery, GraphqlTypes.GetPicrPositionDetailsQueryVariables>;
export const GetPaymentBeneficiaryRiskRatingForCaseDocument = gql`
    query GetPaymentBeneficiaryRiskRatingForCase($caseId: Int!, $programId: Int!) {
  complianceCase(caseId: $caseId) {
    paymentAccount {
      id
      profile {
        riskRating(programId: $programId) {
          id
          overallRating
          calculatedRating
          overriddenRating
          programId
          overrideReviewerId
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentBeneficiaryRiskRatingForCaseQuery__
 *
 * To run a query within a React component, call `useGetPaymentBeneficiaryRiskRatingForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBeneficiaryRiskRatingForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBeneficiaryRiskRatingForCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetPaymentBeneficiaryRiskRatingForCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>(GetPaymentBeneficiaryRiskRatingForCaseDocument, options);
      }
export function useGetPaymentBeneficiaryRiskRatingForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>(GetPaymentBeneficiaryRiskRatingForCaseDocument, options);
        }
// @ts-ignore
export function useGetPaymentBeneficiaryRiskRatingForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>;
export function useGetPaymentBeneficiaryRiskRatingForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery | undefined, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>;
export function useGetPaymentBeneficiaryRiskRatingForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>(GetPaymentBeneficiaryRiskRatingForCaseDocument, options);
        }
export type GetPaymentBeneficiaryRiskRatingForCaseQueryHookResult = ReturnType<typeof useGetPaymentBeneficiaryRiskRatingForCaseQuery>;
export type GetPaymentBeneficiaryRiskRatingForCaseLazyQueryHookResult = ReturnType<typeof useGetPaymentBeneficiaryRiskRatingForCaseLazyQuery>;
export type GetPaymentBeneficiaryRiskRatingForCaseSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBeneficiaryRiskRatingForCaseSuspenseQuery>;
export type GetPaymentBeneficiaryRiskRatingForCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQuery, GraphqlTypes.GetPaymentBeneficiaryRiskRatingForCaseQueryVariables>;
export const CreatePaymentAccountDocument = gql`
    mutation createPaymentAccount($caseId: Int!, $data: PaymentAccountInput!) {
  createPaymentAccount(caseId: $caseId, data: $data) {
    __typename
  }
}
    `;
export type CreatePaymentAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePaymentAccountMutation, GraphqlTypes.CreatePaymentAccountMutationVariables>;

/**
 * __useCreatePaymentAccountMutation__
 *
 * To run a mutation, you first call `useCreatePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentAccountMutation, { data, loading, error }] = useCreatePaymentAccountMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePaymentAccountMutation, GraphqlTypes.CreatePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePaymentAccountMutation, GraphqlTypes.CreatePaymentAccountMutationVariables>(CreatePaymentAccountDocument, options);
      }
export type CreatePaymentAccountMutationHookResult = ReturnType<typeof useCreatePaymentAccountMutation>;
export type CreatePaymentAccountMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePaymentAccountMutation>;
export type CreatePaymentAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePaymentAccountMutation, GraphqlTypes.CreatePaymentAccountMutationVariables>;
export const DeletePaymentAccountDocument = gql`
    mutation deletePaymentAccount($caseId: Int!, $paymentAccountId: Int!) {
  deletePaymentAccount(caseId: $caseId, paymentAccountId: $paymentAccountId)
}
    `;
export type DeletePaymentAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.DeletePaymentAccountMutation, GraphqlTypes.DeletePaymentAccountMutationVariables>;

/**
 * __useDeletePaymentAccountMutation__
 *
 * To run a mutation, you first call `useDeletePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentAccountMutation, { data, loading, error }] = useDeletePaymentAccountMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      paymentAccountId: // value for 'paymentAccountId'
 *   },
 * });
 */
export function useDeletePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeletePaymentAccountMutation, GraphqlTypes.DeletePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeletePaymentAccountMutation, GraphqlTypes.DeletePaymentAccountMutationVariables>(DeletePaymentAccountDocument, options);
      }
export type DeletePaymentAccountMutationHookResult = ReturnType<typeof useDeletePaymentAccountMutation>;
export type DeletePaymentAccountMutationResult = Apollo.MutationResult<GraphqlTypes.DeletePaymentAccountMutation>;
export type DeletePaymentAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeletePaymentAccountMutation, GraphqlTypes.DeletePaymentAccountMutationVariables>;
export const UpdatePaymentAccountDocument = gql`
    mutation updatePaymentAccount($caseId: Int!, $paymentAccountId: Int!, $data: PaymentAccountInput!) {
  updateCompliancePaymentAccount(
    caseId: $caseId
    paymentAccountId: $paymentAccountId
    data: $data
  ) {
    __typename
  }
}
    `;
export type UpdatePaymentAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentAccountMutation, GraphqlTypes.UpdatePaymentAccountMutationVariables>;

/**
 * __useUpdatePaymentAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentAccountMutation, { data, loading, error }] = useUpdatePaymentAccountMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      paymentAccountId: // value for 'paymentAccountId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePaymentAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentAccountMutation, GraphqlTypes.UpdatePaymentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentAccountMutation, GraphqlTypes.UpdatePaymentAccountMutationVariables>(UpdatePaymentAccountDocument, options);
      }
export type UpdatePaymentAccountMutationHookResult = ReturnType<typeof useUpdatePaymentAccountMutation>;
export type UpdatePaymentAccountMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentAccountMutation>;
export type UpdatePaymentAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentAccountMutation, GraphqlTypes.UpdatePaymentAccountMutationVariables>;
export const GetInvestorBankDetailsDocument = gql`
    query GetInvestorBankDetails($caseId: Int!) {
  complianceCase(id: $caseId) {
    id
    readonly
    investingProfile {
      id
      complianceObjectType
      firstName
      middleName
      lastName
      legalName
      accountType
      paymentAccounts {
        id
        profileId
        providerName
        bankCountry {
          id
          name
          alpha2code
        }
        payeeName
        riskRating {
          calculatedRating
          overriddenRating
        }
      }
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
      parentRelationships {
        id
        relationshipType
      }
    }
    profiles {
      id
      complianceObjectType
      firstName
      middleName
      lastName
      legalName
      accountType
      paymentAccounts {
        id
        profileId
        providerName
        bankCountry {
          id
          name
          alpha2code
        }
        payeeName
        riskRating {
          calculatedRating
          overriddenRating
        }
      }
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
      parentRelationships {
        id
        relationshipType
      }
    }
    externalObjects {
      id
      objectId
      name
      objectTypeEnum
    }
    paymentAccount {
      id
      paymentPrefId
      profileId
      payeeName
    }
  }
}
    `;

/**
 * __useGetInvestorBankDetailsQuery__
 *
 * To run a query within a React component, call `useGetInvestorBankDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorBankDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorBankDetailsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetInvestorBankDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables> & ({ variables: GraphqlTypes.GetInvestorBankDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>(GetInvestorBankDetailsDocument, options);
      }
export function useGetInvestorBankDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>(GetInvestorBankDetailsDocument, options);
        }
// @ts-ignore
export function useGetInvestorBankDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>;
export function useGetInvestorBankDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorBankDetailsQuery | undefined, GraphqlTypes.GetInvestorBankDetailsQueryVariables>;
export function useGetInvestorBankDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>(GetInvestorBankDetailsDocument, options);
        }
export type GetInvestorBankDetailsQueryHookResult = ReturnType<typeof useGetInvestorBankDetailsQuery>;
export type GetInvestorBankDetailsLazyQueryHookResult = ReturnType<typeof useGetInvestorBankDetailsLazyQuery>;
export type GetInvestorBankDetailsSuspenseQueryHookResult = ReturnType<typeof useGetInvestorBankDetailsSuspenseQuery>;
export type GetInvestorBankDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestorBankDetailsQuery, GraphqlTypes.GetInvestorBankDetailsQueryVariables>;
export const GetPaymentAccountDocument = gql`
    query GetPaymentAccount($id: Int!, $programId: Int!) {
  compliancePaymentAccount(id: $id) {
    id
    profileId
    profile {
      id
      firstName
      middleName
      lastName
      legalName
      complianceObjectType
      accountType
      paymentAccounts {
        id
        profileId
        providerName
        bankCountry {
          id
          name
          alpha2code
        }
        payeeName
        riskRating {
          calculatedRating
          overriddenRating
        }
      }
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
      parentRelationships {
        id
        relationshipType
      }
    }
    providerName
    bankCountry {
      name
      alpha2code
    }
    payeeName
    mismatchReason
    riskRating(programId: $programId) {
      overriddenRating
    }
  }
}
    `;

/**
 * __useGetPaymentAccountQuery__
 *
 * To run a query within a React component, call `useGetPaymentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetPaymentAccountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables> & ({ variables: GraphqlTypes.GetPaymentAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>(GetPaymentAccountDocument, options);
      }
export function useGetPaymentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>(GetPaymentAccountDocument, options);
        }
// @ts-ignore
export function useGetPaymentAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>;
export function useGetPaymentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentAccountQuery | undefined, GraphqlTypes.GetPaymentAccountQueryVariables>;
export function useGetPaymentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>(GetPaymentAccountDocument, options);
        }
export type GetPaymentAccountQueryHookResult = ReturnType<typeof useGetPaymentAccountQuery>;
export type GetPaymentAccountLazyQueryHookResult = ReturnType<typeof useGetPaymentAccountLazyQuery>;
export type GetPaymentAccountSuspenseQueryHookResult = ReturnType<typeof useGetPaymentAccountSuspenseQuery>;
export type GetPaymentAccountQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentAccountQuery, GraphqlTypes.GetPaymentAccountQueryVariables>;
export const GetSubscriptionAddressDocument = gql`
    query GetSubscriptionAddress($subscriptionId: ID!) {
  subscriptionById(subscriptionId: $subscriptionId) {
    id
    paymentPref {
      ... on CheckPaymentPrefObjectType {
        id
        payeeName
        useAccountMailingAddress
      }
    }
    account {
      ... on SubscriptionAccountEntityObjectType {
        accountId
        name
        mailingAddress {
          ...SubscriptionMailingAddress
        }
      }
      ... on SubscriptionAccountIndividualObjectType {
        accountId
        name
        mailingAddress {
          ...SubscriptionMailingAddress
        }
      }
      ... on SubscriptionAccountJointObjectType {
        accountId
        name
        mailingAddress {
          ...SubscriptionMailingAddress
        }
      }
      ... on SubscriptionAccountTrustObjectType {
        accountId
        name
        mailingAddress {
          ...SubscriptionMailingAddress
        }
      }
    }
  }
}
    ${SubscriptionMailingAddressFragmentDoc}`;

/**
 * __useGetSubscriptionAddressQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionAddressQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetSubscriptionAddressQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables> & ({ variables: GraphqlTypes.GetSubscriptionAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>(GetSubscriptionAddressDocument, options);
      }
export function useGetSubscriptionAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>(GetSubscriptionAddressDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>;
export function useGetSubscriptionAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSubscriptionAddressQuery | undefined, GraphqlTypes.GetSubscriptionAddressQueryVariables>;
export function useGetSubscriptionAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>(GetSubscriptionAddressDocument, options);
        }
export type GetSubscriptionAddressQueryHookResult = ReturnType<typeof useGetSubscriptionAddressQuery>;
export type GetSubscriptionAddressLazyQueryHookResult = ReturnType<typeof useGetSubscriptionAddressLazyQuery>;
export type GetSubscriptionAddressSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionAddressSuspenseQuery>;
export type GetSubscriptionAddressQueryResult = Apollo.QueryResult<GraphqlTypes.GetSubscriptionAddressQuery, GraphqlTypes.GetSubscriptionAddressQueryVariables>;
export const GetPicrProfilesForBeneficiaryDocument = gql`
    query GetPicrProfilesForBeneficiary($caseId: Int!) {
  picrPositionDetailsByCaseId(caseId: $caseId) {
    linkedOnboardingCase {
      profiles {
        ...ProfileForBeneficiarySearch
        latestVersion {
          ...ProfileForBeneficiarySearch
        }
      }
      investingProfile {
        ...ProfileForBeneficiarySearch
        latestVersion {
          ...ProfileForBeneficiarySearch
        }
      }
    }
  }
}
    ${ProfileForBeneficiarySearchFragmentDoc}`;

/**
 * __useGetPicrProfilesForBeneficiaryQuery__
 *
 * To run a query within a React component, call `useGetPicrProfilesForBeneficiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPicrProfilesForBeneficiaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPicrProfilesForBeneficiaryQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetPicrProfilesForBeneficiaryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables> & ({ variables: GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>(GetPicrProfilesForBeneficiaryDocument, options);
      }
export function useGetPicrProfilesForBeneficiaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>(GetPicrProfilesForBeneficiaryDocument, options);
        }
// @ts-ignore
export function useGetPicrProfilesForBeneficiarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>;
export function useGetPicrProfilesForBeneficiarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery | undefined, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>;
export function useGetPicrProfilesForBeneficiarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>(GetPicrProfilesForBeneficiaryDocument, options);
        }
export type GetPicrProfilesForBeneficiaryQueryHookResult = ReturnType<typeof useGetPicrProfilesForBeneficiaryQuery>;
export type GetPicrProfilesForBeneficiaryLazyQueryHookResult = ReturnType<typeof useGetPicrProfilesForBeneficiaryLazyQuery>;
export type GetPicrProfilesForBeneficiarySuspenseQueryHookResult = ReturnType<typeof useGetPicrProfilesForBeneficiarySuspenseQuery>;
export type GetPicrProfilesForBeneficiaryQueryResult = Apollo.QueryResult<GraphqlTypes.GetPicrProfilesForBeneficiaryQuery, GraphqlTypes.GetPicrProfilesForBeneficiaryQueryVariables>;
export const GetPositionsDocument = gql`
    query GetPositions($caseId: Int!) {
  casePositionDetails(caseId: $caseId) {
    caseId
    entityName
    affectedProfiles {
      profileId
      name
    }
    clientName
    rootProfileName
    programName
    riskRatings {
      current {
        bankAccountDomicile
        paymentBeneficiary
        investor
      }
      proposed {
        bankAccountDomicile
        paymentBeneficiary
        investor
      }
    }
  }
  complianceCase(id: $caseId) {
    id
    profiles {
      id
      parentRelationships {
        relationshipType
      }
    }
  }
}
    `;

/**
 * __useGetPositionsQuery__
 *
 * To run a query within a React component, call `useGetPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables> & ({ variables: GraphqlTypes.GetPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>(GetPositionsDocument, options);
      }
export function useGetPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>(GetPositionsDocument, options);
        }
// @ts-ignore
export function useGetPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>;
export function useGetPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsQuery | undefined, GraphqlTypes.GetPositionsQueryVariables>;
export function useGetPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>(GetPositionsDocument, options);
        }
export type GetPositionsQueryHookResult = ReturnType<typeof useGetPositionsQuery>;
export type GetPositionsLazyQueryHookResult = ReturnType<typeof useGetPositionsLazyQuery>;
export type GetPositionsSuspenseQueryHookResult = ReturnType<typeof useGetPositionsSuspenseQuery>;
export type GetPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsQuery, GraphqlTypes.GetPositionsQueryVariables>;
export const GetPositionCaseDetailsDocument = gql`
    query GetPositionCaseDetails($filters: [ComplianceCaseFilters!]!) {
  complianceCasesSlice(filters: $filters) {
    rows {
      id
      externalArena {
        objectId
      }
      externalEntity {
        objectId
      }
      position {
        id
      }
    }
  }
}
    `;

/**
 * __useGetPositionCaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetPositionCaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionCaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionCaseDetailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPositionCaseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables> & ({ variables: GraphqlTypes.GetPositionCaseDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>(GetPositionCaseDetailsDocument, options);
      }
export function useGetPositionCaseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>(GetPositionCaseDetailsDocument, options);
        }
// @ts-ignore
export function useGetPositionCaseDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>;
export function useGetPositionCaseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionCaseDetailsQuery | undefined, GraphqlTypes.GetPositionCaseDetailsQueryVariables>;
export function useGetPositionCaseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>(GetPositionCaseDetailsDocument, options);
        }
export type GetPositionCaseDetailsQueryHookResult = ReturnType<typeof useGetPositionCaseDetailsQuery>;
export type GetPositionCaseDetailsLazyQueryHookResult = ReturnType<typeof useGetPositionCaseDetailsLazyQuery>;
export type GetPositionCaseDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPositionCaseDetailsSuspenseQuery>;
export type GetPositionCaseDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionCaseDetailsQuery, GraphqlTypes.GetPositionCaseDetailsQueryVariables>;
export const UpdatePicrPositionDetailsDocument = gql`
    mutation UpdatePicrPositionDetails($data: PicrPositionDetailsUpdateInput!) {
  updatePicrPositionDetails(data: $data) {
    caseId
    positionId
    linkedProfileId
    createdProfileId
    paymentAccountOverrides {
      payeeName
      mismatchReason
      overriddenRiskRating
    }
  }
}
    `;
export type UpdatePicrPositionDetailsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePicrPositionDetailsMutation, GraphqlTypes.UpdatePicrPositionDetailsMutationVariables>;

/**
 * __useUpdatePicrPositionDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePicrPositionDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePicrPositionDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePicrPositionDetailsMutation, { data, loading, error }] = useUpdatePicrPositionDetailsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePicrPositionDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePicrPositionDetailsMutation, GraphqlTypes.UpdatePicrPositionDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePicrPositionDetailsMutation, GraphqlTypes.UpdatePicrPositionDetailsMutationVariables>(UpdatePicrPositionDetailsDocument, options);
      }
export type UpdatePicrPositionDetailsMutationHookResult = ReturnType<typeof useUpdatePicrPositionDetailsMutation>;
export type UpdatePicrPositionDetailsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePicrPositionDetailsMutation>;
export type UpdatePicrPositionDetailsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePicrPositionDetailsMutation, GraphqlTypes.UpdatePicrPositionDetailsMutationVariables>;
export const LinkPaymentBeneficiaryDocument = gql`
    mutation LinkPaymentBeneficiary($entityId: Int!, $childProfileId: Int!) {
  linkPaymentBeneficiary(entityId: $entityId, childProfileId: $childProfileId) {
    __typename
  }
}
    `;
export type LinkPaymentBeneficiaryMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkPaymentBeneficiaryMutation, GraphqlTypes.LinkPaymentBeneficiaryMutationVariables>;

/**
 * __useLinkPaymentBeneficiaryMutation__
 *
 * To run a mutation, you first call `useLinkPaymentBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPaymentBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPaymentBeneficiaryMutation, { data, loading, error }] = useLinkPaymentBeneficiaryMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *   },
 * });
 */
export function useLinkPaymentBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkPaymentBeneficiaryMutation, GraphqlTypes.LinkPaymentBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkPaymentBeneficiaryMutation, GraphqlTypes.LinkPaymentBeneficiaryMutationVariables>(LinkPaymentBeneficiaryDocument, options);
      }
export type LinkPaymentBeneficiaryMutationHookResult = ReturnType<typeof useLinkPaymentBeneficiaryMutation>;
export type LinkPaymentBeneficiaryMutationResult = Apollo.MutationResult<GraphqlTypes.LinkPaymentBeneficiaryMutation>;
export type LinkPaymentBeneficiaryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkPaymentBeneficiaryMutation, GraphqlTypes.LinkPaymentBeneficiaryMutationVariables>;
export const LinkBeneficialOwnerDocument = gql`
    mutation LinkBeneficialOwner($entityId: Int!, $childProfileId: Int!, $percentage: Float!) {
  linkBeneficialOwner(
    entityId: $entityId
    childProfileId: $childProfileId
    percentage: $percentage
  ) {
    id
  }
}
    `;
export type LinkBeneficialOwnerMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>;

/**
 * __useLinkBeneficialOwnerMutation__
 *
 * To run a mutation, you first call `useLinkBeneficialOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkBeneficialOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkBeneficialOwnerMutation, { data, loading, error }] = useLinkBeneficialOwnerMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *      percentage: // value for 'percentage'
 *   },
 * });
 */
export function useLinkBeneficialOwnerMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>(LinkBeneficialOwnerDocument, options);
      }
export type LinkBeneficialOwnerMutationHookResult = ReturnType<typeof useLinkBeneficialOwnerMutation>;
export type LinkBeneficialOwnerMutationResult = Apollo.MutationResult<GraphqlTypes.LinkBeneficialOwnerMutation>;
export type LinkBeneficialOwnerMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkBeneficialOwnerMutation, GraphqlTypes.LinkBeneficialOwnerMutationVariables>;
export const LinkControllingPersonDocument = gql`
    mutation LinkControllingPerson($entityId: Int!, $childProfileId: Int!, $title: String) {
  linkControllingPerson(
    entityId: $entityId
    childProfileId: $childProfileId
    title: $title
  ) {
    id
  }
}
    `;
export type LinkControllingPersonMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkControllingPersonMutation, GraphqlTypes.LinkControllingPersonMutationVariables>;

/**
 * __useLinkControllingPersonMutation__
 *
 * To run a mutation, you first call `useLinkControllingPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkControllingPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkControllingPersonMutation, { data, loading, error }] = useLinkControllingPersonMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useLinkControllingPersonMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkControllingPersonMutation, GraphqlTypes.LinkControllingPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkControllingPersonMutation, GraphqlTypes.LinkControllingPersonMutationVariables>(LinkControllingPersonDocument, options);
      }
export type LinkControllingPersonMutationHookResult = ReturnType<typeof useLinkControllingPersonMutation>;
export type LinkControllingPersonMutationResult = Apollo.MutationResult<GraphqlTypes.LinkControllingPersonMutation>;
export type LinkControllingPersonMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkControllingPersonMutation, GraphqlTypes.LinkControllingPersonMutationVariables>;
export const UnlinkRelationshipDocument = gql`
    mutation UnlinkRelationship($entityId: Int!, $childProfileId: Int!, $relationshipType: ProfileRelationshipEnum!) {
  unlinkRelationship(
    entityId: $entityId
    childProfileId: $childProfileId
    relationshipType: $relationshipType
  )
}
    `;
export type UnlinkRelationshipMutationFn = Apollo.MutationFunction<GraphqlTypes.UnlinkRelationshipMutation, GraphqlTypes.UnlinkRelationshipMutationVariables>;

/**
 * __useUnlinkRelationshipMutation__
 *
 * To run a mutation, you first call `useUnlinkRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkRelationshipMutation, { data, loading, error }] = useUnlinkRelationshipMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      childProfileId: // value for 'childProfileId'
 *      relationshipType: // value for 'relationshipType'
 *   },
 * });
 */
export function useUnlinkRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnlinkRelationshipMutation, GraphqlTypes.UnlinkRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnlinkRelationshipMutation, GraphqlTypes.UnlinkRelationshipMutationVariables>(UnlinkRelationshipDocument, options);
      }
export type UnlinkRelationshipMutationHookResult = ReturnType<typeof useUnlinkRelationshipMutation>;
export type UnlinkRelationshipMutationResult = Apollo.MutationResult<GraphqlTypes.UnlinkRelationshipMutation>;
export type UnlinkRelationshipMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnlinkRelationshipMutation, GraphqlTypes.UnlinkRelationshipMutationVariables>;
export const GetProfileDetailsDocument = gql`
    query GetProfileDetails($profileId: Int!, $programId: Int!) {
  complianceProfile(id: $profileId) {
    accountType
    dateOfOrganization
    id
    firstName
    middleName
    lastName
    legalName
    complianceObjectType
    isInvestingProfile
    taxIdUnencrypted
    taxIdType
    dateOfBirth
    natureOfBusiness
    principalPlaceOfBusinessId
    registrationNumber
    amlEntityType
    amlEntityTypeId
    parentRelationships {
      parentProfileId
      id
      title
      relationshipType
      percentOwnership
    }
    complianceCases {
      isInvestingProfile
      complianceCase {
        id
        investingProfile {
          id
          accountType
          parentRelationships {
            ...ProfileRelationshipDetails
          }
        }
        profiles {
          id
          accountType
          parentRelationships {
            ...ProfileRelationshipDetails
          }
        }
      }
    }
    addresses {
      id
      street
      city
      postalCode
      street2
      province
      state {
        code
        id
        name
      }
      country {
        id
        name
        alpha2code
        riskRating
      }
      isPrimaryDomicile
    }
    riskRating(programId: $programId) {
      calculatedRating
      overriddenRating
    }
    paymentAccounts {
      id
      profileId
      providerName
      bankCountry {
        id
        name
        alpha2code
        riskRating
      }
      payeeName
      riskRating(programId: $programId) {
        calculatedRating
        overriddenRating
      }
    }
    documents {
      id
      name
      profileId
      s3Link
      status
      expiryDate
      documentPurpose {
        baseType
        expires
        complianceObjectType
      }
      metadata {
        key
        value
        type
      }
      contentType
    }
  }
}
    ${ProfileRelationshipDetailsFragmentDoc}`;

/**
 * __useGetProfileDetailsQuery__
 *
 * To run a query within a React component, call `useGetProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileDetailsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetProfileDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables> & ({ variables: GraphqlTypes.GetProfileDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>(GetProfileDetailsDocument, options);
      }
export function useGetProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>(GetProfileDetailsDocument, options);
        }
// @ts-ignore
export function useGetProfileDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>;
export function useGetProfileDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileDetailsQuery | undefined, GraphqlTypes.GetProfileDetailsQueryVariables>;
export function useGetProfileDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>(GetProfileDetailsDocument, options);
        }
export type GetProfileDetailsQueryHookResult = ReturnType<typeof useGetProfileDetailsQuery>;
export type GetProfileDetailsLazyQueryHookResult = ReturnType<typeof useGetProfileDetailsLazyQuery>;
export type GetProfileDetailsSuspenseQueryHookResult = ReturnType<typeof useGetProfileDetailsSuspenseQuery>;
export type GetProfileDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfileDetailsQuery, GraphqlTypes.GetProfileDetailsQueryVariables>;
export const ReconcileProfileHierarchyDocument = gql`
    mutation ReconcileProfileHierarchy($hierarchyRows: [ProfileHierarchyRowInput!]!, $caseId: Int!) {
  reconcileProfileHierarchy(hierarchyRows: $hierarchyRows, caseId: $caseId) {
    success
    updatedCount
    createdCount
    deletedCount
  }
}
    `;
export type ReconcileProfileHierarchyMutationFn = Apollo.MutationFunction<GraphqlTypes.ReconcileProfileHierarchyMutation, GraphqlTypes.ReconcileProfileHierarchyMutationVariables>;

/**
 * __useReconcileProfileHierarchyMutation__
 *
 * To run a mutation, you first call `useReconcileProfileHierarchyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileProfileHierarchyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileProfileHierarchyMutation, { data, loading, error }] = useReconcileProfileHierarchyMutation({
 *   variables: {
 *      hierarchyRows: // value for 'hierarchyRows'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useReconcileProfileHierarchyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReconcileProfileHierarchyMutation, GraphqlTypes.ReconcileProfileHierarchyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReconcileProfileHierarchyMutation, GraphqlTypes.ReconcileProfileHierarchyMutationVariables>(ReconcileProfileHierarchyDocument, options);
      }
export type ReconcileProfileHierarchyMutationHookResult = ReturnType<typeof useReconcileProfileHierarchyMutation>;
export type ReconcileProfileHierarchyMutationResult = Apollo.MutationResult<GraphqlTypes.ReconcileProfileHierarchyMutation>;
export type ReconcileProfileHierarchyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReconcileProfileHierarchyMutation, GraphqlTypes.ReconcileProfileHierarchyMutationVariables>;
export const IsProfileDirtyDocument = gql`
    query IsProfileDirty($profileIds: [Int!]!) {
  isProfileDirty(profileIds: $profileIds) {
    profileId
    isDirty
    isDivergedFromLatest
  }
}
    `;

/**
 * __useIsProfileDirtyQuery__
 *
 * To run a query within a React component, call `useIsProfileDirtyQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProfileDirtyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProfileDirtyQuery({
 *   variables: {
 *      profileIds: // value for 'profileIds'
 *   },
 * });
 */
export function useIsProfileDirtyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables> & ({ variables: GraphqlTypes.IsProfileDirtyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>(IsProfileDirtyDocument, options);
      }
export function useIsProfileDirtyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>(IsProfileDirtyDocument, options);
        }
// @ts-ignore
export function useIsProfileDirtySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>;
export function useIsProfileDirtySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.IsProfileDirtyQuery | undefined, GraphqlTypes.IsProfileDirtyQueryVariables>;
export function useIsProfileDirtySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>(IsProfileDirtyDocument, options);
        }
export type IsProfileDirtyQueryHookResult = ReturnType<typeof useIsProfileDirtyQuery>;
export type IsProfileDirtyLazyQueryHookResult = ReturnType<typeof useIsProfileDirtyLazyQuery>;
export type IsProfileDirtySuspenseQueryHookResult = ReturnType<typeof useIsProfileDirtySuspenseQuery>;
export type IsProfileDirtyQueryResult = Apollo.QueryResult<GraphqlTypes.IsProfileDirtyQuery, GraphqlTypes.IsProfileDirtyQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  complianceCountries {
    id
    alpha2code
    name
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountriesQuery | undefined, GraphqlTypes.GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountriesQuery, GraphqlTypes.GetCountriesQueryVariables>;
export const OverrideRiskRatingDocument = gql`
    mutation overrideRiskRating($data: RiskRatingInput!) {
  overrideRiskRating(data: $data) {
    id
    overriddenRating
  }
}
    `;
export type OverrideRiskRatingMutationFn = Apollo.MutationFunction<GraphqlTypes.OverrideRiskRatingMutation, GraphqlTypes.OverrideRiskRatingMutationVariables>;

/**
 * __useOverrideRiskRatingMutation__
 *
 * To run a mutation, you first call `useOverrideRiskRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideRiskRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideRiskRatingMutation, { data, loading, error }] = useOverrideRiskRatingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useOverrideRiskRatingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.OverrideRiskRatingMutation, GraphqlTypes.OverrideRiskRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.OverrideRiskRatingMutation, GraphqlTypes.OverrideRiskRatingMutationVariables>(OverrideRiskRatingDocument, options);
      }
export type OverrideRiskRatingMutationHookResult = ReturnType<typeof useOverrideRiskRatingMutation>;
export type OverrideRiskRatingMutationResult = Apollo.MutationResult<GraphqlTypes.OverrideRiskRatingMutation>;
export type OverrideRiskRatingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.OverrideRiskRatingMutation, GraphqlTypes.OverrideRiskRatingMutationVariables>;
export const RemoveProfileFromCaseDocument = gql`
    mutation removeProfileFromCase($caseId: Int!, $profileId: Int!) {
  removeProfileFromCase(caseId: $caseId, profileId: $profileId) {
    id
  }
}
    `;
export type RemoveProfileFromCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>;

/**
 * __useRemoveProfileFromCaseMutation__
 *
 * To run a mutation, you first call `useRemoveProfileFromCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProfileFromCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProfileFromCaseMutation, { data, loading, error }] = useRemoveProfileFromCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useRemoveProfileFromCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>(RemoveProfileFromCaseDocument, options);
      }
export type RemoveProfileFromCaseMutationHookResult = ReturnType<typeof useRemoveProfileFromCaseMutation>;
export type RemoveProfileFromCaseMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveProfileFromCaseMutation>;
export type RemoveProfileFromCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveProfileFromCaseMutation, GraphqlTypes.RemoveProfileFromCaseMutationVariables>;
export const GetProfilesForCaseDocument = gql`
    query GetProfilesForCase($caseId: Int!, $ioReusableProfilesEnabled: Boolean!) {
  complianceCase(id: $caseId) {
    id
    readonly
    caseType
    metaData
    investingProfile {
      id
      sourceProfileId
      latestVersion @include(if: $ioReusableProfilesEnabled) {
        id
      }
      complianceObjectType
      accountType
      firstName
      middleName
      lastName
      taxIdType
      taxIdUnencrypted
      dateOfBirth
      legalName
      dateOfOrganization
      natureOfBusiness
      parentRelationships {
        id
        relationshipType
      }
      addresses {
        id
        street
        street2
        city
        province
        postalCode
        country {
          id
          name
          alpha2code
          riskRating
        }
        isPrimaryDomicile
      }
      countryOfCitizenship {
        name
        alpha2code
        riskRating
      }
      organizationalJurisdiction {
        name
        alpha2code
      }
      paymentAccounts {
        id
        profileId
        providerName
        bankCountry {
          id
          name
          alpha2code
        }
        payeeName
        riskRating {
          calculatedRating
          overriddenRating
        }
      }
      beneficialOwners {
        ...ProfileRelationshipDetails
      }
      controllingPersons {
        ...ProfileRelationshipDetails
      }
      riskRating {
        calculatedRating
        overriddenRating
      }
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
      screeningMatches {
        pepCategory
        result
      }
    }
    profiles {
      id
      sourceProfileId
      latestVersion @include(if: $ioReusableProfilesEnabled) {
        id
      }
      path
      complianceObjectType
      accountType
      firstName
      middleName
      lastName
      taxIdUnencrypted
      dateOfBirth
      legalName
      parentRelationships {
        id
        parentProfileId
        relationshipType
        percentOwnership
        title
      }
      addresses {
        id
        street
        street2
        city
        province
        postalCode
        country {
          id
          name
          alpha2code
          riskRating
        }
        isPrimaryDomicile
      }
      paymentAccounts {
        id
        profileId
        providerName
        bankCountry {
          id
          name
          alpha2code
        }
        payeeName
        riskRating {
          calculatedRating
          overriddenRating
        }
      }
      documents {
        name
        s3Link
        documentPurpose {
          baseType
          expires
          complianceObjectType
        }
      }
      riskRating {
        calculatedRating
        overriddenRating
      }
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
      screeningMatches {
        pepCategory
        result
      }
    }
  }
}
    ${ProfileRelationshipDetailsFragmentDoc}`;

/**
 * __useGetProfilesForCaseQuery__
 *
 * To run a query within a React component, call `useGetProfilesForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesForCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      ioReusableProfilesEnabled: // value for 'ioReusableProfilesEnabled'
 *   },
 * });
 */
export function useGetProfilesForCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables> & ({ variables: GraphqlTypes.GetProfilesForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>(GetProfilesForCaseDocument, options);
      }
export function useGetProfilesForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>(GetProfilesForCaseDocument, options);
        }
// @ts-ignore
export function useGetProfilesForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>;
export function useGetProfilesForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfilesForCaseQuery | undefined, GraphqlTypes.GetProfilesForCaseQueryVariables>;
export function useGetProfilesForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>(GetProfilesForCaseDocument, options);
        }
export type GetProfilesForCaseQueryHookResult = ReturnType<typeof useGetProfilesForCaseQuery>;
export type GetProfilesForCaseLazyQueryHookResult = ReturnType<typeof useGetProfilesForCaseLazyQuery>;
export type GetProfilesForCaseSuspenseQueryHookResult = ReturnType<typeof useGetProfilesForCaseSuspenseQuery>;
export type GetProfilesForCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfilesForCaseQuery, GraphqlTypes.GetProfilesForCaseQueryVariables>;
export const UpdateScreeningMatchesDocument = gql`
    mutation UpdateScreeningMatches($profileId: Int!, $updateMatchInput: [ScreeningMatchUpdateInput!]!) {
  updateScreeningMatches(
    profileId: $profileId
    updateMatchInput: $updateMatchInput
  )
}
    `;
export type UpdateScreeningMatchesMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateScreeningMatchesMutation, GraphqlTypes.UpdateScreeningMatchesMutationVariables>;

/**
 * __useUpdateScreeningMatchesMutation__
 *
 * To run a mutation, you first call `useUpdateScreeningMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreeningMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreeningMatchesMutation, { data, loading, error }] = useUpdateScreeningMatchesMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      updateMatchInput: // value for 'updateMatchInput'
 *   },
 * });
 */
export function useUpdateScreeningMatchesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateScreeningMatchesMutation, GraphqlTypes.UpdateScreeningMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateScreeningMatchesMutation, GraphqlTypes.UpdateScreeningMatchesMutationVariables>(UpdateScreeningMatchesDocument, options);
      }
export type UpdateScreeningMatchesMutationHookResult = ReturnType<typeof useUpdateScreeningMatchesMutation>;
export type UpdateScreeningMatchesMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateScreeningMatchesMutation>;
export type UpdateScreeningMatchesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateScreeningMatchesMutation, GraphqlTypes.UpdateScreeningMatchesMutationVariables>;
export const GetCaseProfilesForScreeningDocument = gql`
    query GetCaseProfilesForScreening($caseId: Int!) {
  complianceCase(id: $caseId) {
    status
    profiles {
      id
      accountType
      complianceObjectType
      firstName
      middleName
      lastName
      legalName
      dateOfBirth
      dateOfOrganization
      taxIdUnencrypted
      taxIdType
      addresses {
        id
        street
        city
        postalCode
        street2
        province
        state {
          code
          id
          name
        }
        country {
          id
          name
          alpha2code
        }
        isPrimaryDomicile
      }
      positions {
        id
      }
      clients
      parentRelationships {
        id
        relationshipType
      }
      screeningMatches {
        id
        caseId
        clients {
          id
          name
        }
        pepCategory
        programs
        result
        screeningRecordId
        searchInput
        details
        modifiedAt
        immutable
        deletedAt
      }
      screeningRecord {
        matches {
          id
          pepCategory
          result
          screeningRecordId
          details
          immutable
          modifiedAt
        }
        searchInput
        status
        result
      }
      paymentAccounts {
        id
        profileId
        bankCountry {
          name
          alpha2code
        }
        __typename
      }
      riskRating {
        id
        calculatedRating
        overriddenRating
      }
    }
  }
}
    `;

/**
 * __useGetCaseProfilesForScreeningQuery__
 *
 * To run a query within a React component, call `useGetCaseProfilesForScreeningQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseProfilesForScreeningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseProfilesForScreeningQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetCaseProfilesForScreeningQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables> & ({ variables: GraphqlTypes.GetCaseProfilesForScreeningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>(GetCaseProfilesForScreeningDocument, options);
      }
export function useGetCaseProfilesForScreeningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>(GetCaseProfilesForScreeningDocument, options);
        }
// @ts-ignore
export function useGetCaseProfilesForScreeningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>;
export function useGetCaseProfilesForScreeningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProfilesForScreeningQuery | undefined, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>;
export function useGetCaseProfilesForScreeningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>(GetCaseProfilesForScreeningDocument, options);
        }
export type GetCaseProfilesForScreeningQueryHookResult = ReturnType<typeof useGetCaseProfilesForScreeningQuery>;
export type GetCaseProfilesForScreeningLazyQueryHookResult = ReturnType<typeof useGetCaseProfilesForScreeningLazyQuery>;
export type GetCaseProfilesForScreeningSuspenseQueryHookResult = ReturnType<typeof useGetCaseProfilesForScreeningSuspenseQuery>;
export type GetCaseProfilesForScreeningQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseProfilesForScreeningQuery, GraphqlTypes.GetCaseProfilesForScreeningQueryVariables>;
export const GetCaseProgramDocument = gql`
    query GetCaseProgram($id: Int!) {
  complianceCase(id: $id) {
    program {
      id
      name
      programType
    }
    caseType
  }
  picrPositionDetailsByCaseId(caseId: $id) {
    positionId
    linkedOnboardingCase {
      program {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCaseProgramQuery__
 *
 * To run a query within a React component, call `useGetCaseProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseProgramQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseProgramQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables> & ({ variables: GraphqlTypes.GetCaseProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>(GetCaseProgramDocument, options);
      }
export function useGetCaseProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>(GetCaseProgramDocument, options);
        }
// @ts-ignore
export function useGetCaseProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>;
export function useGetCaseProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProgramQuery | undefined, GraphqlTypes.GetCaseProgramQueryVariables>;
export function useGetCaseProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>(GetCaseProgramDocument, options);
        }
export type GetCaseProgramQueryHookResult = ReturnType<typeof useGetCaseProgramQuery>;
export type GetCaseProgramLazyQueryHookResult = ReturnType<typeof useGetCaseProgramLazyQuery>;
export type GetCaseProgramSuspenseQueryHookResult = ReturnType<typeof useGetCaseProgramSuspenseQuery>;
export type GetCaseProgramQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseProgramQuery, GraphqlTypes.GetCaseProgramQueryVariables>;
export const GetUpdatedRiskRatingCountForPositionsDocument = gql`
    query GetUpdatedRiskRatingCountForPositions($caseId: Int!) {
  picrPositionDetailsByCaseId(caseId: $caseId) {
    positionId
    linkedOnboardingCase {
      id
    }
    successorCases {
      id
    }
  }
}
    `;

/**
 * __useGetUpdatedRiskRatingCountForPositionsQuery__
 *
 * To run a query within a React component, call `useGetUpdatedRiskRatingCountForPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdatedRiskRatingCountForPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdatedRiskRatingCountForPositionsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetUpdatedRiskRatingCountForPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables> & ({ variables: GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>(GetUpdatedRiskRatingCountForPositionsDocument, options);
      }
export function useGetUpdatedRiskRatingCountForPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>(GetUpdatedRiskRatingCountForPositionsDocument, options);
        }
// @ts-ignore
export function useGetUpdatedRiskRatingCountForPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>;
export function useGetUpdatedRiskRatingCountForPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery | undefined, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>;
export function useGetUpdatedRiskRatingCountForPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>(GetUpdatedRiskRatingCountForPositionsDocument, options);
        }
export type GetUpdatedRiskRatingCountForPositionsQueryHookResult = ReturnType<typeof useGetUpdatedRiskRatingCountForPositionsQuery>;
export type GetUpdatedRiskRatingCountForPositionsLazyQueryHookResult = ReturnType<typeof useGetUpdatedRiskRatingCountForPositionsLazyQuery>;
export type GetUpdatedRiskRatingCountForPositionsSuspenseQueryHookResult = ReturnType<typeof useGetUpdatedRiskRatingCountForPositionsSuspenseQuery>;
export type GetUpdatedRiskRatingCountForPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQuery, GraphqlTypes.GetUpdatedRiskRatingCountForPositionsQueryVariables>;
export const UnlinkOnboardingCaseDocument = gql`
    mutation UnlinkOnboardingCase($caseId: Int!, $arenaId: Int!) {
  unlinkOnboardingCase(caseId: $caseId, arenaId: $arenaId) {
    id
  }
}
    `;
export type UnlinkOnboardingCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.UnlinkOnboardingCaseMutation, GraphqlTypes.UnlinkOnboardingCaseMutationVariables>;

/**
 * __useUnlinkOnboardingCaseMutation__
 *
 * To run a mutation, you first call `useUnlinkOnboardingCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkOnboardingCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkOnboardingCaseMutation, { data, loading, error }] = useUnlinkOnboardingCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useUnlinkOnboardingCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UnlinkOnboardingCaseMutation, GraphqlTypes.UnlinkOnboardingCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UnlinkOnboardingCaseMutation, GraphqlTypes.UnlinkOnboardingCaseMutationVariables>(UnlinkOnboardingCaseDocument, options);
      }
export type UnlinkOnboardingCaseMutationHookResult = ReturnType<typeof useUnlinkOnboardingCaseMutation>;
export type UnlinkOnboardingCaseMutationResult = Apollo.MutationResult<GraphqlTypes.UnlinkOnboardingCaseMutation>;
export type UnlinkOnboardingCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UnlinkOnboardingCaseMutation, GraphqlTypes.UnlinkOnboardingCaseMutationVariables>;
export const GetComplianceClientsSliceDocument = gql`
    query GetComplianceClientsSlice($offset: Int, $limit: Int, $filters: [ComplianceClientsFilters!], $sorts: [ComplianceClientsSort!]) {
  complianceClientsSlice(
    offset: $offset
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    filteredCount
    rows {
      id
      client
      entities
      status
      productLine
      clientProgram
      onboardingStatus
      onboardingCaseId
    }
  }
}
    `;

/**
 * __useGetComplianceClientsSliceQuery__
 *
 * To run a query within a React component, call `useGetComplianceClientsSliceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceClientsSliceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceClientsSliceQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useGetComplianceClientsSliceQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>(GetComplianceClientsSliceDocument, options);
      }
export function useGetComplianceClientsSliceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>(GetComplianceClientsSliceDocument, options);
        }
// @ts-ignore
export function useGetComplianceClientsSliceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>;
export function useGetComplianceClientsSliceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceClientsSliceQuery | undefined, GraphqlTypes.GetComplianceClientsSliceQueryVariables>;
export function useGetComplianceClientsSliceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>(GetComplianceClientsSliceDocument, options);
        }
export type GetComplianceClientsSliceQueryHookResult = ReturnType<typeof useGetComplianceClientsSliceQuery>;
export type GetComplianceClientsSliceLazyQueryHookResult = ReturnType<typeof useGetComplianceClientsSliceLazyQuery>;
export type GetComplianceClientsSliceSuspenseQueryHookResult = ReturnType<typeof useGetComplianceClientsSliceSuspenseQuery>;
export type GetComplianceClientsSliceQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceClientsSliceQuery, GraphqlTypes.GetComplianceClientsSliceQueryVariables>;
export const ComplianceEntitiesDocument = gql`
    query ComplianceEntities($arenaId: Int!, $offset: Int!, $limit: Int!, $sort: ComplianceEntitiesSort, $filters: [ComplianceEntitiesFilter!]) {
  complianceEntitiesSlice(
    arenaId: $arenaId
    offset: $offset
    limit: $limit
    sort: $sort
    filters: $filters
  ) {
    id
    name
    status
    complianceProgram
    complianceEnabled
    fatcaCrsEnabled
    isInvestorDiligenceEnabled
    entityProgram
    onboardingStatus
    onboardingCaseId
    productLine
  }
}
    `;

/**
 * __useComplianceEntitiesQuery__
 *
 * To run a query within a React component, call `useComplianceEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceEntitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useComplianceEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables> & ({ variables: GraphqlTypes.ComplianceEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>(ComplianceEntitiesDocument, options);
      }
export function useComplianceEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>(ComplianceEntitiesDocument, options);
        }
// @ts-ignore
export function useComplianceEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>;
export function useComplianceEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ComplianceEntitiesQuery | undefined, GraphqlTypes.ComplianceEntitiesQueryVariables>;
export function useComplianceEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>(ComplianceEntitiesDocument, options);
        }
export type ComplianceEntitiesQueryHookResult = ReturnType<typeof useComplianceEntitiesQuery>;
export type ComplianceEntitiesLazyQueryHookResult = ReturnType<typeof useComplianceEntitiesLazyQuery>;
export type ComplianceEntitiesSuspenseQueryHookResult = ReturnType<typeof useComplianceEntitiesSuspenseQuery>;
export type ComplianceEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.ComplianceEntitiesQuery, GraphqlTypes.ComplianceEntitiesQueryVariables>;
export const ComplianceEntitiesCountDocument = gql`
    query ComplianceEntitiesCount($arenaId: Int!, $filters: [ComplianceEntitiesFilter!]) {
  complianceEntitiesSliceCount(arenaId: $arenaId, filters: $filters)
}
    `;

/**
 * __useComplianceEntitiesCountQuery__
 *
 * To run a query within a React component, call `useComplianceEntitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceEntitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceEntitiesCountQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useComplianceEntitiesCountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables> & ({ variables: GraphqlTypes.ComplianceEntitiesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>(ComplianceEntitiesCountDocument, options);
      }
export function useComplianceEntitiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>(ComplianceEntitiesCountDocument, options);
        }
// @ts-ignore
export function useComplianceEntitiesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>;
export function useComplianceEntitiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ComplianceEntitiesCountQuery | undefined, GraphqlTypes.ComplianceEntitiesCountQueryVariables>;
export function useComplianceEntitiesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>(ComplianceEntitiesCountDocument, options);
        }
export type ComplianceEntitiesCountQueryHookResult = ReturnType<typeof useComplianceEntitiesCountQuery>;
export type ComplianceEntitiesCountLazyQueryHookResult = ReturnType<typeof useComplianceEntitiesCountLazyQuery>;
export type ComplianceEntitiesCountSuspenseQueryHookResult = ReturnType<typeof useComplianceEntitiesCountSuspenseQuery>;
export type ComplianceEntitiesCountQueryResult = Apollo.QueryResult<GraphqlTypes.ComplianceEntitiesCountQuery, GraphqlTypes.ComplianceEntitiesCountQueryVariables>;
export const GenerateScreeningStatusReportDocument = gql`
    mutation GenerateScreeningStatusReport($reportInput: [ScreeningStatusForPositionInput!]!) {
  createScreeningReportForPositions(reportInput: $reportInput) {
    id
    status
    errorMsg
  }
}
    `;
export type GenerateScreeningStatusReportMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateScreeningStatusReportMutation, GraphqlTypes.GenerateScreeningStatusReportMutationVariables>;

/**
 * __useGenerateScreeningStatusReportMutation__
 *
 * To run a mutation, you first call `useGenerateScreeningStatusReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateScreeningStatusReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateScreeningStatusReportMutation, { data, loading, error }] = useGenerateScreeningStatusReportMutation({
 *   variables: {
 *      reportInput: // value for 'reportInput'
 *   },
 * });
 */
export function useGenerateScreeningStatusReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateScreeningStatusReportMutation, GraphqlTypes.GenerateScreeningStatusReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateScreeningStatusReportMutation, GraphqlTypes.GenerateScreeningStatusReportMutationVariables>(GenerateScreeningStatusReportDocument, options);
      }
export type GenerateScreeningStatusReportMutationHookResult = ReturnType<typeof useGenerateScreeningStatusReportMutation>;
export type GenerateScreeningStatusReportMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateScreeningStatusReportMutation>;
export type GenerateScreeningStatusReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateScreeningStatusReportMutation, GraphqlTypes.GenerateScreeningStatusReportMutationVariables>;
export const GenerateFatcaCrsReportDocument = gql`
    mutation GenerateFatcaCrsReport($positionIds: [String!]!) {
  createFatcaCrsReportForPositions(positionIds: $positionIds) {
    id
    status
    errorMsg
  }
}
    `;
export type GenerateFatcaCrsReportMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateFatcaCrsReportMutation, GraphqlTypes.GenerateFatcaCrsReportMutationVariables>;

/**
 * __useGenerateFatcaCrsReportMutation__
 *
 * To run a mutation, you first call `useGenerateFatcaCrsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFatcaCrsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFatcaCrsReportMutation, { data, loading, error }] = useGenerateFatcaCrsReportMutation({
 *   variables: {
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useGenerateFatcaCrsReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateFatcaCrsReportMutation, GraphqlTypes.GenerateFatcaCrsReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateFatcaCrsReportMutation, GraphqlTypes.GenerateFatcaCrsReportMutationVariables>(GenerateFatcaCrsReportDocument, options);
      }
export type GenerateFatcaCrsReportMutationHookResult = ReturnType<typeof useGenerateFatcaCrsReportMutation>;
export type GenerateFatcaCrsReportMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateFatcaCrsReportMutation>;
export type GenerateFatcaCrsReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateFatcaCrsReportMutation, GraphqlTypes.GenerateFatcaCrsReportMutationVariables>;
export const StartRemediationDocument = gql`
    mutation StartRemediation($positionId: Int!, $arenaId: Int!, $emailAddresses: [String!], $message: String, $entityId: Int!, $programName: String!) {
  startRemediation(
    input: {positionId: $positionId, arenaId: $arenaId, emailAddresses: $emailAddresses, message: $message, entityId: $entityId, programName: $programName}
  )
}
    `;
export type StartRemediationMutationFn = Apollo.MutationFunction<GraphqlTypes.StartRemediationMutation, GraphqlTypes.StartRemediationMutationVariables>;

/**
 * __useStartRemediationMutation__
 *
 * To run a mutation, you first call `useStartRemediationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRemediationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRemediationMutation, { data, loading, error }] = useStartRemediationMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      arenaId: // value for 'arenaId'
 *      emailAddresses: // value for 'emailAddresses'
 *      message: // value for 'message'
 *      entityId: // value for 'entityId'
 *      programName: // value for 'programName'
 *   },
 * });
 */
export function useStartRemediationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartRemediationMutation, GraphqlTypes.StartRemediationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartRemediationMutation, GraphqlTypes.StartRemediationMutationVariables>(StartRemediationDocument, options);
      }
export type StartRemediationMutationHookResult = ReturnType<typeof useStartRemediationMutation>;
export type StartRemediationMutationResult = Apollo.MutationResult<GraphqlTypes.StartRemediationMutation>;
export type StartRemediationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartRemediationMutation, GraphqlTypes.StartRemediationMutationVariables>;
export const GetContactsByPositionDocument = gql`
    query GetContactsByPosition($arenaIds: [ID]!, $positionIds: [ID!]!) {
  positions(
    positionFilters: {arenaIds: $arenaIds, positionIds: $positionIds, includeFundAdminEntities: false}
  ) {
    edges {
      node {
        id
        account {
          id
          name
          portalStatus
        }
        arena {
          id
          name
        }
        investmentEntity {
          id
          name
        }
        contacts {
          edges {
            node {
              id
              fullName
              portal {
                invitedAt
                activatedAt
                portalActivityStatus
              }
              primaryEmail {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetContactsByPositionQuery__
 *
 * To run a query within a React component, call `useGetContactsByPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByPositionQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useGetContactsByPositionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables> & ({ variables: GraphqlTypes.GetContactsByPositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>(GetContactsByPositionDocument, options);
      }
export function useGetContactsByPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>(GetContactsByPositionDocument, options);
        }
// @ts-ignore
export function useGetContactsByPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>;
export function useGetContactsByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetContactsByPositionQuery | undefined, GraphqlTypes.GetContactsByPositionQueryVariables>;
export function useGetContactsByPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>(GetContactsByPositionDocument, options);
        }
export type GetContactsByPositionQueryHookResult = ReturnType<typeof useGetContactsByPositionQuery>;
export type GetContactsByPositionLazyQueryHookResult = ReturnType<typeof useGetContactsByPositionLazyQuery>;
export type GetContactsByPositionSuspenseQueryHookResult = ReturnType<typeof useGetContactsByPositionSuspenseQuery>;
export type GetContactsByPositionQueryResult = Apollo.QueryResult<GraphqlTypes.GetContactsByPositionQuery, GraphqlTypes.GetContactsByPositionQueryVariables>;
export const CancelComplianceInvitationDocument = gql`
    mutation CancelComplianceInvitation($invitationId: Int!, $comment: String = null, $retainCase: Boolean = false) {
  cancelComplianceInvitation(
    invitationId: $invitationId
    comment: $comment
    retainCase: $retainCase
  )
}
    `;
export type CancelComplianceInvitationMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelComplianceInvitationMutation, GraphqlTypes.CancelComplianceInvitationMutationVariables>;

/**
 * __useCancelComplianceInvitationMutation__
 *
 * To run a mutation, you first call `useCancelComplianceInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelComplianceInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelComplianceInvitationMutation, { data, loading, error }] = useCancelComplianceInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *      comment: // value for 'comment'
 *      retainCase: // value for 'retainCase'
 *   },
 * });
 */
export function useCancelComplianceInvitationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelComplianceInvitationMutation, GraphqlTypes.CancelComplianceInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelComplianceInvitationMutation, GraphqlTypes.CancelComplianceInvitationMutationVariables>(CancelComplianceInvitationDocument, options);
      }
export type CancelComplianceInvitationMutationHookResult = ReturnType<typeof useCancelComplianceInvitationMutation>;
export type CancelComplianceInvitationMutationResult = Apollo.MutationResult<GraphqlTypes.CancelComplianceInvitationMutation>;
export type CancelComplianceInvitationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelComplianceInvitationMutation, GraphqlTypes.CancelComplianceInvitationMutationVariables>;
export const GetEntitiesWithSearchWithoutArenaDocument = gql`
    query GetEntitiesWithSearchWithoutArena($nameSearch: String) {
  investmentEntitiesForProgramAssignment(filters: {nameSearchTerm: $nameSearch}) {
    rows {
      name
      id
      arena {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEntitiesWithSearchWithoutArenaQuery__
 *
 * To run a query within a React component, call `useGetEntitiesWithSearchWithoutArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesWithSearchWithoutArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesWithSearchWithoutArenaQuery({
 *   variables: {
 *      nameSearch: // value for 'nameSearch'
 *   },
 * });
 */
export function useGetEntitiesWithSearchWithoutArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>(GetEntitiesWithSearchWithoutArenaDocument, options);
      }
export function useGetEntitiesWithSearchWithoutArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>(GetEntitiesWithSearchWithoutArenaDocument, options);
        }
// @ts-ignore
export function useGetEntitiesWithSearchWithoutArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>;
export function useGetEntitiesWithSearchWithoutArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery | undefined, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>;
export function useGetEntitiesWithSearchWithoutArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>(GetEntitiesWithSearchWithoutArenaDocument, options);
        }
export type GetEntitiesWithSearchWithoutArenaQueryHookResult = ReturnType<typeof useGetEntitiesWithSearchWithoutArenaQuery>;
export type GetEntitiesWithSearchWithoutArenaLazyQueryHookResult = ReturnType<typeof useGetEntitiesWithSearchWithoutArenaLazyQuery>;
export type GetEntitiesWithSearchWithoutArenaSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesWithSearchWithoutArenaSuspenseQuery>;
export type GetEntitiesWithSearchWithoutArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesWithSearchWithoutArenaQuery, GraphqlTypes.GetEntitiesWithSearchWithoutArenaQueryVariables>;
export const GetEntityComplianceSettingsDocument = gql`
    query GetEntityComplianceSettings($nameSearchTerm: String) {
  investmentEntitiesForProgramAssignment(
    filters: {nameSearchTerm: $nameSearchTerm}
  ) {
    rows {
      id
      name
      arena {
        id
        name
      }
      complianceSettings {
        complianceProgram
        enabled
      }
    }
  }
}
    `;

/**
 * __useGetEntityComplianceSettingsQuery__
 *
 * To run a query within a React component, call `useGetEntityComplianceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityComplianceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityComplianceSettingsQuery({
 *   variables: {
 *      nameSearchTerm: // value for 'nameSearchTerm'
 *   },
 * });
 */
export function useGetEntityComplianceSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>(GetEntityComplianceSettingsDocument, options);
      }
export function useGetEntityComplianceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>(GetEntityComplianceSettingsDocument, options);
        }
// @ts-ignore
export function useGetEntityComplianceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>;
export function useGetEntityComplianceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityComplianceSettingsQuery | undefined, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>;
export function useGetEntityComplianceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>(GetEntityComplianceSettingsDocument, options);
        }
export type GetEntityComplianceSettingsQueryHookResult = ReturnType<typeof useGetEntityComplianceSettingsQuery>;
export type GetEntityComplianceSettingsLazyQueryHookResult = ReturnType<typeof useGetEntityComplianceSettingsLazyQuery>;
export type GetEntityComplianceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEntityComplianceSettingsSuspenseQuery>;
export type GetEntityComplianceSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityComplianceSettingsQuery, GraphqlTypes.GetEntityComplianceSettingsQueryVariables>;
export const GetCompliancePositionsListDocument = gql`
    query GetCompliancePositionsList($positionFilters: PositionFilterInput!) {
  positions(positionFilters: $positionFilters) {
    edges {
      node {
        id
        account {
          name
        }
        investmentEntity {
          id
          name
          portalStatus
        }
        arena {
          id
          name
        }
        status
        createdAt
        complianceProgram
        hasPassedPicrComplianceChecks
        prospect {
          id
        }
        subscription {
          id
        }
        isLegacyKyc
        activeCases {
          id
          caseType
        }
        onboardingCase {
          id
          name
          status
          caseType
          subStatus
          programId
          externalObject {
            objectId
          }
          investingProfile {
            id
            complianceObjectType
            firstName
            middleName
            lastName
            legalName
            riskRating {
              overriddenRating
              calculatedRating
            }
          }
          latestInvestingProfile {
            id
            complianceObjectType
            firstName
            middleName
            lastName
            legalName
            riskRating {
              overriddenRating
              calculatedRating
            }
          }
          complianceInvitation {
            id
            emailAddresses
            inviteType
            caseId
            message
            dateSent
            status
            sentCount
          }
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetCompliancePositionsListQuery__
 *
 * To run a query within a React component, call `useGetCompliancePositionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompliancePositionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompliancePositionsListQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *   },
 * });
 */
export function useGetCompliancePositionsListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables> & ({ variables: GraphqlTypes.GetCompliancePositionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>(GetCompliancePositionsListDocument, options);
      }
export function useGetCompliancePositionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>(GetCompliancePositionsListDocument, options);
        }
// @ts-ignore
export function useGetCompliancePositionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>;
export function useGetCompliancePositionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCompliancePositionsListQuery | undefined, GraphqlTypes.GetCompliancePositionsListQueryVariables>;
export function useGetCompliancePositionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>(GetCompliancePositionsListDocument, options);
        }
export type GetCompliancePositionsListQueryHookResult = ReturnType<typeof useGetCompliancePositionsListQuery>;
export type GetCompliancePositionsListLazyQueryHookResult = ReturnType<typeof useGetCompliancePositionsListLazyQuery>;
export type GetCompliancePositionsListSuspenseQueryHookResult = ReturnType<typeof useGetCompliancePositionsListSuspenseQuery>;
export type GetCompliancePositionsListQueryResult = Apollo.QueryResult<GraphqlTypes.GetCompliancePositionsListQuery, GraphqlTypes.GetCompliancePositionsListQueryVariables>;
export const GetProposedCasesForPositionDocument = gql`
    query GetProposedCasesForPosition($offset: Int, $limit: Int, $filters: [ComplianceCaseFilters!], $sorts: [ComplianceCaseSort!], $arenaId: Int, $positionId: String) {
  complianceCasesSlice(
    offset: $offset
    limit: $limit
    filters: $filters
    sorts: $sorts
    arenaId: $arenaId
    positionId: $positionId
  ) {
    filteredCount
    rows {
      id
      program {
        id
        name
        programType
      }
      caseType
      name
      status
      createdAt
      resolution
      assignee {
        id
        externalUser {
          id
          name
        }
      }
      investingProfile {
        id
        firstName
        middleName
        lastName
        legalName
        complianceObjectType
      }
      externalEntity {
        name
        objectId
      }
      externalArena {
        objectId
      }
    }
  }
}
    `;

/**
 * __useGetProposedCasesForPositionQuery__
 *
 * To run a query within a React component, call `useGetProposedCasesForPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposedCasesForPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposedCasesForPositionQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      arenaId: // value for 'arenaId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetProposedCasesForPositionQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>(GetProposedCasesForPositionDocument, options);
      }
export function useGetProposedCasesForPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>(GetProposedCasesForPositionDocument, options);
        }
// @ts-ignore
export function useGetProposedCasesForPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>;
export function useGetProposedCasesForPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProposedCasesForPositionQuery | undefined, GraphqlTypes.GetProposedCasesForPositionQueryVariables>;
export function useGetProposedCasesForPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>(GetProposedCasesForPositionDocument, options);
        }
export type GetProposedCasesForPositionQueryHookResult = ReturnType<typeof useGetProposedCasesForPositionQuery>;
export type GetProposedCasesForPositionLazyQueryHookResult = ReturnType<typeof useGetProposedCasesForPositionLazyQuery>;
export type GetProposedCasesForPositionSuspenseQueryHookResult = ReturnType<typeof useGetProposedCasesForPositionSuspenseQuery>;
export type GetProposedCasesForPositionQueryResult = Apollo.QueryResult<GraphqlTypes.GetProposedCasesForPositionQuery, GraphqlTypes.GetProposedCasesForPositionQueryVariables>;
export const GetIndividualPositionDetailsDocument = gql`
    query GetIndividualPositionDetails($positionFilters: PositionFilterInput!) {
  positions(positionFilters: $positionFilters) {
    edges {
      node {
        id
        account {
          name
        }
        investmentEntity {
          name
        }
        arena {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetIndividualPositionDetailsQuery__
 *
 * To run a query within a React component, call `useGetIndividualPositionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndividualPositionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndividualPositionDetailsQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *   },
 * });
 */
export function useGetIndividualPositionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables> & ({ variables: GraphqlTypes.GetIndividualPositionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>(GetIndividualPositionDetailsDocument, options);
      }
export function useGetIndividualPositionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>(GetIndividualPositionDetailsDocument, options);
        }
// @ts-ignore
export function useGetIndividualPositionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>;
export function useGetIndividualPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIndividualPositionDetailsQuery | undefined, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>;
export function useGetIndividualPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>(GetIndividualPositionDetailsDocument, options);
        }
export type GetIndividualPositionDetailsQueryHookResult = ReturnType<typeof useGetIndividualPositionDetailsQuery>;
export type GetIndividualPositionDetailsLazyQueryHookResult = ReturnType<typeof useGetIndividualPositionDetailsLazyQuery>;
export type GetIndividualPositionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetIndividualPositionDetailsSuspenseQuery>;
export type GetIndividualPositionDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetIndividualPositionDetailsQuery, GraphqlTypes.GetIndividualPositionDetailsQueryVariables>;
export const UpdatePositionCaseMapDocument = gql`
    mutation UpdatePositionCaseMap($positionId: String!, $caseId: Int) {
  updatePositionCaseMap(positionId: $positionId, caseId: $caseId)
}
    `;
export type UpdatePositionCaseMapMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePositionCaseMapMutation, GraphqlTypes.UpdatePositionCaseMapMutationVariables>;

/**
 * __useUpdatePositionCaseMapMutation__
 *
 * To run a mutation, you first call `useUpdatePositionCaseMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionCaseMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionCaseMapMutation, { data, loading, error }] = useUpdatePositionCaseMapMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useUpdatePositionCaseMapMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePositionCaseMapMutation, GraphqlTypes.UpdatePositionCaseMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePositionCaseMapMutation, GraphqlTypes.UpdatePositionCaseMapMutationVariables>(UpdatePositionCaseMapDocument, options);
      }
export type UpdatePositionCaseMapMutationHookResult = ReturnType<typeof useUpdatePositionCaseMapMutation>;
export type UpdatePositionCaseMapMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePositionCaseMapMutation>;
export type UpdatePositionCaseMapMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePositionCaseMapMutation, GraphqlTypes.UpdatePositionCaseMapMutationVariables>;
export const LinkOnboardingCaseDocument = gql`
    mutation LinkOnboardingCase($caseId: Int!, $arenaId: Int!, $externalObject: ExternalObjectInput!) {
  linkOnboardingCase(
    caseId: $caseId
    arenaId: $arenaId
    externalObject: $externalObject
  ) {
    id
  }
}
    `;
export type LinkOnboardingCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkOnboardingCaseMutation, GraphqlTypes.LinkOnboardingCaseMutationVariables>;

/**
 * __useLinkOnboardingCaseMutation__
 *
 * To run a mutation, you first call `useLinkOnboardingCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkOnboardingCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkOnboardingCaseMutation, { data, loading, error }] = useLinkOnboardingCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      arenaId: // value for 'arenaId'
 *      externalObject: // value for 'externalObject'
 *   },
 * });
 */
export function useLinkOnboardingCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkOnboardingCaseMutation, GraphqlTypes.LinkOnboardingCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkOnboardingCaseMutation, GraphqlTypes.LinkOnboardingCaseMutationVariables>(LinkOnboardingCaseDocument, options);
      }
export type LinkOnboardingCaseMutationHookResult = ReturnType<typeof useLinkOnboardingCaseMutation>;
export type LinkOnboardingCaseMutationResult = Apollo.MutationResult<GraphqlTypes.LinkOnboardingCaseMutation>;
export type LinkOnboardingCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkOnboardingCaseMutation, GraphqlTypes.LinkOnboardingCaseMutationVariables>;
export const SetClientProgramDocument = gql`
    mutation setClientProgram($arenaId: Int!, $programType: ProgramType!) {
  setClientProgram(arenaId: $arenaId, programType: $programType) {
    ok
    program
  }
}
    `;
export type SetClientProgramMutationFn = Apollo.MutationFunction<GraphqlTypes.SetClientProgramMutation, GraphqlTypes.SetClientProgramMutationVariables>;

/**
 * __useSetClientProgramMutation__
 *
 * To run a mutation, you first call `useSetClientProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClientProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClientProgramMutation, { data, loading, error }] = useSetClientProgramMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      programType: // value for 'programType'
 *   },
 * });
 */
export function useSetClientProgramMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetClientProgramMutation, GraphqlTypes.SetClientProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetClientProgramMutation, GraphqlTypes.SetClientProgramMutationVariables>(SetClientProgramDocument, options);
      }
export type SetClientProgramMutationHookResult = ReturnType<typeof useSetClientProgramMutation>;
export type SetClientProgramMutationResult = Apollo.MutationResult<GraphqlTypes.SetClientProgramMutation>;
export type SetClientProgramMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetClientProgramMutation, GraphqlTypes.SetClientProgramMutationVariables>;
export const SetEntityProgramDocument = gql`
    mutation setEntityProgram($accountId: Int!, $arenaId: Int!, $programType: ProgramType!) {
  setEntityProgram(
    accountId: $accountId
    arenaId: $arenaId
    programType: $programType
  ) {
    ok
    program
  }
}
    `;
export type SetEntityProgramMutationFn = Apollo.MutationFunction<GraphqlTypes.SetEntityProgramMutation, GraphqlTypes.SetEntityProgramMutationVariables>;

/**
 * __useSetEntityProgramMutation__
 *
 * To run a mutation, you first call `useSetEntityProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEntityProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEntityProgramMutation, { data, loading, error }] = useSetEntityProgramMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      arenaId: // value for 'arenaId'
 *      programType: // value for 'programType'
 *   },
 * });
 */
export function useSetEntityProgramMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetEntityProgramMutation, GraphqlTypes.SetEntityProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetEntityProgramMutation, GraphqlTypes.SetEntityProgramMutationVariables>(SetEntityProgramDocument, options);
      }
export type SetEntityProgramMutationHookResult = ReturnType<typeof useSetEntityProgramMutation>;
export type SetEntityProgramMutationResult = Apollo.MutationResult<GraphqlTypes.SetEntityProgramMutation>;
export type SetEntityProgramMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetEntityProgramMutation, GraphqlTypes.SetEntityProgramMutationVariables>;
export const SetFatcaCrsDataCollectionDocument = gql`
    mutation setFatcaCrsDataCollection($arenaId: ID!, $entityId: ID!, $enabled: Boolean!) {
  setFatcaCrsDataCollection(
    arenaId: $arenaId
    entityId: $entityId
    enabled: $enabled
  ) {
    ... on AccountObjectType {
      id
    }
  }
}
    `;
export type SetFatcaCrsDataCollectionMutationFn = Apollo.MutationFunction<GraphqlTypes.SetFatcaCrsDataCollectionMutation, GraphqlTypes.SetFatcaCrsDataCollectionMutationVariables>;

/**
 * __useSetFatcaCrsDataCollectionMutation__
 *
 * To run a mutation, you first call `useSetFatcaCrsDataCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFatcaCrsDataCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFatcaCrsDataCollectionMutation, { data, loading, error }] = useSetFatcaCrsDataCollectionMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetFatcaCrsDataCollectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetFatcaCrsDataCollectionMutation, GraphqlTypes.SetFatcaCrsDataCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetFatcaCrsDataCollectionMutation, GraphqlTypes.SetFatcaCrsDataCollectionMutationVariables>(SetFatcaCrsDataCollectionDocument, options);
      }
export type SetFatcaCrsDataCollectionMutationHookResult = ReturnType<typeof useSetFatcaCrsDataCollectionMutation>;
export type SetFatcaCrsDataCollectionMutationResult = Apollo.MutationResult<GraphqlTypes.SetFatcaCrsDataCollectionMutation>;
export type SetFatcaCrsDataCollectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetFatcaCrsDataCollectionMutation, GraphqlTypes.SetFatcaCrsDataCollectionMutationVariables>;
export const GetComplianceCasesSliceDocument = gql`
    query GetComplianceCasesSlice($offset: Int, $limit: Int, $filters: [ComplianceCaseFilters!], $sorts: [ComplianceCaseSort!]) {
  complianceCasesSlice(
    offset: $offset
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    filteredCount
    rows {
      ...BasicComplianceCaseDetails
    }
  }
}
    ${BasicComplianceCaseDetailsFragmentDoc}`;

/**
 * __useGetComplianceCasesSliceQuery__
 *
 * To run a query within a React component, call `useGetComplianceCasesSliceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCasesSliceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCasesSliceQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useGetComplianceCasesSliceQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>(GetComplianceCasesSliceDocument, options);
      }
export function useGetComplianceCasesSliceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>(GetComplianceCasesSliceDocument, options);
        }
// @ts-ignore
export function useGetComplianceCasesSliceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>;
export function useGetComplianceCasesSliceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCasesSliceQuery | undefined, GraphqlTypes.GetComplianceCasesSliceQueryVariables>;
export function useGetComplianceCasesSliceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>(GetComplianceCasesSliceDocument, options);
        }
export type GetComplianceCasesSliceQueryHookResult = ReturnType<typeof useGetComplianceCasesSliceQuery>;
export type GetComplianceCasesSliceLazyQueryHookResult = ReturnType<typeof useGetComplianceCasesSliceLazyQuery>;
export type GetComplianceCasesSliceSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCasesSliceSuspenseQuery>;
export type GetComplianceCasesSliceQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCasesSliceQuery, GraphqlTypes.GetComplianceCasesSliceQueryVariables>;
export const GetComplianceCaseDocument = gql`
    query GetComplianceCase($caseId: Int!) {
  complianceCase(id: $caseId) {
    ...FullComplianceCaseDetails
  }
}
    ${FullComplianceCaseDetailsFragmentDoc}`;

/**
 * __useGetComplianceCaseQuery__
 *
 * To run a query within a React component, call `useGetComplianceCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetComplianceCaseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>(GetComplianceCaseDocument, options);
      }
export function useGetComplianceCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>(GetComplianceCaseDocument, options);
        }
// @ts-ignore
export function useGetComplianceCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>;
export function useGetComplianceCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseQuery | undefined, GraphqlTypes.GetComplianceCaseQueryVariables>;
export function useGetComplianceCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>(GetComplianceCaseDocument, options);
        }
export type GetComplianceCaseQueryHookResult = ReturnType<typeof useGetComplianceCaseQuery>;
export type GetComplianceCaseLazyQueryHookResult = ReturnType<typeof useGetComplianceCaseLazyQuery>;
export type GetComplianceCaseSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCaseSuspenseQuery>;
export type GetComplianceCaseQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCaseQuery, GraphqlTypes.GetComplianceCaseQueryVariables>;
export const GetCaseInvestingProfileRiskRatingDocument = gql`
    query GetCaseInvestingProfileRiskRating($caseId: Int!) {
  complianceCase(id: $caseId) {
    riskRating
    investingProfile {
      riskRating {
        calculatedRating
        overriddenRating
      }
    }
  }
}
    `;

/**
 * __useGetCaseInvestingProfileRiskRatingQuery__
 *
 * To run a query within a React component, call `useGetCaseInvestingProfileRiskRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseInvestingProfileRiskRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseInvestingProfileRiskRatingQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetCaseInvestingProfileRiskRatingQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables> & ({ variables: GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>(GetCaseInvestingProfileRiskRatingDocument, options);
      }
export function useGetCaseInvestingProfileRiskRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>(GetCaseInvestingProfileRiskRatingDocument, options);
        }
// @ts-ignore
export function useGetCaseInvestingProfileRiskRatingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>;
export function useGetCaseInvestingProfileRiskRatingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery | undefined, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>;
export function useGetCaseInvestingProfileRiskRatingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>(GetCaseInvestingProfileRiskRatingDocument, options);
        }
export type GetCaseInvestingProfileRiskRatingQueryHookResult = ReturnType<typeof useGetCaseInvestingProfileRiskRatingQuery>;
export type GetCaseInvestingProfileRiskRatingLazyQueryHookResult = ReturnType<typeof useGetCaseInvestingProfileRiskRatingLazyQuery>;
export type GetCaseInvestingProfileRiskRatingSuspenseQueryHookResult = ReturnType<typeof useGetCaseInvestingProfileRiskRatingSuspenseQuery>;
export type GetCaseInvestingProfileRiskRatingQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseInvestingProfileRiskRatingQuery, GraphqlTypes.GetCaseInvestingProfileRiskRatingQueryVariables>;
export const GetCaseProfileScreeningRecordsDocument = gql`
    query GetCaseProfileScreeningRecords($caseId: Int!) {
  complianceCase(id: $caseId) {
    id
    investingProfile {
      id
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
    }
    profiles {
      id
      screeningRecord {
        profileId
        status
        result
        searchInput
      }
    }
  }
}
    `;

/**
 * __useGetCaseProfileScreeningRecordsQuery__
 *
 * To run a query within a React component, call `useGetCaseProfileScreeningRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseProfileScreeningRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseProfileScreeningRecordsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetCaseProfileScreeningRecordsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables> & ({ variables: GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>(GetCaseProfileScreeningRecordsDocument, options);
      }
export function useGetCaseProfileScreeningRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>(GetCaseProfileScreeningRecordsDocument, options);
        }
// @ts-ignore
export function useGetCaseProfileScreeningRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>;
export function useGetCaseProfileScreeningRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProfileScreeningRecordsQuery | undefined, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>;
export function useGetCaseProfileScreeningRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>(GetCaseProfileScreeningRecordsDocument, options);
        }
export type GetCaseProfileScreeningRecordsQueryHookResult = ReturnType<typeof useGetCaseProfileScreeningRecordsQuery>;
export type GetCaseProfileScreeningRecordsLazyQueryHookResult = ReturnType<typeof useGetCaseProfileScreeningRecordsLazyQuery>;
export type GetCaseProfileScreeningRecordsSuspenseQueryHookResult = ReturnType<typeof useGetCaseProfileScreeningRecordsSuspenseQuery>;
export type GetCaseProfileScreeningRecordsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseProfileScreeningRecordsQuery, GraphqlTypes.GetCaseProfileScreeningRecordsQueryVariables>;
export const GetCaseProfileScreeningRecordsWithMatchesDocument = gql`
    query GetCaseProfileScreeningRecordsWithMatches($caseId: Int!, $programId: Int) {
  complianceCase(id: $caseId) {
    id
    investingProfile {
      id
      screeningRecord {
        profileId
        status
        result
        searchInput
        matches(programId: $programId) {
          id
          pepCategory
          result
          screeningRecordId
          details
          immutable
          riskAssessment {
            score
            scoreExplanation
            recommendedAction
            riskType
          }
          modifiedAt
          caseId
          clients {
            id
            name
            objectId
            service
            objectType
            objectTypeEnum
          }
          programs
          searchInput
          deletedAt
        }
      }
      screeningMatches {
        id
        caseId
        clients {
          id
          name
        }
        pepCategory
        programs
        result
        screeningRecordId
        searchInput
        details
        modifiedAt
        immutable
        deletedAt
      }
    }
    profiles {
      id
      screeningRecord {
        profileId
        status
        result
        searchInput
        matches(programId: $programId) {
          id
          pepCategory
          result
          screeningRecordId
          details
          immutable
          riskAssessment {
            score
            scoreExplanation
            recommendedAction
            riskType
          }
          modifiedAt
          caseId
          clients {
            id
            name
            objectId
            service
            objectType
            objectTypeEnum
          }
          programs
          searchInput
          deletedAt
        }
      }
      screeningMatches {
        id
        caseId
        clients {
          id
          name
        }
        pepCategory
        programs
        result
        screeningRecordId
        searchInput
        details
        modifiedAt
        immutable
        deletedAt
      }
    }
  }
}
    `;

/**
 * __useGetCaseProfileScreeningRecordsWithMatchesQuery__
 *
 * To run a query within a React component, call `useGetCaseProfileScreeningRecordsWithMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseProfileScreeningRecordsWithMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseProfileScreeningRecordsWithMatchesQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetCaseProfileScreeningRecordsWithMatchesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables> & ({ variables: GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>(GetCaseProfileScreeningRecordsWithMatchesDocument, options);
      }
export function useGetCaseProfileScreeningRecordsWithMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>(GetCaseProfileScreeningRecordsWithMatchesDocument, options);
        }
// @ts-ignore
export function useGetCaseProfileScreeningRecordsWithMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>;
export function useGetCaseProfileScreeningRecordsWithMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery | undefined, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>;
export function useGetCaseProfileScreeningRecordsWithMatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>(GetCaseProfileScreeningRecordsWithMatchesDocument, options);
        }
export type GetCaseProfileScreeningRecordsWithMatchesQueryHookResult = ReturnType<typeof useGetCaseProfileScreeningRecordsWithMatchesQuery>;
export type GetCaseProfileScreeningRecordsWithMatchesLazyQueryHookResult = ReturnType<typeof useGetCaseProfileScreeningRecordsWithMatchesLazyQuery>;
export type GetCaseProfileScreeningRecordsWithMatchesSuspenseQueryHookResult = ReturnType<typeof useGetCaseProfileScreeningRecordsWithMatchesSuspenseQuery>;
export type GetCaseProfileScreeningRecordsWithMatchesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQuery, GraphqlTypes.GetCaseProfileScreeningRecordsWithMatchesQueryVariables>;
export const EntityFromProspectDocument = gql`
    query EntityFromProspect($prospectId: ID, $includeDeleted: Boolean) {
  investmentEntityFromProspect(
    prospectId: $prospectId
    includeDeleted: $includeDeleted
  ) {
    id
    name
    complianceSettings {
      complianceProgram
      enabled
    }
    arena {
      id
      name
    }
  }
}
    `;

/**
 * __useEntityFromProspectQuery__
 *
 * To run a query within a React component, call `useEntityFromProspectQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityFromProspectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFromProspectQuery({
 *   variables: {
 *      prospectId: // value for 'prospectId'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useEntityFromProspectQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>(EntityFromProspectDocument, options);
      }
export function useEntityFromProspectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>(EntityFromProspectDocument, options);
        }
// @ts-ignore
export function useEntityFromProspectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>;
export function useEntityFromProspectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.EntityFromProspectQuery | undefined, GraphqlTypes.EntityFromProspectQueryVariables>;
export function useEntityFromProspectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>(EntityFromProspectDocument, options);
        }
export type EntityFromProspectQueryHookResult = ReturnType<typeof useEntityFromProspectQuery>;
export type EntityFromProspectLazyQueryHookResult = ReturnType<typeof useEntityFromProspectLazyQuery>;
export type EntityFromProspectSuspenseQueryHookResult = ReturnType<typeof useEntityFromProspectSuspenseQuery>;
export type EntityFromProspectQueryResult = Apollo.QueryResult<GraphqlTypes.EntityFromProspectQuery, GraphqlTypes.EntityFromProspectQueryVariables>;
export const CreateIndividualProfileDocument = gql`
    mutation CreateIndividualProfile($arenaAccessId: Int!, $data: ComplianceIndividualProfileInput!, $parentProfileId: Int) {
  createIndividualProfile(
    arenaAccessId: $arenaAccessId
    data: $data
    parentProfileId: $parentProfileId
  ) {
    id
    firstName
    lastName
  }
}
    `;
export type CreateIndividualProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>;

/**
 * __useCreateIndividualProfileMutation__
 *
 * To run a mutation, you first call `useCreateIndividualProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndividualProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndividualProfileMutation, { data, loading, error }] = useCreateIndividualProfileMutation({
 *   variables: {
 *      arenaAccessId: // value for 'arenaAccessId'
 *      data: // value for 'data'
 *      parentProfileId: // value for 'parentProfileId'
 *   },
 * });
 */
export function useCreateIndividualProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>(CreateIndividualProfileDocument, options);
      }
export type CreateIndividualProfileMutationHookResult = ReturnType<typeof useCreateIndividualProfileMutation>;
export type CreateIndividualProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateIndividualProfileMutation>;
export type CreateIndividualProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateIndividualProfileMutation, GraphqlTypes.CreateIndividualProfileMutationVariables>;
export const UpdateIndividualProfileDocument = gql`
    mutation UpdateIndividualProfile($data: ComplianceIndividualProfileInput!, $profileId: Int!, $parentProfileId: Int, $resolveConflictsOnDocId: Int = null) {
  updateIndividualProfile(
    data: $data
    profileId: $profileId
    parentProfileId: $parentProfileId
    resolveConflictsOnDocId: $resolveConflictsOnDocId
  ) {
    id
  }
}
    `;
export type UpdateIndividualProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateIndividualProfileMutation, GraphqlTypes.UpdateIndividualProfileMutationVariables>;

/**
 * __useUpdateIndividualProfileMutation__
 *
 * To run a mutation, you first call `useUpdateIndividualProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndividualProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndividualProfileMutation, { data, loading, error }] = useUpdateIndividualProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      profileId: // value for 'profileId'
 *      parentProfileId: // value for 'parentProfileId'
 *      resolveConflictsOnDocId: // value for 'resolveConflictsOnDocId'
 *   },
 * });
 */
export function useUpdateIndividualProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateIndividualProfileMutation, GraphqlTypes.UpdateIndividualProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateIndividualProfileMutation, GraphqlTypes.UpdateIndividualProfileMutationVariables>(UpdateIndividualProfileDocument, options);
      }
export type UpdateIndividualProfileMutationHookResult = ReturnType<typeof useUpdateIndividualProfileMutation>;
export type UpdateIndividualProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateIndividualProfileMutation>;
export type UpdateIndividualProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateIndividualProfileMutation, GraphqlTypes.UpdateIndividualProfileMutationVariables>;
export const CreateInstitutionProileDocument = gql`
    mutation CreateInstitutionProile($arenaAccessId: Int!, $data: ComplianceInstitutionProfileInput!, $parentProfileId: Int) {
  createInstitutionProfile(
    arenaAccessId: $arenaAccessId
    data: $data
    parentProfileId: $parentProfileId
  ) {
    id
    legalName
  }
}
    `;
export type CreateInstitutionProileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateInstitutionProileMutation, GraphqlTypes.CreateInstitutionProileMutationVariables>;

/**
 * __useCreateInstitutionProileMutation__
 *
 * To run a mutation, you first call `useCreateInstitutionProileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstitutionProileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstitutionProileMutation, { data, loading, error }] = useCreateInstitutionProileMutation({
 *   variables: {
 *      arenaAccessId: // value for 'arenaAccessId'
 *      data: // value for 'data'
 *      parentProfileId: // value for 'parentProfileId'
 *   },
 * });
 */
export function useCreateInstitutionProileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateInstitutionProileMutation, GraphqlTypes.CreateInstitutionProileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateInstitutionProileMutation, GraphqlTypes.CreateInstitutionProileMutationVariables>(CreateInstitutionProileDocument, options);
      }
export type CreateInstitutionProileMutationHookResult = ReturnType<typeof useCreateInstitutionProileMutation>;
export type CreateInstitutionProileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateInstitutionProileMutation>;
export type CreateInstitutionProileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateInstitutionProileMutation, GraphqlTypes.CreateInstitutionProileMutationVariables>;
export const UpdateInstitutionProfileDocument = gql`
    mutation UpdateInstitutionProfile($data: ComplianceInstitutionProfileInput!, $profileId: Int!, $parentProfileId: Int, $resolveConflictsOnDocId: Int = null) {
  updateInstitutionProfile(
    data: $data
    profileId: $profileId
    parentProfileId: $parentProfileId
    resolveConflictsOnDocId: $resolveConflictsOnDocId
  ) {
    id
  }
}
    `;
export type UpdateInstitutionProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateInstitutionProfileMutation, GraphqlTypes.UpdateInstitutionProfileMutationVariables>;

/**
 * __useUpdateInstitutionProfileMutation__
 *
 * To run a mutation, you first call `useUpdateInstitutionProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstitutionProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstitutionProfileMutation, { data, loading, error }] = useUpdateInstitutionProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      profileId: // value for 'profileId'
 *      parentProfileId: // value for 'parentProfileId'
 *      resolveConflictsOnDocId: // value for 'resolveConflictsOnDocId'
 *   },
 * });
 */
export function useUpdateInstitutionProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateInstitutionProfileMutation, GraphqlTypes.UpdateInstitutionProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateInstitutionProfileMutation, GraphqlTypes.UpdateInstitutionProfileMutationVariables>(UpdateInstitutionProfileDocument, options);
      }
export type UpdateInstitutionProfileMutationHookResult = ReturnType<typeof useUpdateInstitutionProfileMutation>;
export type UpdateInstitutionProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateInstitutionProfileMutation>;
export type UpdateInstitutionProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateInstitutionProfileMutation, GraphqlTypes.UpdateInstitutionProfileMutationVariables>;
export const CreateIndividualProfileAndCreateCaseDocument = gql`
    mutation CreateIndividualProfileAndCreateCase($profileData: ComplianceIndividualProfileInput!, $programId: Int!, $externalEntity: ExternalObjectInput!, $externalArena: ExternalObjectInput!, $caseExternalObject: ExternalObjectInput, $assignSelf: Boolean!, $documentIds: [Int!] = null) {
  createCaseWithNewIndividualProfile(
    profileData: $profileData
    programId: $programId
    externalEntity: $externalEntity
    externalArena: $externalArena
    caseExternalObject: $caseExternalObject
    assignSelf: $assignSelf
    documentIds: $documentIds
  ) {
    profile {
      id
    }
    case {
      id
    }
  }
}
    `;
export type CreateIndividualProfileAndCreateCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateIndividualProfileAndCreateCaseMutation, GraphqlTypes.CreateIndividualProfileAndCreateCaseMutationVariables>;

/**
 * __useCreateIndividualProfileAndCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateIndividualProfileAndCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndividualProfileAndCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndividualProfileAndCreateCaseMutation, { data, loading, error }] = useCreateIndividualProfileAndCreateCaseMutation({
 *   variables: {
 *      profileData: // value for 'profileData'
 *      programId: // value for 'programId'
 *      externalEntity: // value for 'externalEntity'
 *      externalArena: // value for 'externalArena'
 *      caseExternalObject: // value for 'caseExternalObject'
 *      assignSelf: // value for 'assignSelf'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateIndividualProfileAndCreateCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateIndividualProfileAndCreateCaseMutation, GraphqlTypes.CreateIndividualProfileAndCreateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateIndividualProfileAndCreateCaseMutation, GraphqlTypes.CreateIndividualProfileAndCreateCaseMutationVariables>(CreateIndividualProfileAndCreateCaseDocument, options);
      }
export type CreateIndividualProfileAndCreateCaseMutationHookResult = ReturnType<typeof useCreateIndividualProfileAndCreateCaseMutation>;
export type CreateIndividualProfileAndCreateCaseMutationResult = Apollo.MutationResult<GraphqlTypes.CreateIndividualProfileAndCreateCaseMutation>;
export type CreateIndividualProfileAndCreateCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateIndividualProfileAndCreateCaseMutation, GraphqlTypes.CreateIndividualProfileAndCreateCaseMutationVariables>;
export const CreateInstitutionProfileAndCreateCaseDocument = gql`
    mutation CreateInstitutionProfileAndCreateCase($profileData: ComplianceInstitutionProfileInput!, $programId: Int!, $externalEntity: ExternalObjectInput!, $externalArena: ExternalObjectInput!, $caseExternalObject: ExternalObjectInput, $assignSelf: Boolean!, $documentIds: [Int!] = null) {
  createCaseWithNewInstitutionProfile(
    profileData: $profileData
    programId: $programId
    externalEntity: $externalEntity
    externalArena: $externalArena
    caseExternalObject: $caseExternalObject
    assignSelf: $assignSelf
    documentIds: $documentIds
  ) {
    profile {
      id
    }
    case {
      id
    }
  }
}
    `;
export type CreateInstitutionProfileAndCreateCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutation, GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutationVariables>;

/**
 * __useCreateInstitutionProfileAndCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateInstitutionProfileAndCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstitutionProfileAndCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstitutionProfileAndCreateCaseMutation, { data, loading, error }] = useCreateInstitutionProfileAndCreateCaseMutation({
 *   variables: {
 *      profileData: // value for 'profileData'
 *      programId: // value for 'programId'
 *      externalEntity: // value for 'externalEntity'
 *      externalArena: // value for 'externalArena'
 *      caseExternalObject: // value for 'caseExternalObject'
 *      assignSelf: // value for 'assignSelf'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateInstitutionProfileAndCreateCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutation, GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutation, GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutationVariables>(CreateInstitutionProfileAndCreateCaseDocument, options);
      }
export type CreateInstitutionProfileAndCreateCaseMutationHookResult = ReturnType<typeof useCreateInstitutionProfileAndCreateCaseMutation>;
export type CreateInstitutionProfileAndCreateCaseMutationResult = Apollo.MutationResult<GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutation>;
export type CreateInstitutionProfileAndCreateCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutation, GraphqlTypes.CreateInstitutionProfileAndCreateCaseMutationVariables>;
export const GetProgramNamesAndIdsDocument = gql`
    query GetProgramNamesAndIds {
  programsAssignableToEntities {
    name
    id
  }
}
    `;

/**
 * __useGetProgramNamesAndIdsQuery__
 *
 * To run a query within a React component, call `useGetProgramNamesAndIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramNamesAndIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramNamesAndIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgramNamesAndIdsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>(GetProgramNamesAndIdsDocument, options);
      }
export function useGetProgramNamesAndIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>(GetProgramNamesAndIdsDocument, options);
        }
// @ts-ignore
export function useGetProgramNamesAndIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>;
export function useGetProgramNamesAndIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProgramNamesAndIdsQuery | undefined, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>;
export function useGetProgramNamesAndIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>(GetProgramNamesAndIdsDocument, options);
        }
export type GetProgramNamesAndIdsQueryHookResult = ReturnType<typeof useGetProgramNamesAndIdsQuery>;
export type GetProgramNamesAndIdsLazyQueryHookResult = ReturnType<typeof useGetProgramNamesAndIdsLazyQuery>;
export type GetProgramNamesAndIdsSuspenseQueryHookResult = ReturnType<typeof useGetProgramNamesAndIdsSuspenseQuery>;
export type GetProgramNamesAndIdsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProgramNamesAndIdsQuery, GraphqlTypes.GetProgramNamesAndIdsQueryVariables>;
export const GetDocumentExtractedDataDocument = gql`
    query GetDocumentExtractedData($docId: Int!) {
  document(documentId: $docId) {
    id
    name
    agentJobId
    agentJobStatus
    agentExtractedData
  }
}
    `;

/**
 * __useGetDocumentExtractedDataQuery__
 *
 * To run a query within a React component, call `useGetDocumentExtractedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentExtractedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentExtractedDataQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useGetDocumentExtractedDataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables> & ({ variables: GraphqlTypes.GetDocumentExtractedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>(GetDocumentExtractedDataDocument, options);
      }
export function useGetDocumentExtractedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>(GetDocumentExtractedDataDocument, options);
        }
// @ts-ignore
export function useGetDocumentExtractedDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>;
export function useGetDocumentExtractedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentExtractedDataQuery | undefined, GraphqlTypes.GetDocumentExtractedDataQueryVariables>;
export function useGetDocumentExtractedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>(GetDocumentExtractedDataDocument, options);
        }
export type GetDocumentExtractedDataQueryHookResult = ReturnType<typeof useGetDocumentExtractedDataQuery>;
export type GetDocumentExtractedDataLazyQueryHookResult = ReturnType<typeof useGetDocumentExtractedDataLazyQuery>;
export type GetDocumentExtractedDataSuspenseQueryHookResult = ReturnType<typeof useGetDocumentExtractedDataSuspenseQuery>;
export type GetDocumentExtractedDataQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentExtractedDataQuery, GraphqlTypes.GetDocumentExtractedDataQueryVariables>;
export const GetComplianceCaseByProspectDocument = gql`
    query GetComplianceCaseByProspect($arenaId: Int!, $prospectId: Int!) {
  complianceCaseByProspectId(
    prospectId: $prospectId
    arenaId: $arenaId
    includeClosed: true
  ) {
    id
  }
}
    `;

/**
 * __useGetComplianceCaseByProspectQuery__
 *
 * To run a query within a React component, call `useGetComplianceCaseByProspectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComplianceCaseByProspectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComplianceCaseByProspectQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      prospectId: // value for 'prospectId'
 *   },
 * });
 */
export function useGetComplianceCaseByProspectQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables> & ({ variables: GraphqlTypes.GetComplianceCaseByProspectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>(GetComplianceCaseByProspectDocument, options);
      }
export function useGetComplianceCaseByProspectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>(GetComplianceCaseByProspectDocument, options);
        }
// @ts-ignore
export function useGetComplianceCaseByProspectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>;
export function useGetComplianceCaseByProspectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetComplianceCaseByProspectQuery | undefined, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>;
export function useGetComplianceCaseByProspectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>(GetComplianceCaseByProspectDocument, options);
        }
export type GetComplianceCaseByProspectQueryHookResult = ReturnType<typeof useGetComplianceCaseByProspectQuery>;
export type GetComplianceCaseByProspectLazyQueryHookResult = ReturnType<typeof useGetComplianceCaseByProspectLazyQuery>;
export type GetComplianceCaseByProspectSuspenseQueryHookResult = ReturnType<typeof useGetComplianceCaseByProspectSuspenseQuery>;
export type GetComplianceCaseByProspectQueryResult = Apollo.QueryResult<GraphqlTypes.GetComplianceCaseByProspectQuery, GraphqlTypes.GetComplianceCaseByProspectQueryVariables>;
export const OnboardingCaseForSubjectDocument = gql`
    query OnboardingCaseForSubject($caseType: ComplianceCaseTypeEnum!, $externalObject: ExternalObjectInput!) {
  onboardingCaseForSubject(caseType: $caseType, externalObject: $externalObject) {
    id
    status
  }
}
    `;

/**
 * __useOnboardingCaseForSubjectQuery__
 *
 * To run a query within a React component, call `useOnboardingCaseForSubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCaseForSubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingCaseForSubjectQuery({
 *   variables: {
 *      caseType: // value for 'caseType'
 *      externalObject: // value for 'externalObject'
 *   },
 * });
 */
export function useOnboardingCaseForSubjectQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables> & ({ variables: GraphqlTypes.OnboardingCaseForSubjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>(OnboardingCaseForSubjectDocument, options);
      }
export function useOnboardingCaseForSubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>(OnboardingCaseForSubjectDocument, options);
        }
// @ts-ignore
export function useOnboardingCaseForSubjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>;
export function useOnboardingCaseForSubjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.OnboardingCaseForSubjectQuery | undefined, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>;
export function useOnboardingCaseForSubjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>(OnboardingCaseForSubjectDocument, options);
        }
export type OnboardingCaseForSubjectQueryHookResult = ReturnType<typeof useOnboardingCaseForSubjectQuery>;
export type OnboardingCaseForSubjectLazyQueryHookResult = ReturnType<typeof useOnboardingCaseForSubjectLazyQuery>;
export type OnboardingCaseForSubjectSuspenseQueryHookResult = ReturnType<typeof useOnboardingCaseForSubjectSuspenseQuery>;
export type OnboardingCaseForSubjectQueryResult = Apollo.QueryResult<GraphqlTypes.OnboardingCaseForSubjectQuery, GraphqlTypes.OnboardingCaseForSubjectQueryVariables>;
export const CreateEntityClientOnboardingCaseDocument = gql`
    mutation CreateEntityClientOnboardingCase($profileData: ComplianceInstitutionProfileInput!, $programId: Int!, $externalArena: ExternalObjectInput!, $externalEntity: ExternalObjectInput, $caseType: ComplianceCaseTypeEnum, $assignSelf: Boolean!, $documentIds: [Int!] = null) {
  createCaseWithNewInstitutionProfile(
    profileData: $profileData
    programId: $programId
    externalArena: $externalArena
    externalEntity: $externalEntity
    caseType: $caseType
    assignSelf: $assignSelf
    documentIds: $documentIds
  ) {
    case {
      id
    }
  }
}
    `;
export type CreateEntityClientOnboardingCaseMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateEntityClientOnboardingCaseMutation, GraphqlTypes.CreateEntityClientOnboardingCaseMutationVariables>;

/**
 * __useCreateEntityClientOnboardingCaseMutation__
 *
 * To run a mutation, you first call `useCreateEntityClientOnboardingCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityClientOnboardingCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityClientOnboardingCaseMutation, { data, loading, error }] = useCreateEntityClientOnboardingCaseMutation({
 *   variables: {
 *      profileData: // value for 'profileData'
 *      programId: // value for 'programId'
 *      externalArena: // value for 'externalArena'
 *      externalEntity: // value for 'externalEntity'
 *      caseType: // value for 'caseType'
 *      assignSelf: // value for 'assignSelf'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateEntityClientOnboardingCaseMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateEntityClientOnboardingCaseMutation, GraphqlTypes.CreateEntityClientOnboardingCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateEntityClientOnboardingCaseMutation, GraphqlTypes.CreateEntityClientOnboardingCaseMutationVariables>(CreateEntityClientOnboardingCaseDocument, options);
      }
export type CreateEntityClientOnboardingCaseMutationHookResult = ReturnType<typeof useCreateEntityClientOnboardingCaseMutation>;
export type CreateEntityClientOnboardingCaseMutationResult = Apollo.MutationResult<GraphqlTypes.CreateEntityClientOnboardingCaseMutation>;
export type CreateEntityClientOnboardingCaseMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateEntityClientOnboardingCaseMutation, GraphqlTypes.CreateEntityClientOnboardingCaseMutationVariables>;
export const GetEscalationCasesSliceDocument = gql`
    query GetEscalationCasesSlice($offset: Int, $limit: Int, $filters: [ComplianceCaseFilters!], $sorts: [ComplianceCaseSort!], $profileCaseTypes: [ComplianceCaseTypeEnum!]) {
  complianceCasesSlice(
    offset: $offset
    limit: $limit
    filters: $filters
    sorts: $sorts
  ) {
    filteredCount
    rows {
      id
      createdAt
      name
      origin
      status
      resolution
      program {
        id
        name
      }
      externalArena {
        id
        objectId
        name
      }
      investingProfile {
        id
        firstName
        lastName
        legalName
        complianceCases(caseTypes: $profileCaseTypes) {
          complianceCase {
            id
            externalArena {
              id
            }
            position {
              id
            }
          }
        }
      }
      assignee {
        id
        externalUser {
          id
          name
        }
      }
      sourceCase {
        id
        name
        caseType
        investingProfile {
          id
          firstName
          lastName
          legalName
        }
      }
    }
  }
}
    `;

/**
 * __useGetEscalationCasesSliceQuery__
 *
 * To run a query within a React component, call `useGetEscalationCasesSliceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEscalationCasesSliceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEscalationCasesSliceQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      profileCaseTypes: // value for 'profileCaseTypes'
 *   },
 * });
 */
export function useGetEscalationCasesSliceQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>(GetEscalationCasesSliceDocument, options);
      }
export function useGetEscalationCasesSliceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>(GetEscalationCasesSliceDocument, options);
        }
// @ts-ignore
export function useGetEscalationCasesSliceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>;
export function useGetEscalationCasesSliceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEscalationCasesSliceQuery | undefined, GraphqlTypes.GetEscalationCasesSliceQueryVariables>;
export function useGetEscalationCasesSliceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>(GetEscalationCasesSliceDocument, options);
        }
export type GetEscalationCasesSliceQueryHookResult = ReturnType<typeof useGetEscalationCasesSliceQuery>;
export type GetEscalationCasesSliceLazyQueryHookResult = ReturnType<typeof useGetEscalationCasesSliceLazyQuery>;
export type GetEscalationCasesSliceSuspenseQueryHookResult = ReturnType<typeof useGetEscalationCasesSliceSuspenseQuery>;
export type GetEscalationCasesSliceQueryResult = Apollo.QueryResult<GraphqlTypes.GetEscalationCasesSliceQuery, GraphqlTypes.GetEscalationCasesSliceQueryVariables>;
export const ExistingPositionsDocument = gql`
    query ExistingPositions($profileId: Int!) {
  complianceProfile(id: $profileId) {
    id
    complianceObjectType
    firstName
    middleName
    lastName
    legalName
    positionCount
    positions {
      id
      status
      account {
        id
        name
      }
      investmentEntity {
        id
        name
      }
      arena {
        id
      }
      complianceProgram
    }
  }
}
    `;

/**
 * __useExistingPositionsQuery__
 *
 * To run a query within a React component, call `useExistingPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingPositionsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useExistingPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables> & ({ variables: GraphqlTypes.ExistingPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>(ExistingPositionsDocument, options);
      }
export function useExistingPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>(ExistingPositionsDocument, options);
        }
// @ts-ignore
export function useExistingPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>;
export function useExistingPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ExistingPositionsQuery | undefined, GraphqlTypes.ExistingPositionsQueryVariables>;
export function useExistingPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>(ExistingPositionsDocument, options);
        }
export type ExistingPositionsQueryHookResult = ReturnType<typeof useExistingPositionsQuery>;
export type ExistingPositionsLazyQueryHookResult = ReturnType<typeof useExistingPositionsLazyQuery>;
export type ExistingPositionsSuspenseQueryHookResult = ReturnType<typeof useExistingPositionsSuspenseQuery>;
export type ExistingPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.ExistingPositionsQuery, GraphqlTypes.ExistingPositionsQueryVariables>;
export const GetDownloadReportStatusDocument = gql`
    query GetDownloadReportStatus($reportId: Int!) {
  getComplianceReport(id: $reportId) {
    id
    status
    s3Url
    errorMsg
  }
}
    `;

/**
 * __useGetDownloadReportStatusQuery__
 *
 * To run a query within a React component, call `useGetDownloadReportStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadReportStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadReportStatusQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useGetDownloadReportStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables> & ({ variables: GraphqlTypes.GetDownloadReportStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>(GetDownloadReportStatusDocument, options);
      }
export function useGetDownloadReportStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>(GetDownloadReportStatusDocument, options);
        }
// @ts-ignore
export function useGetDownloadReportStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>;
export function useGetDownloadReportStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDownloadReportStatusQuery | undefined, GraphqlTypes.GetDownloadReportStatusQueryVariables>;
export function useGetDownloadReportStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>(GetDownloadReportStatusDocument, options);
        }
export type GetDownloadReportStatusQueryHookResult = ReturnType<typeof useGetDownloadReportStatusQuery>;
export type GetDownloadReportStatusLazyQueryHookResult = ReturnType<typeof useGetDownloadReportStatusLazyQuery>;
export type GetDownloadReportStatusSuspenseQueryHookResult = ReturnType<typeof useGetDownloadReportStatusSuspenseQuery>;
export type GetDownloadReportStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetDownloadReportStatusQuery, GraphqlTypes.GetDownloadReportStatusQueryVariables>;
export const DownloadReportDocument = gql`
    mutation DownloadReport($reportType: ComplianceReportType!, $caseIds: [Int!]!, $idsAreSelectedVsUnselected: Boolean!, $filters: [ComplianceCaseFilters!]!) {
  createComplianceReport(
    createReportInput: {reportType: $reportType, caseIds: $caseIds, idsAreSelectedVsUnselected: $idsAreSelectedVsUnselected, filters: $filters}
  ) {
    id
    status
    errorMsg
  }
}
    `;
export type DownloadReportMutationFn = Apollo.MutationFunction<GraphqlTypes.DownloadReportMutation, GraphqlTypes.DownloadReportMutationVariables>;

/**
 * __useDownloadReportMutation__
 *
 * To run a mutation, you first call `useDownloadReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadReportMutation, { data, loading, error }] = useDownloadReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      caseIds: // value for 'caseIds'
 *      idsAreSelectedVsUnselected: // value for 'idsAreSelectedVsUnselected'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDownloadReportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DownloadReportMutation, GraphqlTypes.DownloadReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DownloadReportMutation, GraphqlTypes.DownloadReportMutationVariables>(DownloadReportDocument, options);
      }
export type DownloadReportMutationHookResult = ReturnType<typeof useDownloadReportMutation>;
export type DownloadReportMutationResult = Apollo.MutationResult<GraphqlTypes.DownloadReportMutation>;
export type DownloadReportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DownloadReportMutation, GraphqlTypes.DownloadReportMutationVariables>;
export const GetWhetherContainsMultipleClientsDocument = gql`
    query GetWhetherContainsMultipleClients($reportType: ComplianceReportType!, $caseIds: [Int!]!, $idsAreSelectedVsUnselected: Boolean!, $filters: [ComplianceCaseFilters!]!) {
  getWhetherContainsMultipleClients(
    createReportInput: {reportType: $reportType, caseIds: $caseIds, idsAreSelectedVsUnselected: $idsAreSelectedVsUnselected, filters: $filters}
  )
}
    `;

/**
 * __useGetWhetherContainsMultipleClientsQuery__
 *
 * To run a query within a React component, call `useGetWhetherContainsMultipleClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhetherContainsMultipleClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhetherContainsMultipleClientsQuery({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      caseIds: // value for 'caseIds'
 *      idsAreSelectedVsUnselected: // value for 'idsAreSelectedVsUnselected'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWhetherContainsMultipleClientsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables> & ({ variables: GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>(GetWhetherContainsMultipleClientsDocument, options);
      }
export function useGetWhetherContainsMultipleClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>(GetWhetherContainsMultipleClientsDocument, options);
        }
// @ts-ignore
export function useGetWhetherContainsMultipleClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>;
export function useGetWhetherContainsMultipleClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWhetherContainsMultipleClientsQuery | undefined, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>;
export function useGetWhetherContainsMultipleClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>(GetWhetherContainsMultipleClientsDocument, options);
        }
export type GetWhetherContainsMultipleClientsQueryHookResult = ReturnType<typeof useGetWhetherContainsMultipleClientsQuery>;
export type GetWhetherContainsMultipleClientsLazyQueryHookResult = ReturnType<typeof useGetWhetherContainsMultipleClientsLazyQuery>;
export type GetWhetherContainsMultipleClientsSuspenseQueryHookResult = ReturnType<typeof useGetWhetherContainsMultipleClientsSuspenseQuery>;
export type GetWhetherContainsMultipleClientsQueryResult = Apollo.QueryResult<GraphqlTypes.GetWhetherContainsMultipleClientsQuery, GraphqlTypes.GetWhetherContainsMultipleClientsQueryVariables>;
export const GetArenasV2Document = gql`
    query GetArenasV2($searchTerm: String) {
  arenas(searchTerm: $searchTerm) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetArenasV2Query__
 *
 * To run a query within a React component, call `useGetArenasV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasV2Query({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetArenasV2Query(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>(GetArenasV2Document, options);
      }
export function useGetArenasV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>(GetArenasV2Document, options);
        }
// @ts-ignore
export function useGetArenasV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>;
export function useGetArenasV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasV2Query | undefined, GraphqlTypes.GetArenasV2QueryVariables>;
export function useGetArenasV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>(GetArenasV2Document, options);
        }
export type GetArenasV2QueryHookResult = ReturnType<typeof useGetArenasV2Query>;
export type GetArenasV2LazyQueryHookResult = ReturnType<typeof useGetArenasV2LazyQuery>;
export type GetArenasV2SuspenseQueryHookResult = ReturnType<typeof useGetArenasV2SuspenseQuery>;
export type GetArenasV2QueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasV2Query, GraphqlTypes.GetArenasV2QueryVariables>;
export const GetPositionContextDocument = gql`
    query GetPositionContext($positionId: ID!) {
  positionForComplianceUser(positionId: $positionId) {
    id
    arena {
      id
      name
    }
    onboardingCase {
      id
    }
    investmentEntity {
      id
      name
      complianceSettings {
        complianceProgram
      }
    }
  }
}
    `;

/**
 * __useGetPositionContextQuery__
 *
 * To run a query within a React component, call `useGetPositionContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionContextQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetPositionContextQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables> & ({ variables: GraphqlTypes.GetPositionContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>(GetPositionContextDocument, options);
      }
export function useGetPositionContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>(GetPositionContextDocument, options);
        }
// @ts-ignore
export function useGetPositionContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>;
export function useGetPositionContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionContextQuery | undefined, GraphqlTypes.GetPositionContextQueryVariables>;
export function useGetPositionContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>(GetPositionContextDocument, options);
        }
export type GetPositionContextQueryHookResult = ReturnType<typeof useGetPositionContextQuery>;
export type GetPositionContextLazyQueryHookResult = ReturnType<typeof useGetPositionContextLazyQuery>;
export type GetPositionContextSuspenseQueryHookResult = ReturnType<typeof useGetPositionContextSuspenseQuery>;
export type GetPositionContextQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionContextQuery, GraphqlTypes.GetPositionContextQueryVariables>;
export const ProfileInvestmentAccountDetailsDocument = gql`
    query ProfileInvestmentAccountDetails($arenaId: Int!, $profileGuid: String!) {
  profileInvestmentAccountDetails(arenaId: $arenaId, profileGuid: $profileGuid) {
    investmentAccountId
    clientName
    accountType
    entityType
    name
    taxId
    positionsSummary {
      id
      name
      complianceProgram
    }
    account {
      domicileAddress {
        ...AccountComparisonAddress
      }
      mailingAddress {
        ...AccountComparisonAddress
      }
    }
  }
}
    ${AccountComparisonAddressFragmentDoc}`;

/**
 * __useProfileInvestmentAccountDetailsQuery__
 *
 * To run a query within a React component, call `useProfileInvestmentAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileInvestmentAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileInvestmentAccountDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      profileGuid: // value for 'profileGuid'
 *   },
 * });
 */
export function useProfileInvestmentAccountDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables> & ({ variables: GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>(ProfileInvestmentAccountDetailsDocument, options);
      }
export function useProfileInvestmentAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>(ProfileInvestmentAccountDetailsDocument, options);
        }
// @ts-ignore
export function useProfileInvestmentAccountDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>;
export function useProfileInvestmentAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProfileInvestmentAccountDetailsQuery | undefined, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>;
export function useProfileInvestmentAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>(ProfileInvestmentAccountDetailsDocument, options);
        }
export type ProfileInvestmentAccountDetailsQueryHookResult = ReturnType<typeof useProfileInvestmentAccountDetailsQuery>;
export type ProfileInvestmentAccountDetailsLazyQueryHookResult = ReturnType<typeof useProfileInvestmentAccountDetailsLazyQuery>;
export type ProfileInvestmentAccountDetailsSuspenseQueryHookResult = ReturnType<typeof useProfileInvestmentAccountDetailsSuspenseQuery>;
export type ProfileInvestmentAccountDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.ProfileInvestmentAccountDetailsQuery, GraphqlTypes.ProfileInvestmentAccountDetailsQueryVariables>;
export const RankedProfilesDocument = gql`
    query RankedProfiles($arenaId: Int!, $entityId: Int!, $investmentAccountId: Int, $taxId: String, $name: String) {
  rankedProfile(
    arenaId: $arenaId
    entityId: $entityId
    investmentAccountId: $investmentAccountId
    taxId: $taxId
    name: $name
  ) {
    investmentAccount {
      id
    }
    profiles {
      id
      profileGuid
      complianceObjectType
      accountType
      firstName
      middleName
      lastName
      legalName
      matchPercent
      lastUsedOnInvestmentAccount
      lastUsedOnInvestmentAccountAt
      lastUsedOnIO
      positions {
        account {
          name
        }
        investmentEntity {
          name
        }
        complianceProgram
      }
      associatedInvestmentAccounts {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useRankedProfilesQuery__
 *
 * To run a query within a React component, call `useRankedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankedProfilesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      investmentAccountId: // value for 'investmentAccountId'
 *      taxId: // value for 'taxId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRankedProfilesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables> & ({ variables: GraphqlTypes.RankedProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>(RankedProfilesDocument, options);
      }
export function useRankedProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>(RankedProfilesDocument, options);
        }
// @ts-ignore
export function useRankedProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>;
export function useRankedProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.RankedProfilesQuery | undefined, GraphqlTypes.RankedProfilesQueryVariables>;
export function useRankedProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>(RankedProfilesDocument, options);
        }
export type RankedProfilesQueryHookResult = ReturnType<typeof useRankedProfilesQuery>;
export type RankedProfilesLazyQueryHookResult = ReturnType<typeof useRankedProfilesLazyQuery>;
export type RankedProfilesSuspenseQueryHookResult = ReturnType<typeof useRankedProfilesSuspenseQuery>;
export type RankedProfilesQueryResult = Apollo.QueryResult<GraphqlTypes.RankedProfilesQuery, GraphqlTypes.RankedProfilesQueryVariables>;
export const GetProfileOwnershipTreeDocument = gql`
    query GetProfileOwnershipTree($profileId: Int!) {
  complianceProfile(id: $profileId) {
    ...OwnershipTreeProfile
    beneficialOwners {
      ...OwnershipTreeEdge
      childProfile {
        ...OwnershipTreeProfileL1
      }
    }
    controllingPersons {
      ...OwnershipTreeEdge
      childProfile {
        ...OwnershipTreeProfileL1
      }
    }
  }
}
    ${OwnershipTreeProfileFragmentDoc}
${OwnershipTreeEdgeFragmentDoc}
${OwnershipTreeProfileL1FragmentDoc}`;

/**
 * __useGetProfileOwnershipTreeQuery__
 *
 * To run a query within a React component, call `useGetProfileOwnershipTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileOwnershipTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileOwnershipTreeQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetProfileOwnershipTreeQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables> & ({ variables: GraphqlTypes.GetProfileOwnershipTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>(GetProfileOwnershipTreeDocument, options);
      }
export function useGetProfileOwnershipTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>(GetProfileOwnershipTreeDocument, options);
        }
// @ts-ignore
export function useGetProfileOwnershipTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>;
export function useGetProfileOwnershipTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileOwnershipTreeQuery | undefined, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>;
export function useGetProfileOwnershipTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>(GetProfileOwnershipTreeDocument, options);
        }
export type GetProfileOwnershipTreeQueryHookResult = ReturnType<typeof useGetProfileOwnershipTreeQuery>;
export type GetProfileOwnershipTreeLazyQueryHookResult = ReturnType<typeof useGetProfileOwnershipTreeLazyQuery>;
export type GetProfileOwnershipTreeSuspenseQueryHookResult = ReturnType<typeof useGetProfileOwnershipTreeSuspenseQuery>;
export type GetProfileOwnershipTreeQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfileOwnershipTreeQuery, GraphqlTypes.GetProfileOwnershipTreeQueryVariables>;
export const ProfileComparisonDocument = gql`
    query ProfileComparison($arenaId: Int!, $entityId: Int!, $investmentAccountId: Int, $name: String) {
  rankedProfile(
    arenaId: $arenaId
    entityId: $entityId
    investmentAccountId: $investmentAccountId
    name: $name
  ) {
    investmentAccount {
      name
      legalEntityName
      accountType
      taxId
      arena {
        id
        name
      }
      positions {
        count
        edges {
          node {
            id
            complianceProgram
            account {
              id
              name
            }
            investmentEntity {
              id
              name
            }
            onboardingCase {
              investingProfile {
                id
                complianceObjectType
                firstName
                middleName
                lastName
                legalName
              }
            }
          }
        }
      }
      domicileAddress {
        ...AccountComparisonAddress
      }
      mailingAddress {
        ...AccountComparisonAddress
      }
    }
    profiles {
      id
      complianceObjectType
      accountType
      firstName
      middleName
      lastName
      legalName
      taxIdUnencrypted
      taxIdType
      clientObjects {
        name
      }
      organizationalJurisdiction {
        name
      }
      addresses {
        street
        street2
        street3
        city
        province
        postalCode
        isPrimaryDomicile
        state {
          name
        }
        country {
          name
        }
      }
      positions {
        complianceProgram
      }
      matchPercent
      perFieldMatch {
        fieldKey
        matches
        profileValue
        iaValue
      }
    }
  }
}
    ${AccountComparisonAddressFragmentDoc}`;

/**
 * __useProfileComparisonQuery__
 *
 * To run a query within a React component, call `useProfileComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileComparisonQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      investmentAccountId: // value for 'investmentAccountId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProfileComparisonQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables> & ({ variables: GraphqlTypes.ProfileComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>(ProfileComparisonDocument, options);
      }
export function useProfileComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>(ProfileComparisonDocument, options);
        }
// @ts-ignore
export function useProfileComparisonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>;
export function useProfileComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProfileComparisonQuery | undefined, GraphqlTypes.ProfileComparisonQueryVariables>;
export function useProfileComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>(ProfileComparisonDocument, options);
        }
export type ProfileComparisonQueryHookResult = ReturnType<typeof useProfileComparisonQuery>;
export type ProfileComparisonLazyQueryHookResult = ReturnType<typeof useProfileComparisonLazyQuery>;
export type ProfileComparisonSuspenseQueryHookResult = ReturnType<typeof useProfileComparisonSuspenseQuery>;
export type ProfileComparisonQueryResult = Apollo.QueryResult<GraphqlTypes.ProfileComparisonQuery, GraphqlTypes.ProfileComparisonQueryVariables>;
export const CheckTaxIdDocument = gql`
    query CheckTaxId($taxId: String!, $arenaAccessId: Int!) {
  complianceRootInvestingProfileExistsByTaxId(
    taxId: $taxId
    arenaAccessId: $arenaAccessId
  )
}
    `;

/**
 * __useCheckTaxIdQuery__
 *
 * To run a query within a React component, call `useCheckTaxIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTaxIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTaxIdQuery({
 *   variables: {
 *      taxId: // value for 'taxId'
 *      arenaAccessId: // value for 'arenaAccessId'
 *   },
 * });
 */
export function useCheckTaxIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables> & ({ variables: GraphqlTypes.CheckTaxIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>(CheckTaxIdDocument, options);
      }
export function useCheckTaxIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>(CheckTaxIdDocument, options);
        }
// @ts-ignore
export function useCheckTaxIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>;
export function useCheckTaxIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CheckTaxIdQuery | undefined, GraphqlTypes.CheckTaxIdQueryVariables>;
export function useCheckTaxIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>(CheckTaxIdDocument, options);
        }
export type CheckTaxIdQueryHookResult = ReturnType<typeof useCheckTaxIdQuery>;
export type CheckTaxIdLazyQueryHookResult = ReturnType<typeof useCheckTaxIdLazyQuery>;
export type CheckTaxIdSuspenseQueryHookResult = ReturnType<typeof useCheckTaxIdSuspenseQuery>;
export type CheckTaxIdQueryResult = Apollo.QueryResult<GraphqlTypes.CheckTaxIdQuery, GraphqlTypes.CheckTaxIdQueryVariables>;
export const CreateCaseForIndividualInvestorDocument = gql`
    mutation CreateCaseForIndividualInvestor($profileData: ComplianceIndividualProfileInput!, $programId: Int!, $externalEntity: ExternalObjectInput!, $externalArena: ExternalObjectInput!, $caseExternalObject: ExternalObjectInput, $caseType: ComplianceCaseTypeEnum, $assignSelf: Boolean!, $documentIds: [Int!] = null) {
  createCaseWithNewIndividualProfile(
    profileData: $profileData
    programId: $programId
    externalEntity: $externalEntity
    externalArena: $externalArena
    caseExternalObject: $caseExternalObject
    caseType: $caseType
    assignSelf: $assignSelf
    documentIds: $documentIds
  ) {
    case {
      id
    }
  }
}
    `;
export type CreateCaseForIndividualInvestorMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateCaseForIndividualInvestorMutation, GraphqlTypes.CreateCaseForIndividualInvestorMutationVariables>;

/**
 * __useCreateCaseForIndividualInvestorMutation__
 *
 * To run a mutation, you first call `useCreateCaseForIndividualInvestorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseForIndividualInvestorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseForIndividualInvestorMutation, { data, loading, error }] = useCreateCaseForIndividualInvestorMutation({
 *   variables: {
 *      profileData: // value for 'profileData'
 *      programId: // value for 'programId'
 *      externalEntity: // value for 'externalEntity'
 *      externalArena: // value for 'externalArena'
 *      caseExternalObject: // value for 'caseExternalObject'
 *      caseType: // value for 'caseType'
 *      assignSelf: // value for 'assignSelf'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateCaseForIndividualInvestorMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateCaseForIndividualInvestorMutation, GraphqlTypes.CreateCaseForIndividualInvestorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateCaseForIndividualInvestorMutation, GraphqlTypes.CreateCaseForIndividualInvestorMutationVariables>(CreateCaseForIndividualInvestorDocument, options);
      }
export type CreateCaseForIndividualInvestorMutationHookResult = ReturnType<typeof useCreateCaseForIndividualInvestorMutation>;
export type CreateCaseForIndividualInvestorMutationResult = Apollo.MutationResult<GraphqlTypes.CreateCaseForIndividualInvestorMutation>;
export type CreateCaseForIndividualInvestorMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateCaseForIndividualInvestorMutation, GraphqlTypes.CreateCaseForIndividualInvestorMutationVariables>;
export const CreateCaseForJointInvestorsDocument = gql`
    mutation CreateCaseForJointInvestors($profileData: ComplianceJointProfileInput!, $programId: Int!, $externalEntity: ExternalObjectInput!, $externalArena: ExternalObjectInput!, $caseExternalObject: ExternalObjectInput, $caseType: ComplianceCaseTypeEnum, $assignSelf: Boolean!, $documentIds: [Int!] = null) {
  createCaseWithNewJointProfile(
    profileData: $profileData
    programId: $programId
    externalEntity: $externalEntity
    externalArena: $externalArena
    caseExternalObject: $caseExternalObject
    caseType: $caseType
    assignSelf: $assignSelf
    documentIds: $documentIds
  ) {
    case {
      id
    }
  }
}
    `;
export type CreateCaseForJointInvestorsMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateCaseForJointInvestorsMutation, GraphqlTypes.CreateCaseForJointInvestorsMutationVariables>;

/**
 * __useCreateCaseForJointInvestorsMutation__
 *
 * To run a mutation, you first call `useCreateCaseForJointInvestorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseForJointInvestorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseForJointInvestorsMutation, { data, loading, error }] = useCreateCaseForJointInvestorsMutation({
 *   variables: {
 *      profileData: // value for 'profileData'
 *      programId: // value for 'programId'
 *      externalEntity: // value for 'externalEntity'
 *      externalArena: // value for 'externalArena'
 *      caseExternalObject: // value for 'caseExternalObject'
 *      caseType: // value for 'caseType'
 *      assignSelf: // value for 'assignSelf'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateCaseForJointInvestorsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateCaseForJointInvestorsMutation, GraphqlTypes.CreateCaseForJointInvestorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateCaseForJointInvestorsMutation, GraphqlTypes.CreateCaseForJointInvestorsMutationVariables>(CreateCaseForJointInvestorsDocument, options);
      }
export type CreateCaseForJointInvestorsMutationHookResult = ReturnType<typeof useCreateCaseForJointInvestorsMutation>;
export type CreateCaseForJointInvestorsMutationResult = Apollo.MutationResult<GraphqlTypes.CreateCaseForJointInvestorsMutation>;
export type CreateCaseForJointInvestorsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateCaseForJointInvestorsMutation, GraphqlTypes.CreateCaseForJointInvestorsMutationVariables>;
export const CreateCaseForInstitutionInvestorDocument = gql`
    mutation CreateCaseForInstitutionInvestor($profileData: ComplianceInstitutionProfileInput!, $programId: Int!, $externalEntity: ExternalObjectInput!, $externalArena: ExternalObjectInput!, $caseExternalObject: ExternalObjectInput, $caseType: ComplianceCaseTypeEnum, $assignSelf: Boolean!, $documentIds: [Int!] = null) {
  createCaseWithNewInstitutionProfile(
    profileData: $profileData
    programId: $programId
    externalEntity: $externalEntity
    externalArena: $externalArena
    caseExternalObject: $caseExternalObject
    caseType: $caseType
    assignSelf: $assignSelf
    documentIds: $documentIds
  ) {
    case {
      id
    }
  }
}
    `;
export type CreateCaseForInstitutionInvestorMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateCaseForInstitutionInvestorMutation, GraphqlTypes.CreateCaseForInstitutionInvestorMutationVariables>;

/**
 * __useCreateCaseForInstitutionInvestorMutation__
 *
 * To run a mutation, you first call `useCreateCaseForInstitutionInvestorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseForInstitutionInvestorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseForInstitutionInvestorMutation, { data, loading, error }] = useCreateCaseForInstitutionInvestorMutation({
 *   variables: {
 *      profileData: // value for 'profileData'
 *      programId: // value for 'programId'
 *      externalEntity: // value for 'externalEntity'
 *      externalArena: // value for 'externalArena'
 *      caseExternalObject: // value for 'caseExternalObject'
 *      caseType: // value for 'caseType'
 *      assignSelf: // value for 'assignSelf'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useCreateCaseForInstitutionInvestorMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateCaseForInstitutionInvestorMutation, GraphqlTypes.CreateCaseForInstitutionInvestorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateCaseForInstitutionInvestorMutation, GraphqlTypes.CreateCaseForInstitutionInvestorMutationVariables>(CreateCaseForInstitutionInvestorDocument, options);
      }
export type CreateCaseForInstitutionInvestorMutationHookResult = ReturnType<typeof useCreateCaseForInstitutionInvestorMutation>;
export type CreateCaseForInstitutionInvestorMutationResult = Apollo.MutationResult<GraphqlTypes.CreateCaseForInstitutionInvestorMutation>;
export type CreateCaseForInstitutionInvestorMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateCaseForInstitutionInvestorMutation, GraphqlTypes.CreateCaseForInstitutionInvestorMutationVariables>;
export const ResolveInvestmentAccountIdDocument = gql`
    query ResolveInvestmentAccountId($arenaId: Int!, $prospectId: Int, $positionId: String) {
  resolveInvestmentAccountId(
    arenaId: $arenaId
    prospectId: $prospectId
    positionId: $positionId
  )
}
    `;

/**
 * __useResolveInvestmentAccountIdQuery__
 *
 * To run a query within a React component, call `useResolveInvestmentAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveInvestmentAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveInvestmentAccountIdQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      prospectId: // value for 'prospectId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useResolveInvestmentAccountIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables> & ({ variables: GraphqlTypes.ResolveInvestmentAccountIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>(ResolveInvestmentAccountIdDocument, options);
      }
export function useResolveInvestmentAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>(ResolveInvestmentAccountIdDocument, options);
        }
// @ts-ignore
export function useResolveInvestmentAccountIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>;
export function useResolveInvestmentAccountIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ResolveInvestmentAccountIdQuery | undefined, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>;
export function useResolveInvestmentAccountIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>(ResolveInvestmentAccountIdDocument, options);
        }
export type ResolveInvestmentAccountIdQueryHookResult = ReturnType<typeof useResolveInvestmentAccountIdQuery>;
export type ResolveInvestmentAccountIdLazyQueryHookResult = ReturnType<typeof useResolveInvestmentAccountIdLazyQuery>;
export type ResolveInvestmentAccountIdSuspenseQueryHookResult = ReturnType<typeof useResolveInvestmentAccountIdSuspenseQuery>;
export type ResolveInvestmentAccountIdQueryResult = Apollo.QueryResult<GraphqlTypes.ResolveInvestmentAccountIdQuery, GraphqlTypes.ResolveInvestmentAccountIdQueryVariables>;
export const SendInvitationReminderDocument = gql`
    mutation SendInvitationReminder($input: SendEmailReminderInput!) {
  sendInvitationReminder(input: $input)
}
    `;
export type SendInvitationReminderMutationFn = Apollo.MutationFunction<GraphqlTypes.SendInvitationReminderMutation, GraphqlTypes.SendInvitationReminderMutationVariables>;

/**
 * __useSendInvitationReminderMutation__
 *
 * To run a mutation, you first call `useSendInvitationReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationReminderMutation, { data, loading, error }] = useSendInvitationReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitationReminderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SendInvitationReminderMutation, GraphqlTypes.SendInvitationReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SendInvitationReminderMutation, GraphqlTypes.SendInvitationReminderMutationVariables>(SendInvitationReminderDocument, options);
      }
export type SendInvitationReminderMutationHookResult = ReturnType<typeof useSendInvitationReminderMutation>;
export type SendInvitationReminderMutationResult = Apollo.MutationResult<GraphqlTypes.SendInvitationReminderMutation>;
export type SendInvitationReminderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SendInvitationReminderMutation, GraphqlTypes.SendInvitationReminderMutationVariables>;
export const GetPositionAndArenaDetailsDocument = gql`
    query GetPositionAndArenaDetails($profileId: Int!) {
  complianceProfile(id: $profileId) {
    id
    positions {
      id
      arena {
        id
      }
    }
    complianceCases {
      caseId
      complianceCase {
        externalArena {
          objectId
        }
        position {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionAndArenaDetailsQuery__
 *
 * To run a query within a React component, call `useGetPositionAndArenaDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionAndArenaDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionAndArenaDetailsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetPositionAndArenaDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables> & ({ variables: GraphqlTypes.GetPositionAndArenaDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>(GetPositionAndArenaDetailsDocument, options);
      }
export function useGetPositionAndArenaDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>(GetPositionAndArenaDetailsDocument, options);
        }
// @ts-ignore
export function useGetPositionAndArenaDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>;
export function useGetPositionAndArenaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionAndArenaDetailsQuery | undefined, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>;
export function useGetPositionAndArenaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>(GetPositionAndArenaDetailsDocument, options);
        }
export type GetPositionAndArenaDetailsQueryHookResult = ReturnType<typeof useGetPositionAndArenaDetailsQuery>;
export type GetPositionAndArenaDetailsLazyQueryHookResult = ReturnType<typeof useGetPositionAndArenaDetailsLazyQuery>;
export type GetPositionAndArenaDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPositionAndArenaDetailsSuspenseQuery>;
export type GetPositionAndArenaDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionAndArenaDetailsQuery, GraphqlTypes.GetPositionAndArenaDetailsQueryVariables>;
export const CreateComplianceCaseFromProfileDocument = gql`
    mutation CreateComplianceCaseFromProfile($caseInput: CaseCreationInput!, $emailInviteInput: EmailInviteInput) {
  createComplianceCaseFromProfile(
    caseInput: $caseInput
    emailInviteInput: $emailInviteInput
  ) {
    id
    status
    caseType
  }
}
    `;
export type CreateComplianceCaseFromProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateComplianceCaseFromProfileMutation, GraphqlTypes.CreateComplianceCaseFromProfileMutationVariables>;

/**
 * __useCreateComplianceCaseFromProfileMutation__
 *
 * To run a mutation, you first call `useCreateComplianceCaseFromProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceCaseFromProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceCaseFromProfileMutation, { data, loading, error }] = useCreateComplianceCaseFromProfileMutation({
 *   variables: {
 *      caseInput: // value for 'caseInput'
 *      emailInviteInput: // value for 'emailInviteInput'
 *   },
 * });
 */
export function useCreateComplianceCaseFromProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateComplianceCaseFromProfileMutation, GraphqlTypes.CreateComplianceCaseFromProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateComplianceCaseFromProfileMutation, GraphqlTypes.CreateComplianceCaseFromProfileMutationVariables>(CreateComplianceCaseFromProfileDocument, options);
      }
export type CreateComplianceCaseFromProfileMutationHookResult = ReturnType<typeof useCreateComplianceCaseFromProfileMutation>;
export type CreateComplianceCaseFromProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateComplianceCaseFromProfileMutation>;
export type CreateComplianceCaseFromProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateComplianceCaseFromProfileMutation, GraphqlTypes.CreateComplianceCaseFromProfileMutationVariables>;
export const GetLatestComplianceProfilesWithFiltersDocument = gql`
    query GetLatestComplianceProfilesWithFilters($first: Int!, $after: String, $filters: [ProfileFilters!], $sorts: [ProfileSort!], $profileId: Int) {
  latestComplianceProfiles(
    pageArgs: {first: $first, after: $after}
    filters: $filters
    sorts: $sorts
    profileId: $profileId
  ) {
    edges {
      node {
        id
        firstName
        profileGuid
        lastName
        legalName
        roles
        amlEntityType
        isInvestingProfile
        complianceCases(caseTypes: [entity_onboarding, client_onboarding]) {
          isInvestingProfile
        }
        parentRelationships {
          parentProfileId
        }
        refreshSchedule {
          id
          lastRefreshDate
          nextRefreshDueDate
        }
        refreshCase {
          id
          status
          subStatus
          complianceInvitation {
            id
            inviteType
            status
            sentCount
            dateSent
          }
        }
        documentRefreshCase {
          id
          status
          subStatus
          caseType
          complianceInvitation {
            id
            inviteType
            status
            sentCount
            dateSent
          }
        }
        refreshStatus
        documentRefreshStatus
        clients
        activeCases {
          id
          caseType
        }
        positions {
          id
        }
        addresses {
          country {
            name
          }
          isPrimaryDomicile
        }
        documentRefreshSchedules {
          documentId
          expiryDate
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetLatestComplianceProfilesWithFiltersQuery__
 *
 * To run a query within a React component, call `useGetLatestComplianceProfilesWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestComplianceProfilesWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestComplianceProfilesWithFiltersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      sorts: // value for 'sorts'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetLatestComplianceProfilesWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables> & ({ variables: GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>(GetLatestComplianceProfilesWithFiltersDocument, options);
      }
export function useGetLatestComplianceProfilesWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>(GetLatestComplianceProfilesWithFiltersDocument, options);
        }
// @ts-ignore
export function useGetLatestComplianceProfilesWithFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>;
export function useGetLatestComplianceProfilesWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery | undefined, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>;
export function useGetLatestComplianceProfilesWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>(GetLatestComplianceProfilesWithFiltersDocument, options);
        }
export type GetLatestComplianceProfilesWithFiltersQueryHookResult = ReturnType<typeof useGetLatestComplianceProfilesWithFiltersQuery>;
export type GetLatestComplianceProfilesWithFiltersLazyQueryHookResult = ReturnType<typeof useGetLatestComplianceProfilesWithFiltersLazyQuery>;
export type GetLatestComplianceProfilesWithFiltersSuspenseQueryHookResult = ReturnType<typeof useGetLatestComplianceProfilesWithFiltersSuspenseQuery>;
export type GetLatestComplianceProfilesWithFiltersQueryResult = Apollo.QueryResult<GraphqlTypes.GetLatestComplianceProfilesWithFiltersQuery, GraphqlTypes.GetLatestComplianceProfilesWithFiltersQueryVariables>;
export const GetLatestComplianceProfilesCountDocument = gql`
    query GetLatestComplianceProfilesCount($filters: [ProfileFilters!], $profileId: Int) {
  latestComplianceProfilesCount(filters: $filters, profileId: $profileId)
}
    `;

/**
 * __useGetLatestComplianceProfilesCountQuery__
 *
 * To run a query within a React component, call `useGetLatestComplianceProfilesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestComplianceProfilesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestComplianceProfilesCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetLatestComplianceProfilesCountQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>(GetLatestComplianceProfilesCountDocument, options);
      }
export function useGetLatestComplianceProfilesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>(GetLatestComplianceProfilesCountDocument, options);
        }
// @ts-ignore
export function useGetLatestComplianceProfilesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>;
export function useGetLatestComplianceProfilesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLatestComplianceProfilesCountQuery | undefined, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>;
export function useGetLatestComplianceProfilesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>(GetLatestComplianceProfilesCountDocument, options);
        }
export type GetLatestComplianceProfilesCountQueryHookResult = ReturnType<typeof useGetLatestComplianceProfilesCountQuery>;
export type GetLatestComplianceProfilesCountLazyQueryHookResult = ReturnType<typeof useGetLatestComplianceProfilesCountLazyQuery>;
export type GetLatestComplianceProfilesCountSuspenseQueryHookResult = ReturnType<typeof useGetLatestComplianceProfilesCountSuspenseQuery>;
export type GetLatestComplianceProfilesCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetLatestComplianceProfilesCountQuery, GraphqlTypes.GetLatestComplianceProfilesCountQueryVariables>;
export const RevertProfileRelationshipDifferencesDocument = gql`
    mutation RevertProfileRelationshipDifferences($currentProfileId: Int!, $proposedProfileId: Int!, $caseId: Int!, $profileType: RevertProfileRelationshipType!) {
  revertProfileRelationshipDifferences(
    currentProfileId: $currentProfileId
    proposedProfileId: $proposedProfileId
    caseId: $caseId
    profileType: $profileType
  )
}
    `;
export type RevertProfileRelationshipDifferencesMutationFn = Apollo.MutationFunction<GraphqlTypes.RevertProfileRelationshipDifferencesMutation, GraphqlTypes.RevertProfileRelationshipDifferencesMutationVariables>;

/**
 * __useRevertProfileRelationshipDifferencesMutation__
 *
 * To run a mutation, you first call `useRevertProfileRelationshipDifferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertProfileRelationshipDifferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertProfileRelationshipDifferencesMutation, { data, loading, error }] = useRevertProfileRelationshipDifferencesMutation({
 *   variables: {
 *      currentProfileId: // value for 'currentProfileId'
 *      proposedProfileId: // value for 'proposedProfileId'
 *      caseId: // value for 'caseId'
 *      profileType: // value for 'profileType'
 *   },
 * });
 */
export function useRevertProfileRelationshipDifferencesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RevertProfileRelationshipDifferencesMutation, GraphqlTypes.RevertProfileRelationshipDifferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RevertProfileRelationshipDifferencesMutation, GraphqlTypes.RevertProfileRelationshipDifferencesMutationVariables>(RevertProfileRelationshipDifferencesDocument, options);
      }
export type RevertProfileRelationshipDifferencesMutationHookResult = ReturnType<typeof useRevertProfileRelationshipDifferencesMutation>;
export type RevertProfileRelationshipDifferencesMutationResult = Apollo.MutationResult<GraphqlTypes.RevertProfileRelationshipDifferencesMutation>;
export type RevertProfileRelationshipDifferencesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RevertProfileRelationshipDifferencesMutation, GraphqlTypes.RevertProfileRelationshipDifferencesMutationVariables>;
export const RevertDocumentDifferencesDocument = gql`
    mutation RevertDocumentDifferences($documentType: BaseDocumentType!, $currentProfileId: Int!, $proposedProfileId: Int!, $caseId: Int!) {
  revertDocumentDifferences(
    documentType: $documentType
    currentProfileId: $currentProfileId
    proposedProfileId: $proposedProfileId
    caseId: $caseId
  )
}
    `;
export type RevertDocumentDifferencesMutationFn = Apollo.MutationFunction<GraphqlTypes.RevertDocumentDifferencesMutation, GraphqlTypes.RevertDocumentDifferencesMutationVariables>;

/**
 * __useRevertDocumentDifferencesMutation__
 *
 * To run a mutation, you first call `useRevertDocumentDifferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertDocumentDifferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertDocumentDifferencesMutation, { data, loading, error }] = useRevertDocumentDifferencesMutation({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      currentProfileId: // value for 'currentProfileId'
 *      proposedProfileId: // value for 'proposedProfileId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useRevertDocumentDifferencesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RevertDocumentDifferencesMutation, GraphqlTypes.RevertDocumentDifferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RevertDocumentDifferencesMutation, GraphqlTypes.RevertDocumentDifferencesMutationVariables>(RevertDocumentDifferencesDocument, options);
      }
export type RevertDocumentDifferencesMutationHookResult = ReturnType<typeof useRevertDocumentDifferencesMutation>;
export type RevertDocumentDifferencesMutationResult = Apollo.MutationResult<GraphqlTypes.RevertDocumentDifferencesMutation>;
export type RevertDocumentDifferencesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RevertDocumentDifferencesMutation, GraphqlTypes.RevertDocumentDifferencesMutationVariables>;
export const GetProfileForComparisonDocument = gql`
    query GetProfileForComparison($profileId: Int!, $programId: Int, $caseId: Int, $showFatcaCrs: Boolean! = false) {
  complianceProfile(id: $profileId) {
    id
    sourceProfileId
    legalName
    firstName
    lastName
    middleName
    accountType
    dateOfOrganization
    dateOfBirth
    taxIdUnencrypted
    taxIdType
    complianceObjectType
    metaData
    amlEntityTypeId
    amlEntityType
    riskRating(programId: $programId) {
      calculatedRating
      overriddenRating
    }
    amlEntityTypeQuestions(caseId: $caseId) {
      id
      text
      subText
      targetAmlEntityTypeId
      isDefault
    }
    addresses {
      id
      street
      street2
      city
      province
      postalCode
      state {
        code
        name
      }
      country {
        id
        name
        alpha2code
      }
      isPrimaryDomicile
    }
    documents {
      id
      name
      s3Link
      status
      documentPurpose {
        baseType
        expires
        complianceObjectType
      }
      metadata {
        key
        value
      }
      taxReportingMetadata @include(if: $showFatcaCrs) {
        id
        taxReportingType
        metaData
      }
      taxDataSourceAssignments @include(if: $showFatcaCrs) {
        assignmentType
        referencedCaseId
        status
      }
    }
    beneficialOwners {
      id
      childProfile {
        id
        sourceProfileId
        firstName
        middleName
        lastName
        legalName
        complianceObjectType
      }
      percentOwnership
      relationshipType
    }
    controllingPersons {
      id
      childProfile {
        id
        sourceProfileId
        firstName
        middleName
        lastName
        legalName
        complianceObjectType
      }
      title
      relationshipType
    }
  }
}
    `;

/**
 * __useGetProfileForComparisonQuery__
 *
 * To run a query within a React component, call `useGetProfileForComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileForComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileForComparisonQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      programId: // value for 'programId'
 *      caseId: // value for 'caseId'
 *      showFatcaCrs: // value for 'showFatcaCrs'
 *   },
 * });
 */
export function useGetProfileForComparisonQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables> & ({ variables: GraphqlTypes.GetProfileForComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>(GetProfileForComparisonDocument, options);
      }
export function useGetProfileForComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>(GetProfileForComparisonDocument, options);
        }
// @ts-ignore
export function useGetProfileForComparisonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>;
export function useGetProfileForComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProfileForComparisonQuery | undefined, GraphqlTypes.GetProfileForComparisonQueryVariables>;
export function useGetProfileForComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>(GetProfileForComparisonDocument, options);
        }
export type GetProfileForComparisonQueryHookResult = ReturnType<typeof useGetProfileForComparisonQuery>;
export type GetProfileForComparisonLazyQueryHookResult = ReturnType<typeof useGetProfileForComparisonLazyQuery>;
export type GetProfileForComparisonSuspenseQueryHookResult = ReturnType<typeof useGetProfileForComparisonSuspenseQuery>;
export type GetProfileForComparisonQueryResult = Apollo.QueryResult<GraphqlTypes.GetProfileForComparisonQuery, GraphqlTypes.GetProfileForComparisonQueryVariables>;
export const ApplyProposedChangesSelectionDocument = gql`
    mutation ApplyProposedChangesSelection($input: ApplyProposedChangesSelectionInput!) {
  applyProposedChangesSelection(input: $input) {
    id
  }
}
    `;
export type ApplyProposedChangesSelectionMutationFn = Apollo.MutationFunction<GraphqlTypes.ApplyProposedChangesSelectionMutation, GraphqlTypes.ApplyProposedChangesSelectionMutationVariables>;

/**
 * __useApplyProposedChangesSelectionMutation__
 *
 * To run a mutation, you first call `useApplyProposedChangesSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyProposedChangesSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyProposedChangesSelectionMutation, { data, loading, error }] = useApplyProposedChangesSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyProposedChangesSelectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApplyProposedChangesSelectionMutation, GraphqlTypes.ApplyProposedChangesSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApplyProposedChangesSelectionMutation, GraphqlTypes.ApplyProposedChangesSelectionMutationVariables>(ApplyProposedChangesSelectionDocument, options);
      }
export type ApplyProposedChangesSelectionMutationHookResult = ReturnType<typeof useApplyProposedChangesSelectionMutation>;
export type ApplyProposedChangesSelectionMutationResult = Apollo.MutationResult<GraphqlTypes.ApplyProposedChangesSelectionMutation>;
export type ApplyProposedChangesSelectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApplyProposedChangesSelectionMutation, GraphqlTypes.ApplyProposedChangesSelectionMutationVariables>;
export const GetCaseArenaByProfileDocument = gql`
    query GetCaseArenaByProfile($externalObject: ExternalObjectInput!) {
  complianceCaseArenaByProfile(externalObject: $externalObject) {
    arenaId
  }
}
    `;

/**
 * __useGetCaseArenaByProfileQuery__
 *
 * To run a query within a React component, call `useGetCaseArenaByProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseArenaByProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseArenaByProfileQuery({
 *   variables: {
 *      externalObject: // value for 'externalObject'
 *   },
 * });
 */
export function useGetCaseArenaByProfileQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables> & ({ variables: GraphqlTypes.GetCaseArenaByProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>(GetCaseArenaByProfileDocument, options);
      }
export function useGetCaseArenaByProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>(GetCaseArenaByProfileDocument, options);
        }
// @ts-ignore
export function useGetCaseArenaByProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>;
export function useGetCaseArenaByProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCaseArenaByProfileQuery | undefined, GraphqlTypes.GetCaseArenaByProfileQueryVariables>;
export function useGetCaseArenaByProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>(GetCaseArenaByProfileDocument, options);
        }
export type GetCaseArenaByProfileQueryHookResult = ReturnType<typeof useGetCaseArenaByProfileQuery>;
export type GetCaseArenaByProfileLazyQueryHookResult = ReturnType<typeof useGetCaseArenaByProfileLazyQuery>;
export type GetCaseArenaByProfileSuspenseQueryHookResult = ReturnType<typeof useGetCaseArenaByProfileSuspenseQuery>;
export type GetCaseArenaByProfileQueryResult = Apollo.QueryResult<GraphqlTypes.GetCaseArenaByProfileQuery, GraphqlTypes.GetCaseArenaByProfileQueryVariables>;
export const GetProposedProfileDetailsDocument = gql`
    query GetProposedProfileDetails($profileId: Int!) {
  complianceProfile(id: $profileId) {
    id
    firstName
    middleName
    lastName
    legalName
    complianceObjectType
    dateOfBirth
    dateOfOrganization
    addresses {
      street
      street2
      street3
      city
      state {
        id
        name
        code
      }
      postalCode
      country {
        id
        name
        alpha2code
      }
      province
      subprovince
      isPrimaryDomicile
    }
    documents {
      id
      name
      s3Link
      status
      documentPurpose {
        baseType
        expires
      }
      metadata {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetProposedProfileDetailsQuery__
 *
 * To run a query within a React component, call `useGetProposedProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposedProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposedProfileDetailsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetProposedProfileDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables> & ({ variables: GraphqlTypes.GetProposedProfileDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>(GetProposedProfileDetailsDocument, options);
      }
export function useGetProposedProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>(GetProposedProfileDetailsDocument, options);
        }
// @ts-ignore
export function useGetProposedProfileDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>;
export function useGetProposedProfileDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProposedProfileDetailsQuery | undefined, GraphqlTypes.GetProposedProfileDetailsQueryVariables>;
export function useGetProposedProfileDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>(GetProposedProfileDetailsDocument, options);
        }
export type GetProposedProfileDetailsQueryHookResult = ReturnType<typeof useGetProposedProfileDetailsQuery>;
export type GetProposedProfileDetailsLazyQueryHookResult = ReturnType<typeof useGetProposedProfileDetailsLazyQuery>;
export type GetProposedProfileDetailsSuspenseQueryHookResult = ReturnType<typeof useGetProposedProfileDetailsSuspenseQuery>;
export type GetProposedProfileDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProposedProfileDetailsQuery, GraphqlTypes.GetProposedProfileDetailsQueryVariables>;
export const CreateJointProfileDocument = gql`
    mutation CreateJointProfile($arenaAccessId: Int!, $data: ComplianceJointProfileInput!, $parentProfileId: Int) {
  createJointProfile(
    arenaAccessId: $arenaAccessId
    data: $data
    parentProfileId: $parentProfileId
  ) {
    id
    legalName
  }
}
    `;
export type CreateJointProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>;

/**
 * __useCreateJointProfileMutation__
 *
 * To run a mutation, you first call `useCreateJointProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJointProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJointProfileMutation, { data, loading, error }] = useCreateJointProfileMutation({
 *   variables: {
 *      arenaAccessId: // value for 'arenaAccessId'
 *      data: // value for 'data'
 *      parentProfileId: // value for 'parentProfileId'
 *   },
 * });
 */
export function useCreateJointProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>(CreateJointProfileDocument, options);
      }
export type CreateJointProfileMutationHookResult = ReturnType<typeof useCreateJointProfileMutation>;
export type CreateJointProfileMutationResult = Apollo.MutationResult<GraphqlTypes.CreateJointProfileMutation>;
export type CreateJointProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateJointProfileMutation, GraphqlTypes.CreateJointProfileMutationVariables>;
export const UpdateJointProfileDocument = gql`
    mutation UpdateJointProfile($data: ComplianceJointProfileInput!, $profileId: Int!, $parentProfileId: Int, $resolveConflictsOnDocId: Int = null) {
  updateJointProfile(
    data: $data
    profileId: $profileId
    parentProfileId: $parentProfileId
    resolveConflictsOnDocId: $resolveConflictsOnDocId
  ) {
    id
    legalName
  }
}
    `;
export type UpdateJointProfileMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateJointProfileMutation, GraphqlTypes.UpdateJointProfileMutationVariables>;

/**
 * __useUpdateJointProfileMutation__
 *
 * To run a mutation, you first call `useUpdateJointProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJointProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJointProfileMutation, { data, loading, error }] = useUpdateJointProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      profileId: // value for 'profileId'
 *      parentProfileId: // value for 'parentProfileId'
 *      resolveConflictsOnDocId: // value for 'resolveConflictsOnDocId'
 *   },
 * });
 */
export function useUpdateJointProfileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateJointProfileMutation, GraphqlTypes.UpdateJointProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateJointProfileMutation, GraphqlTypes.UpdateJointProfileMutationVariables>(UpdateJointProfileDocument, options);
      }
export type UpdateJointProfileMutationHookResult = ReturnType<typeof useUpdateJointProfileMutation>;
export type UpdateJointProfileMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateJointProfileMutation>;
export type UpdateJointProfileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateJointProfileMutation, GraphqlTypes.UpdateJointProfileMutationVariables>;
export const GetActiveNonClosedCasesCountDocument = gql`
    query GetActiveNonClosedCasesCount($filters: [ComplianceCaseFilters!]) {
  complianceCasesSlice(filters: $filters) {
    filteredCount
  }
}
    `;

/**
 * __useGetActiveNonClosedCasesCountQuery__
 *
 * To run a query within a React component, call `useGetActiveNonClosedCasesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveNonClosedCasesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveNonClosedCasesCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetActiveNonClosedCasesCountQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>(GetActiveNonClosedCasesCountDocument, options);
      }
export function useGetActiveNonClosedCasesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>(GetActiveNonClosedCasesCountDocument, options);
        }
// @ts-ignore
export function useGetActiveNonClosedCasesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>;
export function useGetActiveNonClosedCasesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetActiveNonClosedCasesCountQuery | undefined, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>;
export function useGetActiveNonClosedCasesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>(GetActiveNonClosedCasesCountDocument, options);
        }
export type GetActiveNonClosedCasesCountQueryHookResult = ReturnType<typeof useGetActiveNonClosedCasesCountQuery>;
export type GetActiveNonClosedCasesCountLazyQueryHookResult = ReturnType<typeof useGetActiveNonClosedCasesCountLazyQuery>;
export type GetActiveNonClosedCasesCountSuspenseQueryHookResult = ReturnType<typeof useGetActiveNonClosedCasesCountSuspenseQuery>;
export type GetActiveNonClosedCasesCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetActiveNonClosedCasesCountQuery, GraphqlTypes.GetActiveNonClosedCasesCountQueryVariables>;
export const GetPositionsWithoutCasesCountDocument = gql`
    query GetPositionsWithoutCasesCount($positionFilters: PositionFilterInput!) {
  positions(positionFilters: $positionFilters) {
    edges {
      node {
        id
        status
        onboardingCase {
          id
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetPositionsWithoutCasesCountQuery__
 *
 * To run a query within a React component, call `useGetPositionsWithoutCasesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsWithoutCasesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsWithoutCasesCountQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *   },
 * });
 */
export function useGetPositionsWithoutCasesCountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables> & ({ variables: GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>(GetPositionsWithoutCasesCountDocument, options);
      }
export function useGetPositionsWithoutCasesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>(GetPositionsWithoutCasesCountDocument, options);
        }
// @ts-ignore
export function useGetPositionsWithoutCasesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>;
export function useGetPositionsWithoutCasesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsWithoutCasesCountQuery | undefined, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>;
export function useGetPositionsWithoutCasesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>(GetPositionsWithoutCasesCountDocument, options);
        }
export type GetPositionsWithoutCasesCountQueryHookResult = ReturnType<typeof useGetPositionsWithoutCasesCountQuery>;
export type GetPositionsWithoutCasesCountLazyQueryHookResult = ReturnType<typeof useGetPositionsWithoutCasesCountLazyQuery>;
export type GetPositionsWithoutCasesCountSuspenseQueryHookResult = ReturnType<typeof useGetPositionsWithoutCasesCountSuspenseQuery>;
export type GetPositionsWithoutCasesCountQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsWithoutCasesCountQuery, GraphqlTypes.GetPositionsWithoutCasesCountQueryVariables>;
export const UserScopedArenaIdsDocument = gql`
    query UserScopedArenaIds {
  userScopedArenaIds
}
    `;

/**
 * __useUserScopedArenaIdsQuery__
 *
 * To run a query within a React component, call `useUserScopedArenaIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserScopedArenaIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserScopedArenaIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserScopedArenaIdsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>(UserScopedArenaIdsDocument, options);
      }
export function useUserScopedArenaIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>(UserScopedArenaIdsDocument, options);
        }
// @ts-ignore
export function useUserScopedArenaIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>;
export function useUserScopedArenaIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.UserScopedArenaIdsQuery | undefined, GraphqlTypes.UserScopedArenaIdsQueryVariables>;
export function useUserScopedArenaIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>(UserScopedArenaIdsDocument, options);
        }
export type UserScopedArenaIdsQueryHookResult = ReturnType<typeof useUserScopedArenaIdsQuery>;
export type UserScopedArenaIdsLazyQueryHookResult = ReturnType<typeof useUserScopedArenaIdsLazyQuery>;
export type UserScopedArenaIdsSuspenseQueryHookResult = ReturnType<typeof useUserScopedArenaIdsSuspenseQuery>;
export type UserScopedArenaIdsQueryResult = Apollo.QueryResult<GraphqlTypes.UserScopedArenaIdsQuery, GraphqlTypes.UserScopedArenaIdsQueryVariables>;
export const GetClientViewDocument = gql`
    query GetClientView($sort: ClientViewSortInput, $limit: Int! = 50, $page: Int! = 1) {
  clientView(sort: $sort, limit: $limit, page: $page) {
    rows {
      arenaId
      arenaName
      activeWorkflows
      workflowTypes {
        name
        value
        count
      }
      dueIn5Days
      overdue
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalCount
    }
    dateRangeMetadata {
      dueIn5DaysStart
      dueIn5DaysEnd
      overdueBefore
    }
    activeStatuses
    syncStatus {
      lastSyncedAt
      isSyncing
      ticketCount
    }
  }
}
    `;

/**
 * __useGetClientViewQuery__
 *
 * To run a query within a React component, call `useGetClientViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientViewQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetClientViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>(GetClientViewDocument, options);
      }
export function useGetClientViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>(GetClientViewDocument, options);
        }
// @ts-ignore
export function useGetClientViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>;
export function useGetClientViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientViewQuery | undefined, GraphqlTypes.GetClientViewQueryVariables>;
export function useGetClientViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>(GetClientViewDocument, options);
        }
export type GetClientViewQueryHookResult = ReturnType<typeof useGetClientViewQuery>;
export type GetClientViewLazyQueryHookResult = ReturnType<typeof useGetClientViewLazyQuery>;
export type GetClientViewSuspenseQueryHookResult = ReturnType<typeof useGetClientViewSuspenseQuery>;
export type GetClientViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientViewQuery, GraphqlTypes.GetClientViewQueryVariables>;
export const GetClientViewArenaDomainsDocument = gql`
    query GetClientViewArenaDomains($arenaIds: [ID!]) {
  arenas(arenaIds: $arenaIds) {
    edges {
      node {
        id
        secondLevelDomain
      }
    }
  }
}
    `;

/**
 * __useGetClientViewArenaDomainsQuery__
 *
 * To run a query within a React component, call `useGetClientViewArenaDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientViewArenaDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientViewArenaDomainsQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *   },
 * });
 */
export function useGetClientViewArenaDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>(GetClientViewArenaDomainsDocument, options);
      }
export function useGetClientViewArenaDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>(GetClientViewArenaDomainsDocument, options);
        }
// @ts-ignore
export function useGetClientViewArenaDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>;
export function useGetClientViewArenaDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetClientViewArenaDomainsQuery | undefined, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>;
export function useGetClientViewArenaDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>(GetClientViewArenaDomainsDocument, options);
        }
export type GetClientViewArenaDomainsQueryHookResult = ReturnType<typeof useGetClientViewArenaDomainsQuery>;
export type GetClientViewArenaDomainsLazyQueryHookResult = ReturnType<typeof useGetClientViewArenaDomainsLazyQuery>;
export type GetClientViewArenaDomainsSuspenseQueryHookResult = ReturnType<typeof useGetClientViewArenaDomainsSuspenseQuery>;
export type GetClientViewArenaDomainsQueryResult = Apollo.QueryResult<GraphqlTypes.GetClientViewArenaDomainsQuery, GraphqlTypes.GetClientViewArenaDomainsQueryVariables>;
export const GetIndividualViewDocument = gql`
    query GetIndividualView($sort: IndividualViewSortInput, $limit: Int! = 50, $page: Int! = 1) {
  individualView(sort: $sort, limit: $limit, page: $page) {
    rows {
      assigneeId
      assigneeName
      assigneeEmail
      activeWorkflows
      workflowTypes {
        name
        value
        count
      }
      due02Days
      due35Days
      due614Days
      due15PlusDays
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalCount
    }
    dateRangeMetadata {
      due02DaysStart
      due02DaysEnd
      due35DaysStart
      due35DaysEnd
      due614DaysStart
      due614DaysEnd
      due15PlusDaysStart
      due15PlusDaysEnd
    }
    activeStatuses
    syncStatus {
      lastSyncedAt
      isSyncing
      ticketCount
    }
  }
}
    `;

/**
 * __useGetIndividualViewQuery__
 *
 * To run a query within a React component, call `useGetIndividualViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndividualViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndividualViewQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetIndividualViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>(GetIndividualViewDocument, options);
      }
export function useGetIndividualViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>(GetIndividualViewDocument, options);
        }
// @ts-ignore
export function useGetIndividualViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>;
export function useGetIndividualViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetIndividualViewQuery | undefined, GraphqlTypes.GetIndividualViewQueryVariables>;
export function useGetIndividualViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>(GetIndividualViewDocument, options);
        }
export type GetIndividualViewQueryHookResult = ReturnType<typeof useGetIndividualViewQuery>;
export type GetIndividualViewLazyQueryHookResult = ReturnType<typeof useGetIndividualViewLazyQuery>;
export type GetIndividualViewSuspenseQueryHookResult = ReturnType<typeof useGetIndividualViewSuspenseQuery>;
export type GetIndividualViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetIndividualViewQuery, GraphqlTypes.GetIndividualViewQueryVariables>;
export const CreateSavedViewDocument = gql`
    mutation CreateSavedView($input: CreateUserSavedViewInput!) {
  createSavedView(input: $input) {
    id
  }
}
    `;
export type CreateSavedViewMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>;

/**
 * __useCreateSavedViewMutation__
 *
 * To run a mutation, you first call `useCreateSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedViewMutation, { data, loading, error }] = useCreateSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>(CreateSavedViewDocument, options);
      }
export type CreateSavedViewMutationHookResult = ReturnType<typeof useCreateSavedViewMutation>;
export type CreateSavedViewMutationResult = Apollo.MutationResult<GraphqlTypes.CreateSavedViewMutation>;
export type CreateSavedViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>;
export const CreateTicketExportDocument = gql`
    mutation CreateTicketExport($filters: TicketFilters!, $sort: TicketSortInput, $ticketKeys: [String!]) {
  createTicketExport(filters: $filters, sort: $sort, ticketKeys: $ticketKeys)
}
    `;
export type CreateTicketExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>;

/**
 * __useCreateTicketExportMutation__
 *
 * To run a mutation, you first call `useCreateTicketExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketExportMutation, { data, loading, error }] = useCreateTicketExportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      ticketKeys: // value for 'ticketKeys'
 *   },
 * });
 */
export function useCreateTicketExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>(CreateTicketExportDocument, options);
      }
export type CreateTicketExportMutationHookResult = ReturnType<typeof useCreateTicketExportMutation>;
export type CreateTicketExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateTicketExportMutation>;
export type CreateTicketExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>;
export const GetTicketsDocument = gql`
    query GetTickets($filters: TicketFilters, $sort: TicketSortInput, $limit: Int, $pageToken: String, $excludeAllCompleted: Boolean) {
  tickets(
    filters: $filters
    sort: $sort
    limit: $limit
    pageToken: $pageToken
    excludeAllCompleted: $excludeAllCompleted
  ) {
    tickets {
      id
      key
      description
      ticketType
      workType
      status
      customers
      entityName
      createdAt
      jiraLink
      isPrimary
      isReviewer
      faPreparer
      faReviewer
      assignedTo {
        id
        displayName
        email
      }
      managerOfAssignedTo {
        displayName
        email
      }
      client {
        id
        name
        type
        contactEmail
      }
      manager {
        id
        displayName
        email
        department
      }
      progress {
        completedTasks
        totalTasks
        percentage
      }
      pastDue
      timeElapsed
      dueDate
    }
    nextPageToken
    hasNextPage
    totalCount
    fieldMetadata {
      fieldName
      jiraDisplayName
      jiraFieldId
      fieldType
    }
  }
}
    `;

/**
 * __useGetTicketsQuery__
 *
 * To run a query within a React component, call `useGetTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *      excludeAllCompleted: // value for 'excludeAllCompleted'
 *   },
 * });
 */
export function useGetTicketsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>(GetTicketsDocument, options);
      }
export function useGetTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
// @ts-ignore
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>;
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketsQuery | undefined, GraphqlTypes.GetTicketsQueryVariables>;
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
export type GetTicketsQueryHookResult = ReturnType<typeof useGetTicketsQuery>;
export type GetTicketsLazyQueryHookResult = ReturnType<typeof useGetTicketsLazyQuery>;
export type GetTicketsSuspenseQueryHookResult = ReturnType<typeof useGetTicketsSuspenseQuery>;
export type GetTicketsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>;
export const GetSavedViewDocument = gql`
    query GetSavedView {
  getSavedView {
    id
    configuration
  }
}
    `;

/**
 * __useGetSavedViewQuery__
 *
 * To run a query within a React component, call `useGetSavedViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>(GetSavedViewDocument, options);
      }
export function useGetSavedViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>(GetSavedViewDocument, options);
        }
// @ts-ignore
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>;
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSavedViewQuery | undefined, GraphqlTypes.GetSavedViewQueryVariables>;
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>(GetSavedViewDocument, options);
        }
export type GetSavedViewQueryHookResult = ReturnType<typeof useGetSavedViewQuery>;
export type GetSavedViewLazyQueryHookResult = ReturnType<typeof useGetSavedViewLazyQuery>;
export type GetSavedViewSuspenseQueryHookResult = ReturnType<typeof useGetSavedViewSuspenseQuery>;
export type GetSavedViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>;
export const GetTicketExportDocument = gql`
    query GetTicketExport($exportId: String!) {
  getTicketExport(exportId: $exportId) {
    status
    downloadUrl
    errorMessage
  }
}
    `;

/**
 * __useGetTicketExportQuery__
 *
 * To run a query within a React component, call `useGetTicketExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketExportQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetTicketExportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables> & ({ variables: GraphqlTypes.GetTicketExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>(GetTicketExportDocument, options);
      }
export function useGetTicketExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>(GetTicketExportDocument, options);
        }
// @ts-ignore
export function useGetTicketExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>;
export function useGetTicketExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketExportQuery | undefined, GraphqlTypes.GetTicketExportQueryVariables>;
export function useGetTicketExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>(GetTicketExportDocument, options);
        }
export type GetTicketExportQueryHookResult = ReturnType<typeof useGetTicketExportQuery>;
export type GetTicketExportLazyQueryHookResult = ReturnType<typeof useGetTicketExportLazyQuery>;
export type GetTicketExportSuspenseQueryHookResult = ReturnType<typeof useGetTicketExportSuspenseQuery>;
export type GetTicketExportQueryResult = Apollo.QueryResult<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>;
export const GetFilterOptionsDocument = gql`
    query GetFilterOptions($projectKey: String!) {
  filterOptions(projectKey: $projectKey) {
    projectKey
    issuetype {
      value
    }
    status {
      value
    }
    assignee {
      value
      displayName
    }
    customers {
      value
    }
    entityName {
      value
    }
    isPrimary {
      value
      displayName
    }
    isReviewer {
      value
      displayName
    }
    faReviewer {
      value
      displayName
    }
    faPreparer {
      value
      displayName
    }
  }
}
    `;

/**
 * __useGetFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterOptionsQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *   },
 * });
 */
export function useGetFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables> & ({ variables: GraphqlTypes.GetFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
      }
export function useGetFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>;
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilterOptionsQuery | undefined, GraphqlTypes.GetFilterOptionsQueryVariables>;
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
export type GetFilterOptionsQueryHookResult = ReturnType<typeof useGetFilterOptionsQuery>;
export type GetFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetFilterOptionsLazyQuery>;
export type GetFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetFilterOptionsSuspenseQuery>;
export type GetFilterOptionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>;
export const GetFieldMetadataDocument = gql`
    query GetFieldMetadata($projectKey: String!) {
  tickets(filters: {projectKeys: [$projectKey]}, limit: 0) {
    fieldMetadata {
      fieldName
      jiraDisplayName
      jiraFieldId
      fieldType
    }
  }
}
    `;

/**
 * __useGetFieldMetadataQuery__
 *
 * To run a query within a React component, call `useGetFieldMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldMetadataQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *   },
 * });
 */
export function useGetFieldMetadataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables> & ({ variables: GraphqlTypes.GetFieldMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>(GetFieldMetadataDocument, options);
      }
export function useGetFieldMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>(GetFieldMetadataDocument, options);
        }
// @ts-ignore
export function useGetFieldMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>;
export function useGetFieldMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFieldMetadataQuery | undefined, GraphqlTypes.GetFieldMetadataQueryVariables>;
export function useGetFieldMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>(GetFieldMetadataDocument, options);
        }
export type GetFieldMetadataQueryHookResult = ReturnType<typeof useGetFieldMetadataQuery>;
export type GetFieldMetadataLazyQueryHookResult = ReturnType<typeof useGetFieldMetadataLazyQuery>;
export type GetFieldMetadataSuspenseQueryHookResult = ReturnType<typeof useGetFieldMetadataSuspenseQuery>;
export type GetFieldMetadataQueryResult = Apollo.QueryResult<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>;
export const GetProjectStatisticsDocument = gql`
    query GetProjectStatistics($projectId: String!) {
  projectStatistics(projectId: $projectId) {
    projectId
    projectKey
    projectName
    issueTypeStatistics {
      issueTypeName
      activeCount
      completedCount
      totalCount
    }
  }
}
    `;

/**
 * __useGetProjectStatisticsQuery__
 *
 * To run a query within a React component, call `useGetProjectStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatisticsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables> & ({ variables: GraphqlTypes.GetProjectStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
      }
export function useGetProjectStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
        }
// @ts-ignore
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>;
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatisticsQuery | undefined, GraphqlTypes.GetProjectStatisticsQueryVariables>;
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
        }
export type GetProjectStatisticsQueryHookResult = ReturnType<typeof useGetProjectStatisticsQuery>;
export type GetProjectStatisticsLazyQueryHookResult = ReturnType<typeof useGetProjectStatisticsLazyQuery>;
export type GetProjectStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetProjectStatisticsSuspenseQuery>;
export type GetProjectStatisticsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>;
export const GetLinkedIssuesDocument = gql`
    query GetLinkedIssues($issueKey: String!, $commentsStartAt: Int, $commentsMaxResults: Int) {
  linkedIssues(
    issueKey: $issueKey
    commentsStartAt: $commentsStartAt
    commentsMaxResults: $commentsMaxResults
  ) {
    parentKey
    totalCount
    items {
      key
      comments {
        id
        body
        author {
          accountId
          displayName
          emailAddress
        }
        created
        updated
      }
      commentsStartAt
      commentsMaxResults
      hasMoreComments
    }
  }
}
    `;

/**
 * __useGetLinkedIssuesQuery__
 *
 * To run a query within a React component, call `useGetLinkedIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedIssuesQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *      commentsStartAt: // value for 'commentsStartAt'
 *      commentsMaxResults: // value for 'commentsMaxResults'
 *   },
 * });
 */
export function useGetLinkedIssuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables> & ({ variables: GraphqlTypes.GetLinkedIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>(GetLinkedIssuesDocument, options);
      }
export function useGetLinkedIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>(GetLinkedIssuesDocument, options);
        }
// @ts-ignore
export function useGetLinkedIssuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>;
export function useGetLinkedIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedIssuesQuery | undefined, GraphqlTypes.GetLinkedIssuesQueryVariables>;
export function useGetLinkedIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>(GetLinkedIssuesDocument, options);
        }
export type GetLinkedIssuesQueryHookResult = ReturnType<typeof useGetLinkedIssuesQuery>;
export type GetLinkedIssuesLazyQueryHookResult = ReturnType<typeof useGetLinkedIssuesLazyQuery>;
export type GetLinkedIssuesSuspenseQueryHookResult = ReturnType<typeof useGetLinkedIssuesSuspenseQuery>;
export type GetLinkedIssuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>;
export const GetCommentsPaginatedDocument = gql`
    query GetCommentsPaginated($issueKey: String!, $startAt: Int, $maxResults: Int) {
  commentsPaginated(
    issueKey: $issueKey
    startAt: $startAt
    maxResults: $maxResults
  ) {
    comments {
      id
      body
      author {
        accountId
        displayName
        emailAddress
      }
      created
      updated
    }
    startAt
    maxResults
    total
    hasMore
  }
}
    `;

/**
 * __useGetCommentsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetCommentsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsPaginatedQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *      startAt: // value for 'startAt'
 *      maxResults: // value for 'maxResults'
 *   },
 * });
 */
export function useGetCommentsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables> & ({ variables: GraphqlTypes.GetCommentsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>(GetCommentsPaginatedDocument, options);
      }
export function useGetCommentsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>(GetCommentsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetCommentsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>;
export function useGetCommentsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommentsPaginatedQuery | undefined, GraphqlTypes.GetCommentsPaginatedQueryVariables>;
export function useGetCommentsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>(GetCommentsPaginatedDocument, options);
        }
export type GetCommentsPaginatedQueryHookResult = ReturnType<typeof useGetCommentsPaginatedQuery>;
export type GetCommentsPaginatedLazyQueryHookResult = ReturnType<typeof useGetCommentsPaginatedLazyQuery>;
export type GetCommentsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetCommentsPaginatedSuspenseQuery>;
export type GetCommentsPaginatedQueryResult = Apollo.QueryResult<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>;
export const GetChildWorkItemsDocument = gql`
    query GetChildWorkItems($parentIssueKey: String!) {
  childWorkItems(parentIssueKey: $parentIssueKey) {
    parentKey
    items {
      id
      key
      summary
      status
      assignedTo {
        displayName
      }
      fundAdministrationDepartment
    }
  }
}
    `;

/**
 * __useGetChildWorkItemsQuery__
 *
 * To run a query within a React component, call `useGetChildWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildWorkItemsQuery({
 *   variables: {
 *      parentIssueKey: // value for 'parentIssueKey'
 *   },
 * });
 */
export function useGetChildWorkItemsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables> & ({ variables: GraphqlTypes.GetChildWorkItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>(GetChildWorkItemsDocument, options);
      }
export function useGetChildWorkItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>(GetChildWorkItemsDocument, options);
        }
// @ts-ignore
export function useGetChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>;
export function useGetChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildWorkItemsQuery | undefined, GraphqlTypes.GetChildWorkItemsQueryVariables>;
export function useGetChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>(GetChildWorkItemsDocument, options);
        }
export type GetChildWorkItemsQueryHookResult = ReturnType<typeof useGetChildWorkItemsQuery>;
export type GetChildWorkItemsLazyQueryHookResult = ReturnType<typeof useGetChildWorkItemsLazyQuery>;
export type GetChildWorkItemsSuspenseQueryHookResult = ReturnType<typeof useGetChildWorkItemsSuspenseQuery>;
export type GetChildWorkItemsQueryResult = Apollo.QueryResult<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>;
export const GetArenaAccessDocument = gql`
    query GetArenaAccess($filters: ArenaAccessFilterInput) {
  arenaAccess(filters: $filters) {
    output {
      id
      arenaName
      arenaId
      arenaDomain
      globalUserId
      userName
      userEmail
      roleGroupName
      accessType
      startDate
      endDate
      active
      lastAccessTimestamp
      globalUserId
      isBulkAccess
    }
  }
}
    `;

/**
 * __useGetArenaAccessQuery__
 *
 * To run a query within a React component, call `useGetArenaAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaAccessQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetArenaAccessQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>(GetArenaAccessDocument, options);
      }
export function useGetArenaAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>(GetArenaAccessDocument, options);
        }
// @ts-ignore
export function useGetArenaAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>;
export function useGetArenaAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaAccessQuery | undefined, GraphqlTypes.GetArenaAccessQueryVariables>;
export function useGetArenaAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>(GetArenaAccessDocument, options);
        }
export type GetArenaAccessQueryHookResult = ReturnType<typeof useGetArenaAccessQuery>;
export type GetArenaAccessLazyQueryHookResult = ReturnType<typeof useGetArenaAccessLazyQuery>;
export type GetArenaAccessSuspenseQueryHookResult = ReturnType<typeof useGetArenaAccessSuspenseQuery>;
export type GetArenaAccessQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaAccessQuery, GraphqlTypes.GetArenaAccessQueryVariables>;
export const CrmGeneratePresignedUrlsDocument = gql`
    mutation CrmGeneratePresignedUrls($input: DataStudioGeneratePresignedUrlsInput!) {
  dataStudioGeneratePresignedUrls(input: $input) {
    success
    presignedUrlObjs {
      s3Url
      objectKey
      filename
    }
    errors
  }
}
    `;
export type CrmGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.CrmGeneratePresignedUrlsMutation, GraphqlTypes.CrmGeneratePresignedUrlsMutationVariables>;

/**
 * __useCrmGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useCrmGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrmGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crmGeneratePresignedUrlsMutation, { data, loading, error }] = useCrmGeneratePresignedUrlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CrmGeneratePresignedUrlsMutation, GraphqlTypes.CrmGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CrmGeneratePresignedUrlsMutation, GraphqlTypes.CrmGeneratePresignedUrlsMutationVariables>(CrmGeneratePresignedUrlsDocument, options);
      }
export type CrmGeneratePresignedUrlsMutationHookResult = ReturnType<typeof useCrmGeneratePresignedUrlsMutation>;
export type CrmGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.CrmGeneratePresignedUrlsMutation>;
export type CrmGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CrmGeneratePresignedUrlsMutation, GraphqlTypes.CrmGeneratePresignedUrlsMutationVariables>;
export const CreateOnboardingJobStepDocument = gql`
    mutation CreateOnboardingJobStep($input: DataStudioCreateJobInput!) {
  dataStudioCreateJob(input: $input) {
    id
    s3Uri
    jobType
    arenaDomain
    message
    createdAt
  }
}
    `;
export type CreateOnboardingJobStepMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateOnboardingJobStepMutation, GraphqlTypes.CreateOnboardingJobStepMutationVariables>;

/**
 * __useCreateOnboardingJobStepMutation__
 *
 * To run a mutation, you first call `useCreateOnboardingJobStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnboardingJobStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnboardingJobStepMutation, { data, loading, error }] = useCreateOnboardingJobStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOnboardingJobStepMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateOnboardingJobStepMutation, GraphqlTypes.CreateOnboardingJobStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateOnboardingJobStepMutation, GraphqlTypes.CreateOnboardingJobStepMutationVariables>(CreateOnboardingJobStepDocument, options);
      }
export type CreateOnboardingJobStepMutationHookResult = ReturnType<typeof useCreateOnboardingJobStepMutation>;
export type CreateOnboardingJobStepMutationResult = Apollo.MutationResult<GraphqlTypes.CreateOnboardingJobStepMutation>;
export type CreateOnboardingJobStepMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateOnboardingJobStepMutation, GraphqlTypes.CreateOnboardingJobStepMutationVariables>;
export const ListCrmImportJobsDocument = gql`
    query ListCrmImportJobs($limit: Int, $filters: DataStudioListOnboardingJobsFilterInput) {
  dataStudioListOnboardingJobs(limit: $limit, filters: $filters) {
    success
    message
    totalCount
    limit
    hasMore
    nextCursor
    jobs {
      jobId
      jobName
      jobType
      jobStatus
      arenaDomain
      arenaUserEmail
      environment
      createdAt
      createdBy
      jobConfig
      substate
    }
    errors
  }
}
    `;

/**
 * __useListCrmImportJobsQuery__
 *
 * To run a query within a React component, call `useListCrmImportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCrmImportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCrmImportJobsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListCrmImportJobsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>(ListCrmImportJobsDocument, options);
      }
export function useListCrmImportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>(ListCrmImportJobsDocument, options);
        }
// @ts-ignore
export function useListCrmImportJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>;
export function useListCrmImportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ListCrmImportJobsQuery | undefined, GraphqlTypes.ListCrmImportJobsQueryVariables>;
export function useListCrmImportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>(ListCrmImportJobsDocument, options);
        }
export type ListCrmImportJobsQueryHookResult = ReturnType<typeof useListCrmImportJobsQuery>;
export type ListCrmImportJobsLazyQueryHookResult = ReturnType<typeof useListCrmImportJobsLazyQuery>;
export type ListCrmImportJobsSuspenseQueryHookResult = ReturnType<typeof useListCrmImportJobsSuspenseQuery>;
export type ListCrmImportJobsQueryResult = Apollo.QueryResult<GraphqlTypes.ListCrmImportJobsQuery, GraphqlTypes.ListCrmImportJobsQueryVariables>;
export const GetCrmImportJobValidationDocument = gql`
    query GetCrmImportJobValidation($limit: Int, $filters: DataStudioListOnboardingJobsFilterInput) {
  dataStudioListOnboardingJobs(limit: $limit, filters: $filters) {
    success
    message
    jobs {
      jobId
      jobStatus
      substate
      arenaDomain
      arenaUserEmail
      environment
      createdAt
      validationStats {
        totalRecords
        validRecords
        criticalErrors
        warnings
      }
      toolValidations {
        toolType
        fileName
        status
        stats {
          totalRecords
          validRecords
          errorCount
          warningCount
        }
        issues {
          column
          message
          rowNumber
          severity
        }
        s3IssuesPath
        s3FilePath
        startedAt
        completedAt
        retryAttempt
      }
    }
    errors
  }
}
    `;

/**
 * __useGetCrmImportJobValidationQuery__
 *
 * To run a query within a React component, call `useGetCrmImportJobValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmImportJobValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmImportJobValidationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCrmImportJobValidationQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>(GetCrmImportJobValidationDocument, options);
      }
export function useGetCrmImportJobValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>(GetCrmImportJobValidationDocument, options);
        }
// @ts-ignore
export function useGetCrmImportJobValidationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>;
export function useGetCrmImportJobValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCrmImportJobValidationQuery | undefined, GraphqlTypes.GetCrmImportJobValidationQueryVariables>;
export function useGetCrmImportJobValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>(GetCrmImportJobValidationDocument, options);
        }
export type GetCrmImportJobValidationQueryHookResult = ReturnType<typeof useGetCrmImportJobValidationQuery>;
export type GetCrmImportJobValidationLazyQueryHookResult = ReturnType<typeof useGetCrmImportJobValidationLazyQuery>;
export type GetCrmImportJobValidationSuspenseQueryHookResult = ReturnType<typeof useGetCrmImportJobValidationSuspenseQuery>;
export type GetCrmImportJobValidationQueryResult = Apollo.QueryResult<GraphqlTypes.GetCrmImportJobValidationQuery, GraphqlTypes.GetCrmImportJobValidationQueryVariables>;
export const GetCrmImportJobConfigDocument = gql`
    query GetCrmImportJobConfig($limit: Int, $filters: DataStudioListOnboardingJobsFilterInput) {
  dataStudioListOnboardingJobs(limit: $limit, filters: $filters) {
    success
    jobs {
      jobId
      jobConfig
      arenaDomain
      arenaUserEmail
      environment
      createdAt
    }
    errors
  }
}
    `;

/**
 * __useGetCrmImportJobConfigQuery__
 *
 * To run a query within a React component, call `useGetCrmImportJobConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmImportJobConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmImportJobConfigQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCrmImportJobConfigQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>(GetCrmImportJobConfigDocument, options);
      }
export function useGetCrmImportJobConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>(GetCrmImportJobConfigDocument, options);
        }
// @ts-ignore
export function useGetCrmImportJobConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>;
export function useGetCrmImportJobConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCrmImportJobConfigQuery | undefined, GraphqlTypes.GetCrmImportJobConfigQueryVariables>;
export function useGetCrmImportJobConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>(GetCrmImportJobConfigDocument, options);
        }
export type GetCrmImportJobConfigQueryHookResult = ReturnType<typeof useGetCrmImportJobConfigQuery>;
export type GetCrmImportJobConfigLazyQueryHookResult = ReturnType<typeof useGetCrmImportJobConfigLazyQuery>;
export type GetCrmImportJobConfigSuspenseQueryHookResult = ReturnType<typeof useGetCrmImportJobConfigSuspenseQuery>;
export type GetCrmImportJobConfigQueryResult = Apollo.QueryResult<GraphqlTypes.GetCrmImportJobConfigQuery, GraphqlTypes.GetCrmImportJobConfigQueryVariables>;
export const BulkImportDataVaultExtensionFieldValuesDocument = gql`
    mutation BulkImportDataVaultExtensionFieldValues($input: BulkImportDataVaultExtensionFieldValuesInput!) {
  bulkImportDataVaultExtensionFieldValues(input: $input) {
    jobId
  }
}
    `;
export type BulkImportDataVaultExtensionFieldValuesMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutation, GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutationVariables>;

/**
 * __useBulkImportDataVaultExtensionFieldValuesMutation__
 *
 * To run a mutation, you first call `useBulkImportDataVaultExtensionFieldValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkImportDataVaultExtensionFieldValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkImportDataVaultExtensionFieldValuesMutation, { data, loading, error }] = useBulkImportDataVaultExtensionFieldValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkImportDataVaultExtensionFieldValuesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutation, GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutation, GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutationVariables>(BulkImportDataVaultExtensionFieldValuesDocument, options);
      }
export type BulkImportDataVaultExtensionFieldValuesMutationHookResult = ReturnType<typeof useBulkImportDataVaultExtensionFieldValuesMutation>;
export type BulkImportDataVaultExtensionFieldValuesMutationResult = Apollo.MutationResult<GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutation>;
export type BulkImportDataVaultExtensionFieldValuesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutation, GraphqlTypes.BulkImportDataVaultExtensionFieldValuesMutationVariables>;
export const BulkUploadGeneratePresignedUrlsDocument = gql`
    mutation BulkUploadGeneratePresignedUrls($urlGeneratorInput: [PresignedUrlInput]!) {
  generatePresignedUrls(urlGeneratorInput: $urlGeneratorInput) {
    presignedUrlObjs {
      s3Url
      objectKey
      fileName
    }
  }
}
    `;
export type BulkUploadGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkUploadGeneratePresignedUrlsMutation, GraphqlTypes.BulkUploadGeneratePresignedUrlsMutationVariables>;

/**
 * __useBulkUploadGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useBulkUploadGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadGeneratePresignedUrlsMutation, { data, loading, error }] = useBulkUploadGeneratePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *   },
 * });
 */
export function useBulkUploadGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkUploadGeneratePresignedUrlsMutation, GraphqlTypes.BulkUploadGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkUploadGeneratePresignedUrlsMutation, GraphqlTypes.BulkUploadGeneratePresignedUrlsMutationVariables>(BulkUploadGeneratePresignedUrlsDocument, options);
      }
export type BulkUploadGeneratePresignedUrlsMutationHookResult = ReturnType<typeof useBulkUploadGeneratePresignedUrlsMutation>;
export type BulkUploadGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.BulkUploadGeneratePresignedUrlsMutation>;
export type BulkUploadGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkUploadGeneratePresignedUrlsMutation, GraphqlTypes.BulkUploadGeneratePresignedUrlsMutationVariables>;
export const GetAsyncJobsDocument = gql`
    query GetAsyncJobs($filters: AsyncJobsFilters, $first: Int, $after: String, $sort: [AsyncJobObjectTypeSortEnum]) {
  asyncJobs(filters: $filters, first: $first, after: $after, sort: $sort) {
    edges {
      node {
        id
        createdBy {
          firstName
          middleName
          lastName
        }
        jobType
        status
        startTime
        endTime
        createdAt
        progress {
          processedCount
          totalCount
        }
        data
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    count
  }
}
    `;

/**
 * __useGetAsyncJobsQuery__
 *
 * To run a query within a React component, call `useGetAsyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncJobsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAsyncJobsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>(GetAsyncJobsDocument, options);
      }
export function useGetAsyncJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>(GetAsyncJobsDocument, options);
        }
// @ts-ignore
export function useGetAsyncJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>;
export function useGetAsyncJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAsyncJobsQuery | undefined, GraphqlTypes.GetAsyncJobsQueryVariables>;
export function useGetAsyncJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>(GetAsyncJobsDocument, options);
        }
export type GetAsyncJobsQueryHookResult = ReturnType<typeof useGetAsyncJobsQuery>;
export type GetAsyncJobsLazyQueryHookResult = ReturnType<typeof useGetAsyncJobsLazyQuery>;
export type GetAsyncJobsSuspenseQueryHookResult = ReturnType<typeof useGetAsyncJobsSuspenseQuery>;
export type GetAsyncJobsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAsyncJobsQuery, GraphqlTypes.GetAsyncJobsQueryVariables>;
export const GetCountryNamesDocument = gql`
    query GetCountryNames {
  countries {
    edges {
      node {
        id
        name
        alpha2code
      }
    }
  }
}
    `;

/**
 * __useGetCountryNamesQuery__
 *
 * To run a query within a React component, call `useGetCountryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryNamesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>(GetCountryNamesDocument, options);
      }
export function useGetCountryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>(GetCountryNamesDocument, options);
        }
// @ts-ignore
export function useGetCountryNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>;
export function useGetCountryNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountryNamesQuery | undefined, GraphqlTypes.GetCountryNamesQueryVariables>;
export function useGetCountryNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>(GetCountryNamesDocument, options);
        }
export type GetCountryNamesQueryHookResult = ReturnType<typeof useGetCountryNamesQuery>;
export type GetCountryNamesLazyQueryHookResult = ReturnType<typeof useGetCountryNamesLazyQuery>;
export type GetCountryNamesSuspenseQueryHookResult = ReturnType<typeof useGetCountryNamesSuspenseQuery>;
export type GetCountryNamesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountryNamesQuery, GraphqlTypes.GetCountryNamesQueryVariables>;
export const GetStateBasicsDocument = gql`
    query GetStateBasics {
  states {
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useGetStateBasicsQuery__
 *
 * To run a query within a React component, call `useGetStateBasicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateBasicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateBasicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStateBasicsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>(GetStateBasicsDocument, options);
      }
export function useGetStateBasicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>(GetStateBasicsDocument, options);
        }
// @ts-ignore
export function useGetStateBasicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>;
export function useGetStateBasicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetStateBasicsQuery | undefined, GraphqlTypes.GetStateBasicsQueryVariables>;
export function useGetStateBasicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>(GetStateBasicsDocument, options);
        }
export type GetStateBasicsQueryHookResult = ReturnType<typeof useGetStateBasicsQuery>;
export type GetStateBasicsLazyQueryHookResult = ReturnType<typeof useGetStateBasicsLazyQuery>;
export type GetStateBasicsSuspenseQueryHookResult = ReturnType<typeof useGetStateBasicsSuspenseQuery>;
export type GetStateBasicsQueryResult = Apollo.QueryResult<GraphqlTypes.GetStateBasicsQuery, GraphqlTypes.GetStateBasicsQueryVariables>;
export const CreateDataVaultExtensionFieldDocument = gql`
    mutation CreateDataVaultExtensionField($input: CreateDataVaultExtensionFieldInput!) {
  createDataVaultExtensionField(input: $input) {
    extensionField {
      ...ExtensionFieldData
    }
    errors
  }
}
    ${ExtensionFieldDataFragmentDoc}`;
export type CreateDataVaultExtensionFieldMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDataVaultExtensionFieldMutation, GraphqlTypes.CreateDataVaultExtensionFieldMutationVariables>;

/**
 * __useCreateDataVaultExtensionFieldMutation__
 *
 * To run a mutation, you first call `useCreateDataVaultExtensionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataVaultExtensionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataVaultExtensionFieldMutation, { data, loading, error }] = useCreateDataVaultExtensionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataVaultExtensionFieldMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDataVaultExtensionFieldMutation, GraphqlTypes.CreateDataVaultExtensionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDataVaultExtensionFieldMutation, GraphqlTypes.CreateDataVaultExtensionFieldMutationVariables>(CreateDataVaultExtensionFieldDocument, options);
      }
export type CreateDataVaultExtensionFieldMutationHookResult = ReturnType<typeof useCreateDataVaultExtensionFieldMutation>;
export type CreateDataVaultExtensionFieldMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDataVaultExtensionFieldMutation>;
export type CreateDataVaultExtensionFieldMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDataVaultExtensionFieldMutation, GraphqlTypes.CreateDataVaultExtensionFieldMutationVariables>;
export const DeleteDataVaultExtensionFieldDocument = gql`
    mutation DeleteDataVaultExtensionField($input: DeleteDataVaultExtensionFieldInput!) {
  deleteDataVaultExtensionField(input: $input) {
    success
    errors
  }
}
    `;
export type DeleteDataVaultExtensionFieldMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteDataVaultExtensionFieldMutation, GraphqlTypes.DeleteDataVaultExtensionFieldMutationVariables>;

/**
 * __useDeleteDataVaultExtensionFieldMutation__
 *
 * To run a mutation, you first call `useDeleteDataVaultExtensionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataVaultExtensionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataVaultExtensionFieldMutation, { data, loading, error }] = useDeleteDataVaultExtensionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDataVaultExtensionFieldMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteDataVaultExtensionFieldMutation, GraphqlTypes.DeleteDataVaultExtensionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteDataVaultExtensionFieldMutation, GraphqlTypes.DeleteDataVaultExtensionFieldMutationVariables>(DeleteDataVaultExtensionFieldDocument, options);
      }
export type DeleteDataVaultExtensionFieldMutationHookResult = ReturnType<typeof useDeleteDataVaultExtensionFieldMutation>;
export type DeleteDataVaultExtensionFieldMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteDataVaultExtensionFieldMutation>;
export type DeleteDataVaultExtensionFieldMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteDataVaultExtensionFieldMutation, GraphqlTypes.DeleteDataVaultExtensionFieldMutationVariables>;
export const EditDataVaultExtensionFieldDocument = gql`
    mutation EditDataVaultExtensionField($input: EditDataVaultExtensionFieldInput!) {
  editDataVaultExtensionField(input: $input) {
    extensionField {
      ...ExtensionFieldData
    }
    errors
  }
}
    ${ExtensionFieldDataFragmentDoc}`;
export type EditDataVaultExtensionFieldMutationFn = Apollo.MutationFunction<GraphqlTypes.EditDataVaultExtensionFieldMutation, GraphqlTypes.EditDataVaultExtensionFieldMutationVariables>;

/**
 * __useEditDataVaultExtensionFieldMutation__
 *
 * To run a mutation, you first call `useEditDataVaultExtensionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDataVaultExtensionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDataVaultExtensionFieldMutation, { data, loading, error }] = useEditDataVaultExtensionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDataVaultExtensionFieldMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EditDataVaultExtensionFieldMutation, GraphqlTypes.EditDataVaultExtensionFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EditDataVaultExtensionFieldMutation, GraphqlTypes.EditDataVaultExtensionFieldMutationVariables>(EditDataVaultExtensionFieldDocument, options);
      }
export type EditDataVaultExtensionFieldMutationHookResult = ReturnType<typeof useEditDataVaultExtensionFieldMutation>;
export type EditDataVaultExtensionFieldMutationResult = Apollo.MutationResult<GraphqlTypes.EditDataVaultExtensionFieldMutation>;
export type EditDataVaultExtensionFieldMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EditDataVaultExtensionFieldMutation, GraphqlTypes.EditDataVaultExtensionFieldMutationVariables>;
export const CreateDataVaultExtensionFieldSectionDocument = gql`
    mutation CreateDataVaultExtensionFieldSection($input: CreateDataVaultExtensionFieldSectionInput!) {
  createDataVaultExtensionFieldSection(input: $input) {
    section {
      id
      name
      description
      context
      tabName
      sortOrder
      extensionFields {
        id
      }
      fieldCount
      createdAt
      modifiedAt
    }
  }
}
    `;
export type CreateDataVaultExtensionFieldSectionMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateDataVaultExtensionFieldSectionMutation, GraphqlTypes.CreateDataVaultExtensionFieldSectionMutationVariables>;

/**
 * __useCreateDataVaultExtensionFieldSectionMutation__
 *
 * To run a mutation, you first call `useCreateDataVaultExtensionFieldSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataVaultExtensionFieldSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataVaultExtensionFieldSectionMutation, { data, loading, error }] = useCreateDataVaultExtensionFieldSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataVaultExtensionFieldSectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateDataVaultExtensionFieldSectionMutation, GraphqlTypes.CreateDataVaultExtensionFieldSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateDataVaultExtensionFieldSectionMutation, GraphqlTypes.CreateDataVaultExtensionFieldSectionMutationVariables>(CreateDataVaultExtensionFieldSectionDocument, options);
      }
export type CreateDataVaultExtensionFieldSectionMutationHookResult = ReturnType<typeof useCreateDataVaultExtensionFieldSectionMutation>;
export type CreateDataVaultExtensionFieldSectionMutationResult = Apollo.MutationResult<GraphqlTypes.CreateDataVaultExtensionFieldSectionMutation>;
export type CreateDataVaultExtensionFieldSectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateDataVaultExtensionFieldSectionMutation, GraphqlTypes.CreateDataVaultExtensionFieldSectionMutationVariables>;
export const UpdateDataVaultExtensionFieldSectionDocument = gql`
    mutation UpdateDataVaultExtensionFieldSection($input: UpdateDataVaultExtensionFieldSectionInput!) {
  updateDataVaultExtensionFieldSection(input: $input) {
    section {
      id
      name
      description
      context
      tabName
      sortOrder
      extensionFields {
        id
      }
      fieldCount
      createdAt
      modifiedAt
    }
  }
}
    `;
export type UpdateDataVaultExtensionFieldSectionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutation, GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutationVariables>;

/**
 * __useUpdateDataVaultExtensionFieldSectionMutation__
 *
 * To run a mutation, you first call `useUpdateDataVaultExtensionFieldSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataVaultExtensionFieldSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataVaultExtensionFieldSectionMutation, { data, loading, error }] = useUpdateDataVaultExtensionFieldSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDataVaultExtensionFieldSectionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutation, GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutation, GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutationVariables>(UpdateDataVaultExtensionFieldSectionDocument, options);
      }
export type UpdateDataVaultExtensionFieldSectionMutationHookResult = ReturnType<typeof useUpdateDataVaultExtensionFieldSectionMutation>;
export type UpdateDataVaultExtensionFieldSectionMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutation>;
export type UpdateDataVaultExtensionFieldSectionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutation, GraphqlTypes.UpdateDataVaultExtensionFieldSectionMutationVariables>;
export const GetDataVaultExtensionFieldsDocument = gql`
    query GetDataVaultExtensionFields($input: DataVaultExtensionFieldsInput) {
  dataVaultExtensionFields(input: $input) {
    ...ExtensionFieldData
  }
}
    ${ExtensionFieldDataFragmentDoc}`;

/**
 * __useGetDataVaultExtensionFieldsQuery__
 *
 * To run a query within a React component, call `useGetDataVaultExtensionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataVaultExtensionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataVaultExtensionFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataVaultExtensionFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>(GetDataVaultExtensionFieldsDocument, options);
      }
export function useGetDataVaultExtensionFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>(GetDataVaultExtensionFieldsDocument, options);
        }
// @ts-ignore
export function useGetDataVaultExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>;
export function useGetDataVaultExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultExtensionFieldsQuery | undefined, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>;
export function useGetDataVaultExtensionFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>(GetDataVaultExtensionFieldsDocument, options);
        }
export type GetDataVaultExtensionFieldsQueryHookResult = ReturnType<typeof useGetDataVaultExtensionFieldsQuery>;
export type GetDataVaultExtensionFieldsLazyQueryHookResult = ReturnType<typeof useGetDataVaultExtensionFieldsLazyQuery>;
export type GetDataVaultExtensionFieldsSuspenseQueryHookResult = ReturnType<typeof useGetDataVaultExtensionFieldsSuspenseQuery>;
export type GetDataVaultExtensionFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataVaultExtensionFieldsQuery, GraphqlTypes.GetDataVaultExtensionFieldsQueryVariables>;
export const GetExtensionFieldEnumValuesDocument = gql`
    query GetExtensionFieldEnumValues($enumName: String!) {
  extensionFieldEnumValues(enumName: $enumName) {
    id
    enumName
    enumValueCode
    enumValueLabel
  }
}
    `;

/**
 * __useGetExtensionFieldEnumValuesQuery__
 *
 * To run a query within a React component, call `useGetExtensionFieldEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtensionFieldEnumValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtensionFieldEnumValuesQuery({
 *   variables: {
 *      enumName: // value for 'enumName'
 *   },
 * });
 */
export function useGetExtensionFieldEnumValuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables> & ({ variables: GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>(GetExtensionFieldEnumValuesDocument, options);
      }
export function useGetExtensionFieldEnumValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>(GetExtensionFieldEnumValuesDocument, options);
        }
// @ts-ignore
export function useGetExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>;
export function useGetExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExtensionFieldEnumValuesQuery | undefined, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>;
export function useGetExtensionFieldEnumValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>(GetExtensionFieldEnumValuesDocument, options);
        }
export type GetExtensionFieldEnumValuesQueryHookResult = ReturnType<typeof useGetExtensionFieldEnumValuesQuery>;
export type GetExtensionFieldEnumValuesLazyQueryHookResult = ReturnType<typeof useGetExtensionFieldEnumValuesLazyQuery>;
export type GetExtensionFieldEnumValuesSuspenseQueryHookResult = ReturnType<typeof useGetExtensionFieldEnumValuesSuspenseQuery>;
export type GetExtensionFieldEnumValuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetExtensionFieldEnumValuesQuery, GraphqlTypes.GetExtensionFieldEnumValuesQueryVariables>;
export const GetDataVaultExtensionFieldSectionsByContextDocument = gql`
    query GetDataVaultExtensionFieldSectionsByContext($input: DataVaultExtensionFieldSectionsByContextInput!) {
  dataVaultExtensionFieldSectionsByContext(input: $input) {
    id
    name
    description
    context
    tabName
    sortOrder
    extensionFields {
      id
    }
    fieldCount
    createdAt
    modifiedAt
  }
}
    `;

/**
 * __useGetDataVaultExtensionFieldSectionsByContextQuery__
 *
 * To run a query within a React component, call `useGetDataVaultExtensionFieldSectionsByContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataVaultExtensionFieldSectionsByContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataVaultExtensionFieldSectionsByContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataVaultExtensionFieldSectionsByContextQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables> & ({ variables: GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>(GetDataVaultExtensionFieldSectionsByContextDocument, options);
      }
export function useGetDataVaultExtensionFieldSectionsByContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>(GetDataVaultExtensionFieldSectionsByContextDocument, options);
        }
// @ts-ignore
export function useGetDataVaultExtensionFieldSectionsByContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>;
export function useGetDataVaultExtensionFieldSectionsByContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery | undefined, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>;
export function useGetDataVaultExtensionFieldSectionsByContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>(GetDataVaultExtensionFieldSectionsByContextDocument, options);
        }
export type GetDataVaultExtensionFieldSectionsByContextQueryHookResult = ReturnType<typeof useGetDataVaultExtensionFieldSectionsByContextQuery>;
export type GetDataVaultExtensionFieldSectionsByContextLazyQueryHookResult = ReturnType<typeof useGetDataVaultExtensionFieldSectionsByContextLazyQuery>;
export type GetDataVaultExtensionFieldSectionsByContextSuspenseQueryHookResult = ReturnType<typeof useGetDataVaultExtensionFieldSectionsByContextSuspenseQuery>;
export type GetDataVaultExtensionFieldSectionsByContextQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQuery, GraphqlTypes.GetDataVaultExtensionFieldSectionsByContextQueryVariables>;
export const SetDataVaultExtensionFieldValueDocument = gql`
    mutation SetDataVaultExtensionFieldValue($input: SetDataVaultExtensionFieldValueInput!) {
  setDataVaultExtensionFieldValue(input: $input) {
    extensionFieldValue {
      ...ExtensionFieldValueData
    }
    errors
  }
}
    ${ExtensionFieldValueDataFragmentDoc}`;
export type SetDataVaultExtensionFieldValueMutationFn = Apollo.MutationFunction<GraphqlTypes.SetDataVaultExtensionFieldValueMutation, GraphqlTypes.SetDataVaultExtensionFieldValueMutationVariables>;

/**
 * __useSetDataVaultExtensionFieldValueMutation__
 *
 * To run a mutation, you first call `useSetDataVaultExtensionFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDataVaultExtensionFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDataVaultExtensionFieldValueMutation, { data, loading, error }] = useSetDataVaultExtensionFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDataVaultExtensionFieldValueMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetDataVaultExtensionFieldValueMutation, GraphqlTypes.SetDataVaultExtensionFieldValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetDataVaultExtensionFieldValueMutation, GraphqlTypes.SetDataVaultExtensionFieldValueMutationVariables>(SetDataVaultExtensionFieldValueDocument, options);
      }
export type SetDataVaultExtensionFieldValueMutationHookResult = ReturnType<typeof useSetDataVaultExtensionFieldValueMutation>;
export type SetDataVaultExtensionFieldValueMutationResult = Apollo.MutationResult<GraphqlTypes.SetDataVaultExtensionFieldValueMutation>;
export type SetDataVaultExtensionFieldValueMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetDataVaultExtensionFieldValueMutation, GraphqlTypes.SetDataVaultExtensionFieldValueMutationVariables>;
export const GetDataVaultArenasDocument = gql`
    query GetDataVaultArenas($includeAdminArena: Boolean!, $applicationContext: ApplicationContext) {
  arenas(
    includeAdminArena: $includeAdminArena
    applicationContext: $applicationContext
  ) {
    edges {
      node {
        id
        domain
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetDataVaultArenasQuery__
 *
 * To run a query within a React component, call `useGetDataVaultArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataVaultArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataVaultArenasQuery({
 *   variables: {
 *      includeAdminArena: // value for 'includeAdminArena'
 *      applicationContext: // value for 'applicationContext'
 *   },
 * });
 */
export function useGetDataVaultArenasQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables> & ({ variables: GraphqlTypes.GetDataVaultArenasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>(GetDataVaultArenasDocument, options);
      }
export function useGetDataVaultArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>(GetDataVaultArenasDocument, options);
        }
// @ts-ignore
export function useGetDataVaultArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>;
export function useGetDataVaultArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultArenasQuery | undefined, GraphqlTypes.GetDataVaultArenasQueryVariables>;
export function useGetDataVaultArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>(GetDataVaultArenasDocument, options);
        }
export type GetDataVaultArenasQueryHookResult = ReturnType<typeof useGetDataVaultArenasQuery>;
export type GetDataVaultArenasLazyQueryHookResult = ReturnType<typeof useGetDataVaultArenasLazyQuery>;
export type GetDataVaultArenasSuspenseQueryHookResult = ReturnType<typeof useGetDataVaultArenasSuspenseQuery>;
export type GetDataVaultArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataVaultArenasQuery, GraphqlTypes.GetDataVaultArenasQueryVariables>;
export const GetInvestmentEntitiesByArenaDocument = gql`
    query GetInvestmentEntitiesByArena($arenaId: ID, $filterEntitiesWithTransactions: Boolean = false, $first: Int = 100, $after: String) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    filterEntitiesWithTransactions: $filterEntitiesWithTransactions
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        name
        status
        isPartial
        type {
          id
          name
        }
        dataVaultCustomFields {
          ...ExtensionFieldTupleData
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${ExtensionFieldTupleDataFragmentDoc}`;

/**
 * __useGetInvestmentEntitiesByArenaQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesByArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesByArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesByArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      filterEntitiesWithTransactions: // value for 'filterEntitiesWithTransactions'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInvestmentEntitiesByArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>(GetInvestmentEntitiesByArenaDocument, options);
      }
export function useGetInvestmentEntitiesByArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>(GetInvestmentEntitiesByArenaDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesByArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>;
export function useGetInvestmentEntitiesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaQuery | undefined, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>;
export function useGetInvestmentEntitiesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>(GetInvestmentEntitiesByArenaDocument, options);
        }
export type GetInvestmentEntitiesByArenaQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaQuery>;
export type GetInvestmentEntitiesByArenaLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaLazyQuery>;
export type GetInvestmentEntitiesByArenaSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaSuspenseQuery>;
export type GetInvestmentEntitiesByArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaQuery, GraphqlTypes.GetInvestmentEntitiesByArenaQueryVariables>;
export const GetInvestmentEntitiesByArenaOptimizedDocument = gql`
    query GetInvestmentEntitiesByArenaOptimized($arenaId: ID!, $first: Int = 100, $after: String) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    filterEntitiesWithTransactions: false
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        name
        status
        dataVaultCustomFields {
          extensionField {
            id
            name
            extensionFieldTypeId
          }
          values {
            ...ExtensionFieldValueDataMinimal
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ExtensionFieldValueDataMinimalFragmentDoc}`;

/**
 * __useGetInvestmentEntitiesByArenaOptimizedQuery__
 *
 * To run a query within a React component, call `useGetInvestmentEntitiesByArenaOptimizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentEntitiesByArenaOptimizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentEntitiesByArenaOptimizedQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInvestmentEntitiesByArenaOptimizedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables> & ({ variables: GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>(GetInvestmentEntitiesByArenaOptimizedDocument, options);
      }
export function useGetInvestmentEntitiesByArenaOptimizedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>(GetInvestmentEntitiesByArenaOptimizedDocument, options);
        }
// @ts-ignore
export function useGetInvestmentEntitiesByArenaOptimizedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>;
export function useGetInvestmentEntitiesByArenaOptimizedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery | undefined, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>;
export function useGetInvestmentEntitiesByArenaOptimizedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>(GetInvestmentEntitiesByArenaOptimizedDocument, options);
        }
export type GetInvestmentEntitiesByArenaOptimizedQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaOptimizedQuery>;
export type GetInvestmentEntitiesByArenaOptimizedLazyQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaOptimizedLazyQuery>;
export type GetInvestmentEntitiesByArenaOptimizedSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentEntitiesByArenaOptimizedSuspenseQuery>;
export type GetInvestmentEntitiesByArenaOptimizedQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQuery, GraphqlTypes.GetInvestmentEntitiesByArenaOptimizedQueryVariables>;
export const GetEntityExtensionFieldsWithValuesDocument = gql`
    query GetEntityExtensionFieldsWithValues($entityId: ID!) {
  account(accountId: $entityId) {
    id
    name
    dataVaultCustomFields {
      ...ExtensionFieldTupleData
    }
  }
}
    ${ExtensionFieldTupleDataFragmentDoc}`;

/**
 * __useGetEntityExtensionFieldsWithValuesQuery__
 *
 * To run a query within a React component, call `useGetEntityExtensionFieldsWithValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityExtensionFieldsWithValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityExtensionFieldsWithValuesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityExtensionFieldsWithValuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables> & ({ variables: GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>(GetEntityExtensionFieldsWithValuesDocument, options);
      }
export function useGetEntityExtensionFieldsWithValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>(GetEntityExtensionFieldsWithValuesDocument, options);
        }
// @ts-ignore
export function useGetEntityExtensionFieldsWithValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>;
export function useGetEntityExtensionFieldsWithValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery | undefined, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>;
export function useGetEntityExtensionFieldsWithValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>(GetEntityExtensionFieldsWithValuesDocument, options);
        }
export type GetEntityExtensionFieldsWithValuesQueryHookResult = ReturnType<typeof useGetEntityExtensionFieldsWithValuesQuery>;
export type GetEntityExtensionFieldsWithValuesLazyQueryHookResult = ReturnType<typeof useGetEntityExtensionFieldsWithValuesLazyQuery>;
export type GetEntityExtensionFieldsWithValuesSuspenseQueryHookResult = ReturnType<typeof useGetEntityExtensionFieldsWithValuesSuspenseQuery>;
export type GetEntityExtensionFieldsWithValuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityExtensionFieldsWithValuesQuery, GraphqlTypes.GetEntityExtensionFieldsWithValuesQueryVariables>;
export const DataVaultEntitiesDocument = gql`
    query DataVaultEntities($filters: DataVaultEntitiesInput!, $first: Int, $after: String) {
  dataVaultEntities(input: $filters, first: $first, after: $after) {
    count
    edges {
      node {
        arenaId
        arena {
          name
        }
        id
        name
        status
        isPartial
        type {
          id
          name
          __typename
        }
        dataVaultCustomFields {
          ...ExtensionFieldTupleData
          __typename
        }
        __typename
      }
      __typename
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
      __typename
    }
    __typename
  }
}
    ${ExtensionFieldTupleDataFragmentDoc}`;

/**
 * __useDataVaultEntitiesQuery__
 *
 * To run a query within a React component, call `useDataVaultEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataVaultEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataVaultEntitiesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDataVaultEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables> & ({ variables: GraphqlTypes.DataVaultEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>(DataVaultEntitiesDocument, options);
      }
export function useDataVaultEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>(DataVaultEntitiesDocument, options);
        }
// @ts-ignore
export function useDataVaultEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>;
export function useDataVaultEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataVaultEntitiesQuery | undefined, GraphqlTypes.DataVaultEntitiesQueryVariables>;
export function useDataVaultEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>(DataVaultEntitiesDocument, options);
        }
export type DataVaultEntitiesQueryHookResult = ReturnType<typeof useDataVaultEntitiesQuery>;
export type DataVaultEntitiesLazyQueryHookResult = ReturnType<typeof useDataVaultEntitiesLazyQuery>;
export type DataVaultEntitiesSuspenseQueryHookResult = ReturnType<typeof useDataVaultEntitiesSuspenseQuery>;
export type DataVaultEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.DataVaultEntitiesQuery, GraphqlTypes.DataVaultEntitiesQueryVariables>;
export const DeleteAnnouncementDocument = gql`
    mutation deleteAnnouncement($announcementId: Int!) {
  deleteAnnouncement(announcementId: $announcementId)
}
    `;
export type DeleteAnnouncementMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteAnnouncementMutation, GraphqlTypes.DeleteAnnouncementMutationVariables>;

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteAnnouncementMutation, GraphqlTypes.DeleteAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteAnnouncementMutation, GraphqlTypes.DeleteAnnouncementMutationVariables>(DeleteAnnouncementDocument, options);
      }
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteAnnouncementMutation, GraphqlTypes.DeleteAnnouncementMutationVariables>;
export const GetAnnouncementsDocument = gql`
    query GetAnnouncements {
  announcements {
    ...AnnouncementFields
  }
}
    ${AnnouncementFieldsFragmentDoc}`;

/**
 * __useGetAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
      }
export function useGetAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
        }
// @ts-ignore
export function useGetAnnouncementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>;
export function useGetAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAnnouncementsQuery | undefined, GraphqlTypes.GetAnnouncementsQueryVariables>;
export function useGetAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
        }
export type GetAnnouncementsQueryHookResult = ReturnType<typeof useGetAnnouncementsQuery>;
export type GetAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsLazyQuery>;
export type GetAnnouncementsSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementsSuspenseQuery>;
export type GetAnnouncementsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAnnouncementsQuery, GraphqlTypes.GetAnnouncementsQueryVariables>;
export const CreateAnnouncementDocument = gql`
    mutation createAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    ...AnnouncementFields
  }
}
    ${AnnouncementFieldsFragmentDoc}`;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateAnnouncementMutation, GraphqlTypes.CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateAnnouncementMutation, GraphqlTypes.CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateAnnouncementMutation, GraphqlTypes.CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<GraphqlTypes.CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateAnnouncementMutation, GraphqlTypes.CreateAnnouncementMutationVariables>;
export const GetRolesDocument = gql`
    query getRoles {
  roles {
    id
    description
    name
    isManageBasicConfigurationSetting
    isManageStaffAccessSetting
    isManageAdminConfigurationSetting
    isObjectLevelBasicPermission
    isNonStaffRole
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>(GetRolesDocument, options);
        }
// @ts-ignore
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetRolesQuery | undefined, GraphqlTypes.GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GraphqlTypes.GetRolesQuery, GraphqlTypes.GetRolesQueryVariables>;
export const GetArenasForFayDocument = gql`
    query GetArenasForFay($includeAdminArena: Boolean!, $applicationContext: ApplicationContext!, $filterByActiveArenaAccesses: Boolean) {
  arenas(
    includeAdminArena: $includeAdminArena
    applicationContext: $applicationContext
    filterByActiveArenaAccesses: $filterByActiveArenaAccesses
  ) {
    edges {
      node {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetArenasForFayQuery__
 *
 * To run a query within a React component, call `useGetArenasForFayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasForFayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasForFayQuery({
 *   variables: {
 *      includeAdminArena: // value for 'includeAdminArena'
 *      applicationContext: // value for 'applicationContext'
 *      filterByActiveArenaAccesses: // value for 'filterByActiveArenaAccesses'
 *   },
 * });
 */
export function useGetArenasForFayQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables> & ({ variables: GraphqlTypes.GetArenasForFayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>(GetArenasForFayDocument, options);
      }
export function useGetArenasForFayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>(GetArenasForFayDocument, options);
        }
// @ts-ignore
export function useGetArenasForFaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>;
export function useGetArenasForFaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasForFayQuery | undefined, GraphqlTypes.GetArenasForFayQueryVariables>;
export function useGetArenasForFaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>(GetArenasForFayDocument, options);
        }
export type GetArenasForFayQueryHookResult = ReturnType<typeof useGetArenasForFayQuery>;
export type GetArenasForFayLazyQueryHookResult = ReturnType<typeof useGetArenasForFayLazyQuery>;
export type GetArenasForFaySuspenseQueryHookResult = ReturnType<typeof useGetArenasForFaySuspenseQuery>;
export type GetArenasForFayQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasForFayQuery, GraphqlTypes.GetArenasForFayQueryVariables>;
export const ExportManuallyEditedEntityTransactionsDocument = gql`
    mutation exportManuallyEditedEntityTransactions($startDate: Date!, $endDate: Date!) {
  manuallyEditedEntityTransactionExport(startDate: $startDate, endDate: $endDate) {
    job {
      id
      status
    }
  }
}
    `;
export type ExportManuallyEditedEntityTransactionsMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportManuallyEditedEntityTransactionsMutation, GraphqlTypes.ExportManuallyEditedEntityTransactionsMutationVariables>;

/**
 * __useExportManuallyEditedEntityTransactionsMutation__
 *
 * To run a mutation, you first call `useExportManuallyEditedEntityTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportManuallyEditedEntityTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportManuallyEditedEntityTransactionsMutation, { data, loading, error }] = useExportManuallyEditedEntityTransactionsMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useExportManuallyEditedEntityTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportManuallyEditedEntityTransactionsMutation, GraphqlTypes.ExportManuallyEditedEntityTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportManuallyEditedEntityTransactionsMutation, GraphqlTypes.ExportManuallyEditedEntityTransactionsMutationVariables>(ExportManuallyEditedEntityTransactionsDocument, options);
      }
export type ExportManuallyEditedEntityTransactionsMutationHookResult = ReturnType<typeof useExportManuallyEditedEntityTransactionsMutation>;
export type ExportManuallyEditedEntityTransactionsMutationResult = Apollo.MutationResult<GraphqlTypes.ExportManuallyEditedEntityTransactionsMutation>;
export type ExportManuallyEditedEntityTransactionsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportManuallyEditedEntityTransactionsMutation, GraphqlTypes.ExportManuallyEditedEntityTransactionsMutationVariables>;
export const GetTransferEntityPreviewGlSyncDocument = gql`
    query GetTransferEntityPreviewGlSync($syncInput: PreviewTransferGLSyncInput!) {
  entityTransferPreviewGlSync(syncInput: $syncInput) {
    glBatchId
    glBatchDate
    glBatchDescription
    positions {
      positionId
      accountName
      transactionTypes {
        type
        amount
      }
    }
  }
}
    `;

/**
 * __useGetTransferEntityPreviewGlSyncQuery__
 *
 * To run a query within a React component, call `useGetTransferEntityPreviewGlSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferEntityPreviewGlSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferEntityPreviewGlSyncQuery({
 *   variables: {
 *      syncInput: // value for 'syncInput'
 *   },
 * });
 */
export function useGetTransferEntityPreviewGlSyncQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables> & ({ variables: GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>(GetTransferEntityPreviewGlSyncDocument, options);
      }
export function useGetTransferEntityPreviewGlSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>(GetTransferEntityPreviewGlSyncDocument, options);
        }
// @ts-ignore
export function useGetTransferEntityPreviewGlSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>;
export function useGetTransferEntityPreviewGlSyncSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery | undefined, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>;
export function useGetTransferEntityPreviewGlSyncSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>(GetTransferEntityPreviewGlSyncDocument, options);
        }
export type GetTransferEntityPreviewGlSyncQueryHookResult = ReturnType<typeof useGetTransferEntityPreviewGlSyncQuery>;
export type GetTransferEntityPreviewGlSyncLazyQueryHookResult = ReturnType<typeof useGetTransferEntityPreviewGlSyncLazyQuery>;
export type GetTransferEntityPreviewGlSyncSuspenseQueryHookResult = ReturnType<typeof useGetTransferEntityPreviewGlSyncSuspenseQuery>;
export type GetTransferEntityPreviewGlSyncQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransferEntityPreviewGlSyncQuery, GraphqlTypes.GetTransferEntityPreviewGlSyncQueryVariables>;
export const GetTransferBatchesDocument = gql`
    query GetTransferBatches($arenaId: Int!, $entityId: Int!, $isProcessed: Boolean) {
  entityTransferGlBatchesDetails(
    arenaId: $arenaId
    entityId: $entityId
    isProcessed: $isProcessed
  ) {
    history {
      id
      description
      category
      batchDate
      lastSyncUserName
      lastSyncAt
    }
    unsynced {
      id
      description
      positionIds
      category
      batchDate
      lastSyncUserName
    }
  }
}
    `;

/**
 * __useGetTransferBatchesQuery__
 *
 * To run a query within a React component, call `useGetTransferBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferBatchesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      isProcessed: // value for 'isProcessed'
 *   },
 * });
 */
export function useGetTransferBatchesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables> & ({ variables: GraphqlTypes.GetTransferBatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>(GetTransferBatchesDocument, options);
      }
export function useGetTransferBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>(GetTransferBatchesDocument, options);
        }
// @ts-ignore
export function useGetTransferBatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>;
export function useGetTransferBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransferBatchesQuery | undefined, GraphqlTypes.GetTransferBatchesQueryVariables>;
export function useGetTransferBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>(GetTransferBatchesDocument, options);
        }
export type GetTransferBatchesQueryHookResult = ReturnType<typeof useGetTransferBatchesQuery>;
export type GetTransferBatchesLazyQueryHookResult = ReturnType<typeof useGetTransferBatchesLazyQuery>;
export type GetTransferBatchesSuspenseQueryHookResult = ReturnType<typeof useGetTransferBatchesSuspenseQuery>;
export type GetTransferBatchesQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransferBatchesQuery, GraphqlTypes.GetTransferBatchesQueryVariables>;
export const CheckTransactionsWithInvalidPositionIdsDocument = gql`
    query CheckTransactionsWithInvalidPositionIds($input: CheckInvalidPositionIdsInput!) {
  checkTransactionsWithInvalidPositionIds(input: $input) {
    nullJsqPositionIds
    invalidJsqPositionIds
  }
}
    `;

/**
 * __useCheckTransactionsWithInvalidPositionIdsQuery__
 *
 * To run a query within a React component, call `useCheckTransactionsWithInvalidPositionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTransactionsWithInvalidPositionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTransactionsWithInvalidPositionIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckTransactionsWithInvalidPositionIdsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables> & ({ variables: GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>(CheckTransactionsWithInvalidPositionIdsDocument, options);
      }
export function useCheckTransactionsWithInvalidPositionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>(CheckTransactionsWithInvalidPositionIdsDocument, options);
        }
// @ts-ignore
export function useCheckTransactionsWithInvalidPositionIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>;
export function useCheckTransactionsWithInvalidPositionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery | undefined, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>;
export function useCheckTransactionsWithInvalidPositionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>(CheckTransactionsWithInvalidPositionIdsDocument, options);
        }
export type CheckTransactionsWithInvalidPositionIdsQueryHookResult = ReturnType<typeof useCheckTransactionsWithInvalidPositionIdsQuery>;
export type CheckTransactionsWithInvalidPositionIdsLazyQueryHookResult = ReturnType<typeof useCheckTransactionsWithInvalidPositionIdsLazyQuery>;
export type CheckTransactionsWithInvalidPositionIdsSuspenseQueryHookResult = ReturnType<typeof useCheckTransactionsWithInvalidPositionIdsSuspenseQuery>;
export type CheckTransactionsWithInvalidPositionIdsQueryResult = Apollo.QueryResult<GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQuery, GraphqlTypes.CheckTransactionsWithInvalidPositionIdsQueryVariables>;
export const GetEntityGlSyncSettingsDocument = gql`
    query GetEntityGLSyncSettings($arenaId: GlobalID!, $entityId: Int!) {
  entityGLSyncSettings(arenaId: $arenaId, entityId: $entityId) {
    netIncomeSettings {
      glStartDate
      batchPeriod
      active
    }
    capitalCallSettings {
      glStartDate
      active
    }
    distributionSettings {
      glStartDate
      active
    }
    capitalTransactionSettings {
      glStartDate
      active
    }
    transferSettings {
      glStartDate
      glAsOfDate
      active
    }
  }
}
    `;

/**
 * __useGetEntityGlSyncSettingsQuery__
 *
 * To run a query within a React component, call `useGetEntityGlSyncSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityGlSyncSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityGlSyncSettingsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityGlSyncSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables> & ({ variables: GraphqlTypes.GetEntityGlSyncSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>(GetEntityGlSyncSettingsDocument, options);
      }
export function useGetEntityGlSyncSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>(GetEntityGlSyncSettingsDocument, options);
        }
// @ts-ignore
export function useGetEntityGlSyncSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>;
export function useGetEntityGlSyncSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityGlSyncSettingsQuery | undefined, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>;
export function useGetEntityGlSyncSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>(GetEntityGlSyncSettingsDocument, options);
        }
export type GetEntityGlSyncSettingsQueryHookResult = ReturnType<typeof useGetEntityGlSyncSettingsQuery>;
export type GetEntityGlSyncSettingsLazyQueryHookResult = ReturnType<typeof useGetEntityGlSyncSettingsLazyQuery>;
export type GetEntityGlSyncSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEntityGlSyncSettingsSuspenseQuery>;
export type GetEntityGlSyncSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityGlSyncSettingsQuery, GraphqlTypes.GetEntityGlSyncSettingsQueryVariables>;
export const FindTransactionsWithInvalidArenaDocument = gql`
    query FindTransactionsWithInvalidArena($arenaId: GlobalID!, $entityIds: [Int!]!) {
  findTransactionsWithInvalidArena(arenaId: $arenaId, entityIds: $entityIds) {
    entityId
    glBatchIds
  }
}
    `;

/**
 * __useFindTransactionsWithInvalidArenaQuery__
 *
 * To run a query within a React component, call `useFindTransactionsWithInvalidArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTransactionsWithInvalidArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTransactionsWithInvalidArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useFindTransactionsWithInvalidArenaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables> & ({ variables: GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>(FindTransactionsWithInvalidArenaDocument, options);
      }
export function useFindTransactionsWithInvalidArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>(FindTransactionsWithInvalidArenaDocument, options);
        }
// @ts-ignore
export function useFindTransactionsWithInvalidArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>;
export function useFindTransactionsWithInvalidArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FindTransactionsWithInvalidArenaQuery | undefined, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>;
export function useFindTransactionsWithInvalidArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>(FindTransactionsWithInvalidArenaDocument, options);
        }
export type FindTransactionsWithInvalidArenaQueryHookResult = ReturnType<typeof useFindTransactionsWithInvalidArenaQuery>;
export type FindTransactionsWithInvalidArenaLazyQueryHookResult = ReturnType<typeof useFindTransactionsWithInvalidArenaLazyQuery>;
export type FindTransactionsWithInvalidArenaSuspenseQueryHookResult = ReturnType<typeof useFindTransactionsWithInvalidArenaSuspenseQuery>;
export type FindTransactionsWithInvalidArenaQueryResult = Apollo.QueryResult<GraphqlTypes.FindTransactionsWithInvalidArenaQuery, GraphqlTypes.FindTransactionsWithInvalidArenaQueryVariables>;
export const GetSourceMappingGroupsListDocument = gql`
    query GetSourceMappingGroupsList($arenaId: GlobalID!) {
  sourceMappingGroupsList(arenaId: $arenaId) {
    source {
      id
      name
    }
    mappingGroups {
      id
      name
      mappingType
    }
  }
}
    `;

/**
 * __useGetSourceMappingGroupsListQuery__
 *
 * To run a query within a React component, call `useGetSourceMappingGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceMappingGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceMappingGroupsListQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetSourceMappingGroupsListQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables> & ({ variables: GraphqlTypes.GetSourceMappingGroupsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>(GetSourceMappingGroupsListDocument, options);
      }
export function useGetSourceMappingGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>(GetSourceMappingGroupsListDocument, options);
        }
// @ts-ignore
export function useGetSourceMappingGroupsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>;
export function useGetSourceMappingGroupsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSourceMappingGroupsListQuery | undefined, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>;
export function useGetSourceMappingGroupsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>(GetSourceMappingGroupsListDocument, options);
        }
export type GetSourceMappingGroupsListQueryHookResult = ReturnType<typeof useGetSourceMappingGroupsListQuery>;
export type GetSourceMappingGroupsListLazyQueryHookResult = ReturnType<typeof useGetSourceMappingGroupsListLazyQuery>;
export type GetSourceMappingGroupsListSuspenseQueryHookResult = ReturnType<typeof useGetSourceMappingGroupsListSuspenseQuery>;
export type GetSourceMappingGroupsListQueryResult = Apollo.QueryResult<GraphqlTypes.GetSourceMappingGroupsListQuery, GraphqlTypes.GetSourceMappingGroupsListQueryVariables>;
export const GetTransactionMappingValidationDocument = gql`
    query GetTransactionMappingValidation($arenaId: GlobalID!, $entityIds: [Int!]!) {
  transactionMappingValidation(arenaId: $arenaId, entityIds: $entityIds) {
    banner {
      variant
      invalidMappingNames
    }
    entities {
      entityId
      isBlocked
      mappingName
    }
  }
}
    `;

/**
 * __useGetTransactionMappingValidationQuery__
 *
 * To run a query within a React component, call `useGetTransactionMappingValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionMappingValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionMappingValidationQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetTransactionMappingValidationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables> & ({ variables: GraphqlTypes.GetTransactionMappingValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>(GetTransactionMappingValidationDocument, options);
      }
export function useGetTransactionMappingValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>(GetTransactionMappingValidationDocument, options);
        }
// @ts-ignore
export function useGetTransactionMappingValidationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>;
export function useGetTransactionMappingValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTransactionMappingValidationQuery | undefined, GraphqlTypes.GetTransactionMappingValidationQueryVariables>;
export function useGetTransactionMappingValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>(GetTransactionMappingValidationDocument, options);
        }
export type GetTransactionMappingValidationQueryHookResult = ReturnType<typeof useGetTransactionMappingValidationQuery>;
export type GetTransactionMappingValidationLazyQueryHookResult = ReturnType<typeof useGetTransactionMappingValidationLazyQuery>;
export type GetTransactionMappingValidationSuspenseQueryHookResult = ReturnType<typeof useGetTransactionMappingValidationSuspenseQuery>;
export type GetTransactionMappingValidationQueryResult = Apollo.QueryResult<GraphqlTypes.GetTransactionMappingValidationQuery, GraphqlTypes.GetTransactionMappingValidationQueryVariables>;
export const GetEntitiesSyncStatusDocument = gql`
    query GetEntitiesSyncStatus($arenaId: GlobalID!, $entityIds: [Int!]!) {
  entitiesGLSyncStatus(arenaId: $arenaId, entityIds: $entityIds) {
    entityId
    status
    netIncomeStatus
    capitalCallStatus
    capitalTransactionStatus
    distributionStatus
    capitalCallSyncError {
      label
      modalMessage
      errorMessages
    }
    capitalTransactionSyncError {
      label
      modalMessage
      errorMessages
    }
    distributionSyncError {
      label
      modalMessage
      errorMessages
    }
    netIncomeSyncError {
      label
      modalMessage
      errorMessages
    }
  }
}
    `;

/**
 * __useGetEntitiesSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetEntitiesSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesSyncStatusQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetEntitiesSyncStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables> & ({ variables: GraphqlTypes.GetEntitiesSyncStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>(GetEntitiesSyncStatusDocument, options);
      }
export function useGetEntitiesSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>(GetEntitiesSyncStatusDocument, options);
        }
// @ts-ignore
export function useGetEntitiesSyncStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>;
export function useGetEntitiesSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesSyncStatusQuery | undefined, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>;
export function useGetEntitiesSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>(GetEntitiesSyncStatusDocument, options);
        }
export type GetEntitiesSyncStatusQueryHookResult = ReturnType<typeof useGetEntitiesSyncStatusQuery>;
export type GetEntitiesSyncStatusLazyQueryHookResult = ReturnType<typeof useGetEntitiesSyncStatusLazyQuery>;
export type GetEntitiesSyncStatusSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesSyncStatusSuspenseQuery>;
export type GetEntitiesSyncStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesSyncStatusQuery, GraphqlTypes.GetEntitiesSyncStatusQueryVariables>;
export const GetEntitiesGlBatchSyncStatusDocument = gql`
    query GetEntitiesGlBatchSyncStatus($arenaId: GlobalID!, $entityIds: [Int!]!) {
  entitiesGLBatchSyncStatus(arenaId: $arenaId, entityIds: $entityIds) {
    entityId
    glBatchSyncStatuses {
      glBatchId
      status
      syncError {
        label
        modalMessage
        errorMessages
      }
    }
  }
}
    `;

/**
 * __useGetEntitiesGlBatchSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetEntitiesGlBatchSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesGlBatchSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesGlBatchSyncStatusQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetEntitiesGlBatchSyncStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables> & ({ variables: GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>(GetEntitiesGlBatchSyncStatusDocument, options);
      }
export function useGetEntitiesGlBatchSyncStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>(GetEntitiesGlBatchSyncStatusDocument, options);
        }
// @ts-ignore
export function useGetEntitiesGlBatchSyncStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>;
export function useGetEntitiesGlBatchSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery | undefined, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>;
export function useGetEntitiesGlBatchSyncStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>(GetEntitiesGlBatchSyncStatusDocument, options);
        }
export type GetEntitiesGlBatchSyncStatusQueryHookResult = ReturnType<typeof useGetEntitiesGlBatchSyncStatusQuery>;
export type GetEntitiesGlBatchSyncStatusLazyQueryHookResult = ReturnType<typeof useGetEntitiesGlBatchSyncStatusLazyQuery>;
export type GetEntitiesGlBatchSyncStatusSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesGlBatchSyncStatusSuspenseQuery>;
export type GetEntitiesGlBatchSyncStatusQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesGlBatchSyncStatusQuery, GraphqlTypes.GetEntitiesGlBatchSyncStatusQueryVariables>;
export const GetEntitiesGlSyncDetailsDocument = gql`
    query GetEntitiesGLSyncDetails($arenaId: GlobalID!, $entity_ids: [Int!]!) {
  entitiesGLSyncDetails(arenaId: $arenaId, entityIds: $entity_ids) {
    entityId
    capitalCallDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      lastSyncUserName
      active
    }
    capitalTransactionDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      lastSyncUserName
      active
    }
    distributionDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      lastSyncUserName
      active
    }
    netIncomeDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      batchPeriod
      lastSyncUserName
      active
    }
    transferBatchDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      batchPeriod
      active
      newBatchCount
      revisedBatchCount
      syncedGlBatchCount
      lastSyncUserName
    }
  }
}
    `;

/**
 * __useGetEntitiesGlSyncDetailsQuery__
 *
 * To run a query within a React component, call `useGetEntitiesGlSyncDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesGlSyncDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesGlSyncDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entity_ids: // value for 'entity_ids'
 *   },
 * });
 */
export function useGetEntitiesGlSyncDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables> & ({ variables: GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>(GetEntitiesGlSyncDetailsDocument, options);
      }
export function useGetEntitiesGlSyncDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>(GetEntitiesGlSyncDetailsDocument, options);
        }
// @ts-ignore
export function useGetEntitiesGlSyncDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>;
export function useGetEntitiesGlSyncDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntitiesGlSyncDetailsQuery | undefined, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>;
export function useGetEntitiesGlSyncDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>(GetEntitiesGlSyncDetailsDocument, options);
        }
export type GetEntitiesGlSyncDetailsQueryHookResult = ReturnType<typeof useGetEntitiesGlSyncDetailsQuery>;
export type GetEntitiesGlSyncDetailsLazyQueryHookResult = ReturnType<typeof useGetEntitiesGlSyncDetailsLazyQuery>;
export type GetEntitiesGlSyncDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEntitiesGlSyncDetailsSuspenseQuery>;
export type GetEntitiesGlSyncDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntitiesGlSyncDetailsQuery, GraphqlTypes.GetEntitiesGlSyncDetailsQueryVariables>;
export const GetEntityGlSyncDetailsDocument = gql`
    query GetEntityGlSyncDetails($arenaId: GlobalID!, $entityId: Int!) {
  entityGLSyncDetails(arenaId: $arenaId, entityId: $entityId) {
    entityId
    capitalCallDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      batchPeriod
      newTransactionCount
      revisedTransactionCount
      lastSyncUserName
    }
    capitalTransactionDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      batchPeriod
      newTransactionCount
      revisedTransactionCount
      lastSyncUserName
    }
    distributionDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      batchPeriod
      newTransactionCount
      revisedTransactionCount
      lastSyncUserName
    }
    netIncomeDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      batchPeriod
      newTransactionCount
      revisedTransactionCount
      lastSyncUserName
    }
    transferBatchDetails {
      glStartDate
      glAsOfDate
      lastSyncUserId
      lastSyncAt
      active
      newTransactionCount
      revisedTransactionCount
      newBatchCount
      revisedBatchCount
      lastSyncUserName
    }
  }
}
    `;

/**
 * __useGetEntityGlSyncDetailsQuery__
 *
 * To run a query within a React component, call `useGetEntityGlSyncDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityGlSyncDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityGlSyncDetailsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityGlSyncDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables> & ({ variables: GraphqlTypes.GetEntityGlSyncDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>(GetEntityGlSyncDetailsDocument, options);
      }
export function useGetEntityGlSyncDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>(GetEntityGlSyncDetailsDocument, options);
        }
// @ts-ignore
export function useGetEntityGlSyncDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>;
export function useGetEntityGlSyncDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityGlSyncDetailsQuery | undefined, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>;
export function useGetEntityGlSyncDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>(GetEntityGlSyncDetailsDocument, options);
        }
export type GetEntityGlSyncDetailsQueryHookResult = ReturnType<typeof useGetEntityGlSyncDetailsQuery>;
export type GetEntityGlSyncDetailsLazyQueryHookResult = ReturnType<typeof useGetEntityGlSyncDetailsLazyQuery>;
export type GetEntityGlSyncDetailsSuspenseQueryHookResult = ReturnType<typeof useGetEntityGlSyncDetailsSuspenseQuery>;
export type GetEntityGlSyncDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityGlSyncDetailsQuery, GraphqlTypes.GetEntityGlSyncDetailsQueryVariables>;
export const GetEntityPreviewGlSyncDocument = gql`
    query GetEntityPreviewGLSync($input: PreviewEntityGLSyncNewInput!, $withCapitalCall: Boolean!, $withCapitalTransaction: Boolean!, $withDistribution: Boolean!, $withNetIncome: Boolean!) {
  entityPreviewGLSyncNew(syncInput: $input) {
    mappingName
    capitalCall @include(if: $withCapitalCall) {
      ...TransactionCategoryPreview
    }
    capitalTransaction @include(if: $withCapitalTransaction) {
      ...TransactionCategoryPreview
    }
    distribution @include(if: $withDistribution) {
      ...TransactionCategoryPreview
    }
    netIncome @include(if: $withNetIncome) {
      ...TransactionCategoryPreview
    }
  }
}
    ${TransactionCategoryPreviewFragmentDoc}`;

/**
 * __useGetEntityPreviewGlSyncQuery__
 *
 * To run a query within a React component, call `useGetEntityPreviewGlSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityPreviewGlSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityPreviewGlSyncQuery({
 *   variables: {
 *      input: // value for 'input'
 *      withCapitalCall: // value for 'withCapitalCall'
 *      withCapitalTransaction: // value for 'withCapitalTransaction'
 *      withDistribution: // value for 'withDistribution'
 *      withNetIncome: // value for 'withNetIncome'
 *   },
 * });
 */
export function useGetEntityPreviewGlSyncQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables> & ({ variables: GraphqlTypes.GetEntityPreviewGlSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>(GetEntityPreviewGlSyncDocument, options);
      }
export function useGetEntityPreviewGlSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>(GetEntityPreviewGlSyncDocument, options);
        }
// @ts-ignore
export function useGetEntityPreviewGlSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>;
export function useGetEntityPreviewGlSyncSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPreviewGlSyncQuery | undefined, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>;
export function useGetEntityPreviewGlSyncSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>(GetEntityPreviewGlSyncDocument, options);
        }
export type GetEntityPreviewGlSyncQueryHookResult = ReturnType<typeof useGetEntityPreviewGlSyncQuery>;
export type GetEntityPreviewGlSyncLazyQueryHookResult = ReturnType<typeof useGetEntityPreviewGlSyncLazyQuery>;
export type GetEntityPreviewGlSyncSuspenseQueryHookResult = ReturnType<typeof useGetEntityPreviewGlSyncSuspenseQuery>;
export type GetEntityPreviewGlSyncQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityPreviewGlSyncQuery, GraphqlTypes.GetEntityPreviewGlSyncQueryVariables>;
export const StartEntityGlSyncDocument = gql`
    mutation StartEntityGLSync($input: StartEntityGLSyncInput!) {
  startEntityGLSync(input: $input) {
    success
  }
}
    `;
export type StartEntityGlSyncMutationFn = Apollo.MutationFunction<GraphqlTypes.StartEntityGlSyncMutation, GraphqlTypes.StartEntityGlSyncMutationVariables>;

/**
 * __useStartEntityGlSyncMutation__
 *
 * To run a mutation, you first call `useStartEntityGlSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEntityGlSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEntityGlSyncMutation, { data, loading, error }] = useStartEntityGlSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartEntityGlSyncMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartEntityGlSyncMutation, GraphqlTypes.StartEntityGlSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartEntityGlSyncMutation, GraphqlTypes.StartEntityGlSyncMutationVariables>(StartEntityGlSyncDocument, options);
      }
export type StartEntityGlSyncMutationHookResult = ReturnType<typeof useStartEntityGlSyncMutation>;
export type StartEntityGlSyncMutationResult = Apollo.MutationResult<GraphqlTypes.StartEntityGlSyncMutation>;
export type StartEntityGlSyncMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartEntityGlSyncMutation, GraphqlTypes.StartEntityGlSyncMutationVariables>;
export const UpdateEntityGlSyncSettingsDocument = gql`
    mutation UpdateEntityGLSyncSettings($input: EntityGLSyncSettingsInput!) {
  updateEntityGLSyncSettings(input: $input) {
    success
  }
}
    `;
export type UpdateEntityGlSyncSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEntityGlSyncSettingsMutation, GraphqlTypes.UpdateEntityGlSyncSettingsMutationVariables>;

/**
 * __useUpdateEntityGlSyncSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEntityGlSyncSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityGlSyncSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityGlSyncSettingsMutation, { data, loading, error }] = useUpdateEntityGlSyncSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityGlSyncSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEntityGlSyncSettingsMutation, GraphqlTypes.UpdateEntityGlSyncSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEntityGlSyncSettingsMutation, GraphqlTypes.UpdateEntityGlSyncSettingsMutationVariables>(UpdateEntityGlSyncSettingsDocument, options);
      }
export type UpdateEntityGlSyncSettingsMutationHookResult = ReturnType<typeof useUpdateEntityGlSyncSettingsMutation>;
export type UpdateEntityGlSyncSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEntityGlSyncSettingsMutation>;
export type UpdateEntityGlSyncSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEntityGlSyncSettingsMutation, GraphqlTypes.UpdateEntityGlSyncSettingsMutationVariables>;
export const TransactionLookupDocument = gql`
    query TransactionLookup($arenaId: GlobalID!, $entityId: Int = null, $includeDeleted: Boolean! = false, $offset: Int! = 0, $limit: Int! = 50, $glDateFrom: Date = null, $glDateTo: Date = null, $effectiveDateFrom: Date = null, $effectiveDateTo: Date = null, $status: String = null, $batchSourceObjectId: String = null, $glTransactionType: String = null, $hasMapping: Boolean = null, $quickSearch: String = null, $sortBy: String = null, $sortDirection: String! = "desc") {
  transactionLookup(
    arenaId: $arenaId
    entityId: $entityId
    includeDeleted: $includeDeleted
    offset: $offset
    limit: $limit
    glDateFrom: $glDateFrom
    glDateTo: $glDateTo
    effectiveDateFrom: $effectiveDateFrom
    effectiveDateTo: $effectiveDateTo
    status: $status
    batchSourceObjectId: $batchSourceObjectId
    glTransactionType: $glTransactionType
    hasMapping: $hasMapping
    quickSearch: $quickSearch
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    transactions {
      glTransactionId
      arenaId
      entityId
      positionId
      effectiveDate
      glDate
      totalAmount
      totalConvertedCreditAmount
      transactionCount
      totalShares
      totalQuantity
      avgCostPerShare
      jsqPositionIds
      transactionCurrency
      debitOrCredit
      transactionStatus
      transactionType
      transactionDescription
      bankAccount
      vendor
      invoiceNumber
      invoiceDueDate
      relatedParty
      capitalEventReference
      sourcesUses
      glAccountNumber
      glAccountType
      dealName
      batchType
      batchCategory
      batchComments
      batchReference
      batchSourceObjectId
      batchCreatedAt
      createdAt
      modifiedAt
      deletedAt
    }
    totalCount
    offset
    limit
  }
}
    `;

/**
 * __useTransactionLookupQuery__
 *
 * To run a query within a React component, call `useTransactionLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionLookupQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      entityId: // value for 'entityId'
 *      includeDeleted: // value for 'includeDeleted'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      glDateFrom: // value for 'glDateFrom'
 *      glDateTo: // value for 'glDateTo'
 *      effectiveDateFrom: // value for 'effectiveDateFrom'
 *      effectiveDateTo: // value for 'effectiveDateTo'
 *      status: // value for 'status'
 *      batchSourceObjectId: // value for 'batchSourceObjectId'
 *      glTransactionType: // value for 'glTransactionType'
 *      hasMapping: // value for 'hasMapping'
 *      quickSearch: // value for 'quickSearch'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useTransactionLookupQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables> & ({ variables: GraphqlTypes.TransactionLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>(TransactionLookupDocument, options);
      }
export function useTransactionLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>(TransactionLookupDocument, options);
        }
// @ts-ignore
export function useTransactionLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>;
export function useTransactionLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.TransactionLookupQuery | undefined, GraphqlTypes.TransactionLookupQueryVariables>;
export function useTransactionLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>(TransactionLookupDocument, options);
        }
export type TransactionLookupQueryHookResult = ReturnType<typeof useTransactionLookupQuery>;
export type TransactionLookupLazyQueryHookResult = ReturnType<typeof useTransactionLookupLazyQuery>;
export type TransactionLookupSuspenseQueryHookResult = ReturnType<typeof useTransactionLookupSuspenseQuery>;
export type TransactionLookupQueryResult = Apollo.QueryResult<GraphqlTypes.TransactionLookupQuery, GraphqlTypes.TransactionLookupQueryVariables>;
export const TransactionDetailViewerDocument = gql`
    query TransactionDetailViewer($arenaId: GlobalID!, $effectiveDate: Date = null, $targetPattern: String = null, $jsqPositionIds: [Int!] = null, $includeDeleted: Boolean! = false, $offset: Int! = 0, $limit: Int! = 50) {
  transactionDetailViewer(
    arenaId: $arenaId
    effectiveDate: $effectiveDate
    targetPattern: $targetPattern
    jsqPositionIds: $jsqPositionIds
    includeDeleted: $includeDeleted
    offset: $offset
    limit: $limit
  ) {
    transactions {
      glBatchSourceObjectId
      glBatchDate
      glBatchCategory
      transactionId
      jsqPositionId
      effectiveDate
      transactionAmount
      transactionSourceObjectId
      transactionStatus
      transactionIsProcessed
      historyEffectiveDate
      historyAmount
      memo
      target
      historyBatchCategory
      batchCreatedAt
      batchModifiedAt
      batchDeletedAt
      transactionCreatedAt
      transactionModifiedAt
      transactionDeletedAt
      journalEntryCreatedAt
      journalEntryModifiedAt
      journalEntryDeletedAt
      historyCreatedAt
      historyModifiedAt
      historyDeletedAt
    }
    count
    totalCount
    offset
    limit
  }
}
    `;

/**
 * __useTransactionDetailViewerQuery__
 *
 * To run a query within a React component, call `useTransactionDetailViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionDetailViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionDetailViewerQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      effectiveDate: // value for 'effectiveDate'
 *      targetPattern: // value for 'targetPattern'
 *      jsqPositionIds: // value for 'jsqPositionIds'
 *      includeDeleted: // value for 'includeDeleted'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTransactionDetailViewerQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables> & ({ variables: GraphqlTypes.TransactionDetailViewerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>(TransactionDetailViewerDocument, options);
      }
export function useTransactionDetailViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>(TransactionDetailViewerDocument, options);
        }
// @ts-ignore
export function useTransactionDetailViewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>;
export function useTransactionDetailViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.TransactionDetailViewerQuery | undefined, GraphqlTypes.TransactionDetailViewerQueryVariables>;
export function useTransactionDetailViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>(TransactionDetailViewerDocument, options);
        }
export type TransactionDetailViewerQueryHookResult = ReturnType<typeof useTransactionDetailViewerQuery>;
export type TransactionDetailViewerLazyQueryHookResult = ReturnType<typeof useTransactionDetailViewerLazyQuery>;
export type TransactionDetailViewerSuspenseQueryHookResult = ReturnType<typeof useTransactionDetailViewerSuspenseQuery>;
export type TransactionDetailViewerQueryResult = Apollo.QueryResult<GraphqlTypes.TransactionDetailViewerQuery, GraphqlTypes.TransactionDetailViewerQueryVariables>;
export const GetReportTemplatesByArenaDocument = gql`
    query GetReportTemplatesByArena($arenaId: Int) {
  reportTemplatesByArena(arenaId: $arenaId) {
    id
    name
    reportType
    description
    arenaId
    isActive
    dataPackage {
      id
      name
    }
    createdAt
    updatedAt
    createdBy
    createdByUser {
      id
      firstName
      lastName
    }
    updatedBy
    updatedByUser {
      id
      firstName
      lastName
    }
    archivedAt
    archivedByUser {
      id
      firstName
      lastName
    }
    currentVersion {
      id
      version
      fileName
      fileSize
      contentType
      isUploadComplete
      createdAt
      downloadUrl
      status
      review {
        deniedReason
        reviewedAt
        reviewedByUser {
          id
          firstName
          lastName
        }
      }
    }
    versions {
      id
      version
      fileName
      fileSize
      contentType
      isUploadComplete
      createdAt
      downloadUrl
      status
      review {
        deniedReason
        reviewedAt
        reviewedByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportTemplatesByArenaQuery__
 *
 * To run a query within a React component, call `useGetReportTemplatesByArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplatesByArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplatesByArenaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetReportTemplatesByArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>(GetReportTemplatesByArenaDocument, options);
      }
export function useGetReportTemplatesByArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>(GetReportTemplatesByArenaDocument, options);
        }
// @ts-ignore
export function useGetReportTemplatesByArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>;
export function useGetReportTemplatesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplatesByArenaQuery | undefined, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>;
export function useGetReportTemplatesByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>(GetReportTemplatesByArenaDocument, options);
        }
export type GetReportTemplatesByArenaQueryHookResult = ReturnType<typeof useGetReportTemplatesByArenaQuery>;
export type GetReportTemplatesByArenaLazyQueryHookResult = ReturnType<typeof useGetReportTemplatesByArenaLazyQuery>;
export type GetReportTemplatesByArenaSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplatesByArenaSuspenseQuery>;
export type GetReportTemplatesByArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplatesByArenaQuery, GraphqlTypes.GetReportTemplatesByArenaQueryVariables>;
export const GetArenaReportTemplateSummariesDocument = gql`
    query GetArenaReportTemplateSummaries($first: Int, $after: String, $sortBy: ArenaReportTemplateSummarySortField, $sortDirection: SortDirection, $activeOnly: Boolean, $search: String) {
  arenaReportTemplateSummaries(
    first: $first
    after: $after
    sortBy: $sortBy
    sortDirection: $sortDirection
    activeOnly: $activeOnly
    search: $search
  ) {
    edges {
      node {
        arenaId
        arenaName
        templateCount
        lastUpdatedAt
        lastUpdatedByUser {
          id
          firstName
          middleName
          lastName
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetArenaReportTemplateSummariesQuery__
 *
 * To run a query within a React component, call `useGetArenaReportTemplateSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaReportTemplateSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaReportTemplateSummariesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      activeOnly: // value for 'activeOnly'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetArenaReportTemplateSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>(GetArenaReportTemplateSummariesDocument, options);
      }
export function useGetArenaReportTemplateSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>(GetArenaReportTemplateSummariesDocument, options);
        }
// @ts-ignore
export function useGetArenaReportTemplateSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>;
export function useGetArenaReportTemplateSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaReportTemplateSummariesQuery | undefined, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>;
export function useGetArenaReportTemplateSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>(GetArenaReportTemplateSummariesDocument, options);
        }
export type GetArenaReportTemplateSummariesQueryHookResult = ReturnType<typeof useGetArenaReportTemplateSummariesQuery>;
export type GetArenaReportTemplateSummariesLazyQueryHookResult = ReturnType<typeof useGetArenaReportTemplateSummariesLazyQuery>;
export type GetArenaReportTemplateSummariesSuspenseQueryHookResult = ReturnType<typeof useGetArenaReportTemplateSummariesSuspenseQuery>;
export type GetArenaReportTemplateSummariesQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaReportTemplateSummariesQuery, GraphqlTypes.GetArenaReportTemplateSummariesQueryVariables>;
export const GenerateCustomReportTemplatePreviewPdfDocument = gql`
    mutation GenerateCustomReportTemplatePreviewPdf($reportTemplateId: Int, $templateS3Key: String, $queryId: Int, $recipientObjectType: CustomReportRecipientObjectType!, $recipientObjectId: Int!, $arenaId: ID, $parameters: JSONString, $reportTemplateVersionId: Int) {
  generateCustomReportTemplatePreviewPdf(
    reportTemplateId: $reportTemplateId
    templateS3Key: $templateS3Key
    queryId: $queryId
    recipientObjectType: $recipientObjectType
    recipientObjectId: $recipientObjectId
    arenaId: $arenaId
    parameters: $parameters
    reportTemplateVersionId: $reportTemplateVersionId
  ) {
    job {
      id
      status
    }
  }
}
    `;
export type GenerateCustomReportTemplatePreviewPdfMutationFn = Apollo.MutationFunction<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>;

/**
 * __useGenerateCustomReportTemplatePreviewPdfMutation__
 *
 * To run a mutation, you first call `useGenerateCustomReportTemplatePreviewPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCustomReportTemplatePreviewPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCustomReportTemplatePreviewPdfMutation, { data, loading, error }] = useGenerateCustomReportTemplatePreviewPdfMutation({
 *   variables: {
 *      reportTemplateId: // value for 'reportTemplateId'
 *      templateS3Key: // value for 'templateS3Key'
 *      queryId: // value for 'queryId'
 *      recipientObjectType: // value for 'recipientObjectType'
 *      recipientObjectId: // value for 'recipientObjectId'
 *      arenaId: // value for 'arenaId'
 *      parameters: // value for 'parameters'
 *      reportTemplateVersionId: // value for 'reportTemplateVersionId'
 *   },
 * });
 */
export function useGenerateCustomReportTemplatePreviewPdfMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>(GenerateCustomReportTemplatePreviewPdfDocument, options);
      }
export type GenerateCustomReportTemplatePreviewPdfMutationHookResult = ReturnType<typeof useGenerateCustomReportTemplatePreviewPdfMutation>;
export type GenerateCustomReportTemplatePreviewPdfMutationResult = Apollo.MutationResult<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation>;
export type GenerateCustomReportTemplatePreviewPdfMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutation, GraphqlTypes.GenerateCustomReportTemplatePreviewPdfMutationVariables>;
export const CreateReportTemplatePreviewUploadDocument = gql`
    mutation CreateReportTemplatePreviewUpload($input: CreateReportTemplatePreviewUploadInput!) {
  createReportTemplatePreviewUpload(input: $input) {
    uploadUrl
    s3Key
  }
}
    `;
export type CreateReportTemplatePreviewUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateReportTemplatePreviewUploadMutation, GraphqlTypes.CreateReportTemplatePreviewUploadMutationVariables>;

/**
 * __useCreateReportTemplatePreviewUploadMutation__
 *
 * To run a mutation, you first call `useCreateReportTemplatePreviewUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportTemplatePreviewUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportTemplatePreviewUploadMutation, { data, loading, error }] = useCreateReportTemplatePreviewUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportTemplatePreviewUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateReportTemplatePreviewUploadMutation, GraphqlTypes.CreateReportTemplatePreviewUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateReportTemplatePreviewUploadMutation, GraphqlTypes.CreateReportTemplatePreviewUploadMutationVariables>(CreateReportTemplatePreviewUploadDocument, options);
      }
export type CreateReportTemplatePreviewUploadMutationHookResult = ReturnType<typeof useCreateReportTemplatePreviewUploadMutation>;
export type CreateReportTemplatePreviewUploadMutationResult = Apollo.MutationResult<GraphqlTypes.CreateReportTemplatePreviewUploadMutation>;
export type CreateReportTemplatePreviewUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateReportTemplatePreviewUploadMutation, GraphqlTypes.CreateReportTemplatePreviewUploadMutationVariables>;
export const UpdateReportTemplateDocument = gql`
    mutation UpdateReportTemplate($id: Int!, $input: UpdateReportTemplateInput!) {
  updateReportTemplate(id: $id, input: $input) {
    id
    name
    reportType
    description
    arenaId
    dataPackage {
      id
      name
    }
    updatedAt
    updatedBy
  }
}
    `;
export type UpdateReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateReportTemplateMutation, GraphqlTypes.UpdateReportTemplateMutationVariables>;

/**
 * __useUpdateReportTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportTemplateMutation, { data, loading, error }] = useUpdateReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateReportTemplateMutation, GraphqlTypes.UpdateReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateReportTemplateMutation, GraphqlTypes.UpdateReportTemplateMutationVariables>(UpdateReportTemplateDocument, options);
      }
export type UpdateReportTemplateMutationHookResult = ReturnType<typeof useUpdateReportTemplateMutation>;
export type UpdateReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateReportTemplateMutation>;
export type UpdateReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateReportTemplateMutation, GraphqlTypes.UpdateReportTemplateMutationVariables>;
export const CreateReportTemplateWithUploadDocument = gql`
    mutation CreateReportTemplateWithUpload($input: CreateReportTemplateWithUploadInput!) {
  createReportTemplateWithUpload(input: $input) {
    template {
      id
      name
      reportType
      arenaId
    }
    uploadUrl
    versionId
    versionLabel
    s3Key
  }
}
    `;
export type CreateReportTemplateWithUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateReportTemplateWithUploadMutation, GraphqlTypes.CreateReportTemplateWithUploadMutationVariables>;

/**
 * __useCreateReportTemplateWithUploadMutation__
 *
 * To run a mutation, you first call `useCreateReportTemplateWithUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportTemplateWithUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportTemplateWithUploadMutation, { data, loading, error }] = useCreateReportTemplateWithUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportTemplateWithUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateReportTemplateWithUploadMutation, GraphqlTypes.CreateReportTemplateWithUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateReportTemplateWithUploadMutation, GraphqlTypes.CreateReportTemplateWithUploadMutationVariables>(CreateReportTemplateWithUploadDocument, options);
      }
export type CreateReportTemplateWithUploadMutationHookResult = ReturnType<typeof useCreateReportTemplateWithUploadMutation>;
export type CreateReportTemplateWithUploadMutationResult = Apollo.MutationResult<GraphqlTypes.CreateReportTemplateWithUploadMutation>;
export type CreateReportTemplateWithUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateReportTemplateWithUploadMutation, GraphqlTypes.CreateReportTemplateWithUploadMutationVariables>;
export const CompleteReportTemplateUploadDocument = gql`
    mutation CompleteReportTemplateUpload($versionId: Int!, $checksum: String!, $requestApproval: Boolean = false) {
  completeReportTemplateUpload(
    versionId: $versionId
    checksum: $checksum
    requestApproval: $requestApproval
  ) {
    success
    template {
      id
      reportType
    }
    version {
      id
      version
    }
  }
}
    `;
export type CompleteReportTemplateUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.CompleteReportTemplateUploadMutation, GraphqlTypes.CompleteReportTemplateUploadMutationVariables>;

/**
 * __useCompleteReportTemplateUploadMutation__
 *
 * To run a mutation, you first call `useCompleteReportTemplateUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteReportTemplateUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeReportTemplateUploadMutation, { data, loading, error }] = useCompleteReportTemplateUploadMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      checksum: // value for 'checksum'
 *      requestApproval: // value for 'requestApproval'
 *   },
 * });
 */
export function useCompleteReportTemplateUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CompleteReportTemplateUploadMutation, GraphqlTypes.CompleteReportTemplateUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CompleteReportTemplateUploadMutation, GraphqlTypes.CompleteReportTemplateUploadMutationVariables>(CompleteReportTemplateUploadDocument, options);
      }
export type CompleteReportTemplateUploadMutationHookResult = ReturnType<typeof useCompleteReportTemplateUploadMutation>;
export type CompleteReportTemplateUploadMutationResult = Apollo.MutationResult<GraphqlTypes.CompleteReportTemplateUploadMutation>;
export type CompleteReportTemplateUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CompleteReportTemplateUploadMutation, GraphqlTypes.CompleteReportTemplateUploadMutationVariables>;
export const ApproveReportTemplateVersionDocument = gql`
    mutation ApproveReportTemplateVersion($templateId: Int!, $versionId: Int!) {
  approveReportTemplateVersion(templateId: $templateId, versionId: $versionId) {
    id
    version
    status
  }
}
    `;
export type ApproveReportTemplateVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>;

/**
 * __useApproveReportTemplateVersionMutation__
 *
 * To run a mutation, you first call `useApproveReportTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveReportTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveReportTemplateVersionMutation, { data, loading, error }] = useApproveReportTemplateVersionMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useApproveReportTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>(ApproveReportTemplateVersionDocument, options);
      }
export type ApproveReportTemplateVersionMutationHookResult = ReturnType<typeof useApproveReportTemplateVersionMutation>;
export type ApproveReportTemplateVersionMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveReportTemplateVersionMutation>;
export type ApproveReportTemplateVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveReportTemplateVersionMutation, GraphqlTypes.ApproveReportTemplateVersionMutationVariables>;
export const ArchiveReportTemplateDocument = gql`
    mutation ArchiveReportTemplate($id: Int!) {
  archiveReportTemplate(id: $id) {
    id
    reportType
    isActive
    archivedAt
  }
}
    `;
export type ArchiveReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>;

/**
 * __useArchiveReportTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveReportTemplateMutation, { data, loading, error }] = useArchiveReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>(ArchiveReportTemplateDocument, options);
      }
export type ArchiveReportTemplateMutationHookResult = ReturnType<typeof useArchiveReportTemplateMutation>;
export type ArchiveReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.ArchiveReportTemplateMutation>;
export type ArchiveReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ArchiveReportTemplateMutation, GraphqlTypes.ArchiveReportTemplateMutationVariables>;
export const RestoreReportTemplateDocument = gql`
    mutation RestoreReportTemplate($id: Int!) {
  restoreReportTemplate(id: $id) {
    id
    reportType
    isActive
    archivedAt
  }
}
    `;
export type RestoreReportTemplateMutationFn = Apollo.MutationFunction<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>;

/**
 * __useRestoreReportTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreReportTemplateMutation, { data, loading, error }] = useRestoreReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>(RestoreReportTemplateDocument, options);
      }
export type RestoreReportTemplateMutationHookResult = ReturnType<typeof useRestoreReportTemplateMutation>;
export type RestoreReportTemplateMutationResult = Apollo.MutationResult<GraphqlTypes.RestoreReportTemplateMutation>;
export type RestoreReportTemplateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestoreReportTemplateMutation, GraphqlTypes.RestoreReportTemplateMutationVariables>;
export const UploadReportTemplateVersionDocument = gql`
    mutation UploadReportTemplateVersion($input: UploadReportTemplateVersionInput!) {
  uploadReportTemplateVersion(input: $input) {
    uploadUrl
    versionId
    majorVersion
    minorVersion
    versionLabel
    s3Key
  }
}
    `;
export type UploadReportTemplateVersionMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadReportTemplateVersionMutation, GraphqlTypes.UploadReportTemplateVersionMutationVariables>;

/**
 * __useUploadReportTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUploadReportTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadReportTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadReportTemplateVersionMutation, { data, loading, error }] = useUploadReportTemplateVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadReportTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadReportTemplateVersionMutation, GraphqlTypes.UploadReportTemplateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadReportTemplateVersionMutation, GraphqlTypes.UploadReportTemplateVersionMutationVariables>(UploadReportTemplateVersionDocument, options);
      }
export type UploadReportTemplateVersionMutationHookResult = ReturnType<typeof useUploadReportTemplateVersionMutation>;
export type UploadReportTemplateVersionMutationResult = Apollo.MutationResult<GraphqlTypes.UploadReportTemplateVersionMutation>;
export type UploadReportTemplateVersionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadReportTemplateVersionMutation, GraphqlTypes.UploadReportTemplateVersionMutationVariables>;
export const GetReportTemplateDocument = gql`
    query GetReportTemplate($id: Int!) {
  reportTemplate(id: $id) {
    id
    name
    reportType
    description
    arenaId
    isActive
    dataPackage {
      id
      name
      arenaId
    }
    createdAt
    updatedAt
    createdBy
    updatedBy
    updatedByUser {
      id
      firstName
      lastName
    }
    archivedAt
    archivedByUser {
      id
      firstName
      lastName
    }
    currentVersion {
      id
      version
      fileName
      fileSize
      contentType
      isUploadComplete
      status
      queryId
      createdAt
      downloadUrl
      review {
        deniedReason
        reviewedAt
        reviewedByUser {
          id
          firstName
          lastName
        }
      }
    }
    versions {
      id
      version
      fileName
      fileSize
      contentType
      isUploadComplete
      status
      queryId
      createdAt
      downloadUrl
      review {
        deniedReason
        reviewedAt
        reviewedByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportTemplateQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportTemplateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables> & ({ variables: GraphqlTypes.GetReportTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
      }
export function useGetReportTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
        }
// @ts-ignore
export function useGetReportTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>;
export function useGetReportTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetReportTemplateQuery | undefined, GraphqlTypes.GetReportTemplateQueryVariables>;
export function useGetReportTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
        }
export type GetReportTemplateQueryHookResult = ReturnType<typeof useGetReportTemplateQuery>;
export type GetReportTemplateLazyQueryHookResult = ReturnType<typeof useGetReportTemplateLazyQuery>;
export type GetReportTemplateSuspenseQueryHookResult = ReturnType<typeof useGetReportTemplateSuspenseQuery>;
export type GetReportTemplateQueryResult = Apollo.QueryResult<GraphqlTypes.GetReportTemplateQuery, GraphqlTypes.GetReportTemplateQueryVariables>;
export const GetPreviewEntitiesDocument = gql`
    query GetPreviewEntities($arenaId: ID!, $first: Int = 100, $after: String) {
  investmentEntitiesByArena(
    arenaId: $arenaId
    first: $first
    after: $after
    sort: [NAME_ASC]
    filterEntitiesWithTransactions: false
    skipFundAdminProductLineFilter: true
  ) {
    edges {
      node {
        id
        name
        status
        type {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetPreviewEntitiesQuery__
 *
 * To run a query within a React component, call `useGetPreviewEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewEntitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPreviewEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetPreviewEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>(GetPreviewEntitiesDocument, options);
      }
export function useGetPreviewEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>(GetPreviewEntitiesDocument, options);
        }
// @ts-ignore
export function useGetPreviewEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>;
export function useGetPreviewEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewEntitiesQuery | undefined, GraphqlTypes.GetPreviewEntitiesQueryVariables>;
export function useGetPreviewEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>(GetPreviewEntitiesDocument, options);
        }
export type GetPreviewEntitiesQueryHookResult = ReturnType<typeof useGetPreviewEntitiesQuery>;
export type GetPreviewEntitiesLazyQueryHookResult = ReturnType<typeof useGetPreviewEntitiesLazyQuery>;
export type GetPreviewEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetPreviewEntitiesSuspenseQuery>;
export type GetPreviewEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreviewEntitiesQuery, GraphqlTypes.GetPreviewEntitiesQueryVariables>;
export const GetPreviewAccountsByEntityDocument = gql`
    query GetPreviewAccountsByEntity($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    activeAccounts(sort: NAME_ASC) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPreviewAccountsByEntityQuery__
 *
 * To run a query within a React component, call `useGetPreviewAccountsByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewAccountsByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewAccountsByEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetPreviewAccountsByEntityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables> & ({ variables: GraphqlTypes.GetPreviewAccountsByEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>(GetPreviewAccountsByEntityDocument, options);
      }
export function useGetPreviewAccountsByEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>(GetPreviewAccountsByEntityDocument, options);
        }
// @ts-ignore
export function useGetPreviewAccountsByEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>;
export function useGetPreviewAccountsByEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPreviewAccountsByEntityQuery | undefined, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>;
export function useGetPreviewAccountsByEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>(GetPreviewAccountsByEntityDocument, options);
        }
export type GetPreviewAccountsByEntityQueryHookResult = ReturnType<typeof useGetPreviewAccountsByEntityQuery>;
export type GetPreviewAccountsByEntityLazyQueryHookResult = ReturnType<typeof useGetPreviewAccountsByEntityLazyQuery>;
export type GetPreviewAccountsByEntitySuspenseQueryHookResult = ReturnType<typeof useGetPreviewAccountsByEntitySuspenseQuery>;
export type GetPreviewAccountsByEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetPreviewAccountsByEntityQuery, GraphqlTypes.GetPreviewAccountsByEntityQueryVariables>;
export const GetDataPackageForTemplateEditorDocument = gql`
    query GetDataPackageForTemplateEditor($arenaId: Int, $dataPackageId: Int!) {
  finpubDataPackage(arenaId: $arenaId, dataPackageId: $dataPackageId) {
    id
    arenaId
    currentVersion {
      id
    }
  }
}
    `;

/**
 * __useGetDataPackageForTemplateEditorQuery__
 *
 * To run a query within a React component, call `useGetDataPackageForTemplateEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPackageForTemplateEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPackageForTemplateEditorQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *   },
 * });
 */
export function useGetDataPackageForTemplateEditorQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables> & ({ variables: GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>(GetDataPackageForTemplateEditorDocument, options);
      }
export function useGetDataPackageForTemplateEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>(GetDataPackageForTemplateEditorDocument, options);
        }
// @ts-ignore
export function useGetDataPackageForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>;
export function useGetDataPackageForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackageForTemplateEditorQuery | undefined, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>;
export function useGetDataPackageForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>(GetDataPackageForTemplateEditorDocument, options);
        }
export type GetDataPackageForTemplateEditorQueryHookResult = ReturnType<typeof useGetDataPackageForTemplateEditorQuery>;
export type GetDataPackageForTemplateEditorLazyQueryHookResult = ReturnType<typeof useGetDataPackageForTemplateEditorLazyQuery>;
export type GetDataPackageForTemplateEditorSuspenseQueryHookResult = ReturnType<typeof useGetDataPackageForTemplateEditorSuspenseQuery>;
export type GetDataPackageForTemplateEditorQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataPackageForTemplateEditorQuery, GraphqlTypes.GetDataPackageForTemplateEditorQueryVariables>;
export const GetQueriesForTemplateEditorDocument = gql`
    query GetQueriesForTemplateEditor($arenaId: Int, $dataPackageVersionId: Int!, $includeInactive: Boolean! = false) {
  finpubQueries(
    arenaId: $arenaId
    dataPackageVersionId: $dataPackageVersionId
    includeInactive: $includeInactive
  ) {
    id
    name
    isActive
    supportedTemplateType
  }
}
    `;

/**
 * __useGetQueriesForTemplateEditorQuery__
 *
 * To run a query within a React component, call `useGetQueriesForTemplateEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueriesForTemplateEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueriesForTemplateEditorQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetQueriesForTemplateEditorQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables> & ({ variables: GraphqlTypes.GetQueriesForTemplateEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>(GetQueriesForTemplateEditorDocument, options);
      }
export function useGetQueriesForTemplateEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>(GetQueriesForTemplateEditorDocument, options);
        }
// @ts-ignore
export function useGetQueriesForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>;
export function useGetQueriesForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueriesForTemplateEditorQuery | undefined, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>;
export function useGetQueriesForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>(GetQueriesForTemplateEditorDocument, options);
        }
export type GetQueriesForTemplateEditorQueryHookResult = ReturnType<typeof useGetQueriesForTemplateEditorQuery>;
export type GetQueriesForTemplateEditorLazyQueryHookResult = ReturnType<typeof useGetQueriesForTemplateEditorLazyQuery>;
export type GetQueriesForTemplateEditorSuspenseQueryHookResult = ReturnType<typeof useGetQueriesForTemplateEditorSuspenseQuery>;
export type GetQueriesForTemplateEditorQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueriesForTemplateEditorQuery, GraphqlTypes.GetQueriesForTemplateEditorQueryVariables>;
export const GetQueryFieldsForTemplateEditorDocument = gql`
    query GetQueryFieldsForTemplateEditor($queryId: Int!, $arenaId: Int) {
  finpubQuery(queryId: $queryId, arenaId: $arenaId) {
    ...QueryDetailFields
  }
}
    ${QueryDetailFieldsFragmentDoc}`;

/**
 * __useGetQueryFieldsForTemplateEditorQuery__
 *
 * To run a query within a React component, call `useGetQueryFieldsForTemplateEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryFieldsForTemplateEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryFieldsForTemplateEditorQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetQueryFieldsForTemplateEditorQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables> & ({ variables: GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>(GetQueryFieldsForTemplateEditorDocument, options);
      }
export function useGetQueryFieldsForTemplateEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>(GetQueryFieldsForTemplateEditorDocument, options);
        }
// @ts-ignore
export function useGetQueryFieldsForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>;
export function useGetQueryFieldsForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery | undefined, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>;
export function useGetQueryFieldsForTemplateEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>(GetQueryFieldsForTemplateEditorDocument, options);
        }
export type GetQueryFieldsForTemplateEditorQueryHookResult = ReturnType<typeof useGetQueryFieldsForTemplateEditorQuery>;
export type GetQueryFieldsForTemplateEditorLazyQueryHookResult = ReturnType<typeof useGetQueryFieldsForTemplateEditorLazyQuery>;
export type GetQueryFieldsForTemplateEditorSuspenseQueryHookResult = ReturnType<typeof useGetQueryFieldsForTemplateEditorSuspenseQuery>;
export type GetQueryFieldsForTemplateEditorQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueryFieldsForTemplateEditorQuery, GraphqlTypes.GetQueryFieldsForTemplateEditorQueryVariables>;
export const DuplicateDataPackageDocument = gql`
    mutation DuplicateDataPackage($arenaId: Int, $dataPackageId: Int!, $name: String, $description: String) {
  finpubDataPackageDuplicate(
    arenaId: $arenaId
    dataPackageId: $dataPackageId
    name: $name
    description: $description
  ) {
    id
    message
    success
  }
}
    `;
export type DuplicateDataPackageMutationFn = Apollo.MutationFunction<GraphqlTypes.DuplicateDataPackageMutation, GraphqlTypes.DuplicateDataPackageMutationVariables>;

/**
 * __useDuplicateDataPackageMutation__
 *
 * To run a mutation, you first call `useDuplicateDataPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateDataPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateDataPackageMutation, { data, loading, error }] = useDuplicateDataPackageMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useDuplicateDataPackageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DuplicateDataPackageMutation, GraphqlTypes.DuplicateDataPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DuplicateDataPackageMutation, GraphqlTypes.DuplicateDataPackageMutationVariables>(DuplicateDataPackageDocument, options);
      }
export type DuplicateDataPackageMutationHookResult = ReturnType<typeof useDuplicateDataPackageMutation>;
export type DuplicateDataPackageMutationResult = Apollo.MutationResult<GraphqlTypes.DuplicateDataPackageMutation>;
export type DuplicateDataPackageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DuplicateDataPackageMutation, GraphqlTypes.DuplicateDataPackageMutationVariables>;
export const FinpubGeneratePresignedUrlsDocument = gql`
    mutation FinpubGeneratePresignedUrls($inputs: [FinpubPresignedUrlInput!]!, $arenaId: Int) {
  finpubGeneratePresignedUrls(inputs: $inputs, arenaId: $arenaId) {
    objectKey
    s3Url
  }
}
    `;
export type FinpubGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.FinpubGeneratePresignedUrlsMutation, GraphqlTypes.FinpubGeneratePresignedUrlsMutationVariables>;

/**
 * __useFinpubGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useFinpubGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinpubGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finpubGeneratePresignedUrlsMutation, { data, loading, error }] = useFinpubGeneratePresignedUrlsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFinpubGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinpubGeneratePresignedUrlsMutation, GraphqlTypes.FinpubGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinpubGeneratePresignedUrlsMutation, GraphqlTypes.FinpubGeneratePresignedUrlsMutationVariables>(FinpubGeneratePresignedUrlsDocument, options);
      }
export type FinpubGeneratePresignedUrlsMutationHookResult = ReturnType<typeof useFinpubGeneratePresignedUrlsMutation>;
export type FinpubGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.FinpubGeneratePresignedUrlsMutation>;
export type FinpubGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinpubGeneratePresignedUrlsMutation, GraphqlTypes.FinpubGeneratePresignedUrlsMutationVariables>;
export const ImportDataPackageDocument = gql`
    mutation ImportDataPackage($arenaId: Int, $name: String, $description: String, $s3Key: String!) {
  finpubDataPackageImport(
    arenaId: $arenaId
    name: $name
    description: $description
    s3Key: $s3Key
  ) {
    dataPackageId
    message
    processId
  }
}
    `;
export type ImportDataPackageMutationFn = Apollo.MutationFunction<GraphqlTypes.ImportDataPackageMutation, GraphqlTypes.ImportDataPackageMutationVariables>;

/**
 * __useImportDataPackageMutation__
 *
 * To run a mutation, you first call `useImportDataPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDataPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDataPackageMutation, { data, loading, error }] = useImportDataPackageMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useImportDataPackageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ImportDataPackageMutation, GraphqlTypes.ImportDataPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ImportDataPackageMutation, GraphqlTypes.ImportDataPackageMutationVariables>(ImportDataPackageDocument, options);
      }
export type ImportDataPackageMutationHookResult = ReturnType<typeof useImportDataPackageMutation>;
export type ImportDataPackageMutationResult = Apollo.MutationResult<GraphqlTypes.ImportDataPackageMutation>;
export type ImportDataPackageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ImportDataPackageMutation, GraphqlTypes.ImportDataPackageMutationVariables>;
export const UpdateDataPackageMetadataDocument = gql`
    mutation UpdateDataPackageMetadata($dataPackageId: Int!, $arenaId: Int, $name: String, $description: String) {
  finpubDataPackageUpdateMetadata(
    dataPackageId: $dataPackageId
    arenaId: $arenaId
    name: $name
    description: $description
  ) {
    id
    message
    success
  }
}
    `;
export type UpdateDataPackageMetadataMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDataPackageMetadataMutation, GraphqlTypes.UpdateDataPackageMetadataMutationVariables>;

/**
 * __useUpdateDataPackageMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateDataPackageMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataPackageMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataPackageMetadataMutation, { data, loading, error }] = useUpdateDataPackageMetadataMutation({
 *   variables: {
 *      dataPackageId: // value for 'dataPackageId'
 *      arenaId: // value for 'arenaId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateDataPackageMetadataMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDataPackageMetadataMutation, GraphqlTypes.UpdateDataPackageMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDataPackageMetadataMutation, GraphqlTypes.UpdateDataPackageMetadataMutationVariables>(UpdateDataPackageMetadataDocument, options);
      }
export type UpdateDataPackageMetadataMutationHookResult = ReturnType<typeof useUpdateDataPackageMetadataMutation>;
export type UpdateDataPackageMetadataMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDataPackageMetadataMutation>;
export type UpdateDataPackageMetadataMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDataPackageMetadataMutation, GraphqlTypes.UpdateDataPackageMetadataMutationVariables>;
export const UpdateDataPackageDocument = gql`
    mutation UpdateDataPackage($dataPackageId: Int!, $s3Key: String!, $arenaId: Int) {
  finpubDataPackageUpdate(
    dataPackageId: $dataPackageId
    s3Key: $s3Key
    arenaId: $arenaId
  ) {
    id
    message
    success
  }
}
    `;
export type UpdateDataPackageMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateDataPackageMutation, GraphqlTypes.UpdateDataPackageMutationVariables>;

/**
 * __useUpdateDataPackageMutation__
 *
 * To run a mutation, you first call `useUpdateDataPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataPackageMutation, { data, loading, error }] = useUpdateDataPackageMutation({
 *   variables: {
 *      dataPackageId: // value for 'dataPackageId'
 *      s3Key: // value for 's3Key'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useUpdateDataPackageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateDataPackageMutation, GraphqlTypes.UpdateDataPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateDataPackageMutation, GraphqlTypes.UpdateDataPackageMutationVariables>(UpdateDataPackageDocument, options);
      }
export type UpdateDataPackageMutationHookResult = ReturnType<typeof useUpdateDataPackageMutation>;
export type UpdateDataPackageMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateDataPackageMutation>;
export type UpdateDataPackageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateDataPackageMutation, GraphqlTypes.UpdateDataPackageMutationVariables>;
export const DeleteDataPackageDocument = gql`
    mutation DeleteDataPackage($arenaId: Int, $dataPackageId: Int!) {
  finpubDataPackageDelete(arenaId: $arenaId, dataPackageId: $dataPackageId) {
    id
    message
    success
  }
}
    `;
export type DeleteDataPackageMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteDataPackageMutation, GraphqlTypes.DeleteDataPackageMutationVariables>;

/**
 * __useDeleteDataPackageMutation__
 *
 * To run a mutation, you first call `useDeleteDataPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataPackageMutation, { data, loading, error }] = useDeleteDataPackageMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *   },
 * });
 */
export function useDeleteDataPackageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteDataPackageMutation, GraphqlTypes.DeleteDataPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteDataPackageMutation, GraphqlTypes.DeleteDataPackageMutationVariables>(DeleteDataPackageDocument, options);
      }
export type DeleteDataPackageMutationHookResult = ReturnType<typeof useDeleteDataPackageMutation>;
export type DeleteDataPackageMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteDataPackageMutation>;
export type DeleteDataPackageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteDataPackageMutation, GraphqlTypes.DeleteDataPackageMutationVariables>;
export const RestoreDataPackageDocument = gql`
    mutation RestoreDataPackage($arenaId: Int, $dataPackageId: Int!) {
  finpubDataPackageRestore(arenaId: $arenaId, dataPackageId: $dataPackageId) {
    id
    message
    success
  }
}
    `;
export type RestoreDataPackageMutationFn = Apollo.MutationFunction<GraphqlTypes.RestoreDataPackageMutation, GraphqlTypes.RestoreDataPackageMutationVariables>;

/**
 * __useRestoreDataPackageMutation__
 *
 * To run a mutation, you first call `useRestoreDataPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDataPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDataPackageMutation, { data, loading, error }] = useRestoreDataPackageMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *   },
 * });
 */
export function useRestoreDataPackageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestoreDataPackageMutation, GraphqlTypes.RestoreDataPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestoreDataPackageMutation, GraphqlTypes.RestoreDataPackageMutationVariables>(RestoreDataPackageDocument, options);
      }
export type RestoreDataPackageMutationHookResult = ReturnType<typeof useRestoreDataPackageMutation>;
export type RestoreDataPackageMutationResult = Apollo.MutationResult<GraphqlTypes.RestoreDataPackageMutation>;
export type RestoreDataPackageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestoreDataPackageMutation, GraphqlTypes.RestoreDataPackageMutationVariables>;
export const CreateFormulaDocument = gql`
    mutation CreateFormula($dataPackageVersionId: Int!, $name: String!, $expression: String!, $arenaId: Int, $description: String, $roundingMode: RoundingMode, $roundingDecimals: Int, $components: [FormulaComponentInput!]) {
  finpubFormulaCreate(
    name: $name
    expression: $expression
    dataPackageVersionId: $dataPackageVersionId
    arenaId: $arenaId
    description: $description
    roundingMode: $roundingMode
    roundingDecimals: $roundingDecimals
    components: $components
  ) {
    id
    message
    success
    errorCode
  }
}
    `;
export type CreateFormulaMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateFormulaMutation, GraphqlTypes.CreateFormulaMutationVariables>;

/**
 * __useCreateFormulaMutation__
 *
 * To run a mutation, you first call `useCreateFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormulaMutation, { data, loading, error }] = useCreateFormulaMutation({
 *   variables: {
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      name: // value for 'name'
 *      expression: // value for 'expression'
 *      arenaId: // value for 'arenaId'
 *      description: // value for 'description'
 *      roundingMode: // value for 'roundingMode'
 *      roundingDecimals: // value for 'roundingDecimals'
 *      components: // value for 'components'
 *   },
 * });
 */
export function useCreateFormulaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateFormulaMutation, GraphqlTypes.CreateFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateFormulaMutation, GraphqlTypes.CreateFormulaMutationVariables>(CreateFormulaDocument, options);
      }
export type CreateFormulaMutationHookResult = ReturnType<typeof useCreateFormulaMutation>;
export type CreateFormulaMutationResult = Apollo.MutationResult<GraphqlTypes.CreateFormulaMutation>;
export type CreateFormulaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateFormulaMutation, GraphqlTypes.CreateFormulaMutationVariables>;
export const UpdateFormulaDocument = gql`
    mutation UpdateFormula($formulaId: Int!, $name: String!, $expression: String!, $arenaId: Int, $description: String, $roundingMode: RoundingMode, $roundingDecimals: Int, $components: [FormulaComponentInput!]) {
  finpubFormulaUpdate(
    formulaId: $formulaId
    name: $name
    description: $description
    expression: $expression
    arenaId: $arenaId
    roundingMode: $roundingMode
    roundingDecimals: $roundingDecimals
    components: $components
  ) {
    id
    message
    success
    errorCode
  }
}
    `;
export type UpdateFormulaMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateFormulaMutation, GraphqlTypes.UpdateFormulaMutationVariables>;

/**
 * __useUpdateFormulaMutation__
 *
 * To run a mutation, you first call `useUpdateFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormulaMutation, { data, loading, error }] = useUpdateFormulaMutation({
 *   variables: {
 *      formulaId: // value for 'formulaId'
 *      name: // value for 'name'
 *      expression: // value for 'expression'
 *      arenaId: // value for 'arenaId'
 *      description: // value for 'description'
 *      roundingMode: // value for 'roundingMode'
 *      roundingDecimals: // value for 'roundingDecimals'
 *      components: // value for 'components'
 *   },
 * });
 */
export function useUpdateFormulaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateFormulaMutation, GraphqlTypes.UpdateFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateFormulaMutation, GraphqlTypes.UpdateFormulaMutationVariables>(UpdateFormulaDocument, options);
      }
export type UpdateFormulaMutationHookResult = ReturnType<typeof useUpdateFormulaMutation>;
export type UpdateFormulaMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateFormulaMutation>;
export type UpdateFormulaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateFormulaMutation, GraphqlTypes.UpdateFormulaMutationVariables>;
export const DeleteFormulaDocument = gql`
    mutation DeleteFormula($arenaId: Int, $formulaId: Int!) {
  finpubFormulaDelete(arenaId: $arenaId, formulaId: $formulaId) {
    id
    message
    success
  }
}
    `;
export type DeleteFormulaMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteFormulaMutation, GraphqlTypes.DeleteFormulaMutationVariables>;

/**
 * __useDeleteFormulaMutation__
 *
 * To run a mutation, you first call `useDeleteFormulaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormulaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormulaMutation, { data, loading, error }] = useDeleteFormulaMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      formulaId: // value for 'formulaId'
 *   },
 * });
 */
export function useDeleteFormulaMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteFormulaMutation, GraphqlTypes.DeleteFormulaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteFormulaMutation, GraphqlTypes.DeleteFormulaMutationVariables>(DeleteFormulaDocument, options);
      }
export type DeleteFormulaMutationHookResult = ReturnType<typeof useDeleteFormulaMutation>;
export type DeleteFormulaMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteFormulaMutation>;
export type DeleteFormulaMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteFormulaMutation, GraphqlTypes.DeleteFormulaMutationVariables>;
export const CreateQueryDocument = gql`
    mutation CreateQuery($name: String!, $dataPackageVersionId: Int!, $arenaId: Int, $settings: QuerySettingsInput, $fields: [QueryFieldInput!], $footnotes: [QueryFootnoteInput!], $transactionTypeNodeIds: [Int!]) {
  finpubQueryCreate(
    name: $name
    dataPackageVersionId: $dataPackageVersionId
    arenaId: $arenaId
    settings: $settings
    fields: $fields
    footnotes: $footnotes
    transactionTypeNodeIds: $transactionTypeNodeIds
  ) {
    id
    success
    message
    query {
      id
      name
      transactionTypeNodes {
        id
        queryVersionId
        typeHierarchyNodeId
      }
    }
  }
}
    `;
export type CreateQueryMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateQueryMutation, GraphqlTypes.CreateQueryMutationVariables>;

/**
 * __useCreateQueryMutation__
 *
 * To run a mutation, you first call `useCreateQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueryMutation, { data, loading, error }] = useCreateQueryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      arenaId: // value for 'arenaId'
 *      settings: // value for 'settings'
 *      fields: // value for 'fields'
 *      footnotes: // value for 'footnotes'
 *      transactionTypeNodeIds: // value for 'transactionTypeNodeIds'
 *   },
 * });
 */
export function useCreateQueryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateQueryMutation, GraphqlTypes.CreateQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateQueryMutation, GraphqlTypes.CreateQueryMutationVariables>(CreateQueryDocument, options);
      }
export type CreateQueryMutationHookResult = ReturnType<typeof useCreateQueryMutation>;
export type CreateQueryMutationResult = Apollo.MutationResult<GraphqlTypes.CreateQueryMutation>;
export type CreateQueryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateQueryMutation, GraphqlTypes.CreateQueryMutationVariables>;
export const FinpubQueryUpdateDocument = gql`
    mutation FinpubQueryUpdate($queryId: Int!, $arenaId: Int, $name: String, $settings: QuerySettingsInput, $fields: [QueryFieldInput!], $footnotes: [QueryFootnoteInput!], $transactionTypeNodeIds: [Int!]) {
  finpubQueryUpdate(
    queryId: $queryId
    arenaId: $arenaId
    name: $name
    settings: $settings
    fields: $fields
    footnotes: $footnotes
    transactionTypeNodeIds: $transactionTypeNodeIds
  ) {
    id
    success
    message
    query {
      ...QueryDetailFields
    }
  }
}
    ${QueryDetailFieldsFragmentDoc}`;
export type FinpubQueryUpdateMutationFn = Apollo.MutationFunction<GraphqlTypes.FinpubQueryUpdateMutation, GraphqlTypes.FinpubQueryUpdateMutationVariables>;

/**
 * __useFinpubQueryUpdateMutation__
 *
 * To run a mutation, you first call `useFinpubQueryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinpubQueryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finpubQueryUpdateMutation, { data, loading, error }] = useFinpubQueryUpdateMutation({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *      name: // value for 'name'
 *      settings: // value for 'settings'
 *      fields: // value for 'fields'
 *      footnotes: // value for 'footnotes'
 *      transactionTypeNodeIds: // value for 'transactionTypeNodeIds'
 *   },
 * });
 */
export function useFinpubQueryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinpubQueryUpdateMutation, GraphqlTypes.FinpubQueryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinpubQueryUpdateMutation, GraphqlTypes.FinpubQueryUpdateMutationVariables>(FinpubQueryUpdateDocument, options);
      }
export type FinpubQueryUpdateMutationHookResult = ReturnType<typeof useFinpubQueryUpdateMutation>;
export type FinpubQueryUpdateMutationResult = Apollo.MutationResult<GraphqlTypes.FinpubQueryUpdateMutation>;
export type FinpubQueryUpdateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinpubQueryUpdateMutation, GraphqlTypes.FinpubQueryUpdateMutationVariables>;
export const FinpubQueryDeleteDocument = gql`
    mutation FinpubQueryDelete($queryId: Int!, $arenaId: Int) {
  finpubQueryDelete(queryId: $queryId, arenaId: $arenaId) {
    id
    success
    message
  }
}
    `;
export type FinpubQueryDeleteMutationFn = Apollo.MutationFunction<GraphqlTypes.FinpubQueryDeleteMutation, GraphqlTypes.FinpubQueryDeleteMutationVariables>;

/**
 * __useFinpubQueryDeleteMutation__
 *
 * To run a mutation, you first call `useFinpubQueryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinpubQueryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finpubQueryDeleteMutation, { data, loading, error }] = useFinpubQueryDeleteMutation({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFinpubQueryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinpubQueryDeleteMutation, GraphqlTypes.FinpubQueryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinpubQueryDeleteMutation, GraphqlTypes.FinpubQueryDeleteMutationVariables>(FinpubQueryDeleteDocument, options);
      }
export type FinpubQueryDeleteMutationHookResult = ReturnType<typeof useFinpubQueryDeleteMutation>;
export type FinpubQueryDeleteMutationResult = Apollo.MutationResult<GraphqlTypes.FinpubQueryDeleteMutation>;
export type FinpubQueryDeleteMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinpubQueryDeleteMutation, GraphqlTypes.FinpubQueryDeleteMutationVariables>;
export const FinpubQueryRestoreDocument = gql`
    mutation FinpubQueryRestore($queryId: Int!, $arenaId: Int) {
  finpubQueryRestore(queryId: $queryId, arenaId: $arenaId) {
    id
    success
    message
  }
}
    `;
export type FinpubQueryRestoreMutationFn = Apollo.MutationFunction<GraphqlTypes.FinpubQueryRestoreMutation, GraphqlTypes.FinpubQueryRestoreMutationVariables>;

/**
 * __useFinpubQueryRestoreMutation__
 *
 * To run a mutation, you first call `useFinpubQueryRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinpubQueryRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finpubQueryRestoreMutation, { data, loading, error }] = useFinpubQueryRestoreMutation({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFinpubQueryRestoreMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinpubQueryRestoreMutation, GraphqlTypes.FinpubQueryRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinpubQueryRestoreMutation, GraphqlTypes.FinpubQueryRestoreMutationVariables>(FinpubQueryRestoreDocument, options);
      }
export type FinpubQueryRestoreMutationHookResult = ReturnType<typeof useFinpubQueryRestoreMutation>;
export type FinpubQueryRestoreMutationResult = Apollo.MutationResult<GraphqlTypes.FinpubQueryRestoreMutation>;
export type FinpubQueryRestoreMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinpubQueryRestoreMutation, GraphqlTypes.FinpubQueryRestoreMutationVariables>;
export const ExecuteQueryDocument = gql`
    mutation ExecuteQuery($arenaId: Int!, $queryId: Int!, $runtimeParameters: String) {
  finpubQueryExecute(
    arenaId: $arenaId
    queryId: $queryId
    runtimeParameters: $runtimeParameters
  ) {
    data
    message
    metadata {
      arenaId
      executionTimeMs
      formulasExecuted
      queryId
      rowCount
    }
  }
}
    `;
export type ExecuteQueryMutationFn = Apollo.MutationFunction<GraphqlTypes.ExecuteQueryMutation, GraphqlTypes.ExecuteQueryMutationVariables>;

/**
 * __useExecuteQueryMutation__
 *
 * To run a mutation, you first call `useExecuteQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeQueryMutation, { data, loading, error }] = useExecuteQueryMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      queryId: // value for 'queryId'
 *      runtimeParameters: // value for 'runtimeParameters'
 *   },
 * });
 */
export function useExecuteQueryMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExecuteQueryMutation, GraphqlTypes.ExecuteQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExecuteQueryMutation, GraphqlTypes.ExecuteQueryMutationVariables>(ExecuteQueryDocument, options);
      }
export type ExecuteQueryMutationHookResult = ReturnType<typeof useExecuteQueryMutation>;
export type ExecuteQueryMutationResult = Apollo.MutationResult<GraphqlTypes.ExecuteQueryMutation>;
export type ExecuteQueryMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExecuteQueryMutation, GraphqlTypes.ExecuteQueryMutationVariables>;
export const GetDataPackagesDocument = gql`
    query GetDataPackages($arenaId: Int, $includeInactive: Boolean, $templateType: SupportedTemplateType) {
  finpubDataPackages(
    arenaId: $arenaId
    includeInactive: $includeInactive
    templateType: $templateType
  ) {
    id
    arenaId
    name
    description
    version
    isActive
    isDefault
    currentVersionId
    formulaCount
    queryCount
    levelCount
    nodeCount
    lastUpdated
    archivedAt
    createdByUser {
      fullName
    }
    updatedByUser {
      fullName
    }
    archivedByUser {
      fullName
    }
  }
}
    `;

/**
 * __useGetDataPackagesQuery__
 *
 * To run a query within a React component, call `useGetDataPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPackagesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      includeInactive: // value for 'includeInactive'
 *      templateType: // value for 'templateType'
 *   },
 * });
 */
export function useGetDataPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>(GetDataPackagesDocument, options);
      }
export function useGetDataPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>(GetDataPackagesDocument, options);
        }
// @ts-ignore
export function useGetDataPackagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>;
export function useGetDataPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackagesQuery | undefined, GraphqlTypes.GetDataPackagesQueryVariables>;
export function useGetDataPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>(GetDataPackagesDocument, options);
        }
export type GetDataPackagesQueryHookResult = ReturnType<typeof useGetDataPackagesQuery>;
export type GetDataPackagesLazyQueryHookResult = ReturnType<typeof useGetDataPackagesLazyQuery>;
export type GetDataPackagesSuspenseQueryHookResult = ReturnType<typeof useGetDataPackagesSuspenseQuery>;
export type GetDataPackagesQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataPackagesQuery, GraphqlTypes.GetDataPackagesQueryVariables>;
export const GetDataPackageDocument = gql`
    query GetDataPackage($arenaId: Int, $dataPackageId: Int!) {
  finpubDataPackage(arenaId: $arenaId, dataPackageId: $dataPackageId) {
    id
    arenaId
    name
    description
    version
    isActive
    typeHierarchy
    formulaCount
    queryCount
    createdAt
    updatedAt
    archivedAt
    createdByUser {
      fullName
    }
    updatedByUser {
      fullName
    }
    archivedByUser {
      fullName
    }
    currentVersion {
      id
    }
  }
}
    `;

/**
 * __useGetDataPackageQuery__
 *
 * To run a query within a React component, call `useGetDataPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPackageQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *   },
 * });
 */
export function useGetDataPackageQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables> & ({ variables: GraphqlTypes.GetDataPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>(GetDataPackageDocument, options);
      }
export function useGetDataPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>(GetDataPackageDocument, options);
        }
// @ts-ignore
export function useGetDataPackageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>;
export function useGetDataPackageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackageQuery | undefined, GraphqlTypes.GetDataPackageQueryVariables>;
export function useGetDataPackageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>(GetDataPackageDocument, options);
        }
export type GetDataPackageQueryHookResult = ReturnType<typeof useGetDataPackageQuery>;
export type GetDataPackageLazyQueryHookResult = ReturnType<typeof useGetDataPackageLazyQuery>;
export type GetDataPackageSuspenseQueryHookResult = ReturnType<typeof useGetDataPackageSuspenseQuery>;
export type GetDataPackageQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataPackageQuery, GraphqlTypes.GetDataPackageQueryVariables>;
export const GetDataPackageVersionHistoryDocument = gql`
    query GetDataPackageVersionHistory($arenaId: Int, $dataPackageId: Int!) {
  finpubDataPackageVersionHistory(
    arenaId: $arenaId
    dataPackageId: $dataPackageId
  ) {
    id
    version
    createdAt
    createdByUser {
      fullName
    }
    typeHierarchy
    updatedAt
  }
}
    `;

/**
 * __useGetDataPackageVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetDataPackageVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPackageVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPackageVersionHistoryQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *   },
 * });
 */
export function useGetDataPackageVersionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables> & ({ variables: GraphqlTypes.GetDataPackageVersionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>(GetDataPackageVersionHistoryDocument, options);
      }
export function useGetDataPackageVersionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>(GetDataPackageVersionHistoryDocument, options);
        }
// @ts-ignore
export function useGetDataPackageVersionHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>;
export function useGetDataPackageVersionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataPackageVersionHistoryQuery | undefined, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>;
export function useGetDataPackageVersionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>(GetDataPackageVersionHistoryDocument, options);
        }
export type GetDataPackageVersionHistoryQueryHookResult = ReturnType<typeof useGetDataPackageVersionHistoryQuery>;
export type GetDataPackageVersionHistoryLazyQueryHookResult = ReturnType<typeof useGetDataPackageVersionHistoryLazyQuery>;
export type GetDataPackageVersionHistorySuspenseQueryHookResult = ReturnType<typeof useGetDataPackageVersionHistorySuspenseQuery>;
export type GetDataPackageVersionHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataPackageVersionHistoryQuery, GraphqlTypes.GetDataPackageVersionHistoryQueryVariables>;
export const DataPackageExportDocument = gql`
    query DataPackageExport($arenaId: Int, $dataPackageId: Int!, $version: Int) {
  finpubDataPackageExport(
    arenaId: $arenaId
    dataPackageId: $dataPackageId
    version: $version
  ) {
    message
    preSignedUrl
  }
}
    `;

/**
 * __useDataPackageExportQuery__
 *
 * To run a query within a React component, call `useDataPackageExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataPackageExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataPackageExportQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDataPackageExportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables> & ({ variables: GraphqlTypes.DataPackageExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>(DataPackageExportDocument, options);
      }
export function useDataPackageExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>(DataPackageExportDocument, options);
        }
// @ts-ignore
export function useDataPackageExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>;
export function useDataPackageExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataPackageExportQuery | undefined, GraphqlTypes.DataPackageExportQueryVariables>;
export function useDataPackageExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>(DataPackageExportDocument, options);
        }
export type DataPackageExportQueryHookResult = ReturnType<typeof useDataPackageExportQuery>;
export type DataPackageExportLazyQueryHookResult = ReturnType<typeof useDataPackageExportLazyQuery>;
export type DataPackageExportSuspenseQueryHookResult = ReturnType<typeof useDataPackageExportSuspenseQuery>;
export type DataPackageExportQueryResult = Apollo.QueryResult<GraphqlTypes.DataPackageExportQuery, GraphqlTypes.DataPackageExportQueryVariables>;
export const PreviewDataPackageImportDocument = gql`
    query PreviewDataPackageImport($s3Key: String!) {
  finpubDataPackagePreviewImport(s3Key: $s3Key) {
    fileName
    levelCount
    nodeCount
    message
    typeHierarchy
    rowErrors {
      rowNumber
      name
      code
      reason
    }
    preSignedErrorReportUrl
  }
}
    `;

/**
 * __usePreviewDataPackageImportQuery__
 *
 * To run a query within a React component, call `usePreviewDataPackageImportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDataPackageImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDataPackageImportQuery({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function usePreviewDataPackageImportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables> & ({ variables: GraphqlTypes.PreviewDataPackageImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>(PreviewDataPackageImportDocument, options);
      }
export function usePreviewDataPackageImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>(PreviewDataPackageImportDocument, options);
        }
// @ts-ignore
export function usePreviewDataPackageImportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>;
export function usePreviewDataPackageImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PreviewDataPackageImportQuery | undefined, GraphqlTypes.PreviewDataPackageImportQueryVariables>;
export function usePreviewDataPackageImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>(PreviewDataPackageImportDocument, options);
        }
export type PreviewDataPackageImportQueryHookResult = ReturnType<typeof usePreviewDataPackageImportQuery>;
export type PreviewDataPackageImportLazyQueryHookResult = ReturnType<typeof usePreviewDataPackageImportLazyQuery>;
export type PreviewDataPackageImportSuspenseQueryHookResult = ReturnType<typeof usePreviewDataPackageImportSuspenseQuery>;
export type PreviewDataPackageImportQueryResult = Apollo.QueryResult<GraphqlTypes.PreviewDataPackageImportQuery, GraphqlTypes.PreviewDataPackageImportQueryVariables>;
export const DataPackageUsageDocument = gql`
    query DataPackageUsage($dataPackageIds: [Int!]!) {
  dataPackageUsage(dataPackageIds: $dataPackageIds) {
    dataPackageId
    activeTemplateCount
  }
}
    `;

/**
 * __useDataPackageUsageQuery__
 *
 * To run a query within a React component, call `useDataPackageUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataPackageUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataPackageUsageQuery({
 *   variables: {
 *      dataPackageIds: // value for 'dataPackageIds'
 *   },
 * });
 */
export function useDataPackageUsageQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables> & ({ variables: GraphqlTypes.DataPackageUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>(DataPackageUsageDocument, options);
      }
export function useDataPackageUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>(DataPackageUsageDocument, options);
        }
// @ts-ignore
export function useDataPackageUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>;
export function useDataPackageUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataPackageUsageQuery | undefined, GraphqlTypes.DataPackageUsageQueryVariables>;
export function useDataPackageUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>(DataPackageUsageDocument, options);
        }
export type DataPackageUsageQueryHookResult = ReturnType<typeof useDataPackageUsageQuery>;
export type DataPackageUsageLazyQueryHookResult = ReturnType<typeof useDataPackageUsageLazyQuery>;
export type DataPackageUsageSuspenseQueryHookResult = ReturnType<typeof useDataPackageUsageSuspenseQuery>;
export type DataPackageUsageQueryResult = Apollo.QueryResult<GraphqlTypes.DataPackageUsageQuery, GraphqlTypes.DataPackageUsageQueryVariables>;
export const DataPackageImpactDocument = gql`
    query DataPackageImpact($dataPackageVersionId: Int!, $arenaId: Int) {
  dataPackageImpact(
    dataPackageVersionId: $dataPackageVersionId
    arenaId: $arenaId
  ) {
    queryId
    templates {
      id
      name
      arenaId
      arenaName
      isActive
      currentVersion {
        id
        status
      }
      versions {
        id
        status
        isUploadComplete
        createdAt
      }
    }
  }
}
    `;

/**
 * __useDataPackageImpactQuery__
 *
 * To run a query within a React component, call `useDataPackageImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataPackageImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataPackageImpactQuery({
 *   variables: {
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useDataPackageImpactQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables> & ({ variables: GraphqlTypes.DataPackageImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>(DataPackageImpactDocument, options);
      }
export function useDataPackageImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>(DataPackageImpactDocument, options);
        }
// @ts-ignore
export function useDataPackageImpactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>;
export function useDataPackageImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DataPackageImpactQuery | undefined, GraphqlTypes.DataPackageImpactQueryVariables>;
export function useDataPackageImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>(DataPackageImpactDocument, options);
        }
export type DataPackageImpactQueryHookResult = ReturnType<typeof useDataPackageImpactQuery>;
export type DataPackageImpactLazyQueryHookResult = ReturnType<typeof useDataPackageImpactLazyQuery>;
export type DataPackageImpactSuspenseQueryHookResult = ReturnType<typeof useDataPackageImpactSuspenseQuery>;
export type DataPackageImpactQueryResult = Apollo.QueryResult<GraphqlTypes.DataPackageImpactQuery, GraphqlTypes.DataPackageImpactQueryVariables>;
export const GetPrimaryFieldsDocument = gql`
    query GetPrimaryFields($arenaId: Int, $limit: Int, $offset: Int, $search: String) {
  finpubPrimaryFields(
    arenaId: $arenaId
    limit: $limit
    offset: $offset
    search: $search
  ) {
    items {
      name
      displayName
      tableName
      type
      aggregatable
      filterable
      groupable
      nullable
      supportedLevels
    }
    pagination {
      limit
      offset
      total
      hasMore
    }
    success
    message
  }
}
    `;

/**
 * __useGetPrimaryFieldsQuery__
 *
 * To run a query within a React component, call `useGetPrimaryFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimaryFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimaryFieldsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPrimaryFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>(GetPrimaryFieldsDocument, options);
      }
export function useGetPrimaryFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>(GetPrimaryFieldsDocument, options);
        }
// @ts-ignore
export function useGetPrimaryFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>;
export function useGetPrimaryFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPrimaryFieldsQuery | undefined, GraphqlTypes.GetPrimaryFieldsQueryVariables>;
export function useGetPrimaryFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>(GetPrimaryFieldsDocument, options);
        }
export type GetPrimaryFieldsQueryHookResult = ReturnType<typeof useGetPrimaryFieldsQuery>;
export type GetPrimaryFieldsLazyQueryHookResult = ReturnType<typeof useGetPrimaryFieldsLazyQuery>;
export type GetPrimaryFieldsSuspenseQueryHookResult = ReturnType<typeof useGetPrimaryFieldsSuspenseQuery>;
export type GetPrimaryFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPrimaryFieldsQuery, GraphqlTypes.GetPrimaryFieldsQueryVariables>;
export const GetFootnoteCustomFieldsDocument = gql`
    query GetFootnoteCustomFields($arenaId: Int, $limit: Int, $offset: Int) {
  finpubQueryAttributes(arenaId: $arenaId, limit: $limit, offset: $offset) {
    success
    attributes {
      name
      customFieldId: customFieldIdStr
      customFieldName
      customFieldAppliesTo
    }
    pagination {
      total
      hasMore
    }
  }
}
    `;

/**
 * __useGetFootnoteCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetFootnoteCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFootnoteCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFootnoteCustomFieldsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetFootnoteCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>(GetFootnoteCustomFieldsDocument, options);
      }
export function useGetFootnoteCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>(GetFootnoteCustomFieldsDocument, options);
        }
// @ts-ignore
export function useGetFootnoteCustomFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>;
export function useGetFootnoteCustomFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFootnoteCustomFieldsQuery | undefined, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>;
export function useGetFootnoteCustomFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>(GetFootnoteCustomFieldsDocument, options);
        }
export type GetFootnoteCustomFieldsQueryHookResult = ReturnType<typeof useGetFootnoteCustomFieldsQuery>;
export type GetFootnoteCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetFootnoteCustomFieldsLazyQuery>;
export type GetFootnoteCustomFieldsSuspenseQueryHookResult = ReturnType<typeof useGetFootnoteCustomFieldsSuspenseQuery>;
export type GetFootnoteCustomFieldsQueryResult = Apollo.QueryResult<GraphqlTypes.GetFootnoteCustomFieldsQuery, GraphqlTypes.GetFootnoteCustomFieldsQueryVariables>;
export const GetFormulasDocument = gql`
    query GetFormulas($arenaId: Int, $dataPackageVersionId: Int!, $includeInactive: Boolean) {
  finpubFormulas(
    arenaId: $arenaId
    dataPackageVersionId: $dataPackageVersionId
    includeInactive: $includeInactive
  ) {
    id
    name
    description
    expression
    expressionWithLabels
    isActive
    createdAt
    updatedAt
    archivedAt
    createdByUser {
      fullName
    }
    updatedByUser {
      fullName
    }
    archivedByUser {
      fullName
    }
  }
}
    `;

/**
 * __useGetFormulasQuery__
 *
 * To run a query within a React component, call `useGetFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulasQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetFormulasQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables> & ({ variables: GraphqlTypes.GetFormulasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>(GetFormulasDocument, options);
      }
export function useGetFormulasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>(GetFormulasDocument, options);
        }
// @ts-ignore
export function useGetFormulasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>;
export function useGetFormulasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulasQuery | undefined, GraphqlTypes.GetFormulasQueryVariables>;
export function useGetFormulasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>(GetFormulasDocument, options);
        }
export type GetFormulasQueryHookResult = ReturnType<typeof useGetFormulasQuery>;
export type GetFormulasLazyQueryHookResult = ReturnType<typeof useGetFormulasLazyQuery>;
export type GetFormulasSuspenseQueryHookResult = ReturnType<typeof useGetFormulasSuspenseQuery>;
export type GetFormulasQueryResult = Apollo.QueryResult<GraphqlTypes.GetFormulasQuery, GraphqlTypes.GetFormulasQueryVariables>;
export const GetQueriesDocument = gql`
    query GetQueries($arenaId: Int, $dataPackageVersionId: Int, $includeInactive: Boolean! = true) {
  finpubQueries(
    arenaId: $arenaId
    dataPackageVersionId: $dataPackageVersionId
    includeInactive: $includeInactive
  ) {
    id
    name
    dataPackageVersionId
    isActive
    fieldCount
    updatedAt
    updatedByUser {
      fullName
    }
    createdByUser {
      fullName
    }
    archivedAt
    archivedByUser {
      fullName
    }
  }
}
    `;

/**
 * __useGetQueriesQuery__
 *
 * To run a query within a React component, call `useGetQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueriesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetQueriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>(GetQueriesDocument, options);
      }
export function useGetQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>(GetQueriesDocument, options);
        }
// @ts-ignore
export function useGetQueriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>;
export function useGetQueriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueriesQuery | undefined, GraphqlTypes.GetQueriesQueryVariables>;
export function useGetQueriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>(GetQueriesDocument, options);
        }
export type GetQueriesQueryHookResult = ReturnType<typeof useGetQueriesQuery>;
export type GetQueriesLazyQueryHookResult = ReturnType<typeof useGetQueriesLazyQuery>;
export type GetQueriesSuspenseQueryHookResult = ReturnType<typeof useGetQueriesSuspenseQuery>;
export type GetQueriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueriesQuery, GraphqlTypes.GetQueriesQueryVariables>;
export const FinpubQueryDocument = gql`
    query FinpubQuery($queryId: Int!, $arenaId: Int) {
  finpubQuery(queryId: $queryId, arenaId: $arenaId) {
    ...QueryDetailFields
  }
}
    ${QueryDetailFieldsFragmentDoc}`;

/**
 * __useFinpubQueryQuery__
 *
 * To run a query within a React component, call `useFinpubQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinpubQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinpubQueryQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useFinpubQueryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables> & ({ variables: GraphqlTypes.FinpubQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>(FinpubQueryDocument, options);
      }
export function useFinpubQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>(FinpubQueryDocument, options);
        }
// @ts-ignore
export function useFinpubQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>;
export function useFinpubQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FinpubQueryQuery | undefined, GraphqlTypes.FinpubQueryQueryVariables>;
export function useFinpubQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>(FinpubQueryDocument, options);
        }
export type FinpubQueryQueryHookResult = ReturnType<typeof useFinpubQueryQuery>;
export type FinpubQueryLazyQueryHookResult = ReturnType<typeof useFinpubQueryLazyQuery>;
export type FinpubQuerySuspenseQueryHookResult = ReturnType<typeof useFinpubQuerySuspenseQuery>;
export type FinpubQueryQueryResult = Apollo.QueryResult<GraphqlTypes.FinpubQueryQuery, GraphqlTypes.FinpubQueryQueryVariables>;
export const GetQueryDateParametersDocument = gql`
    query GetQueryDateParameters($queryId: Int!, $arenaId: Int) {
  finpubQueryDateParameters(queryId: $queryId, arenaId: $arenaId) {
    parameters
  }
}
    `;

/**
 * __useGetQueryDateParametersQuery__
 *
 * To run a query within a React component, call `useGetQueryDateParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryDateParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryDateParametersQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetQueryDateParametersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables> & ({ variables: GraphqlTypes.GetQueryDateParametersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>(GetQueryDateParametersDocument, options);
      }
export function useGetQueryDateParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>(GetQueryDateParametersDocument, options);
        }
// @ts-ignore
export function useGetQueryDateParametersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>;
export function useGetQueryDateParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryDateParametersQuery | undefined, GraphqlTypes.GetQueryDateParametersQueryVariables>;
export function useGetQueryDateParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>(GetQueryDateParametersDocument, options);
        }
export type GetQueryDateParametersQueryHookResult = ReturnType<typeof useGetQueryDateParametersQuery>;
export type GetQueryDateParametersLazyQueryHookResult = ReturnType<typeof useGetQueryDateParametersLazyQuery>;
export type GetQueryDateParametersSuspenseQueryHookResult = ReturnType<typeof useGetQueryDateParametersSuspenseQuery>;
export type GetQueryDateParametersQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueryDateParametersQuery, GraphqlTypes.GetQueryDateParametersQueryVariables>;
export const GetQueryRuntimeInputsDocument = gql`
    query GetQueryRuntimeInputs($queryId: Int!, $arenaId: Int) {
  finpubQueryRuntimeInputs(queryId: $queryId, arenaId: $arenaId) {
    tokens
  }
}
    `;

/**
 * __useGetQueryRuntimeInputsQuery__
 *
 * To run a query within a React component, call `useGetQueryRuntimeInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryRuntimeInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryRuntimeInputsQuery({
 *   variables: {
 *      queryId: // value for 'queryId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetQueryRuntimeInputsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables> & ({ variables: GraphqlTypes.GetQueryRuntimeInputsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>(GetQueryRuntimeInputsDocument, options);
      }
export function useGetQueryRuntimeInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>(GetQueryRuntimeInputsDocument, options);
        }
// @ts-ignore
export function useGetQueryRuntimeInputsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>;
export function useGetQueryRuntimeInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryRuntimeInputsQuery | undefined, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>;
export function useGetQueryRuntimeInputsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>(GetQueryRuntimeInputsDocument, options);
        }
export type GetQueryRuntimeInputsQueryHookResult = ReturnType<typeof useGetQueryRuntimeInputsQuery>;
export type GetQueryRuntimeInputsLazyQueryHookResult = ReturnType<typeof useGetQueryRuntimeInputsLazyQuery>;
export type GetQueryRuntimeInputsSuspenseQueryHookResult = ReturnType<typeof useGetQueryRuntimeInputsSuspenseQuery>;
export type GetQueryRuntimeInputsQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueryRuntimeInputsQuery, GraphqlTypes.GetQueryRuntimeInputsQueryVariables>;
export const GetFormulaDetailDocument = gql`
    query GetFormulaDetail($arenaId: Int, $formulaId: Int!) {
  finpubFormula(arenaId: $arenaId, formulaId: $formulaId) {
    id
    formulaId
    name
    description
    expression
    expressionWithLabels
    roundingMode
    roundingDecimals
    isActive
    components {
      id
      componentKind
      referencedNodeId
      referencedFormulaId
      referencedPrimaryField
      sortOrder
      label
    }
  }
}
    `;

/**
 * __useGetFormulaDetailQuery__
 *
 * To run a query within a React component, call `useGetFormulaDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaDetailQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      formulaId: // value for 'formulaId'
 *   },
 * });
 */
export function useGetFormulaDetailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables> & ({ variables: GraphqlTypes.GetFormulaDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>(GetFormulaDetailDocument, options);
      }
export function useGetFormulaDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>(GetFormulaDetailDocument, options);
        }
// @ts-ignore
export function useGetFormulaDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>;
export function useGetFormulaDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulaDetailQuery | undefined, GraphqlTypes.GetFormulaDetailQueryVariables>;
export function useGetFormulaDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>(GetFormulaDetailDocument, options);
        }
export type GetFormulaDetailQueryHookResult = ReturnType<typeof useGetFormulaDetailQuery>;
export type GetFormulaDetailLazyQueryHookResult = ReturnType<typeof useGetFormulaDetailLazyQuery>;
export type GetFormulaDetailSuspenseQueryHookResult = ReturnType<typeof useGetFormulaDetailSuspenseQuery>;
export type GetFormulaDetailQueryResult = Apollo.QueryResult<GraphqlTypes.GetFormulaDetailQuery, GraphqlTypes.GetFormulaDetailQueryVariables>;
export const GetFormulaVersionHistoryDocument = gql`
    query GetFormulaVersionHistory($arenaId: Int!, $formulaId: Int!) {
  finpubFormula(arenaId: $arenaId, formulaId: $formulaId) {
    versions {
      id
      version
      createdAt
      createdByUser {
        fullName
      }
      updatedAt
      expression
    }
  }
}
    `;

/**
 * __useGetFormulaVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetFormulaVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaVersionHistoryQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      formulaId: // value for 'formulaId'
 *   },
 * });
 */
export function useGetFormulaVersionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables> & ({ variables: GraphqlTypes.GetFormulaVersionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>(GetFormulaVersionHistoryDocument, options);
      }
export function useGetFormulaVersionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>(GetFormulaVersionHistoryDocument, options);
        }
// @ts-ignore
export function useGetFormulaVersionHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>;
export function useGetFormulaVersionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulaVersionHistoryQuery | undefined, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>;
export function useGetFormulaVersionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>(GetFormulaVersionHistoryDocument, options);
        }
export type GetFormulaVersionHistoryQueryHookResult = ReturnType<typeof useGetFormulaVersionHistoryQuery>;
export type GetFormulaVersionHistoryLazyQueryHookResult = ReturnType<typeof useGetFormulaVersionHistoryLazyQuery>;
export type GetFormulaVersionHistorySuspenseQueryHookResult = ReturnType<typeof useGetFormulaVersionHistorySuspenseQuery>;
export type GetFormulaVersionHistoryQueryResult = Apollo.QueryResult<GraphqlTypes.GetFormulaVersionHistoryQuery, GraphqlTypes.GetFormulaVersionHistoryQueryVariables>;
export const GetFormulasInUseDocument = gql`
    query GetFormulasInUse($arenaId: Int!, $dataPackageVersionId: Int!) {
  finpubFormulasUsingDataPackage(
    arenaId: $arenaId
    dataPackageVersionId: $dataPackageVersionId
  ) {
    id
    name
    description
    expression
    createdAt
    createdByUser {
      fullName
    }
  }
}
    `;

/**
 * __useGetFormulasInUseQuery__
 *
 * To run a query within a React component, call `useGetFormulasInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulasInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulasInUseQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *   },
 * });
 */
export function useGetFormulasInUseQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables> & ({ variables: GraphqlTypes.GetFormulasInUseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>(GetFormulasInUseDocument, options);
      }
export function useGetFormulasInUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>(GetFormulasInUseDocument, options);
        }
// @ts-ignore
export function useGetFormulasInUseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>;
export function useGetFormulasInUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFormulasInUseQuery | undefined, GraphqlTypes.GetFormulasInUseQueryVariables>;
export function useGetFormulasInUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>(GetFormulasInUseDocument, options);
        }
export type GetFormulasInUseQueryHookResult = ReturnType<typeof useGetFormulasInUseQuery>;
export type GetFormulasInUseLazyQueryHookResult = ReturnType<typeof useGetFormulasInUseLazyQuery>;
export type GetFormulasInUseSuspenseQueryHookResult = ReturnType<typeof useGetFormulasInUseSuspenseQuery>;
export type GetFormulasInUseQueryResult = Apollo.QueryResult<GraphqlTypes.GetFormulasInUseQuery, GraphqlTypes.GetFormulasInUseQueryVariables>;
export const ValidateDataPackageNameDocument = gql`
    query ValidateDataPackageName($arenaId: Int, $dataPackageId: Int, $name: String!) {
  finpubDataPackageValidate(
    arenaId: $arenaId
    dataPackageId: $dataPackageId
    name: $name
  ) {
    valid
    errors
    message
  }
}
    `;

/**
 * __useValidateDataPackageNameQuery__
 *
 * To run a query within a React component, call `useValidateDataPackageNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateDataPackageNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateDataPackageNameQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageId: // value for 'dataPackageId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useValidateDataPackageNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables> & ({ variables: GraphqlTypes.ValidateDataPackageNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>(ValidateDataPackageNameDocument, options);
      }
export function useValidateDataPackageNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>(ValidateDataPackageNameDocument, options);
        }
// @ts-ignore
export function useValidateDataPackageNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>;
export function useValidateDataPackageNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateDataPackageNameQuery | undefined, GraphqlTypes.ValidateDataPackageNameQueryVariables>;
export function useValidateDataPackageNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>(ValidateDataPackageNameDocument, options);
        }
export type ValidateDataPackageNameQueryHookResult = ReturnType<typeof useValidateDataPackageNameQuery>;
export type ValidateDataPackageNameLazyQueryHookResult = ReturnType<typeof useValidateDataPackageNameLazyQuery>;
export type ValidateDataPackageNameSuspenseQueryHookResult = ReturnType<typeof useValidateDataPackageNameSuspenseQuery>;
export type ValidateDataPackageNameQueryResult = Apollo.QueryResult<GraphqlTypes.ValidateDataPackageNameQuery, GraphqlTypes.ValidateDataPackageNameQueryVariables>;
export const ValidateFormulaDocument = gql`
    query ValidateFormula($arenaId: Int, $dataPackageVersionId: Int!, $expression: String!, $formulaId: Int, $components: [FormulaComponentInput!]) {
  finpubFormulaValidate(
    arenaId: $arenaId
    dataPackageVersionId: $dataPackageVersionId
    expression: $expression
    formulaId: $formulaId
    components: $components
  ) {
    valid
    message
    validationErrors {
      message
      componentId
      clientKey
    }
  }
}
    `;

/**
 * __useValidateFormulaQuery__
 *
 * To run a query within a React component, call `useValidateFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateFormulaQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      dataPackageVersionId: // value for 'dataPackageVersionId'
 *      expression: // value for 'expression'
 *      formulaId: // value for 'formulaId'
 *      components: // value for 'components'
 *   },
 * });
 */
export function useValidateFormulaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables> & ({ variables: GraphqlTypes.ValidateFormulaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>(ValidateFormulaDocument, options);
      }
export function useValidateFormulaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>(ValidateFormulaDocument, options);
        }
// @ts-ignore
export function useValidateFormulaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>;
export function useValidateFormulaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateFormulaQuery | undefined, GraphqlTypes.ValidateFormulaQueryVariables>;
export function useValidateFormulaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>(ValidateFormulaDocument, options);
        }
export type ValidateFormulaQueryHookResult = ReturnType<typeof useValidateFormulaQuery>;
export type ValidateFormulaLazyQueryHookResult = ReturnType<typeof useValidateFormulaLazyQuery>;
export type ValidateFormulaSuspenseQueryHookResult = ReturnType<typeof useValidateFormulaSuspenseQuery>;
export type ValidateFormulaQueryResult = Apollo.QueryResult<GraphqlTypes.ValidateFormulaQuery, GraphqlTypes.ValidateFormulaQueryVariables>;
export const FinpubReportFieldValuesDocument = gql`
    query FinpubReportFieldValues($arenaId: Int, $field: String!, $limit: Int, $page: Int, $search: [String!]) {
  finpubReportFieldValues(
    arenaId: $arenaId
    field: $field
    limit: $limit
    page: $page
    search: $search
  ) {
    success
    message
    field
    values
    pagination {
      limit
      page
      hasMore
    }
    table {
      logicalName
      warehouseName
      schemaName
      tableName
    }
    column {
      name
      logicalName
      type
      nullable
      filterable
      groupable
      aggregatable
    }
  }
}
    `;

/**
 * __useFinpubReportFieldValuesQuery__
 *
 * To run a query within a React component, call `useFinpubReportFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinpubReportFieldValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinpubReportFieldValuesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      field: // value for 'field'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFinpubReportFieldValuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables> & ({ variables: GraphqlTypes.FinpubReportFieldValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>(FinpubReportFieldValuesDocument, options);
      }
export function useFinpubReportFieldValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>(FinpubReportFieldValuesDocument, options);
        }
// @ts-ignore
export function useFinpubReportFieldValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>;
export function useFinpubReportFieldValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FinpubReportFieldValuesQuery | undefined, GraphqlTypes.FinpubReportFieldValuesQueryVariables>;
export function useFinpubReportFieldValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>(FinpubReportFieldValuesDocument, options);
        }
export type FinpubReportFieldValuesQueryHookResult = ReturnType<typeof useFinpubReportFieldValuesQuery>;
export type FinpubReportFieldValuesLazyQueryHookResult = ReturnType<typeof useFinpubReportFieldValuesLazyQuery>;
export type FinpubReportFieldValuesSuspenseQueryHookResult = ReturnType<typeof useFinpubReportFieldValuesSuspenseQuery>;
export type FinpubReportFieldValuesQueryResult = Apollo.QueryResult<GraphqlTypes.FinpubReportFieldValuesQuery, GraphqlTypes.FinpubReportFieldValuesQueryVariables>;
export const GetQueryLevelsDocument = gql`
    query GetQueryLevels {
  finpubQueryLevels {
    value
    label
  }
}
    `;

/**
 * __useGetQueryLevelsQuery__
 *
 * To run a query within a React component, call `useGetQueryLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQueryLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>(GetQueryLevelsDocument, options);
      }
export function useGetQueryLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>(GetQueryLevelsDocument, options);
        }
// @ts-ignore
export function useGetQueryLevelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>;
export function useGetQueryLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetQueryLevelsQuery | undefined, GraphqlTypes.GetQueryLevelsQueryVariables>;
export function useGetQueryLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>(GetQueryLevelsDocument, options);
        }
export type GetQueryLevelsQueryHookResult = ReturnType<typeof useGetQueryLevelsQuery>;
export type GetQueryLevelsLazyQueryHookResult = ReturnType<typeof useGetQueryLevelsLazyQuery>;
export type GetQueryLevelsSuspenseQueryHookResult = ReturnType<typeof useGetQueryLevelsSuspenseQuery>;
export type GetQueryLevelsQueryResult = Apollo.QueryResult<GraphqlTypes.GetQueryLevelsQuery, GraphqlTypes.GetQueryLevelsQueryVariables>;
export const CancelPaymentBatchForTreasuryAdminDocument = gql`
    mutation CancelPaymentBatchForTreasuryAdmin($cancelPaymentBatchForTreasuryAdminInput: CancelPaymentBatchForTreasuryAdminInput!) {
  cancelPaymentBatchForTreasuryAdmin(
    cancelPaymentBatchForTreasuryAdminInput: $cancelPaymentBatchForTreasuryAdminInput
  ) {
    id
    status
    objectId
  }
}
    `;
export type CancelPaymentBatchForTreasuryAdminMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutation, GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutationVariables>;

/**
 * __useCancelPaymentBatchForTreasuryAdminMutation__
 *
 * To run a mutation, you first call `useCancelPaymentBatchForTreasuryAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentBatchForTreasuryAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentBatchForTreasuryAdminMutation, { data, loading, error }] = useCancelPaymentBatchForTreasuryAdminMutation({
 *   variables: {
 *      cancelPaymentBatchForTreasuryAdminInput: // value for 'cancelPaymentBatchForTreasuryAdminInput'
 *   },
 * });
 */
export function useCancelPaymentBatchForTreasuryAdminMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutation, GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutation, GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutationVariables>(CancelPaymentBatchForTreasuryAdminDocument, options);
      }
export type CancelPaymentBatchForTreasuryAdminMutationHookResult = ReturnType<typeof useCancelPaymentBatchForTreasuryAdminMutation>;
export type CancelPaymentBatchForTreasuryAdminMutationResult = Apollo.MutationResult<GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutation>;
export type CancelPaymentBatchForTreasuryAdminMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutation, GraphqlTypes.CancelPaymentBatchForTreasuryAdminMutationVariables>;
export const LinkEpAndIpdForTransactionDocument = gql`
    mutation LinkEpAndIpdForTransaction($input: LinkEpAndIpdForTransactionInput!) {
  linkEpAndIpdForTransaction(input: $input)
}
    `;
export type LinkEpAndIpdForTransactionMutationFn = Apollo.MutationFunction<GraphqlTypes.LinkEpAndIpdForTransactionMutation, GraphqlTypes.LinkEpAndIpdForTransactionMutationVariables>;

/**
 * __useLinkEpAndIpdForTransactionMutation__
 *
 * To run a mutation, you first call `useLinkEpAndIpdForTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEpAndIpdForTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEpAndIpdForTransactionMutation, { data, loading, error }] = useLinkEpAndIpdForTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkEpAndIpdForTransactionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.LinkEpAndIpdForTransactionMutation, GraphqlTypes.LinkEpAndIpdForTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.LinkEpAndIpdForTransactionMutation, GraphqlTypes.LinkEpAndIpdForTransactionMutationVariables>(LinkEpAndIpdForTransactionDocument, options);
      }
export type LinkEpAndIpdForTransactionMutationHookResult = ReturnType<typeof useLinkEpAndIpdForTransactionMutation>;
export type LinkEpAndIpdForTransactionMutationResult = Apollo.MutationResult<GraphqlTypes.LinkEpAndIpdForTransactionMutation>;
export type LinkEpAndIpdForTransactionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.LinkEpAndIpdForTransactionMutation, GraphqlTypes.LinkEpAndIpdForTransactionMutationVariables>;
export const ModifyPaymentStatusDocument = gql`
    mutation ModifyPaymentStatus($modifyPaymentStatusInput: ModifyPaymentStatusInput!) {
  modifyPaymentStatus(modifyPaymentStatusInput: $modifyPaymentStatusInput) {
    id
    status
    failureReason
    failedAt
    amount
    method
    direction
  }
}
    `;
export type ModifyPaymentStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.ModifyPaymentStatusMutation, GraphqlTypes.ModifyPaymentStatusMutationVariables>;

/**
 * __useModifyPaymentStatusMutation__
 *
 * To run a mutation, you first call `useModifyPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyPaymentStatusMutation, { data, loading, error }] = useModifyPaymentStatusMutation({
 *   variables: {
 *      modifyPaymentStatusInput: // value for 'modifyPaymentStatusInput'
 *   },
 * });
 */
export function useModifyPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ModifyPaymentStatusMutation, GraphqlTypes.ModifyPaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ModifyPaymentStatusMutation, GraphqlTypes.ModifyPaymentStatusMutationVariables>(ModifyPaymentStatusDocument, options);
      }
export type ModifyPaymentStatusMutationHookResult = ReturnType<typeof useModifyPaymentStatusMutation>;
export type ModifyPaymentStatusMutationResult = Apollo.MutationResult<GraphqlTypes.ModifyPaymentStatusMutation>;
export type ModifyPaymentStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ModifyPaymentStatusMutation, GraphqlTypes.ModifyPaymentStatusMutationVariables>;
export const OnboardBankAccountToProviderDocument = gql`
    mutation OnboardBankAccountToProvider($onboardBankAccountToProviderInput: OnboardBankAccountToProviderInput!) {
  onboardBankAccountToProvider(
    onboardBankAccountToProviderInput: $onboardBankAccountToProviderInput
  ) {
    id
    bankAccountIdentifier
    providerId
    providerName
    bankSource
    createdAt
    updatedAt
  }
}
    `;
export type OnboardBankAccountToProviderMutationFn = Apollo.MutationFunction<GraphqlTypes.OnboardBankAccountToProviderMutation, GraphqlTypes.OnboardBankAccountToProviderMutationVariables>;

/**
 * __useOnboardBankAccountToProviderMutation__
 *
 * To run a mutation, you first call `useOnboardBankAccountToProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardBankAccountToProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardBankAccountToProviderMutation, { data, loading, error }] = useOnboardBankAccountToProviderMutation({
 *   variables: {
 *      onboardBankAccountToProviderInput: // value for 'onboardBankAccountToProviderInput'
 *   },
 * });
 */
export function useOnboardBankAccountToProviderMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.OnboardBankAccountToProviderMutation, GraphqlTypes.OnboardBankAccountToProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.OnboardBankAccountToProviderMutation, GraphqlTypes.OnboardBankAccountToProviderMutationVariables>(OnboardBankAccountToProviderDocument, options);
      }
export type OnboardBankAccountToProviderMutationHookResult = ReturnType<typeof useOnboardBankAccountToProviderMutation>;
export type OnboardBankAccountToProviderMutationResult = Apollo.MutationResult<GraphqlTypes.OnboardBankAccountToProviderMutation>;
export type OnboardBankAccountToProviderMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.OnboardBankAccountToProviderMutation, GraphqlTypes.OnboardBankAccountToProviderMutationVariables>;
export const GetPaymentBatchByIdDocument = gql`
    query GetPaymentBatchById($id: ID!) {
  paymentBatch(id: $id) {
    id
    status
    createdAt
    creatorId
    objectId
    netAmount
    objectsCount
    paymentDescription
    requiredApprovalCount
    isDifferentApproverRequired
    canceledAt
    canceledByUserId
    payments {
      id
      status
      amount
      objectType
      objectId
      direction
      method
      transmittedAt
      settledAt
      failedAt
      scheduledProcessDate
      returnCode
      failureReason
      returnReason
      paymentPref {
        id
      }
      adminProviderStatus {
        ... on FidesProviderStatusDto {
          fidesConfirmationStatus {
            hasSystemConfirmation
            hasDeliveryConfirmation
            hasFidesPayCnf
            hasPain002
          }
          missingConfirmations
          systemConfirmationProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
          deliveryConfirmationProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
          fidesPayCnfProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
          pain002ProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
        }
        ... on ModernTreasuryProviderStatusDto {
          placeholder
        }
      }
    }
    fundingPayment {
      id
      method
      status
      objectType
      objectId
      transmittedAt
      scheduledProcessDate
      direction
      bankAccountId
      settledAt
      failedAt
      returnCode
      failureReason
      returnReason
    }
  }
}
    `;

/**
 * __useGetPaymentBatchByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentBatchByIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>(GetPaymentBatchByIdDocument, options);
      }
export function useGetPaymentBatchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>(GetPaymentBatchByIdDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>;
export function useGetPaymentBatchByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchByIdQuery | undefined, GraphqlTypes.GetPaymentBatchByIdQueryVariables>;
export function useGetPaymentBatchByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>(GetPaymentBatchByIdDocument, options);
        }
export type GetPaymentBatchByIdQueryHookResult = ReturnType<typeof useGetPaymentBatchByIdQuery>;
export type GetPaymentBatchByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchByIdLazyQuery>;
export type GetPaymentBatchByIdSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchByIdSuspenseQuery>;
export type GetPaymentBatchByIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchByIdQuery, GraphqlTypes.GetPaymentBatchByIdQueryVariables>;
export const ProcessingPaymentsWithConfirmationStatusDocument = gql`
    query ProcessingPaymentsWithConfirmationStatus($providerType: PaymentProvider!) {
  processingPaymentsWithConfirmationStatus(providerType: $providerType) {
    paymentBatch {
      id
      status
      createdAt
      creatorId
      objectId
      netAmount
      objectsCount
      paymentDescription
      requiredApprovalCount
      isDifferentApproverRequired
      canceledAt
      canceledByUserId
    }
    payments {
      id
      status
      direction
      method
      amount
      objectType
      objectId
      referenceNumber
      transmittedAt
      scheduledProcessDate
      failureReason
      returnCode
      returnReason
      settledAt
      failedAt
      adminProviderStatus {
        ... on FidesProviderStatusDto {
          fidesConfirmationStatus {
            hasSystemConfirmation
            hasDeliveryConfirmation
            hasFidesPayCnf
            hasPain002
          }
          missingConfirmations
          systemConfirmationProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
          deliveryConfirmationProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
          fidesPayCnfProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
          pain002ProviderObject {
            id
            objectId
            providerObjectId
            providerObjectType
            data
          }
        }
        ... on ModernTreasuryProviderStatusDto {
          placeholder
        }
      }
    }
  }
}
    `;

/**
 * __useProcessingPaymentsWithConfirmationStatusQuery__
 *
 * To run a query within a React component, call `useProcessingPaymentsWithConfirmationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingPaymentsWithConfirmationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingPaymentsWithConfirmationStatusQuery({
 *   variables: {
 *      providerType: // value for 'providerType'
 *   },
 * });
 */
export function useProcessingPaymentsWithConfirmationStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables> & ({ variables: GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>(ProcessingPaymentsWithConfirmationStatusDocument, options);
      }
export function useProcessingPaymentsWithConfirmationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>(ProcessingPaymentsWithConfirmationStatusDocument, options);
        }
// @ts-ignore
export function useProcessingPaymentsWithConfirmationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>;
export function useProcessingPaymentsWithConfirmationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery | undefined, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>;
export function useProcessingPaymentsWithConfirmationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>(ProcessingPaymentsWithConfirmationStatusDocument, options);
        }
export type ProcessingPaymentsWithConfirmationStatusQueryHookResult = ReturnType<typeof useProcessingPaymentsWithConfirmationStatusQuery>;
export type ProcessingPaymentsWithConfirmationStatusLazyQueryHookResult = ReturnType<typeof useProcessingPaymentsWithConfirmationStatusLazyQuery>;
export type ProcessingPaymentsWithConfirmationStatusSuspenseQueryHookResult = ReturnType<typeof useProcessingPaymentsWithConfirmationStatusSuspenseQuery>;
export type ProcessingPaymentsWithConfirmationStatusQueryResult = Apollo.QueryResult<GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQuery, GraphqlTypes.ProcessingPaymentsWithConfirmationStatusQueryVariables>;
export const ProviderObjectsDocument = gql`
    query ProviderObjects($input: ProviderObjectsQueryInput!) {
  providerObjects(input: $input) {
    id
    providerId
    arenaId
    objectId
    objectType
    providerObjectId
    providerObjectType
    refProviderObjectId
    refProviderObjectType
    data
    timestamp
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useProviderObjectsQuery__
 *
 * To run a query within a React component, call `useProviderObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderObjectsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderObjectsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables> & ({ variables: GraphqlTypes.ProviderObjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>(ProviderObjectsDocument, options);
      }
export function useProviderObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>(ProviderObjectsDocument, options);
        }
// @ts-ignore
export function useProviderObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>;
export function useProviderObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ProviderObjectsQuery | undefined, GraphqlTypes.ProviderObjectsQueryVariables>;
export function useProviderObjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>(ProviderObjectsDocument, options);
        }
export type ProviderObjectsQueryHookResult = ReturnType<typeof useProviderObjectsQuery>;
export type ProviderObjectsLazyQueryHookResult = ReturnType<typeof useProviderObjectsLazyQuery>;
export type ProviderObjectsSuspenseQueryHookResult = ReturnType<typeof useProviderObjectsSuspenseQuery>;
export type ProviderObjectsQueryResult = Apollo.QueryResult<GraphqlTypes.ProviderObjectsQuery, GraphqlTypes.ProviderObjectsQueryVariables>;
export const AutomatedPaymentsReconciliationGapsDocument = gql`
    query AutomatedPaymentsReconciliationGaps($input: AutomatedPaymentsReconciliationGapsInput!) {
  automatedPaymentsReconciliationGaps(input: $input) {
    expectedPaymentProviderObject {
      id
      providerId
      arenaId
      objectId
      objectType
      providerObjectId
      providerObjectType
      refProviderObjectId
      refProviderObjectType
      data
      timestamp
      createdAt
      updatedAt
    }
    incomingPaymentDetailProviderObject {
      id
      providerId
      arenaId
      objectId
      objectType
      providerObjectId
      providerObjectType
      refProviderObjectId
      refProviderObjectType
      data
      timestamp
      createdAt
      updatedAt
    }
    paymentOrderProviderObjects {
      id
      providerId
      arenaId
      objectId
      objectType
      providerObjectId
      providerObjectType
      refProviderObjectId
      refProviderObjectType
      data
      timestamp
      createdAt
      updatedAt
    }
    fundingPayment {
      id
      objectId
      objectType
      status
      amount
      method
      direction
      bankAccountId
      transmittedAt
      settledAt
      failedAt
      scheduledProcessDate
    }
    paymentBatch {
      id
      objectId
      status
      netAmount
      objectsCount
      requiredApprovalCount
      isDifferentApproverRequired
      creatorId
      createdAt
      canceledAt
      canceledByUserId
      paymentDescription
    }
  }
}
    `;

/**
 * __useAutomatedPaymentsReconciliationGapsQuery__
 *
 * To run a query within a React component, call `useAutomatedPaymentsReconciliationGapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomatedPaymentsReconciliationGapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomatedPaymentsReconciliationGapsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutomatedPaymentsReconciliationGapsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables> & ({ variables: GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>(AutomatedPaymentsReconciliationGapsDocument, options);
      }
export function useAutomatedPaymentsReconciliationGapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>(AutomatedPaymentsReconciliationGapsDocument, options);
        }
// @ts-ignore
export function useAutomatedPaymentsReconciliationGapsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>;
export function useAutomatedPaymentsReconciliationGapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery | undefined, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>;
export function useAutomatedPaymentsReconciliationGapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>(AutomatedPaymentsReconciliationGapsDocument, options);
        }
export type AutomatedPaymentsReconciliationGapsQueryHookResult = ReturnType<typeof useAutomatedPaymentsReconciliationGapsQuery>;
export type AutomatedPaymentsReconciliationGapsLazyQueryHookResult = ReturnType<typeof useAutomatedPaymentsReconciliationGapsLazyQuery>;
export type AutomatedPaymentsReconciliationGapsSuspenseQueryHookResult = ReturnType<typeof useAutomatedPaymentsReconciliationGapsSuspenseQuery>;
export type AutomatedPaymentsReconciliationGapsQueryResult = Apollo.QueryResult<GraphqlTypes.AutomatedPaymentsReconciliationGapsQuery, GraphqlTypes.AutomatedPaymentsReconciliationGapsQueryVariables>;
export const RecreatOutgoingPaymentDocument = gql`
    mutation RecreatOutgoingPayment($recreateOutgoingPaymentInput: RecreateOutgoingPaymentInput!) {
  recreateOutgoingPayment(
    recreateOutgoingPaymentInput: $recreateOutgoingPaymentInput
  ) {
    id
  }
}
    `;
export type RecreatOutgoingPaymentMutationFn = Apollo.MutationFunction<GraphqlTypes.RecreatOutgoingPaymentMutation, GraphqlTypes.RecreatOutgoingPaymentMutationVariables>;

/**
 * __useRecreatOutgoingPaymentMutation__
 *
 * To run a mutation, you first call `useRecreatOutgoingPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreatOutgoingPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreatOutgoingPaymentMutation, { data, loading, error }] = useRecreatOutgoingPaymentMutation({
 *   variables: {
 *      recreateOutgoingPaymentInput: // value for 'recreateOutgoingPaymentInput'
 *   },
 * });
 */
export function useRecreatOutgoingPaymentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RecreatOutgoingPaymentMutation, GraphqlTypes.RecreatOutgoingPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RecreatOutgoingPaymentMutation, GraphqlTypes.RecreatOutgoingPaymentMutationVariables>(RecreatOutgoingPaymentDocument, options);
      }
export type RecreatOutgoingPaymentMutationHookResult = ReturnType<typeof useRecreatOutgoingPaymentMutation>;
export type RecreatOutgoingPaymentMutationResult = Apollo.MutationResult<GraphqlTypes.RecreatOutgoingPaymentMutation>;
export type RecreatOutgoingPaymentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RecreatOutgoingPaymentMutation, GraphqlTypes.RecreatOutgoingPaymentMutationVariables>;
export const SetBankAccountVerificationStatusDocument = gql`
    mutation SetBankAccountVerificationStatus($setBankAccountVerificationStatusInput: SetBankAccountVerificationStatusInput!) {
  setBankAccountVerificationStatus(
    setBankAccountVerificationStatusInput: $setBankAccountVerificationStatusInput
  ) {
    id
    verificationStatus
  }
}
    `;
export type SetBankAccountVerificationStatusMutationFn = Apollo.MutationFunction<GraphqlTypes.SetBankAccountVerificationStatusMutation, GraphqlTypes.SetBankAccountVerificationStatusMutationVariables>;

/**
 * __useSetBankAccountVerificationStatusMutation__
 *
 * To run a mutation, you first call `useSetBankAccountVerificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBankAccountVerificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBankAccountVerificationStatusMutation, { data, loading, error }] = useSetBankAccountVerificationStatusMutation({
 *   variables: {
 *      setBankAccountVerificationStatusInput: // value for 'setBankAccountVerificationStatusInput'
 *   },
 * });
 */
export function useSetBankAccountVerificationStatusMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetBankAccountVerificationStatusMutation, GraphqlTypes.SetBankAccountVerificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetBankAccountVerificationStatusMutation, GraphqlTypes.SetBankAccountVerificationStatusMutationVariables>(SetBankAccountVerificationStatusDocument, options);
      }
export type SetBankAccountVerificationStatusMutationHookResult = ReturnType<typeof useSetBankAccountVerificationStatusMutation>;
export type SetBankAccountVerificationStatusMutationResult = Apollo.MutationResult<GraphqlTypes.SetBankAccountVerificationStatusMutation>;
export type SetBankAccountVerificationStatusMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetBankAccountVerificationStatusMutation, GraphqlTypes.SetBankAccountVerificationStatusMutationVariables>;
export const AddGroupMembershipDocument = gql`
    mutation AddGroupMembership($input: AddGroupMembershipInput!) {
  addGroupMembership(input: $input) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on AddGroupMembershipResult {
      groupMembershipsCreatedCount
    }
  }
}
    `;
export type AddGroupMembershipMutationFn = Apollo.MutationFunction<GraphqlTypes.AddGroupMembershipMutation, GraphqlTypes.AddGroupMembershipMutationVariables>;

/**
 * __useAddGroupMembershipMutation__
 *
 * To run a mutation, you first call `useAddGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGroupMembershipMutation, { data, loading, error }] = useAddGroupMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddGroupMembershipMutation, GraphqlTypes.AddGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddGroupMembershipMutation, GraphqlTypes.AddGroupMembershipMutationVariables>(AddGroupMembershipDocument, options);
      }
export type AddGroupMembershipMutationHookResult = ReturnType<typeof useAddGroupMembershipMutation>;
export type AddGroupMembershipMutationResult = Apollo.MutationResult<GraphqlTypes.AddGroupMembershipMutation>;
export type AddGroupMembershipMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddGroupMembershipMutation, GraphqlTypes.AddGroupMembershipMutationVariables>;
export const CreateBulkArenaAccessDocument = gql`
    mutation CreateBulkArenaAccess($input: CreateBulkArenaAccessInput!) {
  createBulkArenaAccess(input: $input) {
    __typename
    ... on CreateBulkArenaAccessResponse {
      access {
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreateBulkArenaAccessMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateBulkArenaAccessMutation, GraphqlTypes.CreateBulkArenaAccessMutationVariables>;

/**
 * __useCreateBulkArenaAccessMutation__
 *
 * To run a mutation, you first call `useCreateBulkArenaAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkArenaAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkArenaAccessMutation, { data, loading, error }] = useCreateBulkArenaAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkArenaAccessMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateBulkArenaAccessMutation, GraphqlTypes.CreateBulkArenaAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateBulkArenaAccessMutation, GraphqlTypes.CreateBulkArenaAccessMutationVariables>(CreateBulkArenaAccessDocument, options);
      }
export type CreateBulkArenaAccessMutationHookResult = ReturnType<typeof useCreateBulkArenaAccessMutation>;
export type CreateBulkArenaAccessMutationResult = Apollo.MutationResult<GraphqlTypes.CreateBulkArenaAccessMutation>;
export type CreateBulkArenaAccessMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateBulkArenaAccessMutation, GraphqlTypes.CreateBulkArenaAccessMutationVariables>;
export const EndBulkArenaAccessDocument = gql`
    mutation EndBulkArenaAccess($input: EndBulkArenaAccessInput!) {
  endBulkArenaAccess(input: $input) {
    __typename
    ... on EndBulkArenaAccessResponse {
      access {
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type EndBulkArenaAccessMutationFn = Apollo.MutationFunction<GraphqlTypes.EndBulkArenaAccessMutation, GraphqlTypes.EndBulkArenaAccessMutationVariables>;

/**
 * __useEndBulkArenaAccessMutation__
 *
 * To run a mutation, you first call `useEndBulkArenaAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndBulkArenaAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endBulkArenaAccessMutation, { data, loading, error }] = useEndBulkArenaAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndBulkArenaAccessMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EndBulkArenaAccessMutation, GraphqlTypes.EndBulkArenaAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EndBulkArenaAccessMutation, GraphqlTypes.EndBulkArenaAccessMutationVariables>(EndBulkArenaAccessDocument, options);
      }
export type EndBulkArenaAccessMutationHookResult = ReturnType<typeof useEndBulkArenaAccessMutation>;
export type EndBulkArenaAccessMutationResult = Apollo.MutationResult<GraphqlTypes.EndBulkArenaAccessMutation>;
export type EndBulkArenaAccessMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EndBulkArenaAccessMutation, GraphqlTypes.EndBulkArenaAccessMutationVariables>;
export const RemoveGroupMembershipDocument = gql`
    mutation RemoveGroupMembership($input: RemoveGroupMembershipInput!) {
  removeGroupMembership(input: $input) {
    __typename
    ... on MutationErrorResponse {
      errorCode
      message
    }
    ... on RemoveGroupMembershipResponse {
      groupMembershipsRemovedCount
      orphanedUsers
    }
  }
}
    `;
export type RemoveGroupMembershipMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveGroupMembershipMutation, GraphqlTypes.RemoveGroupMembershipMutationVariables>;

/**
 * __useRemoveGroupMembershipMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMembershipMutation, { data, loading, error }] = useRemoveGroupMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveGroupMembershipMutation, GraphqlTypes.RemoveGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveGroupMembershipMutation, GraphqlTypes.RemoveGroupMembershipMutationVariables>(RemoveGroupMembershipDocument, options);
      }
export type RemoveGroupMembershipMutationHookResult = ReturnType<typeof useRemoveGroupMembershipMutation>;
export type RemoveGroupMembershipMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveGroupMembershipMutation>;
export type RemoveGroupMembershipMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveGroupMembershipMutation, GraphqlTypes.RemoveGroupMembershipMutationVariables>;
export const DeleteCanopyUserAndArenaAccessesDocument = gql`
    mutation DeleteCanopyUserAndArenaAccesses($input: DeleteCanopyUserAndArenaAccessesInput!) {
  deleteCanopyUserAndArenaAccesses(input: $input) {
    __typename
    ... on DeleteCanopyUserAndArenaAccessesResponse {
      arenaIds
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type DeleteCanopyUserAndArenaAccessesMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutation, GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutationVariables>;

/**
 * __useDeleteCanopyUserAndArenaAccessesMutation__
 *
 * To run a mutation, you first call `useDeleteCanopyUserAndArenaAccessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCanopyUserAndArenaAccessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCanopyUserAndArenaAccessesMutation, { data, loading, error }] = useDeleteCanopyUserAndArenaAccessesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCanopyUserAndArenaAccessesMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutation, GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutation, GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutationVariables>(DeleteCanopyUserAndArenaAccessesDocument, options);
      }
export type DeleteCanopyUserAndArenaAccessesMutationHookResult = ReturnType<typeof useDeleteCanopyUserAndArenaAccessesMutation>;
export type DeleteCanopyUserAndArenaAccessesMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutation>;
export type DeleteCanopyUserAndArenaAccessesMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutation, GraphqlTypes.DeleteCanopyUserAndArenaAccessesMutationVariables>;
export const ArenaAccessForUserDocument = gql`
    query ArenaAccessForUser($filters: ArenaAccessForUserInput!) {
  arenaAccessForUser(filters: $filters) {
    output {
      id
      arenaName
      arenaId
      arenaDomain
      roleGroupName
      active
      accessType
      endDate
      lastAccessTimestamp
      isBulkAccess
    }
  }
}
    `;

/**
 * __useArenaAccessForUserQuery__
 *
 * To run a query within a React component, call `useArenaAccessForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useArenaAccessForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArenaAccessForUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useArenaAccessForUserQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables> & ({ variables: GraphqlTypes.ArenaAccessForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>(ArenaAccessForUserDocument, options);
      }
export function useArenaAccessForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>(ArenaAccessForUserDocument, options);
        }
// @ts-ignore
export function useArenaAccessForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>;
export function useArenaAccessForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaAccessForUserQuery | undefined, GraphqlTypes.ArenaAccessForUserQueryVariables>;
export function useArenaAccessForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>(ArenaAccessForUserDocument, options);
        }
export type ArenaAccessForUserQueryHookResult = ReturnType<typeof useArenaAccessForUserQuery>;
export type ArenaAccessForUserLazyQueryHookResult = ReturnType<typeof useArenaAccessForUserLazyQuery>;
export type ArenaAccessForUserSuspenseQueryHookResult = ReturnType<typeof useArenaAccessForUserSuspenseQuery>;
export type ArenaAccessForUserQueryResult = Apollo.QueryResult<GraphqlTypes.ArenaAccessForUserQuery, GraphqlTypes.ArenaAccessForUserQueryVariables>;
export const ActiveArenaAccessesDocument = gql`
    query ActiveArenaAccesses($filters: ActiveArenaAccessInput!) {
  activeArenaAccesses(filters: $filters) {
    ... on ActiveArenaAccessOutput {
      activeArenas {
        name
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useActiveArenaAccessesQuery__
 *
 * To run a query within a React component, call `useActiveArenaAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveArenaAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveArenaAccessesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useActiveArenaAccessesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables> & ({ variables: GraphqlTypes.ActiveArenaAccessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>(ActiveArenaAccessesDocument, options);
      }
export function useActiveArenaAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>(ActiveArenaAccessesDocument, options);
        }
// @ts-ignore
export function useActiveArenaAccessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>;
export function useActiveArenaAccessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ActiveArenaAccessesQuery | undefined, GraphqlTypes.ActiveArenaAccessesQueryVariables>;
export function useActiveArenaAccessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>(ActiveArenaAccessesDocument, options);
        }
export type ActiveArenaAccessesQueryHookResult = ReturnType<typeof useActiveArenaAccessesQuery>;
export type ActiveArenaAccessesLazyQueryHookResult = ReturnType<typeof useActiveArenaAccessesLazyQuery>;
export type ActiveArenaAccessesSuspenseQueryHookResult = ReturnType<typeof useActiveArenaAccessesSuspenseQuery>;
export type ActiveArenaAccessesQueryResult = Apollo.QueryResult<GraphqlTypes.ActiveArenaAccessesQuery, GraphqlTypes.ActiveArenaAccessesQueryVariables>;
export const ExportArenaAccessDocument = gql`
    mutation ExportArenaAccess($input: ExportArenaAccessInput!) {
  exportArenaAccess(input: $input) {
    ... on ExportArenaAccessResponse {
      job {
        id
        jobType
        status
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type ExportArenaAccessMutationFn = Apollo.MutationFunction<GraphqlTypes.ExportArenaAccessMutation, GraphqlTypes.ExportArenaAccessMutationVariables>;

/**
 * __useExportArenaAccessMutation__
 *
 * To run a mutation, you first call `useExportArenaAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportArenaAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportArenaAccessMutation, { data, loading, error }] = useExportArenaAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportArenaAccessMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ExportArenaAccessMutation, GraphqlTypes.ExportArenaAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ExportArenaAccessMutation, GraphqlTypes.ExportArenaAccessMutationVariables>(ExportArenaAccessDocument, options);
      }
export type ExportArenaAccessMutationHookResult = ReturnType<typeof useExportArenaAccessMutation>;
export type ExportArenaAccessMutationResult = Apollo.MutationResult<GraphqlTypes.ExportArenaAccessMutation>;
export type ExportArenaAccessMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ExportArenaAccessMutation, GraphqlTypes.ExportArenaAccessMutationVariables>;
export const GetDownloadUrlDocument = gql`
    query GetDownloadUrl($asyncJobId: ID!) {
  arenaAccessExportFileUrl(input: {asyncJobId: $asyncJobId}) {
    url
  }
}
    `;

/**
 * __useGetDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadUrlQuery({
 *   variables: {
 *      asyncJobId: // value for 'asyncJobId'
 *   },
 * });
 */
export function useGetDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
      }
export function useGetDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>;
export function useGetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDownloadUrlQuery | undefined, GraphqlTypes.GetDownloadUrlQueryVariables>;
export function useGetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
        }
export type GetDownloadUrlQueryHookResult = ReturnType<typeof useGetDownloadUrlQuery>;
export type GetDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDownloadUrlLazyQuery>;
export type GetDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDownloadUrlSuspenseQuery>;
export type GetDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetDownloadUrlQuery, GraphqlTypes.GetDownloadUrlQueryVariables>;
export const ArenaAccessByUsersDocument = gql`
    query ArenaAccessByUsers($filters: ArenaAccessByUsersFilterInput!) {
  arenaAccessByUsers(filters: $filters) {
    ... on ArenaAccessByUsersOutput {
      users {
        fullName
        emailAddress
        globalUserId
        adminArenaUserId
        activeWorkspaces
        lastAccessTimestamp
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useArenaAccessByUsersQuery__
 *
 * To run a query within a React component, call `useArenaAccessByUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useArenaAccessByUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArenaAccessByUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useArenaAccessByUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables> & ({ variables: GraphqlTypes.ArenaAccessByUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>(ArenaAccessByUsersDocument, options);
      }
export function useArenaAccessByUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>(ArenaAccessByUsersDocument, options);
        }
// @ts-ignore
export function useArenaAccessByUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>;
export function useArenaAccessByUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaAccessByUsersQuery | undefined, GraphqlTypes.ArenaAccessByUsersQueryVariables>;
export function useArenaAccessByUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>(ArenaAccessByUsersDocument, options);
        }
export type ArenaAccessByUsersQueryHookResult = ReturnType<typeof useArenaAccessByUsersQuery>;
export type ArenaAccessByUsersLazyQueryHookResult = ReturnType<typeof useArenaAccessByUsersLazyQuery>;
export type ArenaAccessByUsersSuspenseQueryHookResult = ReturnType<typeof useArenaAccessByUsersSuspenseQuery>;
export type ArenaAccessByUsersQueryResult = Apollo.QueryResult<GraphqlTypes.ArenaAccessByUsersQuery, GraphqlTypes.ArenaAccessByUsersQueryVariables>;
export const GetWorkspaceRolesDocument = gql`
    query GetWorkspaceRoles {
  arenaAccessByRoleGroups {
    ... on ArenaAccessByRoleGroupsOutput {
      countByRoles {
        roleGroupName
        count
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;

/**
 * __useGetWorkspaceRolesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspaceRolesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>(GetWorkspaceRolesDocument, options);
      }
export function useGetWorkspaceRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>(GetWorkspaceRolesDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>;
export function useGetWorkspaceRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkspaceRolesQuery | undefined, GraphqlTypes.GetWorkspaceRolesQueryVariables>;
export function useGetWorkspaceRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>(GetWorkspaceRolesDocument, options);
        }
export type GetWorkspaceRolesQueryHookResult = ReturnType<typeof useGetWorkspaceRolesQuery>;
export type GetWorkspaceRolesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceRolesLazyQuery>;
export type GetWorkspaceRolesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceRolesSuspenseQuery>;
export type GetWorkspaceRolesQueryResult = Apollo.QueryResult<GraphqlTypes.GetWorkspaceRolesQuery, GraphqlTypes.GetWorkspaceRolesQueryVariables>;
export const ArenaAccessForArenaDocument = gql`
    query ArenaAccessForArena($filters: ArenaAccessForArenaInput!) {
  arenaAccessForArena(filters: $filters) {
    output {
      id
      arenaName
      arenaId
      arenaDomain
      globalUserId
      adminArenaUserId
      userName
      userEmail
      roleGroupName
      accessType
      startDate
      endDate
      lastAccessTimestamp
      active
    }
  }
}
    `;

/**
 * __useArenaAccessForArenaQuery__
 *
 * To run a query within a React component, call `useArenaAccessForArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useArenaAccessForArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArenaAccessForArenaQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useArenaAccessForArenaQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables> & ({ variables: GraphqlTypes.ArenaAccessForArenaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>(ArenaAccessForArenaDocument, options);
      }
export function useArenaAccessForArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>(ArenaAccessForArenaDocument, options);
        }
// @ts-ignore
export function useArenaAccessForArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>;
export function useArenaAccessForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaAccessForArenaQuery | undefined, GraphqlTypes.ArenaAccessForArenaQueryVariables>;
export function useArenaAccessForArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>(ArenaAccessForArenaDocument, options);
        }
export type ArenaAccessForArenaQueryHookResult = ReturnType<typeof useArenaAccessForArenaQuery>;
export type ArenaAccessForArenaLazyQueryHookResult = ReturnType<typeof useArenaAccessForArenaLazyQuery>;
export type ArenaAccessForArenaSuspenseQueryHookResult = ReturnType<typeof useArenaAccessForArenaSuspenseQuery>;
export type ArenaAccessForArenaQueryResult = Apollo.QueryResult<GraphqlTypes.ArenaAccessForArenaQuery, GraphqlTypes.ArenaAccessForArenaQueryVariables>;
export const CreateArenaAccessDocument = gql`
    mutation CreateArenaAccess($input: CreateArenaAccessInput!) {
  createArenaAccess(input: $input) {
    __typename
    ... on CreateArenaAccessResponse {
      accesses {
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreateArenaAccessMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateArenaAccessMutation, GraphqlTypes.CreateArenaAccessMutationVariables>;

/**
 * __useCreateArenaAccessMutation__
 *
 * To run a mutation, you first call `useCreateArenaAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArenaAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArenaAccessMutation, { data, loading, error }] = useCreateArenaAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArenaAccessMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateArenaAccessMutation, GraphqlTypes.CreateArenaAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateArenaAccessMutation, GraphqlTypes.CreateArenaAccessMutationVariables>(CreateArenaAccessDocument, options);
      }
export type CreateArenaAccessMutationHookResult = ReturnType<typeof useCreateArenaAccessMutation>;
export type CreateArenaAccessMutationResult = Apollo.MutationResult<GraphqlTypes.CreateArenaAccessMutation>;
export type CreateArenaAccessMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateArenaAccessMutation, GraphqlTypes.CreateArenaAccessMutationVariables>;
export const UsersWithArenaAccessDocument = gql`
    query UsersWithArenaAccess($filters: UsersWithArenaAccessInput!) {
  usersWithArenaAccess(filters: $filters) {
    users {
      id
      emailAddress
      firstName
      lastName
      fullName
    }
  }
}
    `;

/**
 * __useUsersWithArenaAccessQuery__
 *
 * To run a query within a React component, call `useUsersWithArenaAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithArenaAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithArenaAccessQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUsersWithArenaAccessQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables> & ({ variables: GraphqlTypes.UsersWithArenaAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>(UsersWithArenaAccessDocument, options);
      }
export function useUsersWithArenaAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>(UsersWithArenaAccessDocument, options);
        }
// @ts-ignore
export function useUsersWithArenaAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>;
export function useUsersWithArenaAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.UsersWithArenaAccessQuery | undefined, GraphqlTypes.UsersWithArenaAccessQueryVariables>;
export function useUsersWithArenaAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>(UsersWithArenaAccessDocument, options);
        }
export type UsersWithArenaAccessQueryHookResult = ReturnType<typeof useUsersWithArenaAccessQuery>;
export type UsersWithArenaAccessLazyQueryHookResult = ReturnType<typeof useUsersWithArenaAccessLazyQuery>;
export type UsersWithArenaAccessSuspenseQueryHookResult = ReturnType<typeof useUsersWithArenaAccessSuspenseQuery>;
export type UsersWithArenaAccessQueryResult = Apollo.QueryResult<GraphqlTypes.UsersWithArenaAccessQuery, GraphqlTypes.UsersWithArenaAccessQueryVariables>;
export const EndArenaAccessDocument = gql`
    mutation EndArenaAccess($input: EndArenaAccessInput!) {
  endArenaAccess(input: $input) {
    __typename
    ... on EndArenaAccessResponse {
      accesses {
        id
      }
    }
    ... on MutationErrorResponse {
      message
      errorCode
    }
  }
}
    `;
export type EndArenaAccessMutationFn = Apollo.MutationFunction<GraphqlTypes.EndArenaAccessMutation, GraphqlTypes.EndArenaAccessMutationVariables>;

/**
 * __useEndArenaAccessMutation__
 *
 * To run a mutation, you first call `useEndArenaAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndArenaAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endArenaAccessMutation, { data, loading, error }] = useEndArenaAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndArenaAccessMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.EndArenaAccessMutation, GraphqlTypes.EndArenaAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.EndArenaAccessMutation, GraphqlTypes.EndArenaAccessMutationVariables>(EndArenaAccessDocument, options);
      }
export type EndArenaAccessMutationHookResult = ReturnType<typeof useEndArenaAccessMutation>;
export type EndArenaAccessMutationResult = Apollo.MutationResult<GraphqlTypes.EndArenaAccessMutation>;
export type EndArenaAccessMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.EndArenaAccessMutation, GraphqlTypes.EndArenaAccessMutationVariables>;
export const AssignDdqProdOpsTaskDocument = gql`
    mutation AssignDdqProdOpsTask($taskId: ID!, $assigneeId: ID) {
  assignDdqProdOpsTask(taskId: $taskId, assigneeId: $assigneeId) {
    id
    state
    blocked
    assignee {
      id
      fullName
    }
  }
}
    `;
export type AssignDdqProdOpsTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.AssignDdqProdOpsTaskMutation, GraphqlTypes.AssignDdqProdOpsTaskMutationVariables>;

/**
 * __useAssignDdqProdOpsTaskMutation__
 *
 * To run a mutation, you first call `useAssignDdqProdOpsTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDdqProdOpsTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDdqProdOpsTaskMutation, { data, loading, error }] = useAssignDdqProdOpsTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignDdqProdOpsTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AssignDdqProdOpsTaskMutation, GraphqlTypes.AssignDdqProdOpsTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AssignDdqProdOpsTaskMutation, GraphqlTypes.AssignDdqProdOpsTaskMutationVariables>(AssignDdqProdOpsTaskDocument, options);
      }
export type AssignDdqProdOpsTaskMutationHookResult = ReturnType<typeof useAssignDdqProdOpsTaskMutation>;
export type AssignDdqProdOpsTaskMutationResult = Apollo.MutationResult<GraphqlTypes.AssignDdqProdOpsTaskMutation>;
export type AssignDdqProdOpsTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AssignDdqProdOpsTaskMutation, GraphqlTypes.AssignDdqProdOpsTaskMutationVariables>;
export const StartDdqProdOpsTaskDocument = gql`
    mutation StartDdqProdOpsTask($taskId: ID!) {
  startDdqProdOpsTask(taskId: $taskId) {
    id
    state
    blocked
    currentStep
    assignee {
      id
      fullName
    }
  }
}
    `;
export type StartDdqProdOpsTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.StartDdqProdOpsTaskMutation, GraphqlTypes.StartDdqProdOpsTaskMutationVariables>;

/**
 * __useStartDdqProdOpsTaskMutation__
 *
 * To run a mutation, you first call `useStartDdqProdOpsTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDdqProdOpsTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDdqProdOpsTaskMutation, { data, loading, error }] = useStartDdqProdOpsTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartDdqProdOpsTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartDdqProdOpsTaskMutation, GraphqlTypes.StartDdqProdOpsTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartDdqProdOpsTaskMutation, GraphqlTypes.StartDdqProdOpsTaskMutationVariables>(StartDdqProdOpsTaskDocument, options);
      }
export type StartDdqProdOpsTaskMutationHookResult = ReturnType<typeof useStartDdqProdOpsTaskMutation>;
export type StartDdqProdOpsTaskMutationResult = Apollo.MutationResult<GraphqlTypes.StartDdqProdOpsTaskMutation>;
export type StartDdqProdOpsTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartDdqProdOpsTaskMutation, GraphqlTypes.StartDdqProdOpsTaskMutationVariables>;
export const HoldDdqProdOpsWorkflowDocument = gql`
    mutation HoldDdqProdOpsWorkflow($workflowId: ID!, $comment: String!) {
  holdDdqProdOpsWorkflow(workflowId: $workflowId, comment: $comment) {
    id
    status
    dueAt
    onHoldAt
  }
}
    `;
export type HoldDdqProdOpsWorkflowMutationFn = Apollo.MutationFunction<GraphqlTypes.HoldDdqProdOpsWorkflowMutation, GraphqlTypes.HoldDdqProdOpsWorkflowMutationVariables>;

/**
 * __useHoldDdqProdOpsWorkflowMutation__
 *
 * To run a mutation, you first call `useHoldDdqProdOpsWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldDdqProdOpsWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdDdqProdOpsWorkflowMutation, { data, loading, error }] = useHoldDdqProdOpsWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useHoldDdqProdOpsWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.HoldDdqProdOpsWorkflowMutation, GraphqlTypes.HoldDdqProdOpsWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.HoldDdqProdOpsWorkflowMutation, GraphqlTypes.HoldDdqProdOpsWorkflowMutationVariables>(HoldDdqProdOpsWorkflowDocument, options);
      }
export type HoldDdqProdOpsWorkflowMutationHookResult = ReturnType<typeof useHoldDdqProdOpsWorkflowMutation>;
export type HoldDdqProdOpsWorkflowMutationResult = Apollo.MutationResult<GraphqlTypes.HoldDdqProdOpsWorkflowMutation>;
export type HoldDdqProdOpsWorkflowMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.HoldDdqProdOpsWorkflowMutation, GraphqlTypes.HoldDdqProdOpsWorkflowMutationVariables>;
export const RestartDdqProdOpsWorkflowDocument = gql`
    mutation RestartDdqProdOpsWorkflow($workflowId: ID!) {
  restartDdqProdOpsWorkflow(workflowId: $workflowId) {
    id
    status
    dueAt
    onHoldAt
  }
}
    `;
export type RestartDdqProdOpsWorkflowMutationFn = Apollo.MutationFunction<GraphqlTypes.RestartDdqProdOpsWorkflowMutation, GraphqlTypes.RestartDdqProdOpsWorkflowMutationVariables>;

/**
 * __useRestartDdqProdOpsWorkflowMutation__
 *
 * To run a mutation, you first call `useRestartDdqProdOpsWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartDdqProdOpsWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartDdqProdOpsWorkflowMutation, { data, loading, error }] = useRestartDdqProdOpsWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useRestartDdqProdOpsWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RestartDdqProdOpsWorkflowMutation, GraphqlTypes.RestartDdqProdOpsWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RestartDdqProdOpsWorkflowMutation, GraphqlTypes.RestartDdqProdOpsWorkflowMutationVariables>(RestartDdqProdOpsWorkflowDocument, options);
      }
export type RestartDdqProdOpsWorkflowMutationHookResult = ReturnType<typeof useRestartDdqProdOpsWorkflowMutation>;
export type RestartDdqProdOpsWorkflowMutationResult = Apollo.MutationResult<GraphqlTypes.RestartDdqProdOpsWorkflowMutation>;
export type RestartDdqProdOpsWorkflowMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RestartDdqProdOpsWorkflowMutation, GraphqlTypes.RestartDdqProdOpsWorkflowMutationVariables>;
export const CancelDdqProdOpsWorkflowDocument = gql`
    mutation CancelDdqProdOpsWorkflow($workflowId: ID!) {
  cancelDdqProdOpsWorkflow(workflowId: $workflowId) {
    id
    status
    dueAt
    onHoldAt
  }
}
    `;
export type CancelDdqProdOpsWorkflowMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelDdqProdOpsWorkflowMutation, GraphqlTypes.CancelDdqProdOpsWorkflowMutationVariables>;

/**
 * __useCancelDdqProdOpsWorkflowMutation__
 *
 * To run a mutation, you first call `useCancelDdqProdOpsWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDdqProdOpsWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDdqProdOpsWorkflowMutation, { data, loading, error }] = useCancelDdqProdOpsWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useCancelDdqProdOpsWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelDdqProdOpsWorkflowMutation, GraphqlTypes.CancelDdqProdOpsWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelDdqProdOpsWorkflowMutation, GraphqlTypes.CancelDdqProdOpsWorkflowMutationVariables>(CancelDdqProdOpsWorkflowDocument, options);
      }
export type CancelDdqProdOpsWorkflowMutationHookResult = ReturnType<typeof useCancelDdqProdOpsWorkflowMutation>;
export type CancelDdqProdOpsWorkflowMutationResult = Apollo.MutationResult<GraphqlTypes.CancelDdqProdOpsWorkflowMutation>;
export type CancelDdqProdOpsWorkflowMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelDdqProdOpsWorkflowMutation, GraphqlTypes.CancelDdqProdOpsWorkflowMutationVariables>;
export const AddDdqProdOpsWorkflowCommentDocument = gql`
    mutation AddDdqProdOpsWorkflowComment($workflowId: ID!, $body: String!) {
  addDdqProdOpsWorkflowComment(workflowId: $workflowId, body: $body) {
    id
    eventType
    actor {
      id
      fullName
    }
    namedUsers {
      id
      fullName
    }
    eventAt
    detail
  }
}
    `;
export type AddDdqProdOpsWorkflowCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.AddDdqProdOpsWorkflowCommentMutation, GraphqlTypes.AddDdqProdOpsWorkflowCommentMutationVariables>;

/**
 * __useAddDdqProdOpsWorkflowCommentMutation__
 *
 * To run a mutation, you first call `useAddDdqProdOpsWorkflowCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDdqProdOpsWorkflowCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDdqProdOpsWorkflowCommentMutation, { data, loading, error }] = useAddDdqProdOpsWorkflowCommentMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useAddDdqProdOpsWorkflowCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddDdqProdOpsWorkflowCommentMutation, GraphqlTypes.AddDdqProdOpsWorkflowCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddDdqProdOpsWorkflowCommentMutation, GraphqlTypes.AddDdqProdOpsWorkflowCommentMutationVariables>(AddDdqProdOpsWorkflowCommentDocument, options);
      }
export type AddDdqProdOpsWorkflowCommentMutationHookResult = ReturnType<typeof useAddDdqProdOpsWorkflowCommentMutation>;
export type AddDdqProdOpsWorkflowCommentMutationResult = Apollo.MutationResult<GraphqlTypes.AddDdqProdOpsWorkflowCommentMutation>;
export type AddDdqProdOpsWorkflowCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddDdqProdOpsWorkflowCommentMutation, GraphqlTypes.AddDdqProdOpsWorkflowCommentMutationVariables>;
export const SetDdqProdOpsRequestOwnersDocument = gql`
    mutation SetDdqProdOpsRequestOwners($workflowId: ID!, $ownerIds: [ID!]!) {
  setDdqProdOpsRequestOwners(workflowId: $workflowId, ownerIds: $ownerIds) {
    id
    owners {
      id
      fullName
    }
  }
}
    `;
export type SetDdqProdOpsRequestOwnersMutationFn = Apollo.MutationFunction<GraphqlTypes.SetDdqProdOpsRequestOwnersMutation, GraphqlTypes.SetDdqProdOpsRequestOwnersMutationVariables>;

/**
 * __useSetDdqProdOpsRequestOwnersMutation__
 *
 * To run a mutation, you first call `useSetDdqProdOpsRequestOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDdqProdOpsRequestOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDdqProdOpsRequestOwnersMutation, { data, loading, error }] = useSetDdqProdOpsRequestOwnersMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      ownerIds: // value for 'ownerIds'
 *   },
 * });
 */
export function useSetDdqProdOpsRequestOwnersMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetDdqProdOpsRequestOwnersMutation, GraphqlTypes.SetDdqProdOpsRequestOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetDdqProdOpsRequestOwnersMutation, GraphqlTypes.SetDdqProdOpsRequestOwnersMutationVariables>(SetDdqProdOpsRequestOwnersDocument, options);
      }
export type SetDdqProdOpsRequestOwnersMutationHookResult = ReturnType<typeof useSetDdqProdOpsRequestOwnersMutation>;
export type SetDdqProdOpsRequestOwnersMutationResult = Apollo.MutationResult<GraphqlTypes.SetDdqProdOpsRequestOwnersMutation>;
export type SetDdqProdOpsRequestOwnersMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetDdqProdOpsRequestOwnersMutation, GraphqlTypes.SetDdqProdOpsRequestOwnersMutationVariables>;
export const SetDdqProdOpsRequestDueDateDocument = gql`
    mutation SetDdqProdOpsRequestDueDate($workflowId: ID!, $dueAt: DateTime!) {
  setDdqProdOpsRequestDueDate(workflowId: $workflowId, dueAt: $dueAt) {
    id
    dueAt
  }
}
    `;
export type SetDdqProdOpsRequestDueDateMutationFn = Apollo.MutationFunction<GraphqlTypes.SetDdqProdOpsRequestDueDateMutation, GraphqlTypes.SetDdqProdOpsRequestDueDateMutationVariables>;

/**
 * __useSetDdqProdOpsRequestDueDateMutation__
 *
 * To run a mutation, you first call `useSetDdqProdOpsRequestDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDdqProdOpsRequestDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDdqProdOpsRequestDueDateMutation, { data, loading, error }] = useSetDdqProdOpsRequestDueDateMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      dueAt: // value for 'dueAt'
 *   },
 * });
 */
export function useSetDdqProdOpsRequestDueDateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetDdqProdOpsRequestDueDateMutation, GraphqlTypes.SetDdqProdOpsRequestDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetDdqProdOpsRequestDueDateMutation, GraphqlTypes.SetDdqProdOpsRequestDueDateMutationVariables>(SetDdqProdOpsRequestDueDateDocument, options);
      }
export type SetDdqProdOpsRequestDueDateMutationHookResult = ReturnType<typeof useSetDdqProdOpsRequestDueDateMutation>;
export type SetDdqProdOpsRequestDueDateMutationResult = Apollo.MutationResult<GraphqlTypes.SetDdqProdOpsRequestDueDateMutation>;
export type SetDdqProdOpsRequestDueDateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetDdqProdOpsRequestDueDateMutation, GraphqlTypes.SetDdqProdOpsRequestDueDateMutationVariables>;
export const SetDdqProdOpsRequestSubmitByDateDocument = gql`
    mutation SetDdqProdOpsRequestSubmitByDate($workflowId: ID!, $dueDate: Date!) {
  setDdqProdOpsRequestSubmitByDate(workflowId: $workflowId, dueDate: $dueDate) {
    id
    submitByDate
  }
}
    `;
export type SetDdqProdOpsRequestSubmitByDateMutationFn = Apollo.MutationFunction<GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutation, GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutationVariables>;

/**
 * __useSetDdqProdOpsRequestSubmitByDateMutation__
 *
 * To run a mutation, you first call `useSetDdqProdOpsRequestSubmitByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDdqProdOpsRequestSubmitByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDdqProdOpsRequestSubmitByDateMutation, { data, loading, error }] = useSetDdqProdOpsRequestSubmitByDateMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useSetDdqProdOpsRequestSubmitByDateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutation, GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutation, GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutationVariables>(SetDdqProdOpsRequestSubmitByDateDocument, options);
      }
export type SetDdqProdOpsRequestSubmitByDateMutationHookResult = ReturnType<typeof useSetDdqProdOpsRequestSubmitByDateMutation>;
export type SetDdqProdOpsRequestSubmitByDateMutationResult = Apollo.MutationResult<GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutation>;
export type SetDdqProdOpsRequestSubmitByDateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutation, GraphqlTypes.SetDdqProdOpsRequestSubmitByDateMutationVariables>;
export const GetHistoricalDdqUploadDownloadUrlDocument = gql`
    query GetHistoricalDdqUploadDownloadUrl($arenaId: Int!, $uploadId: ID!) {
  historicalDdqUploadDownloadUrl(arenaId: $arenaId, uploadId: $uploadId)
}
    `;

/**
 * __useGetHistoricalDdqUploadDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetHistoricalDdqUploadDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalDdqUploadDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalDdqUploadDownloadUrlQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useGetHistoricalDdqUploadDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>(GetHistoricalDdqUploadDownloadUrlDocument, options);
      }
export function useGetHistoricalDdqUploadDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>(GetHistoricalDdqUploadDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetHistoricalDdqUploadDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>;
export function useGetHistoricalDdqUploadDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery | undefined, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>;
export function useGetHistoricalDdqUploadDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>(GetHistoricalDdqUploadDownloadUrlDocument, options);
        }
export type GetHistoricalDdqUploadDownloadUrlQueryHookResult = ReturnType<typeof useGetHistoricalDdqUploadDownloadUrlQuery>;
export type GetHistoricalDdqUploadDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetHistoricalDdqUploadDownloadUrlLazyQuery>;
export type GetHistoricalDdqUploadDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetHistoricalDdqUploadDownloadUrlSuspenseQuery>;
export type GetHistoricalDdqUploadDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQuery, GraphqlTypes.GetHistoricalDdqUploadDownloadUrlQueryVariables>;
export const GetAssignableDdqProdOpsOperatorsDocument = gql`
    query GetAssignableDdqProdOpsOperators($search: String) {
  assignableDdqProdOpsOperators(search: $search) {
    id
    fullName
  }
}
    `;

/**
 * __useGetAssignableDdqProdOpsOperatorsQuery__
 *
 * To run a query within a React component, call `useGetAssignableDdqProdOpsOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignableDdqProdOpsOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignableDdqProdOpsOperatorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAssignableDdqProdOpsOperatorsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>(GetAssignableDdqProdOpsOperatorsDocument, options);
      }
export function useGetAssignableDdqProdOpsOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>(GetAssignableDdqProdOpsOperatorsDocument, options);
        }
// @ts-ignore
export function useGetAssignableDdqProdOpsOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>;
export function useGetAssignableDdqProdOpsOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery | undefined, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>;
export function useGetAssignableDdqProdOpsOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>(GetAssignableDdqProdOpsOperatorsDocument, options);
        }
export type GetAssignableDdqProdOpsOperatorsQueryHookResult = ReturnType<typeof useGetAssignableDdqProdOpsOperatorsQuery>;
export type GetAssignableDdqProdOpsOperatorsLazyQueryHookResult = ReturnType<typeof useGetAssignableDdqProdOpsOperatorsLazyQuery>;
export type GetAssignableDdqProdOpsOperatorsSuspenseQueryHookResult = ReturnType<typeof useGetAssignableDdqProdOpsOperatorsSuspenseQuery>;
export type GetAssignableDdqProdOpsOperatorsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAssignableDdqProdOpsOperatorsQuery, GraphqlTypes.GetAssignableDdqProdOpsOperatorsQueryVariables>;
export const GetDdqProdOpsWorkflowLogDocument = gql`
    query GetDdqProdOpsWorkflowLog($workflowId: ID!, $limit: Int, $offset: Int!) {
  ddqProdOpsWorkflowLog(workflowId: $workflowId, limit: $limit, offset: $offset) {
    entries {
      id
      eventType
      actor {
        id
        fullName
      }
      namedUsers {
        id
        fullName
      }
      eventAt
      detail
    }
    totalCount
  }
}
    `;

/**
 * __useGetDdqProdOpsWorkflowLogQuery__
 *
 * To run a query within a React component, call `useGetDdqProdOpsWorkflowLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqProdOpsWorkflowLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqProdOpsWorkflowLogQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDdqProdOpsWorkflowLogQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables> & ({ variables: GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>(GetDdqProdOpsWorkflowLogDocument, options);
      }
export function useGetDdqProdOpsWorkflowLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>(GetDdqProdOpsWorkflowLogDocument, options);
        }
// @ts-ignore
export function useGetDdqProdOpsWorkflowLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>;
export function useGetDdqProdOpsWorkflowLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery | undefined, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>;
export function useGetDdqProdOpsWorkflowLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>(GetDdqProdOpsWorkflowLogDocument, options);
        }
export type GetDdqProdOpsWorkflowLogQueryHookResult = ReturnType<typeof useGetDdqProdOpsWorkflowLogQuery>;
export type GetDdqProdOpsWorkflowLogLazyQueryHookResult = ReturnType<typeof useGetDdqProdOpsWorkflowLogLazyQuery>;
export type GetDdqProdOpsWorkflowLogSuspenseQueryHookResult = ReturnType<typeof useGetDdqProdOpsWorkflowLogSuspenseQuery>;
export type GetDdqProdOpsWorkflowLogQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqProdOpsWorkflowLogQuery, GraphqlTypes.GetDdqProdOpsWorkflowLogQueryVariables>;
export const GetDdqQueueSummaryCountsDocument = gql`
    query GetDdqQueueSummaryCounts($defaultStatuses: [DdqProdOpsWorkflowStatus!]) {
  ddqRequestCount: ddqProdOpsQueue(
    limit: 0
    workflowTypes: [DDQ_REQUEST]
    statuses: $defaultStatuses
  ) {
    totalCount
  }
  originalFormatCount: ddqProdOpsQueue(
    limit: 0
    workflowTypes: [ORIGINAL_FORMAT]
    statuses: $defaultStatuses
  ) {
    totalCount
  }
  backfillDdqCount: ddqProdOpsQueue(
    limit: 0
    workflowTypes: [BACKFILL_DDQ]
    statuses: $defaultStatuses
  ) {
    totalCount
  }
  notStartedCount: ddqProdOpsQueue(limit: 0, statuses: [pending]) {
    totalCount
  }
  onHoldCount: ddqProdOpsQueue(limit: 0, statuses: [on_hold]) {
    totalCount
  }
  dueBucket: ddqProdOpsQueue(
    limit: 100
    statuses: [pending, in_progress, in_review]
  ) {
    totalCount
    items {
      id
      dueAt
    }
  }
}
    `;

/**
 * __useGetDdqQueueSummaryCountsQuery__
 *
 * To run a query within a React component, call `useGetDdqQueueSummaryCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqQueueSummaryCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqQueueSummaryCountsQuery({
 *   variables: {
 *      defaultStatuses: // value for 'defaultStatuses'
 *   },
 * });
 */
export function useGetDdqQueueSummaryCountsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>(GetDdqQueueSummaryCountsDocument, options);
      }
export function useGetDdqQueueSummaryCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>(GetDdqQueueSummaryCountsDocument, options);
        }
// @ts-ignore
export function useGetDdqQueueSummaryCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>;
export function useGetDdqQueueSummaryCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqQueueSummaryCountsQuery | undefined, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>;
export function useGetDdqQueueSummaryCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>(GetDdqQueueSummaryCountsDocument, options);
        }
export type GetDdqQueueSummaryCountsQueryHookResult = ReturnType<typeof useGetDdqQueueSummaryCountsQuery>;
export type GetDdqQueueSummaryCountsLazyQueryHookResult = ReturnType<typeof useGetDdqQueueSummaryCountsLazyQuery>;
export type GetDdqQueueSummaryCountsSuspenseQueryHookResult = ReturnType<typeof useGetDdqQueueSummaryCountsSuspenseQuery>;
export type GetDdqQueueSummaryCountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqQueueSummaryCountsQuery, GraphqlTypes.GetDdqQueueSummaryCountsQueryVariables>;
export const GetDdqProdOpsQueueDocument = gql`
    query GetDdqProdOpsQueue($limit: Int, $offset: Int!, $search: String, $workflowTypes: [DdqProdOpsWorkflowType!], $statuses: [DdqProdOpsWorkflowStatus!], $assigneeId: ID, $sortBy: DdqProdOpsQueueSortField! = DUE_AT, $sortOrder: DdqProdOpsQueueSortOrder! = ASC) {
  ddqProdOpsQueue(
    limit: $limit
    offset: $offset
    search: $search
    workflowTypes: $workflowTypes
    statuses: $statuses
    assigneeId: $assigneeId
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    totalCount
    items {
      id
      arena {
        id
        name
      }
      workflowType
      status
      title
      lpName
      dueAt
      submitByDate
      originalSubmissionDate
      onHoldAt
      targetId
      ddqId
      createdAt
      sourceFileIsPdf
      extractionStatus
      extractionError
      owners {
        id
        fullName
      }
      requestedBy {
        id
        fullName
        emailAddress
      }
      additionalNotes
      originalFileDocumentVersionId
      originalFileContentType
      ddqResponseId
      requestedFormat
      completedResponseDocumentVersionId
      offerings {
        id
        name
      }
      tasks {
        id
        position
        kind
        state
        blocked
        currentStep
        steps {
          position
          slug
          state
        }
        viewerIsAssignee
        assignee {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetDdqProdOpsQueueQuery__
 *
 * To run a query within a React component, call `useGetDdqProdOpsQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqProdOpsQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqProdOpsQueueQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      workflowTypes: // value for 'workflowTypes'
 *      statuses: // value for 'statuses'
 *      assigneeId: // value for 'assigneeId'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetDdqProdOpsQueueQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables> & ({ variables: GraphqlTypes.GetDdqProdOpsQueueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>(GetDdqProdOpsQueueDocument, options);
      }
export function useGetDdqProdOpsQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>(GetDdqProdOpsQueueDocument, options);
        }
// @ts-ignore
export function useGetDdqProdOpsQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>;
export function useGetDdqProdOpsQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqProdOpsQueueQuery | undefined, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>;
export function useGetDdqProdOpsQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>(GetDdqProdOpsQueueDocument, options);
        }
export type GetDdqProdOpsQueueQueryHookResult = ReturnType<typeof useGetDdqProdOpsQueueQuery>;
export type GetDdqProdOpsQueueLazyQueryHookResult = ReturnType<typeof useGetDdqProdOpsQueueLazyQuery>;
export type GetDdqProdOpsQueueSuspenseQueryHookResult = ReturnType<typeof useGetDdqProdOpsQueueSuspenseQuery>;
export type GetDdqProdOpsQueueQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqProdOpsQueueQuery, GraphqlTypes.GetDdqProdOpsQueueQueryVariables>;
export const UploadOriginalFormatFileDocument = gql`
    mutation UploadOriginalFormatFile($input: UploadOriginalFormatFileInput!) {
  uploadOriginalFormatFile(input: $input) {
    id
    completedResponseDocumentVersionId
  }
}
    `;
export type UploadOriginalFormatFileMutationFn = Apollo.MutationFunction<GraphqlTypes.UploadOriginalFormatFileMutation, GraphqlTypes.UploadOriginalFormatFileMutationVariables>;

/**
 * __useUploadOriginalFormatFileMutation__
 *
 * To run a mutation, you first call `useUploadOriginalFormatFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOriginalFormatFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOriginalFormatFileMutation, { data, loading, error }] = useUploadOriginalFormatFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadOriginalFormatFileMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UploadOriginalFormatFileMutation, GraphqlTypes.UploadOriginalFormatFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UploadOriginalFormatFileMutation, GraphqlTypes.UploadOriginalFormatFileMutationVariables>(UploadOriginalFormatFileDocument, options);
      }
export type UploadOriginalFormatFileMutationHookResult = ReturnType<typeof useUploadOriginalFormatFileMutation>;
export type UploadOriginalFormatFileMutationResult = Apollo.MutationResult<GraphqlTypes.UploadOriginalFormatFileMutation>;
export type UploadOriginalFormatFileMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UploadOriginalFormatFileMutation, GraphqlTypes.UploadOriginalFormatFileMutationVariables>;
export const AnswerDdqResponseQuestionsForProdOpsDocument = gql`
    mutation AnswerDdqResponseQuestionsForProdOps($arenaId: Int!, $input: AnswerDdqResponseQuestionsInput!) {
  answerDdqResponseQuestionsForProdOps(arenaId: $arenaId, input: $input) {
    id
    questionId
    value
    valueText
    source
    sources {
      id
      title
      snippet
      sourceType
      confidence
    }
  }
}
    `;
export type AnswerDdqResponseQuestionsForProdOpsMutationFn = Apollo.MutationFunction<GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutation, GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutationVariables>;

/**
 * __useAnswerDdqResponseQuestionsForProdOpsMutation__
 *
 * To run a mutation, you first call `useAnswerDdqResponseQuestionsForProdOpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerDdqResponseQuestionsForProdOpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerDdqResponseQuestionsForProdOpsMutation, { data, loading, error }] = useAnswerDdqResponseQuestionsForProdOpsMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerDdqResponseQuestionsForProdOpsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutation, GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutation, GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutationVariables>(AnswerDdqResponseQuestionsForProdOpsDocument, options);
      }
export type AnswerDdqResponseQuestionsForProdOpsMutationHookResult = ReturnType<typeof useAnswerDdqResponseQuestionsForProdOpsMutation>;
export type AnswerDdqResponseQuestionsForProdOpsMutationResult = Apollo.MutationResult<GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutation>;
export type AnswerDdqResponseQuestionsForProdOpsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutation, GraphqlTypes.AnswerDdqResponseQuestionsForProdOpsMutationVariables>;
export const GetDdqResponsesForProdOpsTaskDocument = gql`
    query GetDdqResponsesForProdOpsTask($arenaId: Int!, $ddqProdOpsTaskId: ID!) {
  ddqResponsesForProdOpsTask(
    arenaId: $arenaId
    ddqProdOpsTaskId: $ddqProdOpsTaskId
  ) {
    id
    offering {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDdqResponsesForProdOpsTaskQuery__
 *
 * To run a query within a React component, call `useGetDdqResponsesForProdOpsTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqResponsesForProdOpsTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqResponsesForProdOpsTaskQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      ddqProdOpsTaskId: // value for 'ddqProdOpsTaskId'
 *   },
 * });
 */
export function useGetDdqResponsesForProdOpsTaskQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables> & ({ variables: GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>(GetDdqResponsesForProdOpsTaskDocument, options);
      }
export function useGetDdqResponsesForProdOpsTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>(GetDdqResponsesForProdOpsTaskDocument, options);
        }
// @ts-ignore
export function useGetDdqResponsesForProdOpsTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>;
export function useGetDdqResponsesForProdOpsTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery | undefined, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>;
export function useGetDdqResponsesForProdOpsTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>(GetDdqResponsesForProdOpsTaskDocument, options);
        }
export type GetDdqResponsesForProdOpsTaskQueryHookResult = ReturnType<typeof useGetDdqResponsesForProdOpsTaskQuery>;
export type GetDdqResponsesForProdOpsTaskLazyQueryHookResult = ReturnType<typeof useGetDdqResponsesForProdOpsTaskLazyQuery>;
export type GetDdqResponsesForProdOpsTaskSuspenseQueryHookResult = ReturnType<typeof useGetDdqResponsesForProdOpsTaskSuspenseQuery>;
export type GetDdqResponsesForProdOpsTaskQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqResponsesForProdOpsTaskQuery, GraphqlTypes.GetDdqResponsesForProdOpsTaskQueryVariables>;
export const GetDdqResponseForProdOpsDocument = gql`
    query GetDdqResponseForProdOps($arenaId: Int!, $id: ID!, $filter: AnswerProvenanceFilter!) {
  ddqResponseForProdOps(arenaId: $arenaId, id: $id, filter: $filter) {
    id
    ddqTitle
    sections {
      id
      parentSectionId
      position
      title
    }
    questions {
      id
      sectionId
      position
      questionType
      questionText
      generationResultKind
      answer {
        id
        value
        valueText
        source
        sources {
          id
          title
          snippet
          sourceType
          confidence
        }
      }
    }
  }
}
    `;

/**
 * __useGetDdqResponseForProdOpsQuery__
 *
 * To run a query within a React component, call `useGetDdqResponseForProdOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqResponseForProdOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqResponseForProdOpsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDdqResponseForProdOpsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables> & ({ variables: GraphqlTypes.GetDdqResponseForProdOpsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>(GetDdqResponseForProdOpsDocument, options);
      }
export function useGetDdqResponseForProdOpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>(GetDdqResponseForProdOpsDocument, options);
        }
// @ts-ignore
export function useGetDdqResponseForProdOpsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>;
export function useGetDdqResponseForProdOpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqResponseForProdOpsQuery | undefined, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>;
export function useGetDdqResponseForProdOpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>(GetDdqResponseForProdOpsDocument, options);
        }
export type GetDdqResponseForProdOpsQueryHookResult = ReturnType<typeof useGetDdqResponseForProdOpsQuery>;
export type GetDdqResponseForProdOpsLazyQueryHookResult = ReturnType<typeof useGetDdqResponseForProdOpsLazyQuery>;
export type GetDdqResponseForProdOpsSuspenseQueryHookResult = ReturnType<typeof useGetDdqResponseForProdOpsSuspenseQuery>;
export type GetDdqResponseForProdOpsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqResponseForProdOpsQuery, GraphqlTypes.GetDdqResponseForProdOpsQueryVariables>;
export const GetDdqResponseProgressForProdOpsDocument = gql`
    query GetDdqResponseProgressForProdOps($arenaId: Int!, $id: ID!) {
  ddqResponseProgressForProdOps(arenaId: $arenaId, id: $id) {
    bankReusedQuestions
    generatedQuestions
    noResponseQuestions
  }
}
    `;

/**
 * __useGetDdqResponseProgressForProdOpsQuery__
 *
 * To run a query within a React component, call `useGetDdqResponseProgressForProdOpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqResponseProgressForProdOpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqResponseProgressForProdOpsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDdqResponseProgressForProdOpsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables> & ({ variables: GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>(GetDdqResponseProgressForProdOpsDocument, options);
      }
export function useGetDdqResponseProgressForProdOpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>(GetDdqResponseProgressForProdOpsDocument, options);
        }
// @ts-ignore
export function useGetDdqResponseProgressForProdOpsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>;
export function useGetDdqResponseProgressForProdOpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery | undefined, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>;
export function useGetDdqResponseProgressForProdOpsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>(GetDdqResponseProgressForProdOpsDocument, options);
        }
export type GetDdqResponseProgressForProdOpsQueryHookResult = ReturnType<typeof useGetDdqResponseProgressForProdOpsQuery>;
export type GetDdqResponseProgressForProdOpsLazyQueryHookResult = ReturnType<typeof useGetDdqResponseProgressForProdOpsLazyQuery>;
export type GetDdqResponseProgressForProdOpsSuspenseQueryHookResult = ReturnType<typeof useGetDdqResponseProgressForProdOpsSuspenseQuery>;
export type GetDdqResponseProgressForProdOpsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqResponseProgressForProdOpsQuery, GraphqlTypes.GetDdqResponseProgressForProdOpsQueryVariables>;
export const MarkDdqReadyForReviewDocument = gql`
    mutation MarkDdqReadyForReview($taskId: ID!, $checkerId: ID!) {
  markDdqReadyForReview(taskId: $taskId, checkerId: $checkerId) {
    id
    status
  }
}
    `;
export type MarkDdqReadyForReviewMutationFn = Apollo.MutationFunction<GraphqlTypes.MarkDdqReadyForReviewMutation, GraphqlTypes.MarkDdqReadyForReviewMutationVariables>;

/**
 * __useMarkDdqReadyForReviewMutation__
 *
 * To run a mutation, you first call `useMarkDdqReadyForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDdqReadyForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDdqReadyForReviewMutation, { data, loading, error }] = useMarkDdqReadyForReviewMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      checkerId: // value for 'checkerId'
 *   },
 * });
 */
export function useMarkDdqReadyForReviewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MarkDdqReadyForReviewMutation, GraphqlTypes.MarkDdqReadyForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MarkDdqReadyForReviewMutation, GraphqlTypes.MarkDdqReadyForReviewMutationVariables>(MarkDdqReadyForReviewDocument, options);
      }
export type MarkDdqReadyForReviewMutationHookResult = ReturnType<typeof useMarkDdqReadyForReviewMutation>;
export type MarkDdqReadyForReviewMutationResult = Apollo.MutationResult<GraphqlTypes.MarkDdqReadyForReviewMutation>;
export type MarkDdqReadyForReviewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MarkDdqReadyForReviewMutation, GraphqlTypes.MarkDdqReadyForReviewMutationVariables>;
export const ApproveDdqForGpDocument = gql`
    mutation ApproveDdqForGp($taskId: ID!) {
  approveDdqForGp(taskId: $taskId) {
    id
    status
  }
}
    `;
export type ApproveDdqForGpMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveDdqForGpMutation, GraphqlTypes.ApproveDdqForGpMutationVariables>;

/**
 * __useApproveDdqForGpMutation__
 *
 * To run a mutation, you first call `useApproveDdqForGpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDdqForGpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDdqForGpMutation, { data, loading, error }] = useApproveDdqForGpMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useApproveDdqForGpMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveDdqForGpMutation, GraphqlTypes.ApproveDdqForGpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveDdqForGpMutation, GraphqlTypes.ApproveDdqForGpMutationVariables>(ApproveDdqForGpDocument, options);
      }
export type ApproveDdqForGpMutationHookResult = ReturnType<typeof useApproveDdqForGpMutation>;
export type ApproveDdqForGpMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveDdqForGpMutation>;
export type ApproveDdqForGpMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveDdqForGpMutation, GraphqlTypes.ApproveDdqForGpMutationVariables>;
export const ReturnDdqForEditsDocument = gql`
    mutation ReturnDdqForEdits($taskId: ID!, $comment: String!) {
  returnDdqForEdits(taskId: $taskId, comment: $comment) {
    id
    status
  }
}
    `;
export type ReturnDdqForEditsMutationFn = Apollo.MutationFunction<GraphqlTypes.ReturnDdqForEditsMutation, GraphqlTypes.ReturnDdqForEditsMutationVariables>;

/**
 * __useReturnDdqForEditsMutation__
 *
 * To run a mutation, you first call `useReturnDdqForEditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnDdqForEditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnDdqForEditsMutation, { data, loading, error }] = useReturnDdqForEditsMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useReturnDdqForEditsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReturnDdqForEditsMutation, GraphqlTypes.ReturnDdqForEditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReturnDdqForEditsMutation, GraphqlTypes.ReturnDdqForEditsMutationVariables>(ReturnDdqForEditsDocument, options);
      }
export type ReturnDdqForEditsMutationHookResult = ReturnType<typeof useReturnDdqForEditsMutation>;
export type ReturnDdqForEditsMutationResult = Apollo.MutationResult<GraphqlTypes.ReturnDdqForEditsMutation>;
export type ReturnDdqForEditsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReturnDdqForEditsMutation, GraphqlTypes.ReturnDdqForEditsMutationVariables>;
export const CompleteBackfillDdqDocument = gql`
    mutation CompleteBackfillDdq($taskId: ID!) {
  completeBackfillDdq(taskId: $taskId) {
    id
    status
  }
}
    `;
export type CompleteBackfillDdqMutationFn = Apollo.MutationFunction<GraphqlTypes.CompleteBackfillDdqMutation, GraphqlTypes.CompleteBackfillDdqMutationVariables>;

/**
 * __useCompleteBackfillDdqMutation__
 *
 * To run a mutation, you first call `useCompleteBackfillDdqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBackfillDdqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBackfillDdqMutation, { data, loading, error }] = useCompleteBackfillDdqMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCompleteBackfillDdqMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CompleteBackfillDdqMutation, GraphqlTypes.CompleteBackfillDdqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CompleteBackfillDdqMutation, GraphqlTypes.CompleteBackfillDdqMutationVariables>(CompleteBackfillDdqDocument, options);
      }
export type CompleteBackfillDdqMutationHookResult = ReturnType<typeof useCompleteBackfillDdqMutation>;
export type CompleteBackfillDdqMutationResult = Apollo.MutationResult<GraphqlTypes.CompleteBackfillDdqMutation>;
export type CompleteBackfillDdqMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CompleteBackfillDdqMutation, GraphqlTypes.CompleteBackfillDdqMutationVariables>;
export const RunDdqGenerationDocument = gql`
    mutation RunDdqGeneration($input: RunDdqGenerationInput!) {
  runDdqGeneration(input: $input) {
    id
    status
    error
    model
    prompt
    knowledgeSource
    createdAt
  }
}
    `;
export type RunDdqGenerationMutationFn = Apollo.MutationFunction<GraphqlTypes.RunDdqGenerationMutation, GraphqlTypes.RunDdqGenerationMutationVariables>;

/**
 * __useRunDdqGenerationMutation__
 *
 * To run a mutation, you first call `useRunDdqGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunDdqGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runDdqGenerationMutation, { data, loading, error }] = useRunDdqGenerationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunDdqGenerationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RunDdqGenerationMutation, GraphqlTypes.RunDdqGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RunDdqGenerationMutation, GraphqlTypes.RunDdqGenerationMutationVariables>(RunDdqGenerationDocument, options);
      }
export type RunDdqGenerationMutationHookResult = ReturnType<typeof useRunDdqGenerationMutation>;
export type RunDdqGenerationMutationResult = Apollo.MutationResult<GraphqlTypes.RunDdqGenerationMutation>;
export type RunDdqGenerationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RunDdqGenerationMutation, GraphqlTypes.RunDdqGenerationMutationVariables>;
export const GetDdqGenerationDefaultsDocument = gql`
    query GetDdqGenerationDefaults {
  ddqGenerationDefaults {
    prompt
    model
    knowledgeSource
    models {
      id
      label
      isDefault
    }
  }
}
    `;

/**
 * __useGetDdqGenerationDefaultsQuery__
 *
 * To run a query within a React component, call `useGetDdqGenerationDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqGenerationDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqGenerationDefaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDdqGenerationDefaultsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>(GetDdqGenerationDefaultsDocument, options);
      }
export function useGetDdqGenerationDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>(GetDdqGenerationDefaultsDocument, options);
        }
// @ts-ignore
export function useGetDdqGenerationDefaultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>;
export function useGetDdqGenerationDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqGenerationDefaultsQuery | undefined, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>;
export function useGetDdqGenerationDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>(GetDdqGenerationDefaultsDocument, options);
        }
export type GetDdqGenerationDefaultsQueryHookResult = ReturnType<typeof useGetDdqGenerationDefaultsQuery>;
export type GetDdqGenerationDefaultsLazyQueryHookResult = ReturnType<typeof useGetDdqGenerationDefaultsLazyQuery>;
export type GetDdqGenerationDefaultsSuspenseQueryHookResult = ReturnType<typeof useGetDdqGenerationDefaultsSuspenseQuery>;
export type GetDdqGenerationDefaultsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqGenerationDefaultsQuery, GraphqlTypes.GetDdqGenerationDefaultsQueryVariables>;
export const GetDdqGenerationRunsDocument = gql`
    query GetDdqGenerationRuns($arenaId: Int!, $ddqProdOpsTaskId: ID!, $limit: Int) {
  ddqGenerationRuns(
    arenaId: $arenaId
    ddqProdOpsTaskId: $ddqProdOpsTaskId
    limit: $limit
  ) {
    id
    status
    error
    createdAt
    succeededAt
    failedAt
  }
}
    `;

/**
 * __useGetDdqGenerationRunsQuery__
 *
 * To run a query within a React component, call `useGetDdqGenerationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqGenerationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqGenerationRunsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      ddqProdOpsTaskId: // value for 'ddqProdOpsTaskId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDdqGenerationRunsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables> & ({ variables: GraphqlTypes.GetDdqGenerationRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>(GetDdqGenerationRunsDocument, options);
      }
export function useGetDdqGenerationRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>(GetDdqGenerationRunsDocument, options);
        }
// @ts-ignore
export function useGetDdqGenerationRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>;
export function useGetDdqGenerationRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqGenerationRunsQuery | undefined, GraphqlTypes.GetDdqGenerationRunsQueryVariables>;
export function useGetDdqGenerationRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>(GetDdqGenerationRunsDocument, options);
        }
export type GetDdqGenerationRunsQueryHookResult = ReturnType<typeof useGetDdqGenerationRunsQuery>;
export type GetDdqGenerationRunsLazyQueryHookResult = ReturnType<typeof useGetDdqGenerationRunsLazyQuery>;
export type GetDdqGenerationRunsSuspenseQueryHookResult = ReturnType<typeof useGetDdqGenerationRunsSuspenseQuery>;
export type GetDdqGenerationRunsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqGenerationRunsQuery, GraphqlTypes.GetDdqGenerationRunsQueryVariables>;
export const GetHistoricalDdqAnswersDocument = gql`
    query GetHistoricalDdqAnswers($arenaId: Int!, $uploadId: ID!) {
  historicalDdqAnswers(arenaId: $arenaId, uploadId: $uploadId) {
    id
    questionText
    questionType
    textAnswer
    value
    position
    approvedForAnswerBank
  }
}
    `;

/**
 * __useGetHistoricalDdqAnswersQuery__
 *
 * To run a query within a React component, call `useGetHistoricalDdqAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalDdqAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalDdqAnswersQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useGetHistoricalDdqAnswersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables> & ({ variables: GraphqlTypes.GetHistoricalDdqAnswersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>(GetHistoricalDdqAnswersDocument, options);
      }
export function useGetHistoricalDdqAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>(GetHistoricalDdqAnswersDocument, options);
        }
// @ts-ignore
export function useGetHistoricalDdqAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>;
export function useGetHistoricalDdqAnswersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetHistoricalDdqAnswersQuery | undefined, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>;
export function useGetHistoricalDdqAnswersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>(GetHistoricalDdqAnswersDocument, options);
        }
export type GetHistoricalDdqAnswersQueryHookResult = ReturnType<typeof useGetHistoricalDdqAnswersQuery>;
export type GetHistoricalDdqAnswersLazyQueryHookResult = ReturnType<typeof useGetHistoricalDdqAnswersLazyQuery>;
export type GetHistoricalDdqAnswersSuspenseQueryHookResult = ReturnType<typeof useGetHistoricalDdqAnswersSuspenseQuery>;
export type GetHistoricalDdqAnswersQueryResult = Apollo.QueryResult<GraphqlTypes.GetHistoricalDdqAnswersQuery, GraphqlTypes.GetHistoricalDdqAnswersQueryVariables>;
export const SetDdqQuestionTypeDocument = gql`
    mutation SetDdqQuestionType($input: SetDdqQuestionTypeInput!) {
  setDdqQuestionType(input: $input) {
    id
    questionType
    updatedAnswerIds
    reconciledConditionQuestionIds
  }
}
    `;
export type SetDdqQuestionTypeMutationFn = Apollo.MutationFunction<GraphqlTypes.SetDdqQuestionTypeMutation, GraphqlTypes.SetDdqQuestionTypeMutationVariables>;

/**
 * __useSetDdqQuestionTypeMutation__
 *
 * To run a mutation, you first call `useSetDdqQuestionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDdqQuestionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDdqQuestionTypeMutation, { data, loading, error }] = useSetDdqQuestionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDdqQuestionTypeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SetDdqQuestionTypeMutation, GraphqlTypes.SetDdqQuestionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SetDdqQuestionTypeMutation, GraphqlTypes.SetDdqQuestionTypeMutationVariables>(SetDdqQuestionTypeDocument, options);
      }
export type SetDdqQuestionTypeMutationHookResult = ReturnType<typeof useSetDdqQuestionTypeMutation>;
export type SetDdqQuestionTypeMutationResult = Apollo.MutationResult<GraphqlTypes.SetDdqQuestionTypeMutation>;
export type SetDdqQuestionTypeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SetDdqQuestionTypeMutation, GraphqlTypes.SetDdqQuestionTypeMutationVariables>;
export const GetDdqStructureDocument = gql`
    query GetDdqStructure($arenaId: Int!, $ddqId: ID!) {
  ddqSections(arenaId: $arenaId, ddqId: $ddqId) {
    id
    title
    parentSectionId
    position
  }
  ddqQuestions(arenaId: $arenaId, ddqId: $ddqId) {
    id
    sectionId
    parentQuestionId
    position
    questionText
    questionType
    questionNotes
  }
}
    `;

/**
 * __useGetDdqStructureQuery__
 *
 * To run a query within a React component, call `useGetDdqStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqStructureQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      ddqId: // value for 'ddqId'
 *   },
 * });
 */
export function useGetDdqStructureQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables> & ({ variables: GraphqlTypes.GetDdqStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>(GetDdqStructureDocument, options);
      }
export function useGetDdqStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>(GetDdqStructureDocument, options);
        }
// @ts-ignore
export function useGetDdqStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>;
export function useGetDdqStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqStructureQuery | undefined, GraphqlTypes.GetDdqStructureQueryVariables>;
export function useGetDdqStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>(GetDdqStructureDocument, options);
        }
export type GetDdqStructureQueryHookResult = ReturnType<typeof useGetDdqStructureQuery>;
export type GetDdqStructureLazyQueryHookResult = ReturnType<typeof useGetDdqStructureLazyQuery>;
export type GetDdqStructureSuspenseQueryHookResult = ReturnType<typeof useGetDdqStructureSuspenseQuery>;
export type GetDdqStructureQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqStructureQuery, GraphqlTypes.GetDdqStructureQueryVariables>;
export const RunDdqExtractionDocument = gql`
    mutation RunDdqExtraction($input: RunDdqExtractionInput!) {
  runDdqExtraction(input: $input) {
    id
    status
    error
    model
    questionsPrompt
    createdAt
  }
}
    `;
export type RunDdqExtractionMutationFn = Apollo.MutationFunction<GraphqlTypes.RunDdqExtractionMutation, GraphqlTypes.RunDdqExtractionMutationVariables>;

/**
 * __useRunDdqExtractionMutation__
 *
 * To run a mutation, you first call `useRunDdqExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunDdqExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runDdqExtractionMutation, { data, loading, error }] = useRunDdqExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunDdqExtractionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RunDdqExtractionMutation, GraphqlTypes.RunDdqExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RunDdqExtractionMutation, GraphqlTypes.RunDdqExtractionMutationVariables>(RunDdqExtractionDocument, options);
      }
export type RunDdqExtractionMutationHookResult = ReturnType<typeof useRunDdqExtractionMutation>;
export type RunDdqExtractionMutationResult = Apollo.MutationResult<GraphqlTypes.RunDdqExtractionMutation>;
export type RunDdqExtractionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RunDdqExtractionMutation, GraphqlTypes.RunDdqExtractionMutationVariables>;
export const GetDdqExtractionDefaultsDocument = gql`
    query GetDdqExtractionDefaults($targetType: DdqProdOpsWorkflowType!) {
  ddqExtractionDefaults(targetType: $targetType) {
    outlinePrompt
    questionsPrompt
    models {
      id
      label
      isDefault
    }
  }
}
    `;

/**
 * __useGetDdqExtractionDefaultsQuery__
 *
 * To run a query within a React component, call `useGetDdqExtractionDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqExtractionDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqExtractionDefaultsQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useGetDdqExtractionDefaultsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables> & ({ variables: GraphqlTypes.GetDdqExtractionDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>(GetDdqExtractionDefaultsDocument, options);
      }
export function useGetDdqExtractionDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>(GetDdqExtractionDefaultsDocument, options);
        }
// @ts-ignore
export function useGetDdqExtractionDefaultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>;
export function useGetDdqExtractionDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqExtractionDefaultsQuery | undefined, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>;
export function useGetDdqExtractionDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>(GetDdqExtractionDefaultsDocument, options);
        }
export type GetDdqExtractionDefaultsQueryHookResult = ReturnType<typeof useGetDdqExtractionDefaultsQuery>;
export type GetDdqExtractionDefaultsLazyQueryHookResult = ReturnType<typeof useGetDdqExtractionDefaultsLazyQuery>;
export type GetDdqExtractionDefaultsSuspenseQueryHookResult = ReturnType<typeof useGetDdqExtractionDefaultsSuspenseQuery>;
export type GetDdqExtractionDefaultsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqExtractionDefaultsQuery, GraphqlTypes.GetDdqExtractionDefaultsQueryVariables>;
export const GetDdqExtractionRunsDocument = gql`
    query GetDdqExtractionRuns($arenaId: Int!, $prodOpsTaskId: ID!, $limit: Int) {
  ddqExtractionRuns(
    arenaId: $arenaId
    prodOpsTaskId: $prodOpsTaskId
    limit: $limit
  ) {
    id
    status
    error
    createdAt
    succeededAt
    failedAt
  }
}
    `;

/**
 * __useGetDdqExtractionRunsQuery__
 *
 * To run a query within a React component, call `useGetDdqExtractionRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDdqExtractionRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDdqExtractionRunsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      prodOpsTaskId: // value for 'prodOpsTaskId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDdqExtractionRunsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables> & ({ variables: GraphqlTypes.GetDdqExtractionRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>(GetDdqExtractionRunsDocument, options);
      }
export function useGetDdqExtractionRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>(GetDdqExtractionRunsDocument, options);
        }
// @ts-ignore
export function useGetDdqExtractionRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>;
export function useGetDdqExtractionRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDdqExtractionRunsQuery | undefined, GraphqlTypes.GetDdqExtractionRunsQueryVariables>;
export function useGetDdqExtractionRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>(GetDdqExtractionRunsDocument, options);
        }
export type GetDdqExtractionRunsQueryHookResult = ReturnType<typeof useGetDdqExtractionRunsQuery>;
export type GetDdqExtractionRunsLazyQueryHookResult = ReturnType<typeof useGetDdqExtractionRunsLazyQuery>;
export type GetDdqExtractionRunsSuspenseQueryHookResult = ReturnType<typeof useGetDdqExtractionRunsSuspenseQuery>;
export type GetDdqExtractionRunsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDdqExtractionRunsQuery, GraphqlTypes.GetDdqExtractionRunsQueryVariables>;
export const GetDocumentViewerUrlDocument = gql`
    query GetDocumentViewerUrl($documentId: ID!, $arenaId: Int!) {
  documentViewerUrl(documentId: $documentId, arenaId: $arenaId) {
    pdfUrl
    filename
    contentType
    initialPage
  }
}
    `;

/**
 * __useGetDocumentViewerUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentViewerUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentViewerUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentViewerUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetDocumentViewerUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables> & ({ variables: GraphqlTypes.GetDocumentViewerUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>(GetDocumentViewerUrlDocument, options);
      }
export function useGetDocumentViewerUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>(GetDocumentViewerUrlDocument, options);
        }
// @ts-ignore
export function useGetDocumentViewerUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>;
export function useGetDocumentViewerUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDocumentViewerUrlQuery | undefined, GraphqlTypes.GetDocumentViewerUrlQueryVariables>;
export function useGetDocumentViewerUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>(GetDocumentViewerUrlDocument, options);
        }
export type GetDocumentViewerUrlQueryHookResult = ReturnType<typeof useGetDocumentViewerUrlQuery>;
export type GetDocumentViewerUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentViewerUrlLazyQuery>;
export type GetDocumentViewerUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentViewerUrlSuspenseQuery>;
export type GetDocumentViewerUrlQueryResult = Apollo.QueryResult<GraphqlTypes.GetDocumentViewerUrlQuery, GraphqlTypes.GetDocumentViewerUrlQueryVariables>;